import 'ol/ol.css';
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
///// import Stamen from 'ol/source/Stamen';
import XYZ from 'ol/source/XYZ';
import TileGrid from 'ol/tilegrid/TileGrid';
import CartoDB from 'ol/source/CartoDB';
import Static from 'ol/source/ImageStatic';
import Projection from 'ol/proj/Projection';
import TileWMS from 'ol/source/TileWMS';
import View from 'ol/View';
import proj4 from 'proj4';
import {Group as LayerGroup, Image as ImageLayer, Tile as TileLayer, getSource} from 'ol/layer';
import Overlay from 'ol/Overlay';
import {getCenter, getWidth} from 'ol/extent';
import {register} from 'ol/proj/proj4';
import {get as getProjection, transformExtent} from 'ol/proj';
import {transform} from 'ol/proj';
import {toLonLat, fromLonLat, transformExtent} from 'ol/proj';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector'; 
import GeoJSON from 'ol/format/GeoJSON';
import {Icon, Style, Stroke, Fill} from 'ol/style';  
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import Modify from 'ol/interaction/Modify.js';

import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import { DoubleClickZoom } from 'ol/interaction/DoubleClickZoom';
import {FullScreen, defaults as defaultControls} from 'ol/control';

var Version = "3.22";
var ModelMode = false;
var Nowcast = false;
var WindMaps = false; 
var L_GDPSE = false;
var L_SHOP = true;
var ChoixDuoEnCour = false;

const queryString = window.location.search;
console.log('QueryString: ', queryString);

const imeteoMapsParams = new URLSearchParams(queryString);
console.log('URLSearchParams: ', imeteoMapsParams);

const ParamWindMaps = imeteoMapsParams.get('windmaps')
const ParamFlot = imeteoMapsParams.get('flot')
const ParamFlots = imeteoMapsParams.get('flots')

if ( imeteoMapsParams.has('windmaps') ) {

     console.log('windmaps: ', ParamWindMaps);
     console.log(" query string has windmaps");

   let chaineParamWindMaps = ParamWindMaps.toString();
   console.log("windmaps was given as: ", chaineParamWindMaps);

   if ( (chaineParamWindMaps != "F") || (chaineParamWindMaps != "FALSE") ) {
     console.log(" WinMaps is activated as requested in URL");
     WindMaps = true;
     console.log(" shop is activated as requested in windmaps");
     L_SHOP = true;
   } else {
     console.log(" windmaps is not activated since F or FALSE was flaged");
   }
} else if ( imeteoMapsParams.has('flots') ) {

     console.log('flots: ', ParamFlots);
     console.log(" query string has flots");

   let chaineParamFlots = ParamFlots.toString();
   console.log("windmaps was given as: ", chaineParamFlots);

   if ( (chaineParamFlots != "F") || (chaineParamFlots != "FALSE") ) {
     console.log(" WinMaps is activated as requested in URL via parameter: flots");
     WindMaps = true;
     console.log(" shop is activated as requested in windmaps");
     L_SHOP = true;
   } else {
     console.log(" windmaps is not activated since F or FALSE was flaged via parameter: flots");
   }
} else if ( imeteoMapsParams.has('flot') ) {

     console.log('flot: ', ParamFlot);
     console.log(" query string has flot");

   let chaineParamFlot = ParamFlot.toString();
   console.log("windmaps was given as: ", chaineParamFlot);

   if ( (chaineParamFlot != "F") || (chaineParamFlot != "FALSE") ) {
     console.log(" WinMaps is activated as requested in URL via parameter: flot");
     WindMaps = true;
     console.log(" shop is activated as requested in windmaps");
     L_SHOP = true;
   } else {
     console.log(" windmaps is not activated since F or FALSE was flaged via parameter: flot");
   }
}

const ParamNowcast = imeteoMapsParams.get('nowcast')

if   (imeteoMapsParams.has('nowcast') && !WindMaps ) {

     console.log('nowcast: ', ParamNowcast);
     console.log(" query string has nowcast");

   let chaineParamNowcast = ParamNowcast.toString();

   console.log("nowcast was given as: ", chaineParamNowcast);

   if ( (chaineParamNowcast != "F") || (chaineParamNowcast != "FALSE") ) {
     console.log(" Nowcast is activated as requested in URL");
     Nowcast = true;
   } else {
     console.log(" Nowcast is not activated since F or FALSE was flaged");
   }
}

if ( !Nowcast && !WindMaps ) {  ModelMode = true; }

const ParamGDPSE = imeteoMapsParams.get('europe')

if   (imeteoMapsParams.has('europe') && !WindMaps ) {

     console.log('europe: ', ParamGDPSE);
     console.log(" query string has europe");

   let chaineParamGDPSE = ParamGDPSE.toString();

   console.log("europe was given as: ", chaineParamGDPSE);

   if ( (chaineParamGDPSE != "F") || (chaineParamGDPSE != "FALSE") ) {
     console.log(" europe is activated as requested in URL");
     L_GDPSE = true;
   } else {
     console.log(" GDPSE is not activated since F or FALSE was flaged");
   }
}
const ParamSHOP = imeteoMapsParams.get('shop')

if   (imeteoMapsParams.has('shop') ) {

     console.log('shop: ', ParamSHOP);
     console.log(" query string has shop");

   let chaineParamSHOP = ParamSHOP.toString();

   console.log("shop was given as: ", chaineParamSHOP);

   if ( (chaineParamSHOP != "F") || (chaineParamSHOP != "FALSE") ) {
     console.log(" shop is activated as requested in URL");
     L_SHOP = true;
   } else {
     console.log(" SHOP is not activated since F or FALSE was flaged");
   }
}
// ---  Preparing viewing projections ------------------------
//
proj4.defs(
  'EPSG:2163',
  '+proj=laea +lat_0=45 +lon_0=-100 +x_0=0 +y_0=0 ' +
    '+a=6370997 +b=6370997 +units=m +no_defs'
);

proj4.defs(
  'SR-ORG:8237',
  '+proj=stere +lat_0=90 +lat_ts=60 +lon_0=-111  +x_0=0 +y_0=0 ' +
    '+a=6371229 +b=6371229 +units=m +no_defs'
)
//  RDPS:
//  cellcentre.offset: Named num [1:2] -4551441 -7314318
//  bbox       : num [1:2, 1:2] -4556441 -7319318 4793559 920682
//
//  Origin = (-4556441.403315242379904,920682.141165949404240)
//Corner Coordinates:
//Upper Left  (-4556441.403,  920682.141) (147d34'35.51"E, 47d17'21.08"N)
//Lower Left  (-4556441.403,-7319317.859) (142d54'11.52"W, 18d 6' 5.46"N)
//Upper Right ( 4793558.597,  920682.141) ( 10d 7'40.08"W, 45d21'25.84"N)
//Lower Right ( 4793558.597,-7319317.859) ( 77d46'42.45"W, 17d17'57.97"N)
//Center      (  118558.597,-3199317.859) (108d52'39.85"W, 59d51'25.44"N)
//
//  projargs: chr +proj=stere +lat_0=90 +lat_ts=60 +lon_0=249 +k=90 +x_0=0 +y_0=0 +a=6371229 +b=6371229 +units=m +no_defs"
//

proj4.defs(
       'SR-ORG:9237',
      '+proj=stere +lat_0=90 +lat_ts=60 +lon_0=252  +x_0=0 +y_0=0 ' +
        '+a=6371229 +b=6371229 +units=m +no_defs'
)

proj4.defs(
      'SR-ORG:9238',
      '+proj=longlat +a=6371229 +b=6371229 +no_defs'                   
)

proj4.defs(
  'EPSG:3413',
  '+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +k=1 ' +
    '+x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs'
);

//proj4.defs(
//  'EPSG:9001',
//  '+proj=ob_tran +o_proj=longlat +o_lon_p=0 +o_lat_p=36.08852 ' +
//        ' +lon_0=-114.694858 +R=6371229 +no_defs'
//);
///operation@kraken:~/grib/data/HRDPS_LL$ gdalsrsinfo 20230316T12Z_MSC_HRDPS_TMP_ISBL_0850_RLatLon0.0225_PT048H.grib2

///PROJ.4 : +proj=ob_tran +o_proj=longlat +o_lon_p=0 +o_lat_p=36.08852 +lon_0=-114.694858 +R=6371229 +no_defs



////   Regional OPS PS
//  RDPS
//
//
//
/*
    Images continentales:   1691 x 1235  = 2 088 385
                935 x 824=   770 440

Driver: GRIB/GRIdded Binary (.grb)
Files: CMC_reg_HGT_ISBL_700_ps10km_2021122406_P084.grib2
Size is 935, 824
Coordinate System is:
PROJCS["unnamed",
    GEOGCS["Coordinate System imported from GRIB file",
        DATUM["unknown",
            SPHEROID["Sphere",6371229,0]],
        PRIMEM["Greenwich",0],
        UNIT["degree",0.0174532925199433]],
    PROJECTION["Polar_Stereographic"],
    PARAMETER["latitude_of_origin",60],
    PARAMETER["central_meridian",249],
   PARAMETER["scale_factor",90],
    PARAMETER["false_easting",0],
    PARAMETER["false_northing",0]]
Origin = (-4556441.403315242379904,920682.141165949404240)
Pixel Size = (10000.000000000000000,-10000.000000000000000)
Corner Coordinates:
Upper Left  (-4556441.403,  920682.141) (147d34'35.51"E, 47d17'21.08"N)
Lower Left  (-4556441.403,-7319317.859) (142d54'11.52"W, 18d 6' 5.46"N)
Upper Right ( 4793558.597,  920682.141) ( 10d 7'40.08"W, 45d21'25.84"N)
Lower Right ( 4793558.597,-7319317.859) ( 77d46'42.45"W, 17d17'57.97"N)
Center      (  118558.597,-3199317.859) (108d52'39.85"W, 59d51'25.44"N)
Band 1 Block=935x1 Type=Float64, ColorInterp=Undefined
  Description = 69999999999999992861909247110435160666542483456969070400199778929114697432472734636454224471710480991647905381140924834250752[Pa] ISBL="Isobaric surface"
  NoData Value=9999
  Metadata:
    oRIB_COMMENT=Geopotential height [gpm]
    GRIB_ELEMENT=HGT
    GRIB_FORECAST_SECONDS=302400 sec
    GRIB_PDS_PDTN=0
    GRIB_PDS_TEMPLATE_NUMBERS=3 5 2 36 36 0 0 0 1 0 0 0 84 100 132 0 0 0 7 255 255 255 255 255 255
    GRIB_REF_TIME=  1640325600 sec UTC
    GRIB_SHORT_NAME=69999999999999992861909247110435160666542483456969070400199778929114697432472734636454224471710480991647905381140924834250752-ISBL
    GRIB_UNIT=[gpm]
    GRIB_VALID_TIME=  1640628000 sec UTC
*/

/*
//  HRDPS:
    //     Images EAST   1870 x 1188    = 2 221 560
    //     Images WEST   1870 x 1231    = 2 301 970
    //     2576 x 1456          = 3 750 656

    //  Driver: GRIB/GRIdded Binary (.grb)
Files: CMC_hrdps_continental_WEARN_SFC_0_ps2.5km_2021122406_P048-00.grib2
Size is 2576, 1456
Coordinate System is:
PROJCS["unnamed",
    GEOGCS["Coordinate System imported from GRIB file",
        DATUM["unknown",
            SPHEROID["Sphere",6371229,0]],
        PRIMEM["Greenwich",0],
        UNIT["degree",0.0174532925199433]],
    PROJECTION["Polar_Stereographic"],
    PARAMETER["latitude_of_origin",60],
    PARAMETER["central_meridian",252],
    PARAMETER["scale_factor",90],
    PARAMETER["false_easting",0],
    PARAMETER["false_northing",0]]
Origin = (-2099127.494496937375516,-2099388.521499627269804)
Pixel Size = (2500.000000000000000,-2500.000000000000000)
Corner Coordinates:
Upper Left  (-2099127.494,-2099388.521) (152d59'47.18"W, 61d57'30.73"N)
Lower Left  (-2099127.494,-5739388.521) (128d 5'22.27"W, 35d35'28.15"N)
Upper Right ( 4340872.506,-2099388.521) ( 43d48'35.77"W, 45d50'49.32"N)
Lower Right ( 4340872.506,-5739388.521) ( 70d53'55.27"W, 27d37'43.23"N)
Center      ( 1120872.506,-3919388.521) ( 92d 2'25.63"W, 52d 8'52.39"N)
Band 1 Block=2576x1 Type=Float64, ColorInterp=Undefined
  Description = 0[-] SFC="Ground or water surface"
  NoData Value=9999
  Metadata:
    GRIB_COMMENT=Rain precipitation rate [kg/(m^2*s)]
    GRIB_ELEMENT=RPRATE
    GRIB_FORECAST_SECONDS=0 sec
    GRIB_PDS_PDTN=8
    GRIB_PDS_TEMPLATE_NUMBERS=1 65 2 50 50 0 0 0 1 0 0 0 0 1 0 0 0 0 0 255 255 255 255 255 255 7 229 12 26 6 0 0 1 0 0 0 0 1 2 1 0 0 0 48 1 0 0 0 0
    GRIB_REF_TIME=  1640325600 sec UTC
    GRIB_SHORT_NAME=0-SFC
    GRIB_UNIT=[kg/(m^2*s)]
    GRIB_VALID_TIME=  1640498400 sec UTC
*/

//
//  GDPS:
//
//  Images NOAM:     1573 x 1238 = 1 947 374
//                   2400 x 1201 = 2 882 400
//
//  cellcentre.offset: Named num [1:2] -180 -90
//  bbox       : num [1:2, 1:2] -180 -90.1 180 90.1
//  projargs: chr "+proj=longlat +a=6371229 +b=6371229 +no_defs"
//
/*
Files: CMC_glb_HGT_ISBY_1000-500_latlon.15x.15_2021122400_P240.grib2
Size is 2400, 1201
Coordinate System is:
GEOGCS["Coordinate System imported from GRIB file",
    DATUM["unknown",
        SPHEROID["Sphere",6371229,0]],
    PRIMEM["Greenwich",0],
    UNIT["degree",0.0174532925199433]]
Origin = (179.925000000000011,90.075000000000003)
Pixel Size = (0.150000000000000,-0.150000000000000)
Corner Coordinates:
Upper Left  ( 179.9250000,  90.0750000) (179d55'30.00"E, 90d 4'30.00"N)
Lower Left  ( 179.9250000, -90.0750000) (179d55'30.00"E, 90d 4'30.00"S)
Upper Right (     539.925,      90.075) (Invalid angle, 90d 4'30.00"N)
Lower Right (     539.925,     -90.075) (Invalid angle, 90d 4'30.00"S)
Center      (     359.925,       0.000) (359d55'30.00"E,  0d 0' 0.01"N)
Band 1 Block=2400x1 Type=Float64, ColorInterp=Undefined
  Description = 999999999999999977709969731404129670057984297594921577392083322662491290889839886077866558841507631684757522070951350501376-49999999999999996243388080949644102127233543491741923071961298611264709998789651330158174688140882687576502920682776614141952[Pa] ISBL="Isobaric surface"
  Metadata:
    GRIB_COMMENT=Thickness [m]
    GRIB_ELEMENT=THICK
    GRIB_FORECAST_SECONDS=864000 sec
    GRIB_PDS_PDTN=0
    GRIB_PDS_TEMPLATE_NUMBERS=3 12 2 47 47 0 0 0 1 0 0 0 240 100 133 0 0 0 1 100 132 0 0 0 5
    GRIB_REF_TIME=  1640304000 sec UTC
    GRIB_SHORT_NAME=999999999999999977709969731404129670057984297594921577392083322662491290889839886077866558841507631684757522070951350501376-49999999999999996243388080949644102127233543491741923071961298611264709998789651330158174688140882687576502920682776614141952-ISBL
    GRIB_UNIT=[m]
    GRIB_VALID_TIME=  1641168000 sec UTC
*/
/*
//                GFS
    //                GFS NOAM:   980 x 795 = 779 100
    //                  1440 x 721      = 1 038 240
Driver: GRIB/GRIdded Binary (.grb)
Files: NWS_glb_WEASN_SFC_0_latlon.25x.25_2021122400_P120.grib2
Size is 1440, 721
Coordinate System is:
GEOGCS["Coordinate System imported from GRIB file",
    DATUM["unknown",
        SPHEROID["Sphere",6371229,0]],
    PRIMEM["Greenwich",0],
    UNIT["degree",0.0174532925199433]]
Origin = (-0.125000000000000,90.125000000000000)
Pixel Size = (0.250000000000000,-0.250000000000000)
Corner Coordinates:
Upper Left  (  -0.1250000,  90.1250000) (  0d 7'30.00"W, 90d 7'30.00"N)
Lower Left  (  -0.1250000, -90.1250000) (  0d 7'30.00"W, 90d 7'30.00"S)
Upper Right (     359.875,      90.125) (359d52'30.00"E, 90d 7'30.00"N)
Lower Right (     359.875,     -90.125) (359d52'30.00"E, 90d 7'30.00"S)
Center      ( 179.8750000,   0.0000000) (179d52'30.00"E,  0d 0' 0.01"N)
Band 1 Block=1440x1 Type=Float64, ColorInterp=Undefined
  Description = 0[-] SFC="Ground or water surface"
  Metadata:
    GRIB_COMMENT=Categorical Snow [0=no; 1=yes]
    GRIB_ELEMENT=CSNOW
    GRIB_FORECAST_SECONDS=432000 sec
    GRIB_PDS_PDTN=0
    GRIB_PDS_TEMPLATE_NUMBERS=1 195 2 0 96 0 0 0 1 0 0 0 120 1 0 0 0 0 0 255 0 0 0 0 0
    GRIB_REF_TIME=  1640304000 sec UTC
    GRIB_SHORT_NAME=0-SFC
    GRIB_UNIT=[0=no; 1=yes]
    GRIB_VALID_TIME=  1640736000 sec UTC
Band 2 Block=1440x1 Type=Float64, ColorInterp=Undefined
  Description = 0[-] SFC="Ground or water surface"
  Metadata:
    GRIB_COMMENT=Categorical Snow [0=no; 1=yes]
    GRIB_ELEMENT=CSNOW
    GRIB_FORECAST_SECONDS=410400 sec
    GRIB_PDS_PDTN=8
    GRIB_PDS_TEMPLATE_NUMBERS=1 195 2 0 96 0 0 0 1 0 0 0 114 1 0 0 0 0 0 255 0 0 0 0 0 7 229 12 29 0 0 0 1 0 0 0 0 0 2 1 0 0 0 6 255 0 0 0 0
    GRIB_REF_TIME=  1640304000 sec UTC
    GRIB_SHORT_NAME=0-SFC
    GRIB_UNIT=[0=no; 1=yes]
    GRIB_VALID_TIME=  1640736000 sec UTC
*/

//proj4.defs(
//  'SR-ORG:100999',
//  '+proj=nsper +lat_0=45 +lon_0=-100 +units=m +h=3000000 +ellps=WGS84 +datum=WGS84 ' 
//);

register(proj4);

const proj2163 = getProjection('EPSG:2163');
proj2163.setExtent( transformExtent( [-145, 5, -35, 75 ], 'EPSG:4326', 'EPSG:2163' ) );

const proj8237 = getProjection('SR-ORG:8237');
//proj8237.setExtent( transformExtent( [-180, -50, 0, 0  ], 'EPSG:4326', 'SR-ORG:8237' ) );
//proj8237.setExtent( [-4556441.403, -7319317.859, 4793558.597 , 920682.141 ] );

proj8237.setExtent( transformExtent( [-155, -5, 0, 55  ], 'EPSG:4326', 'SR-ORG:8237' ) );

const proj9237 = getProjection('SR-ORG:9237');
//proj9237.setExtent( [ -2099127.494, -5739388.521,  4340872.506,-2099388.521 ] );
proj9237.setExtent( transformExtent( [-155, -5, 0, 55  ], 'EPSG:4326', 'SR-ORG:9237' ) );

const proj9238 = getProjection('SR-ORG:9238');
proj9238.setExtent( [ -180, -90, 180,  90] );

//Upper Left  (-4556441.403,  920682.141) (147d34'35.51"E, 47d17'21.08"N)
//Lower Left  (-4556441.403,-7319317.859) (142d54'11.52"W, 18d 6' 5.46"N)
//Upper Right ( 4793558.597,  920682.141) ( 10d 7'40.08"W, 45d21'25.84"N)
//Lower Right ( 4793558.597,-7319317.859) ( 77d46'42.45"W, 17d17'57.97"N)
//Center      (  118558.597,-3199317.859) (108d52'39.85"W, 59d51'25.44"N)


//projargs: chr +proj=stere +lat_0=90 +lat_ts=60 +lon_0=249 +k=90 +x_0=0 +y_0=0 +a=6371229 +b=6371229 +units=m +no_defs"
/*function LonLatToXY(lon, lat, rayon, ecc, lat0, lon0) {

    //%convert to radians
    var degtorad = Math.PI/180.;

        var lonR= lon * degtorad;
    var latR = lat * degtorad;
    var lat0R = lat0 * degtorad;
    var lon0R = lon0 * degtorad;

        var k = 2/( 1 + Math.sin( lat0R )*Math.sin( latR ) + Math.cos( lat0R )*Math.cos( latR )*Math.cos( lonR-lon0R  ) ) ;

    var x = rayon * k * Math.cos( latR ) * Math.sin( lonR-lon0R  );
    var y = rayon * k * ( Math.cos( lat0R )*Math.sin( latR ) - Math.sin( lat0R )*Math.cos( latR )*Math.cos( lonR-lon0R  )  );

    var point = [];
    point[0] = x;
    point[1] = y;

    return point;
 }

var point = LonLatToXY( -142.8968 , 18.1429, 6371229, 1, 60, -111);
*/

const proj3413 = getProjection('EPSG:3413');
//proj3413.setExtent( [-5194304, -5194304, 4194304, 4194304] );
proj3413.setExtent( [-5693528, -6627744, 603750, 751207 ]);

//const proj9001 = getProjection('EPSG:9001');
//proj9001.setExtent( transformExtent( [-180, 89, 0, 0], 'EPSG:4326', 'EPSG:9001' ) );

//const proj100999 = getProjection('SR-ORG:100999');
//proj100999.setExtent( transformExtent( [-145, 05, -40, 75 ], 'EPSG:4326', 'SR-ORG:100999' ) );

const projView = 'EPSG:3857';

// -------------------------------------------------------------------------------------------

import Attribution from 'ol/control/Attribution.js';

const attribution1 = new Attribution({
    collapsible: true,
    collapsed: true,
    // ... autres options de configuration
});

const attribution2 = new Attribution({
    collapsible: true,
    collapsed: true,
    // ... autres options de configuration
});

// var WrapperFull = "fullscreen-wrapper";
var WrapperFull = "total-wrapper";

const map = new Map({
  controls: defaultControls({attribution: false}).extend([new FullScreen({ source: WrapperFull, } )], [attribution1]),
  interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
  moveTolerance: 10,
  maxTilesLoading: 256,
  target: 'map',
  view: new View({
    center: fromLonLat([-88, 45], projView),
    zoom: 5,
    projection: projView,
    constrainResolution: false,
  }),
});

map.addControl(attribution1);

const map2 = new Map({
  controls: defaultControls({attribution: false}).extend([new FullScreen({ source: WrapperFull, } )], [attribution2]),
  interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
  moveTolerance: 10,
  maxTilesLoading: 256,
  target: 'map2',
  view: new View({
    center: fromLonLat([-88, 45], projView),
    zoom: 5,
    projection: projView,
    constrainResolution: false,                                                                                                                                                                                                                 
  }),
});

map2.addControl(attribution2);

const LightBasemap = new TileLayer({
  title: 'LightBasemap',
  zIndex: 0,
  visible: true,
  source: new XYZ({
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
  }),
});

const LightBasemap2 = new TileLayer({
  title: 'LightBasemap',
  zIndex: 0,
  visible: true,
  source: new XYZ({
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
  }),
});

const DarkBasemap = new TileLayer({
  title: 'DarkBasemap',
  zIndex: 0,
  visible: false,
  source: new XYZ({
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>' ,
  }),
});

const DarkBasemap2 = new TileLayer({
  title: 'DarkBasemap',
  zIndex: 0,
  visible: false,
  source: new XYZ({
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
  }),
});

const OSMStandard = new TileLayer({
      source: new OSM({
        attributions: ' Basemap &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
      }),
      projection: projView || 'EPSG:4326' || 'EPSG:3857',
      zIndex: 0,
      visible: false,
      title: 'OSMStandard',
    });

const OSMStandard2 = new TileLayer({
      source: new OSM({
        attributions: ' Basemap &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
      }),
      projection: projView || 'EPSG:4326' || 'EPSG:3857',
      zIndex: 0,
      visible: false,
      title: 'OSMStandard',
     attributions: ' Basemap &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
    });

//_______________________________________________________________

const sourceAhocevar = new TileWMS({
      url: 'https://ahocevar.com/geoserver/wms',
      projection: projView || 'EPSG:4326' || 'EPSG:3857',
      params: {
        'LAYERS': 'ne:NE1_HR_LC_SR_W_DR',
        'TILED': true,
        attributions: 'Basemap &copy; <a href="https://ahocevar.com"> Ahocevar</a> &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
      },
    });

const Ahocevar = new TileLayer({
   source: sourceAhocevar,
   zIndex: 0,
   visible: false,
   title: 'Ahocevar',
  });

const Ahocevar2 = new TileLayer({
   source: sourceAhocevar,
   zIndex: 0,
   visible: false,
   title: 'Ahocevar',
  });

    var Visible = true;
if ( WindMaps ) {
   Visible = false;
}

//_______________________________________________________________
///   Hydro :   contour et filled...   lacs et rivières...
const sourceCanvecHydro = new TileWMS({
        url: 'https://maps.geogratis.gc.ca/wms/canvec_en',
        params: {'LAYERS':'hydro', 'TILED': true},
        projection: 'EPSG:4326' || 'EPSG:3857',
        serverType: 'geoserver',
        transition: 0,
      });

const CanvecHydro = new TileLayer({
      source: sourceCanvecHydro,
      minZoom: 29,
      zIndex: 10,
      visible: Visible,
      title: 'CanvecHydro',
   });

const CanvecHydro2 = new TileLayer({
      source: sourceCanvecHydro,
      minZoom: 29,
      zIndex: 10,
      visible: Visible,
      title: 'CanvecHydro',
   });

//_______________________________________________________________
///   Elevation :   contour topographiques 
const sourceCanvecElevation = new TileWMS({
        url: 'https://maps.geogratis.gc.ca/wms/canvec_en',
        params: {'LAYERS':'elevation', 'TILED': true},
        projection: projView || 'EPSG:4326' || 'EPSG:3857',
        minZoom: 6,
        serverType: 'geoserver',
        transition: 0,
      });

const CanvecElevation = new TileLayer({
      source: sourceCanvecElevation,
      zIndex: 10,
      visible: false,
      title: 'CanvecElevation',
   });

const CanvecElevation2 = new TileLayer({
      source: sourceCanvecElevation,
      zIndex: 10,
      visible: false,
      title: 'CanvecElevation',
   });

//_______________________________________________________________

const sourceCanvecAdmin = new TileWMS({
        url: 'https://maps.geogratis.gc.ca/wms/canvec_en',
        params: {'LAYERS':"('boundary_small', 'boundary_mid', 'boundary_large_01', 'boundary_large_02', 'boundary_large_03')", 'TILED': true},
        projection: 'EPSG:4326' || 'EPSG:3857',
        minZoom: 6, 
        serverType: 'geoserver',
        transition: 0,
        zDirection: 0,
        zIndex: 98,
      });

const CanvecAdmin = new TileLayer({
      source: sourceCanvecAdmin,
      zIndex: 98,
      visible: false,
      title: 'CanvecAdmin',
   });
const CanvecAdmin2 = new TileLayer({
      source: sourceCanvecAdmin,
      zIndex: 98,
      visible: false,
      title: 'CanvecAdmin',
   });

//_______________________________________________________________
//   Toponymie:  bon pour les noms de lacs et Montagnes...
const sourceCanvecToponymy = new TileWMS({
        url: 'https://maps.geogratis.gc.ca/wms/canvec_en',
        params: {'LAYERS':'toponymy', 'TILED': true},
        projection: 'EPSG:4326' || 'EPSG:3857',
        minZoom: 6,
        serverType: 'geoserver',
        transition: 0,
        zDirection: 0,
        zIndex: 98,
      });

const CanvecToponymy = new TileLayer({
      source: sourceCanvecToponymy,
      zIndex: 98,
      visible: false,
      title: 'CanvecToponymy',
   });
const CanvecToponymy2 = new TileLayer({
      source: sourceCanvecToponymy,
      zIndex: 98,
      visible: false,
      title: 'CanvecToponymy',
   });

 Visible = true;
if ( WindMaps ) {
   Visible = true;
}

//_______________________________________________________________
//  Transport
const sourceCanvecTransport = new TileWMS({
            url: 'https://maps.geogratis.gc.ca/wms/canvec_en',
            params: {'LAYERS':'transport', 'TILED': true},
            projection: 'EPSG:4326' || 'EPSG:3857',
            serverType: 'geoserver',
            transition: 0,
            zDirection: 0,
            zIndex: 98,
   });

const CanvecTransport = new TileLayer({
      source: sourceCanvecTransport,
       minZoom: 30,
       zIndex: 98,
      visible: Visible,
      title: 'CanvecTransport',
   });

const CanvecTransport2 = new TileLayer({
      source: sourceCanvecTransport,
       minZoom: 30,
        zIndex: 98,
      visible: Visible,
      title: 'CanvecTransport',
   });
//
//  stand alone Top map layers :  geographical references to render on top of the weather information
//  in order to provide geographical reference even when the weather information is colored and opaque
//
//  Those are selctable on the layer switcher
//
   Visible = true;
    
// Style pour les frontières des pays,  rivièeres,  coastlines,  etc

const lineStyleDarkGrey = new Style({
    stroke: new Stroke({
        color: [100, 100, 100, 1.0],
        width: 1
    })
});

const lineStyleLightGrey = new Style({
    stroke: new Stroke({
        color: [160, 160, 160, 1.0],
        width: 1
    })
});

const lineStyleBlue = new Style({
    stroke: new Stroke({
        color: [100, 150, 255, 1.0],
        width: 1
    })
});
const lineStyleGreen = new Style({
    stroke: new Stroke({
        color: [100, 255, 150, 1.0],
        width: 1
    })
});
const lineStyleCyan = new Style({
    stroke: new Stroke({
        color: [100, 255, 255, 1.0],
        width: 1
    })
});
const countryStyleWhite = new Style({
    stroke: new Stroke({
        color: [255,255,255,1.0],
        width: 2
    })
});
const countryStyleColor = new Style({
    stroke: new Stroke({
        color: [153,153,102,1.0],
        width: 1
    })
});
// 153,153,102 is #999966

const countryStyleRiverColor = new Style({
    stroke: new Stroke({
        color: [136,136,170,1.0],
        width: 1
    })
});
//  136 136 170  is #8888AA

//   vectorSource json are obtained from ogr2ogr procedure applied to shapefiles 

//   vectorSource names tagged as NE  were derived from shapefiles at source:
//                https://www.naturalearthdata.com/downloads/

    const vectorSourceNE_stateProv = new VectorSource({
            format: new GeoJSON(),
            projection: 'EPSG:4326', 
            url: '../maps/geoJSON/states_prov.json',
            attributions: '<a href="https://www.naturalearthdata.com"> NaturelEarth</a>'
    });

         // style: [countryStyleWhite, lineStyleDarkGrey],
    const vectorLayerNE_stateProv = new VectorLayer({
        source: vectorSourceNE_stateProv,
         style: countryStyleColor,
       zIndex: 98,
      visible: Visible,
      title: 'vectorLayerNE_stateProv',
   });
    const vectorLayerNE_stateProv2 = new VectorLayer({
        source: vectorSourceNE_stateProv,
         style: countryStyleColor,
       zIndex: 98,
      visible: Visible,
      title: 'vectorLayerNE_stateProv',
   });

//   ---------------------------------------------------------
//   Rivers and Lakes   2 sources,  considering the North america extention
//   ---------------------------------------------------------
    const vectorSourceNE_rivers_lake = new VectorSource({
            format: new GeoJSON(),
            projection: 'EPSG:4326', 
            url: '../maps/geoJSON/rivers_lake.json',
      attributions: '<a href="https://www.naturalearthdata.com"> NaturelEarth</a>'
    });

    const vectorLayerNE_rivers_lake = new VectorLayer({
        source: vectorSourceNE_rivers_lake,
         style: countryStyleRiverColor,
      minZoom: 23,
       zIndex: 98,
      visible: Visible,
      title: 'vectorLayerNE_rivers_lake',
   });
    const vectorLayerNE_rivers_lake2 = new VectorLayer({
        source: vectorSourceNE_rivers_lake,
         style: countryStyleRiverColor,
      minZoom: 23,
       zIndex: 98,
      visible: Visible,
      title: 'vectorLayerNE_rivers_lake',
   });

//   North america extention
    const vectorSourceNE_rivers = new VectorSource({
            format: new GeoJSON(),
            projection: 'EPSG:4326', 
            url: '../maps/geoJSON/rivers_NA.json'
    });
    const vectorLayerNE_rivers = new VectorLayer({
        source: vectorSourceNE_rivers,
         style: countryStyleRiverColor,
      minZoom: 23,
       zIndex: 98,
      visible: Visible,
      title: 'vectorLayerNE_rivers',
   });
    const vectorLayerNE_rivers2 = new VectorLayer({
        source: vectorSourceNE_rivers,
         style: countryStyleRiverColor,
      minZoom: 23,
       zIndex: 98,
      visible: Visible,
      title: 'vectorLayerNE_rivers',
   });

//   vectorSource json are obtained from ogr2ogr procedure applied to shapefiles 
//   example:  ogr2ogr -f GeoJSON river_NA.json ne_10m_rivers_north_america_unzip/rivers_NA.shp


//   vectorSource names tagged as CAN?  or USA?  were derived fromi shapefile at source:
//               https://www.geoboundaries.org/api.html#api   
//   attribution:   "geoBoundaries" 'https://www.geoboundaries.org/api.html#api'


//  Canada admin level zero:   better source found  for detailed islands and coastlines 
//                              including st-Laurent river downstream Sorel
    const vectorSourceCAN0         = new VectorSource({
            format: new GeoJSON(),
            projection: 'EPSG:4326', 
            url: '../maps/geoJSON/CAN_ADM0.json',
      attributions: '<a href="https://www.geoboundaries.org/api.html#api"> geoBoudaries</a>'
    });

    const vectorLayerCAN0 = new VectorLayer({
        source: vectorSourceCAN0,
         style: countryStyleColor,
      minZoom: 24,
       zIndex: 98,
      visible: Visible,
      title: 'vectorLayerCAN0',
   });
    const vectorLayerCAN02 = new VectorLayer({
        source: vectorSourceCAN0,
         style: countryStyleColor,
      minZoom: 24,
       zIndex: 98,
      visible: Visible,
      title: 'vectorLayerCAN0',
   });

//  USA admin level zero: 
//                       better source found  for detailed islands and coastlines 
//                       including Great lakes                       
    const vectorSourceUSA0         = new VectorSource({
            format: new GeoJSON(),
            projection: 'EPSG:4326', 
            url: '../maps/geoJSON/USA_ADM0.json',
      attributions: '<a href="https://www.geoboundaries.org/api.html#api"> geoBoudaries</a>'
    });
    const vectorLayerUSA0 = new VectorLayer({
        source: vectorSourceUSA0,
         style: countryStyleColor,
      minZoom: 24,
       zIndex: 98,
      visible: Visible,
      title: 'vectorLayerUSA0',
   });
    const vectorLayerUSA02 = new VectorLayer({
        source: vectorSourceUSA0,
         style: countryStyleColor,
      minZoom: 24,
       zIndex: 98,
      visible: Visible,
      title: 'vectorLayerUSA0',
   });


 Visible = false;

const StandFordContour =  new TileLayer({
      source: new TileWMS({
        url: 'https://geowebservices.stanford.edu/geoserver/wms',
        params: {'LAYERS': 'druid:hz772ng0160', 'TILED': true},
        //projection: 'EPSG:3857',
        projection: projView || 'EPSG:4326' || 'EPSG:3857',
        maxZoom: 10,
        serverType: 'geoserver',
        //  so do not fade tiles:
        transition: 0,
        zIndex: 98,
    attributions: '<a href="https://geowebservices.stanford.edu/geoserver/web/"> Stanford U.</a>',
      }),
      zIndex: 98,
      visible: Visible,
      title: 'StandFordContour',
    });

const StandFordContour2 =  new TileLayer({
      source: new TileWMS({
         url: 'https://geowebservices.stanford.edu/geoserver/wms',
         params: {'LAYERS': 'druid:hz772ng0160', 'TILED': true},
        projection: projView || 'EPSG:4326' || 'EPSG:3857',
        maxZoom: 10,
        serverType: 'geoserver',
        //  so do not fade tiles:
        transition: 0,
        zIndex: 98,
        attributions: '<a href="https://geowebservices.stanford.edu/geoserver/web/"> Stanford U.</a>',
      }),
      zIndex: 98,
      visible: Visible,
      title: 'StandFordContour',
    });
//
//  Top map layers Labels:  geographical references Label to render on top of the weather information
//  in order to provide geographical reference even when the weather information is colored and opaque
//
//   These Labels are paired with Basemaps:  they are not offered in the layer swithcher
//   They are set to visible when their associated basemap is selcted
//   For this to work,   it is important that their titles match with the basemap with the addition of "Labels"

//   comme pour Basemap   remplacer l'URL par Reference  au lieu de Base pour ESRi:

const LightLabels = new TileLayer({
  title: 'LightBasemapLabels',
  zIndex: 100,
  visible: true,
  source: new XYZ({
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
    attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
    zDirection: 1,
  }),
});

const LightLabels2 = new TileLayer({
  title: 'LightBasemapLabels',
  zIndex: 100,
  visible: true,
  source: new XYZ({
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
    attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
    zDirection: 1,
  }),
});

//const LightLabels = new TileLayer({
//      source: new XYZ({
//        url: 'https://{1-4}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png',
//        projection: 'EPSG:3857',
//    zDirection: 1,
//     }),
//     zIndex: 100,
//     visible: true,
//     title: 'LightBasemapLabels',
//  });

const DarkLabels = new TileLayer({
  title: 'DarkBasemapLabels',
  zIndex: 100,
  visible: true,
  source: new XYZ({
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
    attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
    zDirection: 1,
  }),
});

const DarkLabels2 = new TileLayer({
  title: 'DarkBasemapLabels',
  zIndex: 100,
  visible: true,
  source: new XYZ({
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
    attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
    zDirection: 1,
  }),
});

const OSMStandardLabels = new TileLayer({
      source: new XYZ({
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        projection: 'EPSG:3857',
    zDirection: 1,
     }),
     zIndex: 100,
     visible: false,
     title: 'OSMStandardLabels',
  });
const OSMStandardLabels2 = new TileLayer({
      source: new XYZ({
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        projection: 'EPSG:3857',
    zDirection: 1,
     }),
     zIndex: 100,
     visible: false,
     title: 'OSMStandardLabels',
  });

const AhocevarLabels = new TileLayer({
      source: new XYZ({
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        projection: 'EPSG:3857',
    zDirection: 1,
     }),
     zIndex: 100,
     visible: false,
     title: 'AhocevarLabels',
  });
const AhocevarLabels2 = new TileLayer({
      source: new XYZ({
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        projection: 'EPSG:3857',
    zDirection: 1,
     }),
     zIndex: 100,
     visible: false,
     title: 'AhocevarLabels',
  });

// Basemaps layer group

const BaseLayerGroup1 = new LayerGroup({
    layers:[
       LightBasemap, DarkBasemap, OSMStandard, Ahocevar 
    ]
});

const BaseLayerGroup2 = new LayerGroup({
    layers:[
       LightBasemap2, DarkBasemap2, OSMStandard2, Ahocevar2 
    ]
});
// Basemaps overlay layer group 

const BaseOverlayLayerGroup1 = new LayerGroup({
    layers:[
       CanvecHydro, CanvecElevation
    ]
});
const BaseOverlayLayerGroup2 = new LayerGroup({
    layers:[
       CanvecHydro2, CanvecElevation2
    ]
});
//
//  stand alone Top maps layers group
//

const TopLayerGroup1 = new LayerGroup({
    layers:[
      CanvecAdmin, CanvecToponymy, CanvecTransport, vectorLayerNE_stateProv, vectorLayerNE_rivers, vectorLayerNE_rivers_lake, vectorLayerCAN0, vectorLayerUSA0, StandFordContour
    ]
});
const TopLayerGroup2 = new LayerGroup({
    layers:[
      CanvecAdmin2, CanvecToponymy2, CanvecTransport2, vectorLayerNE_stateProv2, vectorLayerNE_rivers2, vectorLayerNE_rivers_lake2, vectorLayerCAN02, vectorLayerUSA02, StandFordContour2
    ]
});
//
//    Top Layer Label group
//
const TopLayerLabelGroup1 = new LayerGroup({
    layers:[
      LightLabels, DarkLabels, OSMStandardLabels, AhocevarLabels
    ]
});
const TopLayerLabelGroup2 = new LayerGroup({
    layers:[
      LightLabels2, DarkLabels2, OSMStandardLabels2, AhocevarLabels2
    ]
});

var ActiveLoadLayers = true;
var LoadExtra = false;

const imageLayers1 = [];
const imageLayers2 = [];
const tileLayers1 = [];
const tileLayers2 = [];
const tileLayersCo1 = [];
const tileLayersCo2 = [];
var NoLimitOfLayers = 2;
var NoOfLayers = 2;
var ii =0;
//var iimin = imageLayers1.length ;
for ( ii = 0 ; ii <= NoLimitOfLayers-1 ; ii++ ) {
   imageLayers2[ii] = new ImageLayer( { zIndex: 11 });
   imageLayers1[ii] = new ImageLayer( { zIndex: 12 });
   tileLayers2[ii] = new TileLayer( { zIndex: 11 });
   tileLayers1[ii] = new TileLayer( { zIndex: 12 });
   tileLayersCo2[ii] = new TileLayer( { zIndex: 13 });
   tileLayersCo1[ii] = new TileLayer( { zIndex: 14 });
}

const imageLayers2Group = new LayerGroup({ 
    layers:[ imageLayers2[0], imageLayers2[1] ]
     });
const imageLayers1Group = new LayerGroup({ 
    layers:[ imageLayers1[0], imageLayers1[1] ]
     });
const tileLayers2Group = new LayerGroup({ 
    layers:[ tileLayers2[0],    tileLayers2[1],
             tileLayersCo2[0], tileLayersCo2[1] ]
     });
const tileLayers1Group = new LayerGroup({ 
    layers:[   tileLayers1[0],   tileLayers1[1],
             tileLayersCo1[0], tileLayersCo1[1] ]
     });

map.addLayer(BaseLayerGroup1);
map.addLayer(BaseOverlayLayerGroup1);
map.addLayer(imageLayers2Group);
map.addLayer(imageLayers1Group);
map.addLayer(tileLayers2Group);
map.addLayer(tileLayers1Group);
map.addLayer(TopLayerGroup1);
map.addLayer(TopLayerLabelGroup1);

map2.addLayer(BaseLayerGroup2);
map2.addLayer(BaseOverlayLayerGroup2);
//map2.addLayer(imageLayers2Group);
map2.addLayer(TopLayerGroup2);
map2.addLayer(TopLayerLabelGroup2);

//   Layer switcher Logic for basemaps  and their associated Top Layers Labels
//

const BaseLayerElements = document.getElementsByName("baseLayerRadioButton");
for ( let BaseLayerElement of BaseLayerElements) {

    BaseLayerElement.addEventListener('change', function(){
                let BaseLayerElementValue = this.value;
                BaseLayerGroup1.getLayers().forEach(function(element, index, array){
                        let BaseLayerTitle = element.get('title');
                console.log(" Base Layer Title: " + BaseLayerTitle + " Base selected radio: " + BaseLayerElementValue);
                        element.setVisible(BaseLayerTitle === BaseLayerElementValue);
                })
                BaseLayerGroup2.getLayers().forEach(function(element, index, array){
                        let BaseLayerTitle2 = element.get('title');
                console.log(" map2 Base Layer Title: " + BaseLayerTitle2 + " Base selected radio: " + BaseLayerElementValue);
                        element.setVisible(BaseLayerTitle2 === BaseLayerElementValue);
                })
        //   the Labels associated to a basemap are added-replicated on top of weatherlayers 
       //    A change in the base layer will also trigger a change to the top label layer. Here is why the values and titles are matched 
       //    The titles of the top label layers are constructed with the same name with the addition of the strind 'Labels'
                let TopLayerElementLabel = BaseLayerElementValue + "Labels";
                TopLayerLabelGroup1.getLayers().forEach(function(element, index, array){
                        let TopLayerLabelTitle = element.get('title');
                    console.log(" Label layer Title: " + TopLayerLabelTitle + " Label associated with base selected: " + TopLayerElementLabel);
                        element.setVisible(TopLayerLabelTitle === TopLayerElementLabel);
                })
                TopLayerLabelGroup2.getLayers().forEach(function(element, index, array){
                        let TopLayerLabelTitle2 = element.get('title');
                    console.log(" map2 Label layer Title: " + TopLayerLabelTitle2 + " Label associated with base selected: " + TopLayerElementLabel);
                        element.setVisible(TopLayerLabelTitle2 === TopLayerElementLabel);
                })
        })
}

//   Layer et Logic for basemaps overlays   and Top Layers overlays having checkbox in the HTML
//

//const LayerElements = document.querySelectorAll('.sidenav > input[type=checkbox]');
const LayerElements = document.getElementsByName("topLayerCheckBox");
for ( let LayerElement of LayerElements) {
    LayerElement.addEventListener('change', function(){
        let LayerElementValue = this.value;
        BaseOverlayLayerGroup1.getLayers().forEach(function(element, index, array){
            let BaseOverlayLayerTitle = element.get('title');
            console.log(" BaseOverlay Layer Title: " + BaseOverlayLayerTitle + " Overlay selected radio: " + LayerElementValue);
            if ( BaseOverlayLayerTitle === LayerElementValue) {
                element.setVisible(  LayerElement.checked ) ;
            }
        })
        BaseOverlayLayerGroup2.getLayers().forEach(function(element, index, array){
            let BaseOverlayLayerTitle2 = element.get('title');
            console.log(" map2 BaseOverlay Layer Title: " + BaseOverlayLayerTitle2 + " Overlay selected radio: " + LayerElementValue);
            if ( BaseOverlayLayerTitle2 === LayerElementValue) {
                element.setVisible(  LayerElement.checked ) ;
            }
        })
        TopLayerGroup1.getLayers().forEach(function(element, index, array){
                        let TopLayerTitle = element.get('title');
                        console.log(" Top Layer Title: " + TopLayerTitle + " Top Layer selected radio: " + LayerElementValue);
                        if ( TopLayerTitle === LayerElementValue) {
                                element.setVisible(  LayerElement.checked ) ;
                        }
        })
        TopLayerGroup2.getLayers().forEach(function(element, index, array){
                        let TopLayerTitle2 = element.get('title');
                        console.log(" map2 Top Layer Title: " + TopLayerTitle2 + " Top Layer selected radio: " + LayerElementValue);
                        if ( TopLayerTitle2 === LayerElementValue) {
                                element.setVisible(  LayerElement.checked ) ;
                        }
        })
    })
}

//   For markers --------------------------------
////modify.on('drag', function(evt) {
  ////const modifiedFeature = evt.features.getArray()[0]; // Get the modified feature
  ////const newCoords = modifiedFeature.getGeometry().getCoordinates(); // Get new coordinates
 ////// Update your logic here to handle the new marker position (e.g., display coordinates, store in database)
  ////console.log('New Marker Position:', newCoords); // Example: log new coordinates to console
//});


let tempoLaLoA = fromLonLat([-73.562, 45.499], projView);
let tempoLaLoB = fromLonLat([-71.208, 46.813], projView);

var StorageLoAId = "longitudeA";
var StorageLaAId = "latitudeA";
var StorageLoBId = "longitudeB";
var StorageLaBId = "latitudeB";

var storageLoA = localStorage.getItem(StorageLoAId)
var storageLaA = localStorage.getItem(StorageLaAId)
var storageLoB = localStorage.getItem(StorageLoBId)
var storageLaB = localStorage.getItem(StorageLaBId)

if (( storageLoA !== null ) && ( storageLaA !== null )) {
   console.log(" valeur de long et lat  en storage du marqueur A sont:", storageLoA, " ", storageLaA );
   tempoLaLoA = fromLonLat([storageLoA, storageLaA], projView);
} 
if (( storageLoB !== null ) && ( storageLaB !== null )) {
   console.log(" valeur de long et lat  en storage du marqueur B sont:", storageLoB, " ", storageLaB );
   tempoLaLoB = fromLonLat([storageLoB, storageLaB], projView);
}
const longitudeInputA = document.getElementById('longitudeA');
const latitudeInputA = document.getElementById('latitudeA');

const longitudeInputB = document.getElementById('longitudeB');
const latitudeInputB = document.getElementById('latitudeB');

const iconFeatureA = new Feature({
  geometry: new Point(tempoLaLoA, projView),
  name: 'Mark A',
});
const iconFeatureB = new Feature({
  geometry: new Point(tempoLaLoB, projView),
  name: 'Mark B',
});

function MiseAJourCoordFromFeature(feature, lonInput, latInput, storageLoId, storageLaId) {
  const geometry = feature.getGeometry();
  const coordinates = geometry.getCoordinates();
  const lonLat = toLonLat(coordinates, projView);
  lonInput.value = lonLat[0].toFixed(3);
  latInput.value = lonLat[1].toFixed(3);
  localStorage.setItem( storageLoId, lonLat[0]);
  localStorage.setItem( storageLaId, lonLat[1]);
}

// Afficher les coordonnées initiales des marqueurs  
MiseAJourCoordFromFeature(iconFeatureA, longitudeInputA, latitudeInputA, StorageLoAId, StorageLaAId);
MiseAJourCoordFromFeature(iconFeatureB, longitudeInputB, latitudeInputB, StorageLoBId, StorageLaBId);

function MiseAJourFeaturesFromInputs() {
  const longitudeA = parseFloat(longitudeInputA.value);
  const latitudeA = parseFloat(latitudeInputA.value);
  const coordonneesA = fromLonLat([longitudeA, latitudeA], projView);
  iconFeatureA.getGeometry().setCoordinates(coordonneesA);
  iconFeatureA2.getGeometry().setCoordinates(coordonneesA);
  localStorage.setItem( StorageLoAId, longitudeA);
  localStorage.setItem( StorageLaAId, latitudeA);

  const longitudeB = parseFloat(longitudeInputB.value);
  const latitudeB = parseFloat(latitudeInputB.value);
  const coordonneesB = fromLonLat([longitudeB, latitudeB], projView);
  iconFeatureB.getGeometry().setCoordinates(coordonneesB);
  iconFeatureB2.getGeometry().setCoordinates(coordonneesB);
  localStorage.setItem( StorageLoBId, longitudeB);
  localStorage.setItem( StorageLaBId, latitudeB);
}
//   MIse en pause des marqueurs:
//   Les marqueurs pourraient etre rendu invisibles mais alors leurs intéractions seraient encore actives
//   et cela pourrait entrainer des confusions, puisque on pourrait les déplacer sans s'en rendre compte. 
//   Les marqueurs pourraient etre retirer et ajouter sur les cartes  au besoin mais
//   il faudrait alors réactiver toutes les intéractions, et synchronisations, ce qui pourrait etre lourd.
//   Par simplicfication: ien mode pause....  on déplace l'icone loin dans l'hémisphère sud  
//   ce qui le fait litérallement disparaitre et empèche les intéractions
//   Les marqueurs sont en mode pause par l'appel suivant,  et ils sont réactivés par l'appel qui précéde...

function MiseEnPauseFeatures() {
  const coordonnees = fromLonLat([0, -84], projView);
  iconFeatureA.getGeometry().setCoordinates(coordonnees);
  iconFeatureB.getGeometry().setCoordinates(coordonnees);
  iconFeatureA2.getGeometry().setCoordinates(coordonnees);
  iconFeatureB2.getGeometry().setCoordinates(coordonnees);
}

function mettreAJourMarqueurA(longitude, latitude) {
  const coordonnees = fromLonLat([longitude, latitude], projView);
  iconFeatureA.getGeometry().setCoordinates(coordonnees);
  localStorage.setItem( StorageLoAId, longitude);
  localStorage.setItem( StorageLaAId, latitude);
}
function mettreAJourMarqueurB(longitude, latitude) {
  const coordonnees = fromLonLat([longitude, latitude], projView);
  iconFeatureB.getGeometry().setCoordinates(coordonnees);
  localStorage.setItem( StorageLoBId, longitude);
  localStorage.setItem( StorageLaBId, latitude);
}

// Mettre à jour les marqueur lorsque les champs de saisie changent
longitudeInputA.addEventListener('change', function() {
  const longitude = parseFloat(longitudeInputA.value);
  const latitude = parseFloat(latitudeInputA.value);
  mettreAJourMarqueurA(longitude, latitude);
});

latitudeInputA.addEventListener('change', function() {
  const longitude = parseFloat(longitudeInputA.value);
  const latitude = parseFloat(latitudeInputA.value);
  mettreAJourMarqueurA(longitude, latitude);
});

longitudeInputB.addEventListener('change', function() {
  const longitude = parseFloat(longitudeInputB.value);
  const latitude = parseFloat(latitudeInputB.value);
  mettreAJourMarqueurB(longitude, latitude);
});

latitudeInputB.addEventListener('change', function() {
  const longitude = parseFloat(longitudeInputB.value);
  const latitude = parseFloat(latitudeInputB.value);
  mettreAJourMarqueurB(longitude, latitude);
});

const iconStyleA = new Style(
       {
         image: new Icon({
              anchor: [0.5, 1],
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction',
              src: '../image_res/location-noir.png',
              width: 20,
              height: 32,
             }),
         zIndex: 102,
});
const iconStyleB = new Style(
       {
         image: new Icon({
              anchor: [0.5, 1],
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction',
              src: '../image_res/location-rouge.png',
              width: 20,
              height: 32,
             }),
         zIndex: 102,
});
iconFeatureA.setStyle(iconStyleA);
iconFeatureB.setStyle(iconStyleB);

const vectorSourceMarkA = new VectorSource({
  features: [iconFeatureA],
});
const vectorSourceMarkB = new VectorSource({
  features: [iconFeatureB],
});

const vectorLayerMarkA = new VectorLayer({
  source: vectorSourceMarkA,
  zIndex: 102,
});
const vectorLayerMarkB = new VectorLayer({
  source: vectorSourceMarkB,
  zIndex: 102,
});
map.addLayer(vectorLayerMarkA);
map.addLayer(vectorLayerMarkB);

const modifyA = new Modify({
  hitDetection: vectorLayerMarkA,
  source: vectorSourceMarkA,
});
const modifyB = new Modify({
  hitDetection: vectorLayerMarkB,
  source: vectorSourceMarkB,
});

const target = document.getElementById('map');

modifyA.on(['modifystart', 'modifyend'], function (evt) {
  target.style.cursor = evt.type === 'modifystart' ? 'grabbing' : 'pointer';
});
modifyB.on(['modifystart', 'modifyend'], function (evt) {
  target.style.cursor = evt.type === 'modifystart' ? 'grabbing' : 'pointer';
});

const overlaySourceMarkA = modifyA.getOverlay().getSource();
const overlaySourceMarkB = modifyB.getOverlay().getSource();

overlaySourceMarkA.on(['addfeature', 'removefeature'], function (evt) {
  target.style.cursor = evt.type === 'addfeature' ? 'pointer' : '';
});
overlaySourceMarkB.on(['addfeature', 'removefeature'], function (evt) {
  target.style.cursor = evt.type === 'addfeature' ? 'pointer' : '';
});

const iconFeatureA2 = iconFeatureA.clone();
const iconFeatureB2 = iconFeatureB.clone();
const vectorSourceMarkA2 = new VectorSource({
  features: [iconFeatureA2],
});
const vectorSourceMarkB2 = new VectorSource({
  features: [iconFeatureB2],
});
const vectorLayerMarkA2 = new VectorLayer({
  source: vectorSourceMarkA2,
  zIndex: 102,
});
const vectorLayerMarkB2 = new VectorLayer({
  source: vectorSourceMarkB2,
  zIndex: 102,
});

map2.addLayer(vectorLayerMarkA2);
map2.addLayer(vectorLayerMarkB2);

const modifyA2 = new Modify({
  hitDetection: vectorLayerMarkA2,
  source: vectorSourceMarkA2,
});
const modifyB2 = new Modify({
  hitDetection: vectorLayerMarkB2,
  source: vectorSourceMarkB2,
});

function syncModifA(evt) {
       iconFeatureA2.setGeometry(iconFeatureA.getGeometry());
       MiseAJourCoordFromFeature(iconFeatureA, longitudeInputA, latitudeInputA, StorageLoAId, StorageLaAId  );
} 
function syncModifA2(evt) {
       iconFeatureA.setGeometry(iconFeatureA2.getGeometry());
       MiseAJourCoordFromFeature(iconFeatureA2, longitudeInputA, latitudeInputA, StorageLoAId, StorageLaAId);
} 
function syncModifB(evt) {
       iconFeatureB2.setGeometry(iconFeatureB.getGeometry());
       MiseAJourCoordFromFeature(iconFeatureB, longitudeInputB, latitudeInputB, StorageLoBId, StorageLaBId);
} 
function syncModifB2(evt) {
       iconFeatureB.setGeometry(iconFeatureB2.getGeometry());
       MiseAJourCoordFromFeature(iconFeatureB2, longitudeInputB, latitudeInputB, StorageLoBId, StorageLaBId);
} 
modifyA.on('modifyend', syncModifA);
modifyB.on('modifyend', syncModifB);

modifyA2.on('modifyend', syncModifA2);
modifyB2.on('modifyend', syncModifB2);

map.addInteraction(modifyA);
map.addInteraction(modifyB);
map2.addInteraction(modifyA2);
map2.addInteraction(modifyB2);

// pour que les coordonnées soient mises à jour sur l'affichage lors du déplacement   FONCTIONNE PAS

///let dernierTemps = Date.now();
///const intervalleCoor = 100; // Intervalle de mise à jour en millisecondes

///function afficherCoordonneesDebounce(evt) {
///  const tempsActuel = Date.now();
///  if (tempsActuel - dernierTemps >= intervalleCoor) {
///    console.log(' déplacement marqueur1 ', tempsActuel, ' ', dernierTemps);
///    if (evt.features.getArray()[0].get('name') === 'Mark A') {
///      afficherCoordonnees(iconFeatureA);
///    } else if (evt.features.getArray()[0].get('name') === 'Mark B') {
///      afficherCoordonnees(iconFeatureB);
///    }
///    dernierTemps = tempsActuel;
///  }
///}

///modifyA.on('modify', afficherCoordonneesDebounce); // Affichage des coordonnées en temps réel
///modifyB.on('modify', afficherCoordonneesDebounce);
///modifyA2.on('modify', afficherCoordonneesDebounce);
///modifyB2.on('modify', afficherCoordonneesDebounce);

// -----------------------------------------------------------------------------------
//   Selector  for view projection
//
const ViewProjSelect = document.getElementById('view-projection');
// ________________________________________________________________________________
function updateViewProjection() {

  if ( ViewProjSelect.value == "Syst.Prev" ) {

  console.log(" Syst.Prev " );
       SetVu( Couche1.getProjection(),  ZoomToViewExtent.get( Couche1.zoomId ), false );

  } else if ( ViewProjSelect.value == "EPSG:3857" ) {

  console.log(" EPSG:3857 " );
       SetVu( getProjection(ViewProjSelect.value), transformExtent( [-180, -80, 180, 80 ], 'EPSG:4326', 'EPSG:3857' ), false );

  } else if ( ViewProjSelect.value == "EPSG:4326" ) {

      console.log(" EPSG:4326 " );
       SetVu( getProjection(ViewProjSelect.value),  [-180, -80, 180, 80 ] , false);

  } else {
         console.log(" Selct proj: ", ViewProjSelect.value );
     SetVu( getProjection(ViewProjSelect.value), getProjection(ViewProjSelect.value).getExtent() , false);
  }
}
// ________________________________________________________________________________
//
function SetVu(proj_, extent_, init) {

    var couche1Centre_ = GetCentre( ZoomToExtent.get( Couche1.zoomId ) )
    var couche1Extent_ = ZoomToExtent.get( Couche1.zoomId );
    var couche1Proj_ = ZoomToProjec.get( Couche1.zoomId )

    if ( couche1Proj_ != 'EPSG:4326' ) {
       couche1Extent_ = transformExtent(couche1Extent_, couche1Proj_, 'EPSG:4326');
       couche1Centre_ = transform(couche1Centre_, couche1Proj_, 'EPSG:4326');
    }

    if ( (Couche2.modeleZoom != "void") && (Couche2.modeleZoom != Couche1.modeleZoom) ) {

       var couche2Centre_ = GetCentre( ZoomToExtent.get( Couche2.zoomId ) )
       var couche2Extent_ = ZoomToExtent.get( Couche2.zoomId );
       var couche2Proj_ = ZoomToProjec.get( Couche2.zoomId )

       if ( couche2Proj_ != 'EPSG:4326' ) {
          couche2Extent_ = transformExtent(couche2Extent_, couche2Proj_, 'EPSG:4326');
          couche2Centre_ = transform(couche1Centre_, couche2Proj_, 'EPSG:4326');
       }
    }

    var centerView_isInside1 = false;
    var centerView_isInside2 = false;
    var coucheIsInsideView = false;

    var zoomInit = 15;
    var zoom_ = zoomInit;
    var centre_ =  couche1Centre_;

    if ( WindMaps ) {
       zoomInit = 24;
       zoom_ = zoomInit;
    }

    let nowcast1=isNowcast(Couche1.modeleZoom) 
    if ( nowcast1 ) {
       zoomInit = 15;
       zoom_ = zoomInit;
    }

    if ( init ) {
             var storageZoom = localStorage.getItem(StorageZoomId);
             var storageProj = localStorage.getItem(StorageProjId);

             const storageCenter = [0, 0];
             storageCenter[0] = localStorage.getItem(StorageCenterIdX);
             storageCenter[1] = localStorage.getItem(StorageCenterIdY);
             if ( storageCenter[0] != null && storageCenter[1] != null && storageProj != null && storageZoom != null ) { 

                 console.log("Proj,  Zoom, Center from storage :", storageProj, storageZoom, storageCenter );
                 centre_ = storageCenter; 
                 if ( storageProj != "EPSG:4326" ) {
                    centre_ = transform( storageCenter, storageProj, "EPSG:4326"); 
                 }
                 zoom_ = storageZoom;
              }
             
    } else {

        let viewZoom_ = map.getView().getZoom();
        let viewCentre_ = map.getView().getCenter();
        let viewExtent_ = map.getView().calculateExtent(map.getSize());
        let viewProj_ = map.getView().getProjection();

        if ( viewProj_ != 'EPSG:4326' ) {
           viewExtent_ = transformExtent(viewExtent_, viewProj_, 'EPSG:4326');
           viewCentre_ = transform(viewCentre_, viewProj_, 'EPSG:4326');
        }

        centre_ = viewCentre_;
        zoom_   = viewZoom_;
        
       centerView_isInside1 = IsLonLatInExtent(centre_[0], centre_[1],  couche1Extent_ );
       console.log("    ExtentCouche 1: " , couche1Extent_,  "centre_: ", centre_) ;
       console.log(" center_isInside 1: ", centerView_isInside1);

       if ( (Couche2.modeleZoom == "void") || (Couche2.modeleZoom == Couche1.modeleZoom) ) {

            if ( !centerView_isInside1 ) {
              centre_ = couche1Centre_;
              zoom_ = zoomInit;
              console.log(" SetVu 1 couche  Outside couche1 ", proj_, " Extent: ", extent_, " Zoom: ", zoom_, " Center: ", centre_ );
            }

       } else {

            centerView_isInside2 = IsLonLatInExtent(centre_[0], centre_[1],  couche2Extent_ );
            console.log("    ExtentCouche2: " , couche2Extent_,  "viewCentre_: ", viewCentre_);
            console.log(" centerView_isInside 2: ",  centerView_isInside2);
            
            if ( !centerView_isInside1 && !centerView_isInside2 ) {
              centre_ = GetCentreDes2( couche1Extent_, couche2Extent_)
              zoom_ = zoomInit;
              console.log(" SetVu centre view  Outside  couche 1 et 2  reset centre to Center: ", centre_ );
            }
            coucheIsInsideView = IsCoucheExtentInExtent( viewExtent_, couche1Extent_);
            console.log("    ExtentCouche 1: " , couche1Extent_,  "view extent", viewExtent_) ;
            console.log(" couche 1 IsInsideView: ", coucheIsInsideView);
            if ( coucheIsInsideView ) {
              coucheIsInsideView = IsCoucheExtentInExtent( viewExtent_, couche2Extent_);
              console.log("    ExtentCouche 2: " , couche2Extent_,  "view extent", viewExtent_) ;
              console.log(" couche 2 IsInsideView: ", coucheIsInsideView);
            }

            if ( !coucheIsInsideView ) {
              centre_ = GetCentreDes2( couche1Extent_, couche2Extent_)
              zoom_ = zoomInit;
              console.log(" SetVu centre view  Outside  couche 1 et 2  seset centre to Center: ", centre_ );
            }
       }
    }

    var center_ = centre_;

    if ( proj_ != "EPSG:4326" ) {
       console.log(" Ici le centre n est pas dans les bonnes  coordonnées ", centre_);
       center_ = transform( centre_, "EPSG:4326", proj_); 
       console.log(" Ici le centre est converti dans ls bonnes coordonnées ", center_);
    }
    
    console.log(" SetVu proj_ ", proj_, " Extent: ", extent_, " Zoom: ", zoom_, " Center: ", center_ );

        const newView = new View({
        projection: proj_,
        zoom: zoom_,
        zoomFactor: 1.26,  // zoomFactor is 2 by default, i.e.  factor 2 at each steps
        extent: extent_,
        center: center_,
        constrainResolution: false,
        showFullExtent: true,
        multiWorld: false,
     });


    if ( !init) { UnsetValeurs("0"); }

    map.setView(newView);

    if ( L_Juxtapo ) { map2.setView(newView); }
    
    if ( !init) { ResetValeurs(); }

}
// ________________________________________________________________________________
// ________________________________________________________________________________
// Handle change event.
//
ViewProjSelect.onchange = function () {
  StopAnimate(); 
  updateViewProjection();
  if ( ActiveLoop  ) {
               StartAnimate();
  } 
};
if ( WindMaps ) {                                                                                                                                       
   document.getElementById("view-projection").style.display = "none";
   document.getElementById("labelViewProjection").style.display = "none";
} 

// ------------------------------------------------------------------------------
//ViewProjSelect.value ="EPSG:3857";
//ViewProjSelect.value ="EPSG:2163";
//updateViewProjection();

//
//---------------------------------------------------------------------------------
//   Weather layers properties  set up and initialisation
// ________________________________________________________________________________
//

function Couche(s_modele, s_modele_zoom,  s_zoomid, s_extent, s_projection, s_mapid_h, s_mapidCo, s_houroid, i_debut, i_fin, i_interval) {
  this.modele= s_modele;
  this.getModele = function() { return this.modele; } ;
  this.modeleZoom= s_modele_zoom;
  this.getModeleZoom = function() { return this.modeleZoom; } ;
  this.zoomId= s_zoomid;
  this.getZoomId = function() { return this.zoomId; } ;
  this.extent= s_extent;
  this.getExtent= function() { return this.extent; } ;
  this.projection= s_projection;
  this.getProjection= function() { return this.projection; };
  this.mapIdH  = s_mapid_h;
  this.getMapIdH= function() { return this.mapIdH; };
  this.mapIdCo = s_mapidCo;
  this.getMapIdCo=function() { return this.mapIdCo; };
  this.hourOId= s_houroid;
  this.getHourOId= function() { return this.hourOId; };
  this.debut= i_debut;
  this.getDebut= function() { return this.debut; };
  this.fin= i_fin;
  this.getFin= function() { return this.fin; };
  this.interval= i_interval;
  this.getInterval= function() { return this.interval; };
  this.getMapId= function() { if ( this.mapIdH.indexOf("_h") != -1) { return this.mapIdH.replace("_h", "_") + Math.round(this.interval/60.) + "h";  }
                  else                                  { return this.mapIdH; }
                  };
};

var Tronc = 'maps';
var ArchivesVerif = false;

const ModADebut = new Map();
ModADebut.set("RDPS", 180);
ModADebut.set("GDPS", 360);
ModADebut.set("GDPSIA", 360);
ModADebut.set("GDPSE", 360);
ModADebut.set("GDPSIAE", 360);
ModADebut.set("GFS", 360);
ModADebut.set("AIFS", 360);
ModADebut.set("AIFSE", 360);
ModADebut.set("ECMWF", 360);
ModADebut.set("ECMWFE", 360);
ModADebut.set("ECMWF3", 180);
ModADebut.set("HRDPS E", 60);
ModADebut.set("HRDPS W", 180);
ModADebut.set("HRDPS S", 60);
ModADebut.set("HRDPS S0", 60);
ModADebut.set("HRDPS S1", 60);
ModADebut.set("HRDPS S2", 60);
ModADebut.set("HRDPS S3", 60);
ModADebut.set("RAQDPS", 180);
ModADebut.set("WCPS", 60);
ModADebut.set("SHOP", 60);
ModADebut.set("RDWPS", 60);
ModADebut.set("DIAGW", 60);
ModADebut.set("CIOPS", 60);
ModADebut.set("GOESR CO", -1440);
ModADebut.set("GOESR GLM", -1440);
ModADebut.set("GOESR_PLUS", -1440);
ModADebut.set("RADAR CO", -1440);
ModADebut.set("RADART CO", -1440);
ModADebut.set("FOUDRE CO", -1440);

const ModAFin = new Map();
ModAFin.set("RDPS", 5040);
ModAFin.set("GDPS", 14400);
ModAFin.set("GDPSIA", 14400);
ModAFin.set("GDPSE", 14400);
ModAFin.set("GDPSIAE", 14400);
ModAFin.set("GFS", 14400);
ModAFin.set("AIFS", 14400);
ModAFin.set("AIFSE", 14400);
ModAFin.set("ECMWF", 14400);
ModAFin.set("ECMWFE", 14400);
ModAFin.set("ECMWF3", 5400);
ModAFin.set("HRDPS E", 2880);
ModAFin.set("HRDPS W", 2880);
ModAFin.set("HRDPS S", 2880);
ModAFin.set("HRDPS S0", 2880);
ModAFin.set("HRDPS S1", 2880);
ModAFin.set("HRDPS S2", 2880);
ModAFin.set("HRDPS S3", 2880);
ModAFin.set("RAQDPS", 4320);
ModAFin.set("CIOPS", 2880);
ModAFin.set("WCPS", 2880);
ModAFin.set("SHOP", 2880);
ModAFin.set("RDWPS", 2880);
ModAFin.set("DIAGW", 2880);
ModAFin.set("GOESR CO", 0);
ModAFin.set("GOESR GLM", 0);
ModAFin.set("GOESR_PLUS", 0);
ModAFin.set("RADAR CO", 0);
ModAFin.set("RADART CO", 0);
ModAFin.set("FOUDRE CO", 0);

const ModAInterv = new Map();
ModAInterv.set("RDPS", 180);
ModAInterv.set("GDPS", 360);
ModAInterv.set("GDPSIA", 360);
ModAInterv.set("GDPSE", 360);
ModAInterv.set("GDPSIAE", 360);
ModAInterv.set("GFS", 360);
ModAInterv.set("AIFS", 360);
ModAInterv.set("AIFSE", 360);
ModAInterv.set("ECMWF", 360);
ModAInterv.set("ECMWFE", 360);
ModAInterv.set("ECMWF3", 180);
ModAInterv.set("HRDPS E", 60);
ModAInterv.set("HRDPS W", 180);
ModAInterv.set("HRDPS S", 60);
ModAInterv.set("HRDPS S0", 60);
ModAInterv.set("HRDPS S1", 60);
ModAInterv.set("HRDPS S2", 60);
ModAInterv.set("HRDPS S3", 60);
ModAInterv.set("RAQDPS", 180);

ModAInterv.set("CIOPS", 60 );
ModAInterv.set("WCPS", 60 );
ModAInterv.set("SHOP", 60 );
ModAInterv.set("RDWPS", 60 );
ModAInterv.set("DIAGW", 60 );
ModAInterv.set("GOESR CO", 5);
ModAInterv.set("GOESR GLM", 5);
ModAInterv.set("GOESR_PLUS", 5);
ModAInterv.set("RADAR CO", 6);
ModAInterv.set("RADART CO", 6);
ModAInterv.set("FOUDRE CO", 5);

const ModAHourOId = new Map();
ModAHourOId.set("RDPS", GuessHourOId("RDPS",-1) );
ModAHourOId.set("GDPS", GuessHourOId("GDPS",-1));
ModAHourOId.set("GDPSIA", GuessHourOId("GDPSIA",-1));
ModAHourOId.set("GDPSE", GuessHourOId("GDPSE",-1));
ModAHourOId.set("GDPSIAE", GuessHourOId("GDPSIAE",-1));
ModAHourOId.set("GFS",  GuessHourOId("GFS",-1));
ModAHourOId.set("AIFS",  GuessHourOId("AIFS",-1));
ModAHourOId.set("AIFSE",  GuessHourOId("AIFSE",-1));
ModAHourOId.set("ECMWF",  GuessHourOId("ECMWF",-1));
ModAHourOId.set("ECMWFE",  GuessHourOId("ECMWFE",-1));
ModAHourOId.set("ECMWF3",  GuessHourOId("ECMWF3",-1));
ModAHourOId.set("HRDPS E", GuessHourOId("HRDPS E",-1));
ModAHourOId.set("HRDPS W", GuessHourOId("HRDPS W",-1));
ModAHourOId.set("HRDPS S", GuessHourOId("HRDPS S",-1));
ModAHourOId.set("HRDPS S0", GuessHourOId("HRDPS S0",-1));
ModAHourOId.set("HRDPS S1", GuessHourOId("HRDPS S1",-1));
ModAHourOId.set("HRDPS S2", GuessHourOId("HRDPS S2",-1));
ModAHourOId.set("HRDPS S3", GuessHourOId("HRDPS S3",-1));
ModAHourOId.set("RAQDPS", GuessHourOId("RAQDPS",-1) );
ModAHourOId.set("WCPS", GuessHourOId("WCPS",-1));
ModAHourOId.set("SHOP", GuessHourOId("SHOP",-1));
ModAHourOId.set("RDWPS", GuessHourOId("RDWPS",-1));
ModAHourOId.set("DIAGW", GuessHourOId("DIAGW",-1));
ModAHourOId.set("CIOPS", GuessHourOId("CIOPS",-1));

ModAHourOId.set("GOESR CO", GuessHourOId("GOESR CO",-1));
ModAHourOId.set("GOESR GLM", GuessHourOId("GOESR GLM",-1));
ModAHourOId.set("GOESR_PLUS", GuessHourOId("GOESR_PLUS",-1));
ModAHourOId.set("FOUDRE CO", GuessHourOId("FOUDRE CO",-1));
ModAHourOId.set("RADAR CO", GuessHourOId("RADAR CO",-1)); 
ModAHourOId.set("RADART CO", GuessHourOId("RADART CO",-1)); 

const ModToId = new Map();
ModToId.set("RDPS", "RDPS");
ModToId.set("GDPS", "GDPS");
ModToId.set("GDPSIA", "GDPSIA");
ModToId.set("GDPSE", "GDPS");
ModToId.set("GDPSIAE", "GDPSIA");
ModToId.set("GFS",  "GFS");
ModToId.set("AIFS",  "AIFS");
ModToId.set("AIFSE",  "AIFS");
ModToId.set("ECMWF",  "ECMWF");
ModToId.set("ECMWFE",  "ECMWF");
ModToId.set("ECMWF3",  "ECMWF3");
ModToId.set("HRDPS E", "HRDPS");
ModToId.set("HRDPS W", "HRDPS");
ModToId.set("HRDPS S", "HRDPS");
ModToId.set("HRDPS S0", "HRDPS");
ModToId.set("HRDPS S1", "HRDPS");
ModToId.set("HRDPS S2", "HRDPS");
ModToId.set("HRDPS S3", "HRDPS");
ModToId.set("RAQDPS", "RAQDPS");
ModToId.set("WCPS", "WCPS");
ModToId.set("SHOP", "SHOP");
ModToId.set("RDWPS", "RDWPS");
ModToId.set("DIAGW", "DIAGW");
ModToId.set("CIOPS", "CIOPS");

ModToId.set("GOESR CO", "GOESR");
ModToId.set("GOESR GLM", "GLM");
ModToId.set("GOESR_PLUS", "GOESR_PLUS");
ModToId.set("FOUDRE CO", "FOUDRE");
ModToId.set("RADAR CO", "RADAR");
ModToId.set("RADART CO", "RADART");

const ModToLyrTyp = new Map();
ModToLyrTyp.set("RDPS", "Tuile");
ModToLyrTyp.set("GDPS", "Tuile");
ModToLyrTyp.set("GDPSIA", "Tuile");
ModToLyrTyp.set("GDPSE", "Tuile");
ModToLyrTyp.set("GDPSIAE", "Tuile");
ModToLyrTyp.set("GFS",  "Tuile");
ModToLyrTyp.set("AIFS",  "Tuile");
ModToLyrTyp.set("AIFSE",  "Tuile");
ModToLyrTyp.set("ECMWF",  "Tuile");
ModToLyrTyp.set("ECMWFE",  "Tuile");
ModToLyrTyp.set("ECMWF3",  "Tuile");
ModToLyrTyp.set("HRDPS E", "Tuile");
ModToLyrTyp.set("HRDPS W", "Image");
ModToLyrTyp.set("HRDPS S", "Image");
ModToLyrTyp.set("HRDPS S0", "Tuile");
ModToLyrTyp.set("HRDPS S1", "Image");
ModToLyrTyp.set("HRDPS S2", "Image");
ModToLyrTyp.set("HRDPS S3", "Image");
ModToLyrTyp.set("RAQDPS", "Tuile");
ModToLyrTyp.set("WCPS", "Tuile");
ModToLyrTyp.set("SHOP", "Tuile");
ModToLyrTyp.set("RDWPS", "Tuile");
ModToLyrTyp.set("DIAGW", "Tuile");
ModToLyrTyp.set("CIOPS", "Tuile");

ModToLyrTyp.set("GOESR CO", "Tuile");
ModToLyrTyp.set("GOESR GLM", "Tuile");
ModToLyrTyp.set("GOESR_PLUS", "Tuile");
ModToLyrTyp.set("FOUDRE CO", "Tuile");
ModToLyrTyp.set("RADAR CO", "Tuile");
ModToLyrTyp.set("RADART CO", "Tuile");

var Resolutions1 = [];
var Resolutions2 = [];
var ResolutionsCo1 = [];
var ResolutionsCo2 = [];

const ModToDimX = new Map();
const ModToDimY = new Map();
//if ( ModToLyrTyp.get("RDPS") != "Image" ) { ModToDimX.set("RDPS", 530); }
//if ( ModToLyrTyp.get("RDPS") != "Image" ) { ModToDimY.set("RDPS", 265); }
//if ( ModToLyrTyp.get("RDPS") != "Image" ) { ModToDimX.set("RDPS", 371); }
//if ( ModToLyrTyp.get("RDPS") != "Image" ) { ModToDimY.set("RDPS", 336); }
if ( ModToLyrTyp.get("RDPS") != "Image" ) { ModToDimX.set("RDPS", 279); }
if ( ModToLyrTyp.get("RDPS") != "Image" ) { ModToDimY.set("RDPS", 252); }

//if ( ModToLyrTyp.get("GDPS") != "Image" ) { ModToDimX.set("GDPS", 432); }
//if ( ModToLyrTyp.get("GDPS") != "Image" ) { ModToDimY.set("GDPS", 216); }
//if ( ModToLyrTyp.get("GDPS") != "Image" ) { ModToDimX.set("GDPS", 354); }
//if ( ModToLyrTyp.get("GDPS") != "Image" ) { ModToDimY.set("GDPS", 264); }
if ( ModToLyrTyp.get("GDPS") != "Image" ) { ModToDimX.set("GDPS", 223); }
if ( ModToLyrTyp.get("GDPS") != "Image" ) { ModToDimY.set("GDPS", 167); }
if ( ModToLyrTyp.get("GDPSIA") != "Image" ) { ModToDimX.set("GDPSIA", 223); }
if ( ModToLyrTyp.get("GDPSIA") != "Image" ) { ModToDimY.set("GDPSIA", 167); }
if ( ModToLyrTyp.get("GDPSE") != "Image" ) { ModToDimX.set("GDPSE", 223); }
if ( ModToLyrTyp.get("GDPSE") != "Image" ) { ModToDimY.set("GDPSE", 167); }
if ( ModToLyrTyp.get("GDPSIAE") != "Image" ) { ModToDimX.set("GDPSIAE", 223); }
if ( ModToLyrTyp.get("GDPSIAE") != "Image" ) { ModToDimY.set("GDPSIAE", 167); }
//if ( ModToLyrTyp.get("GFS") != "Image" ) { ModToDimX.set("GFS", 354); }
//if ( ModToLyrTyp.get("GFS") != "Image" ) { ModToDimY.set("GFS", 264); }
if ( ModToLyrTyp.get("GFS") != "Image" ) { ModToDimX.set("GFS", 166); }
if ( ModToLyrTyp.get("GFS") != "Image" ) { ModToDimY.set("GFS", 124); }
//if ( ModToLyrTyp.get("ECMWF") != "Image" ) { ModToDimX.set("ECMWF", 354); }
//if ( ModToLyrTyp.get("ECMWF") != "Image" ) { ModToDimY.set("ECMWF", 264); }
if ( ModToLyrTyp.get("ECMWF") != "Image" ) { ModToDimX.set("ECMWF", 168); }
if ( ModToLyrTyp.get("ECMWF") != "Image" ) { ModToDimY.set("ECMWF", 125); }
if ( ModToLyrTyp.get("ECMWFE") != "Image" ) { ModToDimX.set("ECMWFE", 168); }
if ( ModToLyrTyp.get("ECMWFE") != "Image" ) { ModToDimY.set("ECMWFE", 125); }
if ( ModToLyrTyp.get("ECMWF3") != "Image" ) { ModToDimX.set("ECMWF3", 168); }
if ( ModToLyrTyp.get("ECMWF3") != "Image" ) { ModToDimY.set("ECMWF3", 125); }
//if ( ModToLyrTyp.get("AIFS") != "Image" ) { ModToDimX.set("AIFS", 354); }
//if ( ModToLyrTyp.get("AIFS") != "Image" ) { ModToDimY.set("AIFS", 264); }
if ( ModToLyrTyp.get("AIFS") != "Image" ) { ModToDimX.set("AIFS", 168); }
if ( ModToLyrTyp.get("AIFS") != "Image" ) { ModToDimY.set("AIFS", 125); }
if ( ModToLyrTyp.get("AIFSE") != "Image" ) { ModToDimX.set("AIFSE", 168); }
if ( ModToLyrTyp.get("AIFSE") != "Image" ) { ModToDimY.set("AIFSE", 125); }

if ( ModToLyrTyp.get("RAQDPS") != "Image" ) { ModToDimX.set("RAQDPS", 280); }
if ( ModToLyrTyp.get("RAQDPS") != "Image" ) { ModToDimY.set("RAQDPS", 255); }
if ( ModToLyrTyp.get("CIOPS") != "Image" ) { ModToDimX.set("CIOPS", 472); }
if ( ModToLyrTyp.get("CIOPS") != "Image" ) { ModToDimY.set("CIOPS", 276); }

if ( ModToLyrTyp.get("HRDPS E") != "Image" ) { ModToDimX.set("HRDPS E", 446); }
if ( ModToLyrTyp.get("HRDPS E") != "Image" ) { ModToDimY.set("HRDPS E", 265); }

if ( ModToLyrTyp.get("HRDPS S0") != "Image" ) { ModToDimX.set("HRDPS S0", 454); }
if ( ModToLyrTyp.get("HRDPS S0") != "Image" ) { ModToDimY.set("HRDPS S0", 259); }

//if ( ModToLyrTyp.get("WCPS") != "Image" ) { ModToDimX.set("WCPS", 474); }
//if ( ModToLyrTyp.get("WCPS") != "Image" ) { ModToDimY.set("WCPS", 277); }
if ( ModToLyrTyp.get("WCPS") != "Image" ) { ModToDimX.set("WCPS", 454); }
if ( ModToLyrTyp.get("WCPS") != "Image" ) { ModToDimY.set("WCPS", 259); }

if ( ModToLyrTyp.get("RDWPS") != "Image" ) { ModToDimX.set("RDWPS", 454); }
if ( ModToLyrTyp.get("RDWPS") != "Image" ) { ModToDimY.set("RDWPS", 259); }
if ( ModToLyrTyp.get("DIAGW") != "Image" ) { ModToDimX.set("DIAGW", 454); }
if ( ModToLyrTyp.get("DIAGW") != "Image" ) { ModToDimY.set("DIAGW", 259); }
//200m sur 3857 => 140m
if ( ModToLyrTyp.get("SHOP") != "Image" ) { ModToDimX.set("SHOP", 627); }
if ( ModToLyrTyp.get("SHOP") != "Image" ) { ModToDimY.set("SHOP", 444); }

if ( ModToLyrTyp.get("GOESR CO") != "Image" ) { ModToDimX.set("GOESR CO", 720); }
if ( ModToLyrTyp.get("GOESR CO") != "Image" ) { ModToDimY.set("GOESR CO", 516); }
if ( ModToLyrTyp.get("GOESR GLM") != "Image" ) { ModToDimX.set("GOESR GLM", 720); }
if ( ModToLyrTyp.get("GOESR GLM") != "Image" ) { ModToDimY.set("GOESR GLM", 516); }
if ( ModToLyrTyp.get("GOESR_PLUS") != "Image" ) { ModToDimX.set("GOESR_PLUS", 720); }
if ( ModToLyrTyp.get("GOESR_PLUS") != "Image" ) { ModToDimY.set("GOESR_PLUS", 516); }
if ( ModToLyrTyp.get("FOUDRE CO") != "Image" ) { ModToDimX.set("FOUDRE CO", 960); }
if ( ModToLyrTyp.get("FOUDRE CO") != "Image" ) { ModToDimY.set("FOUDRE CO", 687); }
if ( ModToLyrTyp.get("RADAR CO") != "Image" ) { ModToDimX.set("RADAR CO", 960); }
if ( ModToLyrTyp.get("RADAR CO") != "Image" ) { ModToDimY.set("RADAR CO", 687); }
if ( ModToLyrTyp.get("RADART CO") != "Image" ) { ModToDimX.set("RADART CO", 960); }
if ( ModToLyrTyp.get("RADART CO") != "Image" ) { ModToDimY.set("RADART CO", 687); }


const ModToZoom = new Map();
ModToZoom.set("RDPS", "NOAMR");
ModToZoom.set("GDPS", "NOAM");
ModToZoom.set("GDPSIA", "NOAM");
ModToZoom.set("GDPSE", "EURO");
ModToZoom.set("GDPSIAE", "EURO");
ModToZoom.set("HRDPS E", "EAST");
ModToZoom.set("HRDPS S0", "SUDQC");
ModToZoom.set("CIOPS", "SUDQC");

ModToZoom.set("GFS",  "NOAM20");
ModToZoom.set("AIFS",  "NOAM20");
ModToZoom.set("AIFSE",  "EURO20");
ModToZoom.set("ECMWF",  "NOAM20");
ModToZoom.set("ECMWFE",  "EURO20");
ModToZoom.set("ECMWF3",  "NOAM20");

ModToZoom.set("HRDPS W", "HRDPSW_PS");
ModToZoom.set("HRDPS S", "HRDPSS_PS");
ModToZoom.set("HRDPS S1", "SUDQC1");
ModToZoom.set("HRDPS S2", "SUDQC2");
ModToZoom.set("HRDPS S3", "SUDQC3");
ModToZoom.set("RAQDPS", "NOAMAQ");

//ModToZoom.set("WCPS", "WCPS3857");
ModToZoom.set("WCPS", "SUDQC");
ModToZoom.set("RDWPS", "SUDQC");
ModToZoom.set("DIAGW", "SUDQC");
ModToZoom.set("SHOP", "SLFE3857");
ModToZoom.set("GOESR CO", "GOESR_LLCO");
ModToZoom.set("GOESR GLM", "GOESR_LLCO");
ModToZoom.set("GOESR_PLUS", "GOESR3857");
ModToZoom.set("FOUDRE CO", "FOUDRE_CO3857");
ModToZoom.set("RADAR CO", "RADAR_LL");
ModToZoom.set("RADART CO", "RADAR_LL");

const ZoomToProjec = new Map();
ZoomToProjec.set( "NOAM", "EPSG:3857");
ZoomToProjec.set( "NOAM20", "EPSG:3857");
ZoomToProjec.set( "EURO", "EPSG:3857");
ZoomToProjec.set( "EURO20", "EPSG:3857");
ZoomToProjec.set( "GDPS_LLW", "EPSG:4326");
ZoomToProjec.set( "GFS_LLW", "EPSG:4326");
ZoomToProjec.set("NOAMR", "EPSG:3857");
ZoomToProjec.set("NOAMAQ", "EPSG:3857");

ZoomToProjec.set("RDPS_PS", "SR-ORG:8237");
ZoomToProjec.set("RDPSS_PS", "SR-ORG:8237");
ZoomToProjec.set("HRDPS_PS", "SR-ORG:9237");
ZoomToProjec.set("HRDPSE_PS", "SR-ORG:9237");
ZoomToProjec.set("HRDPSW_PS", "SR-ORG:9237");
ZoomToProjec.set("HRDPSS_PS", "SR-ORG:9237");

ZoomToProjec.set( "EAST", "EPSG:3857");
ZoomToProjec.set( "WEST", "EPSG:3857");
ZoomToProjec.set("SUDQC", "EPSG:3857");
ZoomToProjec.set("SLFE", "EPSG:3857");
ZoomToProjec.set("SLFE3857", "EPSG:3857");

ZoomToProjec.set("SUDQC1", "EPSG:3857");
ZoomToProjec.set("SUDQC2", "EPSG:3857");
ZoomToProjec.set("SUDQC3", "EPSG:3857");

ZoomToProjec.set("WCPS_LL", "EPSG:4326");
ZoomToProjec.set("WCPS3857", "EPSG:3857");
ZoomToProjec.set("GOESR_LLCO", "EPSG:3857");
ZoomToProjec.set("GOESR3857", "EPSG:3857");
ZoomToProjec.set("FOUDRE_CO3857", "EPSG:3857");

ZoomToProjec.set("RADAR_LL", "EPSG:3857");

function transforme(extent_, zoom_) {
  return transformExtent(extent_, 'EPSG:4326', ZoomToProjec.get(zoom_));
}
const ZoomToExtent = new Map();
//ZoomToExtent.set("NOAM", transforme( [-160.075, 9.925, -39.125, 70.075 ], "NOAM") );
ZoomToExtent.set("NOAM", [-17824430.6699214,  1133170.3990476, -4444430.66992145,  11093170.3990476]);

ZoomToExtent.set("NOAM20", [-17884430.6699214,  1093170.3990476, -4444430.66992145,  11093170.3990476]);

ZoomToExtent.set("EURO",   [-4466091.77472862,  1133170.3990476, 8913908.22527138, 11093170.3990476]);
ZoomToExtent.set("EURO20", [-4526091.77472862,  1093170.3990476, 8913908.22527138, 11093170.3990476]);

ZoomToExtent.set("GDPS_LLW", [-160.075, 10.075, -40.075, 70.075 ] );
ZoomToExtent.set("GFS_LLW",  [-160.125, 10.125, -40.125, 70.125 ] );
//ZoomToExtent.set("NOAMR", transforme( [-145, 25, -45, 75 ], "NOAMR") );
ZoomToExtent.set("NOAMR", [-16169377.0856973, 2852243.11199203, -5009377.08569731, 12932243.111992 ] );
ZoomToExtent.set("NOAMAQ", [-16200000.0, 2800000.0, -5000000.0, 13000000.0 ] );

ZoomToExtent.set("RDPS_PS", [-4556441.403, -7319317.859, 4793558.597 , 920682.141 ] );
ZoomToExtent.set("RDPSS_PS", [-4556441.403, -7319317.859, 4793558.597 , 500682.141 ] );
ZoomToExtent.set("HRDPS_PS", [ -2099127.494, -5739388.521,  4340872.506,-2099388.521 ] );

ZoomToExtent.set("HRDPSE_PS", [ 1120872.506, -5439388.521,  4340872.506,-2099388.521 ] );
ZoomToExtent.set("HRDPSW_PS", [ -2099127.494, -5439388.521,  1120872.506,-2099388.521 ] );
ZoomToExtent.set("HRDPSS_PS", [ 2086872.506, -4839388.521,  3696872.506,-2949388.521 ] );

//ZoomToExtent.set("EAST", transforme( [ -92, 39, -52, 55 ], "EAST") );
ZoomToExtent.set("EAST", [ -10248613.5212502, 4711866.11305119, -5788613.52125023, 7361866.11305119] );
ZoomToExtent.set("WEST", transforme(  [-132, 41, -92, 57 ], "WEST" ) );
//ZoomToExtent.set("SUDQC", transforme( [-78, 43.75, -61, 50.5 ], "SUDQC" ) );
//ZoomToExtent.set("SUDQC",  [-8686488.93838969, 5425321.56783793, -6790488.93838969, 6533321.56783793 ] );
ZoomToExtent.set("SUDQC",  [-8687235.8917887, 5349725.45439731, -6144835.89178879, 6800125.45439731 ] );

ZoomToExtent.set("SLFE",      [-8254764.35552915,  5668637.35442844, -7792364.35552915, 6015837.35442844 ] );
//ZoomToExtent.set("SLFE3857",  transforme( [ -74.5, 45.3, -70, 47.5 ], "SLFE3857" ) );
ZoomToExtent.set("SLFE3857",  [-8293964.355 ,      5668872.119,      -7792364.356,      6024072.119] );

ZoomToExtent.set("SUDQC1", transforme( [-79, 43.5, -72, 47 ], "SUDQC1" ) );
ZoomToExtent.set("SUDQC2", transforme( [-73, 44.75, -67, 49.5 ], "SUDQC2" ) );
ZoomToExtent.set("SUDQC3", transforme( [-68, 44, -61, 50.5 ], "SUDQC3" ) );
ZoomToExtent.set("WCPS_LL", [-94.5042, 38.99583, -67.9958, 53.00417 ] );
ZoomToExtent.set("WCPS3857", transforme( [-94.5042, 38.99583, -67.9958, 53.00417 ], "WCPS3857") );

ZoomToExtent.set("GOESR_LLCO", transforme( [ -110.0555, 22.0215, -58.50, 51.00], "GOESR_LLCO") );
ZoomToExtent.set("GOESR3857", transforme( [ -110.055, 22.0215, -58.50, 51.00], "GOESR3857") );
//ZoomToExtent.set("FOUDRE_CO3857", transforme( [ -110.0555, 22.00, -58.50, 51.00], "FOUDRE_CO3857") );
//ZoomToExtent.set("FOUDRE_CO3857", [ -12251266.5592537, 2511525.23484571, -6512190.2114065, 6621293.72274017] );
//ZoomToExtent.set("FOUDRE_CO3857", [ -12251266.5592537, 2550092.56646875, -6512190.2114065, 6621293.72274017] );
//ZoomToExtent.set("FOUDRE_CO3857", transforme( [ -110.0555, 22.0228361765039, -58.50, 51.00], "FOUDRE_CO3857") );
//ZoomToExtent.set("FOUDRE_CO3857", transforme( [ -110.0555, 22.0228361765039, -58.50, 51.00], "FOUDRE_CO3857") );
ZoomToExtent.set("FOUDRE_CO3857", [ -12251266.5592537,2514267.211312,-6512190.2114065,6621293.72274017]);
ZoomToExtent.set("RADAR_LLNE", [ -81.28, 41.00, -64.00, 50.72] );
//ZoomToExtent.set("RADAR_LLCO", transforme( [ -110.0555, 22.00, -58.50, 51.00], "RADAR_LLCO") );
//ZoomToExtent.set("RADAR_LLCO",  [ -12251328.40, 2511525.23, -6512190.21, 6621293.72]);
//ZoomToExtent.set("RADAR_LLCO",  [ -12251328.40, 2550092.56646875, -6512190.21, 6621293.72]);
ZoomToExtent.set("RADAR_LL",  [ -12251266.5592537,2514267.211312,-6512190.2114065,6621293.72274017]);

function GetCentre(extent_) {
  let centre_ = [ ( (extent_[0] + extent_[2])/2.) , ( (extent_[1] + extent_[3])/2.) ];
  return centre_
}
function GetCentreDes2(extent_1, extent_2) {
  let centre_ = [ ( (extent_1[0]+extent_1[2]+extent_2[0]+extent_2[2])/4.) , ( (extent_1[1]+extent_1[3]+extent_2[1]+extent_2[3])/4.) ];
  return centre_
}

function IsLonLatInExtent(lon_, lat_, extent_) {
  let lonLatIsIn = false;

  if ( lon_ > extent_[0] && lon_ < extent_[2] ) {
     if ( lat_ > extent_[1] && lat_ < extent_[3] ) {
        lonLatIsIn = true; 
     }
  }
  return lonLatIsIn;
}

function IsCoucheExtentInExtent( extent_, coucheExtent_) {

     ///var minlon = extent_[0];
    ///var minlat = extent_[1];
    ///var maxlon = extent_[2]; 
    ///var maxlat = extent_[3]; 

    var coucheExtentIsInExtent_ = false;

    if ( (extent_[0] < coucheExtent_[2]) && (extent_[2] > coucheExtent_[0]) ) {  
       // longitude is ok
       if ( (extent_[1] < coucheExtent_[3]) && (extent_[3] > coucheExtent_[1]) ) {
          // latitude is ok
          coucheExtentIsInExtent_ = true;
       }
    }
    return coucheExtentIsInExtent_;
}

const ZoomToViewExtent = new Map();
ZoomToViewExtent.set("NOAM", transforme( [-180, -10, 180, 80 ], "NOAM") );
ZoomToViewExtent.set("NOAM20", transforme( [-180, -10, 180, 80 ], "NOAM20") );
ZoomToViewExtent.set("EURO", transforme( [-180, -10, 180, 80 ], "EURO") );
ZoomToViewExtent.set("GDPS_LLW", [-165, 5, -35, 75] );
ZoomToViewExtent.set("GFS_LLW",  [-165, 5, -35, 75] );
ZoomToViewExtent.set("NOAMR", transforme( [-180, 10, -20, 80 ], "NOAMR") );
ZoomToViewExtent.set("NOAMAQ", transforme( [-180, 10, -20, 80 ], "NOAMAQ") );

ZoomToViewExtent.set("RDPS_PS", transforme( [-145, 15, -13, 45 ], "RDPS_PS") );
ZoomToViewExtent.set("RDPSS_PS", transforme( [-145, 15, -13, 45 ], "RDPSS_PS") );
ZoomToViewExtent.set("HRDPS_PS", transforme( [-150, 20, -40, 70 ], "HRDPS_PS") );
ZoomToViewExtent.set("HRDPSE_PS", transforme( [-150, 20, -40, 70 ], "HRDPSE_PS") );
ZoomToViewExtent.set("HRDPSS_PS", transforme( [-150, 20, -40, 70 ], "HRDPSS_PS") );
ZoomToViewExtent.set("HRDPSW_PS", transforme( [-150, 20, -40, 70 ], "HRDPSW_PS") );

ZoomToViewExtent.set("EAST", transforme( [ -95, 36, -49, 58 ] , "EAST") );
ZoomToViewExtent.set("WEST", transforme(  [-135, 39, -89, 60 ], "WEST" ) );

ZoomToViewExtent.set("SUDQC", transforme( [-150, 20, -40, 70 ], "SUDQC" ) );
ZoomToViewExtent.set("SUDQC1", transforme( [-80, 41, -58, 53 ], "SUDQC1" ) );
ZoomToViewExtent.set("SUDQC2", transforme( [-80, 41, -58, 53 ], "SUDQC2" ) );
ZoomToViewExtent.set("SUDQC3", transforme( [-80, 41, -58, 53 ], "SUDQC3" ) );
ZoomToViewExtent.set("SLFE", transforme( [-100, 35, -50, 60 ], "SLFE" ) );
ZoomToViewExtent.set("SLFE3857", transforme( [-100, 35, -50, 60 ], "SLFE3857" ) );
ZoomToViewExtent.set("WCPS_LL", [-96, 38, -65, 54 ] );
ZoomToViewExtent.set("WCPS3857", transforme( [-96, 38, -65, 54 ], "WCPS3857") );
ZoomToViewExtent.set("GOESR_LLCO", transforme(  [-185, 10, -30, 70 ], "GOESR_LLCO" ));
ZoomToViewExtent.set("GOESR3857", transforme(  [-185, 10, -30, 70 ], "GOESR3857" ));
ZoomToViewExtent.set("FOUDRE_CO3857", transforme(  [-185, 10, -30, 70 ], "FOUDRE_CO3857" ));
ZoomToViewExtent.set("RADAR_LLNE", [-95, 30, -45, 60 ] );
ZoomToViewExtent.set("RADAR_LL", transforme( [-165, 15, -35, 60 ], "RADAR_LL") );

const ModToMapId = new Map();
ModToMapId.set("RDPS", "PRMSL_");
ModToMapId.set("GDPS", "PRMSL_");
ModToMapId.set("GDPSIA", "PRMSL_");
ModToMapId.set("GDPSE", "PRMSL_");
ModToMapId.set("GDPSIAE", "PRMSL_");
ModToMapId.set("GFS", "PRMSL_");
ModToMapId.set("AIFS", "PRMSL_");
ModToMapId.set("AIFSE", "PRMSL_");
ModToMapId.set("ECMWF", "PRMSL_");
ModToMapId.set("ECMWFE", "PRMSL_");
ModToMapId.set("ECMWF3", "PRMSL_");
ModToMapId.set("HRDPS E", "PRMSL_");
ModToMapId.set("HRDPS W", "PRMSL");
ModToMapId.set("HRDPS S", "PRMSL_");
ModToMapId.set("HRDPS S0", "WDIR_10");
ModToMapId.set("HRDPS S1", "WDIR_10");
ModToMapId.set("HRDPS S2", "WDIR_10");
ModToMapId.set("HRDPS S3", "WDIR_10");
ModToMapId.set("RAQDPS", "PM10_SFC");
ModToMapId.set("WCPS", "IICECONC_");
ModToMapId.set("RDWPS", "HTSGW_Sfc");
ModToMapId.set("DIAGW", "IaG_Sfc");
ModToMapId.set("SHOP", "SOSSHEIG");
ModToMapId.set("CIOPS", "IICECONC_");
ModToMapId.set("GOESR CO", "C13_CO");
ModToMapId.set("GOESR GLM", "GLM_G19");
ModToMapId.set("GOESR_PLUS", "C13_CO");
ModToMapId.set("FOUDRE CO", "FOUDRE_PTS_CO");
ModToMapId.set("RADART CO", "RTYP");
ModToMapId.set("RADAR CO", "RRAI");

const ListModeleId = [];
if ( WindMaps ) {
    ListModeleId[0] = "HRDPS S0"; ListModeleId[ListModeleId.length] = "WCPS"; 
} else {
      ListModeleId[0] = "RDPS"; ListModeleId[ListModeleId.length] = "RAQDPS";      
//  retrait RAQDPS ici
//      ListModeleId[0] = "RDPS"; 
      ListModeleId[ListModeleId.length] = "GDPS";  ListModeleId[ListModeleId.length] = "GFS";
      ListModeleId[ListModeleId.length] = "HRDPS E"; ListModeleId[ListModeleId.length] = "HRDPS S0";
      ListModeleId[ListModeleId.length] = "WCPS";    ListModeleId[ListModeleId.length] = "ECMWF";  
      ListModeleId[ListModeleId.length] = "ECMWF3";  ListModeleId[ListModeleId.length] = "AIFS";
      ListModeleId[ListModeleId.length] = "GOESR CO"; ListModeleId[ListModeleId.length] = "RADAR CO"; 
      ListModeleId[ListModeleId.length] = "RADART CO";
      ////ListModeleId[ListModeleId.length] = "GOESR GLM"; 
      ListModeleId[ListModeleId.length] = "FOUDRE CO"; ListModeleId[ListModeleId.length] = "GOESR_PLUS";
      if ( L_GDPSE ) {  
          ListModeleId[ListModeleId.length] = "GDPSE";   ListModeleId[ListModeleId.length] = "ECMWFE"; 
          ListModeleId[ListModeleId.length] = "AIFSE";
      }
}
      ListModeleId[ListModeleId.length] = "RDWPS";
      ListModeleId[ListModeleId.length] = "DIAGW";
if ( L_SHOP )  {
      ListModeleId[ListModeleId.length] = "SHOP";
}
ListModeleId[ListModeleId.length] = "void";

const ListCartePix = ["WIND"];
      ListCartePix[ListCartePix.length] = "WIN-_10";    
      ListCartePix[ListCartePix.length] = "GUST";    
      ListCartePix[ListCartePix.length] = "1000-500";    
      ListCartePix[ListCartePix.length] = "D-HGT_500";    
      ListCartePix[ListCartePix.length] = "TCDC";    
      ListCartePix[ListCartePix.length] = "WEARN";    
      ListCartePix[ListCartePix.length] = "WEASN";    
      ListCartePix[ListCartePix.length] = "WEAFR";    
      ListCartePix[ListCartePix.length] = "WEAPE";    
      ListCartePix[ListCartePix.length] = "COMPO";    
      ListCartePix[ListCartePix.length] = "APCP_";    
      ListCartePix[ListCartePix.length] = "APCP-_";    
      ListCartePix[ListCartePix.length] = "TMP";    
      ListCartePix[ListCartePix.length] = "DPT";    
      ListCartePix[ListCartePix.length] = "HUDX";    
      ListCartePix[ListCartePix.length] = "CAPE";    
      ListCartePix[ListCartePix.length] = "MU-VT-LI_500";    
      ListCartePix[ListCartePix.length] = "ABSV";    
      ListCartePix[ListCartePix.length] = "C13_CO";    
      ListCartePix[ListCartePix.length] = "C02_CO";    
      ListCartePix[ListCartePix.length] = "RSNO";
      ListCartePix[ListCartePix.length] = "RSNO NET";
      ListCartePix[ListCartePix.length] = "RRAI";
      ListCartePix[ListCartePix.length] = "RRAI NET";
      ListCartePix[ListCartePix.length] = "SNOD_sfc";
      ListCartePix[ListCartePix.length] = "ICECONC";
      ListCartePix[ListCartePix.length] = "VOTEMPER";
      ListCartePix[ListCartePix.length] = "CSPEED_0.5";
      ListCartePix[ListCartePix.length] = "SOSSHEIG";
      ListCartePix[ListCartePix.length] = "PM10_SFC";
      ListCartePix[ListCartePix.length] = "PM10_ATM";
      ListCartePix[ListCartePix.length] = "PM2.5_SFC";
      ListCartePix[ListCartePix.length] = "PM2.5_ATM";


const ListCarteCon = ["WDIR_10"];
      ListCarteCon[ListCarteCon.length] = "PRMSL__WDIR_10";
      ListCarteCon[ListCarteCon.length] = "WDIR_850";
      ListCarteCon[ListCarteCon.length] = "WDIR_250";
      ListCarteCon[ListCarteCon.length] = "PRMSL_";
      ListCarteCon[ListCarteCon.length] = "HGT_1000";
      ListCarteCon[ListCarteCon.length] = "HGT_850";
      ListCarteCon[ListCarteCon.length] = "HGT_700";
      ListCarteCon[ListCarteCon.length] = "HGT_500";
      ListCarteCon[ListCarteCon.length] = "HGT_250";
      ListCarteCon[ListCarteCon.length] = "FOUDRE_PTS_CO";
      ListCarteCon[ListCarteCon.length] = "CDIR_0.5";
      ListCarteCon[ListCarteCon.length] = "CDIR_Avg";
      ListCarteCon[ListCarteCon.length] = "PWAVEDIR_Sfc";
      ListCarteCon[ListCarteCon.length] = "WVDIR_Sfc";
      ListCarteCon[ListCarteCon.length] = "H1DIR_Sfc";
      ListCarteCon[ListCarteCon.length] = "H2DIR_Sfc";
      ListCarteCon[ListCarteCon.length] = "MWDFSWEL_Sfc";
      ListCarteCon[ListCarteCon.length] = "MWDSSWEL_Sfc";
      ListCarteCon[ListCarteCon.length] = "IaDir_Sfc";
      ListCarteCon[ListCarteCon.length] = "Ia2Dir_Sfc";

var Warning_ECMWF_TYPES = "";
var INFO_version = "";

var Model1_Def ="";
var Model2_Def ="";

var Model1 ;
var Model2 ;
var MapIdH2; 
var MapIdH1;
var MapIdCo2; 
var MapIdCo1;

if ( WindMaps ) {
     Model2_Def = "HRDPS S0";
     Model1_Def = "HRDPS S0";
     Model1 = localStorage.getItem("Model1_V");
     Model2 = localStorage.getItem("Model2_V");
     MapIdH2= localStorage.getItem("MapIdH2_V");
     MapIdH1= localStorage.getItem("MapIdH1_V");
     MapIdCo2= localStorage.getItem("MapIdCo2_V");
     MapIdCo1= localStorage.getItem("MapIdCo1_V");
     INFO_version = localStorage.getItem("INFO_version");
     console.log(" WindMaps mode local Model1: " + Model1  + " Model2: " + Model2);
     console.log(" WindMaps mode local maps MapIdH1: " + MapIdH1 + " MapIdH2: " + MapIdH2);
     console.log(" WindMaps mode local maps MapIdCo1: " + MapIdCo1 + " MapIdCo2: " + MapIdCo2);
     console.log(" Nowcast mode INFO_version: ", INFO_version );
} else if (Nowcast) {
     Model1_Def ="RADAR CO";
     Model2_Def ="GOESR CO";
     Model1 = localStorage.getItem("Model1_N");
     Model2 = localStorage.getItem("Model2_N");
     MapIdH2= localStorage.getItem("MapIdH2_N");
     MapIdH1= localStorage.getItem("MapIdH1_N");
     MapIdCo2= localStorage.getItem("MapIdCo2_N");
     MapIdCo1= localStorage.getItem("MapIdCo1_N");
     INFO_version = localStorage.getItem("INFO_version");
     console.log(" Nowcast mode local Model1: " + Model1  + " Model2: " + Model2);
     console.log(" Nowcast mode local maps MapIdH1: " + MapIdH1 + " MapIdH2: " + MapIdH2);
     console.log(" Nowcast mode local maps MapIdCo1: " + MapIdCo1 + " MapIdCo2: " + MapIdCo2);
     console.log(" Nowcast mode INFO_version: ", INFO_version );
} else {
     Model1_Def ="RDPS";
     Model2_Def ="RDPS";
     Model1 = localStorage.getItem("Model1");
     Model2 = localStorage.getItem("Model2");
     MapIdH2= localStorage.getItem("MapIdH2");
     MapIdH1= localStorage.getItem("MapIdH1");
     MapIdCo2= localStorage.getItem("MapIdCo2");
     MapIdCo1= localStorage.getItem("MapIdCo1");
     Warning_ECMWF_TYPES = localStorage.getItem("Warning_ECMWF_TYPES");
     INFO_version = localStorage.getItem("INFO_version");
     console.log(" Prog mode local Model1: " + Model1  + " Model2: " + Model2)
     console.log(" Prog mode local maps MapIdH1: " + MapIdH1 + " MapIdH2: " + MapIdH2)
     console.log(" Prog mode local maps MapIdCo1: " + MapIdCo1 + " MapIdCo2: " + MapIdCo2)
     console.log(" Prog mode local Warning ECMWF: ", Warning_ECMWF_TYPES )
     console.log(" Prog mode INFO_version: ", INFO_version )
}
function supprimerAvantVersion(chaine) {
  if  ( ( chaine === undefined ) || ( chaine === null ) ) {
     chaine = " ";
  }
  const index = chaine.indexOf("Version ");
  if (index !== -1) {
    return chaine.substring(index + "Version ".length);
  }
  return chaine; // Retourne la chaîne originale si "Version " n'est pas trouvé
}

//   Backward compatibility with previous versions including de string Version_   at the begining...

INFO_version = supprimerAvantVersion(INFO_version);

var Couche2Void = false;
var Model2localVoid = false;
var Couche1CoVoid = false;
var Couche2CoVoid = false;

var foundModel = false;
for (let i = 0; i < ListModeleId.length-1; i++) {
           if ( Model1 == ListModeleId[i] ) {
              foundModel = true; 
           }
}
if ( !foundModel ) { Model1 = Model1_Def; }

foundModel = false;
for (let i = 0; i < ListModeleId.length; i++) {
           if ( Model2 == ListModeleId[i] ) {
              foundModel = true; 
           }
}
if ( !foundModel ) { Model2 = Model2_Def; }

if ( ( MapIdH1 === undefined ) || ( MapIdH1 === null ) ) {
  MapIdH1= ModToMapId.get(Model1);
}
if ( MapIdCo1 == null ) { Couche1CoVoid = true; MapIdCo1 = "void"; }

if ( Model2 == "void" ) {
    MapIdH2= MapIdH1;
    MapIdCo2= MapIdCo1;
    Model2localVoid = true;
    Couche2Void = true;
} else {

    if ( ( MapIdH2 === undefined ) || ( MapIdH2 === null ) ) {
    MapIdH2= ModToMapId.get(Model2);
    }
    if ( MapIdCo2 == null ) { Couche2CoVoid = true; MapIdCo2 = "void"; }
}
var Opacitee1 = 1.0;
var Opacitee2 = 1.0;
var Smooting = true;
var SmootingA = true;

var Mod1Id = ModToId.get(Model1);
var Mod2Id = ModToId.get(Model2);

if ( WindMaps ) {
     Opacitee1 = 1.0;
     Opacitee2 = 1.0;
}

//
let CountTiles1=[];
let CountTiles2=[];

//MapIdH2="WDIR_10_";
//MapIdH1="WIN-_10_";

const Couche2 = new Couche( Mod2Id, Model2, ModToZoom.get(Model2), ZoomToExtent.get(ModToZoom.get(Model2)), ZoomToProjec.get(ModToZoom.get(Model2)),  
            MapIdH2, MapIdCo2, ModAHourOId.get(Model2), ModADebut.get(Model2), ModAFin.get(Model2), ModAInterv.get(Model2) );

const Couche1 = new Couche( Mod1Id, Model1, ModToZoom.get(Model1), ZoomToExtent.get(ModToZoom.get(Model1)), ZoomToProjec.get(ModToZoom.get(Model1)), 
            MapIdH1, MapIdCo1, ModAHourOId.get(Model1), ModADebut.get(Model1), ModAFin.get(Model1), ModAInterv.get(Model1) );

var ResetModeleDefaults = false;

//      'TO_PRMSL__COMPO__3h_2021091412_' + nHour + '.png',
//      'TO_WIN-_10_2021091412_' + nHour + '.png',
//      'TO_WDIR_10_2021091412_' + nHour + '.png',
//      'TO_PRMSL__2021091506_' + nHour + '.png',

// -------------------------------------------------------------------
//
//showLgnd(1);
//showLgnd(2);
//------------------------------------------------------------------
// ---  checking for valid Houroid
var VerboseHourOIdOk = true;
var indexListHourOIdOk = 0;

var SetMenuHourOIdRun1 = false;
var SetMenuHourOIdRun2 = false;
readSetLatestHourOId(ModAHourOId.get(Model1), Model1, false, true);
readSetLatestHourOId(ModAHourOId.get(Model2), Model2, false, true);


//------------------------------------------------------------------------
//const LoadedAndReady = [false, false, false];

// ________________________________________________________________________________

function SetAttribution( mod2Id, icouche) {

let attributionECCC = ' <a href="https://eccc-msc.github.io/open-data/">ECCC</a>';
let attributionECMWF = ' <a href="https://www.ecmwf.int">ECMWF</a> <a href="https://creativecommons.org/licenses/by/4.0/">©</a>' ;
let attributionNCEP = ' <a href="https://www.ncei.noaa.gov/products/weather-climate-models/global-forecast">NOAA</a>';
let attributionGOES = ' <a href="https://thredds.ucar.edu/thredds/catalog/catalog.html">GOES via UNIDATA</a>';
let attributionFOUDRE = ' <a href="https://www.blitzortung.org/en/live_lightning_maps.php">Foudre via Blitzortung</a>';

let attributionDebut = " Sources météo: ";
let attribution = "";

if ( ( mod2Id == "RDPS" ) || ( mod2Id == "GDPS" ) || ( mod2Id == "GDPSIA" ) || ( mod2Id == "GDPSE" ) || ( mod2Id == "HRDPS" ) || ( mod2Id == "WCPS" ) 
  || ( mod2Id == "SHOP" ) || ( mod2Id == "RDWPS" ) || ( mod2Id == "DIAGW" ) || ( mod2Id == "RAQDPS" ) || ( mod2Id == "GDPSIAE" ) ) {
   attribution = attributionDebut + attributionECCC;
} else if ( mod2Id == "GFS" ) {
   attribution = attributionDebut + attributionNCEP;
} else if (( mod2Id == "ECMWF" ) || ( mod2Id == "ECMWFE" ) ||( mod2Id == "ECMWF3" ) || ( mod2Id == "AIFS" ) || ( mod2Id == "AIFSE" ) ) {
   attribution = attributionDebut + attributionECMWF;
} else if ( mod2Id == "RADAR" )  {
   attribution = attributionDebut + attributionECCC;
} else if ( mod2Id == "GOESR" || ( mod2Id == "GOESR_PLUS" ) || ( mod2Id == "GLM" ) ) {
   attribution = attributionDebut + attributionGOES;
} else if ( mod2Id == "FOUDRE" ) {
   attribution = attributionDebut + attributionFOUDRE;
} else {
   attribution = attributionDebut + " Non identifiée...";
}

attribution = attribution + " préparé par Imeteo. Overlay: ";

  return attribution
}
// ________________________________________________________________________________

//-----------------------------------------------------------------------------------

var AttributionMeteo1 = SetAttribution(Couche1.modele, "1");
var AttributionMeteo2 = SetAttribution(Couche2.modele, "2");

// ________________________________________________________________________________
function calculResolutions( tileDimX, tileDimY, projExtent, resolution, number) {

       // Calcul la rsolution des mozaic pour les zoom 
       // la longueur de resolutions   detremine le nombre de zoom de la couche           

     let startResolution = getWidth(projExtent) / tileDimX;

     for (let i = 0, ii = (number+1) ; i < ii; ++i) {
              resolution[i] = startResolution / Math.pow(2, i);
     }
     return resolution
}

// ________________________________________________________________________________
function updateSource(istep, i_couche) {

      var index = istep % NoOfLayers;
      var message;

    if ( i_couche == "1" ) {

        ISTEP_ecout1 = istep;

        message="updateSource Url change for layer no:" + i_couche.toString() + ' step:' + istep + ' index:' + index  ;
        console.log(message);

         if ( tileSource1[index] == null ) { 

            console.log("Warning: Refresh could not be made for layer 1. Will resetSource 1");
            resetSource(listUrlCo1[istep], listUrl1[istep], istep, Couche1, i_couche)

         } else if ( !Couche1CoVoid && tileSourceCo1[index] == null ) {

            console.log("Warning: Refresh could not be made for colayer 1. Will resetSource 1");
            resetSource(listUrlCo1[istep], listUrl1[istep], istep, Couche1, i_couche)

         } else { 
             var urlTuile = listUrl1[istep] + '/{z}/{x}/{y}.png';
             console.log("Refresh will be made for main layer 1 URL: " + listUrl1[istep]);

             for ( let indice = index; indice <= ISTEP_max; indice=indice+NoOfLayers ) {
                  listLoaded1[indice] = "non"; 
                  listNuLoadStart1[indice] = 0;
                  listNuLoadEnd1[indice] = 0;
                  listNuLoadErr1[indice] = 0;
                  listNuWait1[indice] = 0;
              }
              listLoaded1[istep] = "loading";
 
              tileSource1[index].setUrl(urlTuile);
              tileSource1[index].refresh();
              tileLayers1[index].setOpacity(0.0);

              if ( !Couche1CoVoid ) {

                urlTuile = listUrlCo1[istep] + '/{z}/{x}/{y}.png';
                console.log("Refresh will be made for co layer 1 URL: " + listUrlCo1[istep]);

                for ( let indice = index; indice <= ISTEP_max; indice=indice+NoOfLayers ) {
                    listLoadedCo1[indice] = "non"; 
                    listNuLoadStartCo1[indice] = 0;
                    listNuLoadEndCo1[indice] = 0;
                    listNuLoadErrCo1[indice] = 0;
                    listNuWaitCo1[indice] = 0;
                }
                listLoadedCo1[istep] = "loading";
                           
                tileSourceCo1[index].setUrl(urlTuile);
                tileSourceCo1[index].refresh();
                tileLayersCo1[index].setOpacity(0.0);
             } 
        }
    } else if ( ( i_couche == "2" ) && !Couche2Void ) { 

        ISTEP_ecout2 = istep;

        message="updateSource Url change for layer no:" + i_couche.toString() + ' step:' + istep + ' index:' + index  ;
        console.log(message);

         if ( tileSource2[index] == null ) { 

            console.log("Warning: Refresh could not be made for layer 2. Will resetSource 2");
            resetSource(listUrlCo2[istep], listUrl2[istep], istep, Couche2, i_couche)

         } else if ( !Couche2CoVoid && tileSourceCo2[index] == null ) {

            console.log("Warning: Refresh could not be made for layer 2. Will resetSource 2");
            resetSource(listUrlCo2[istep], listUrl2[istep], istep, Couche2, i_couche)

         } else { 
             var urlTuile = listUrl2[istep] + '/{z}/{x}/{y}.png';
             console.log("Refresh will be made for main layer 2 URL: " + listUrl2[istep]);

             for ( let indice = index; indice <= ISTEP_max; indice=indice+NoOfLayers ) {
                  listLoaded2[indice] = "non"; 
                  listNuLoadStart2[indice] = 0;
                  listNuLoadEnd2[indice] = 0;
                  listNuLoadErr2[indice] = 0;
                  listNuWait2[indice] = 0;
              }
              listLoaded2[istep] = "loading";
 
              tileSource2[index].setUrl(urlTuile);
              tileSource2[index].refresh();
              tileLayers2[index].setOpacity(0.0);

              if ( !Couche2CoVoid ) {

                urlTuile = listUrlCo2[istep] + '/{z}/{x}/{y}.png';
                console.log("Refresh will be made for co layer 2 URL: " + listUrlCo2[istep]);

                for ( let indice = index; indice <= ISTEP_max; indice=indice+NoOfLayers ) {
                    listLoadedCo2[indice] = "non"; 
                    listNuLoadStartCo2[indice] = 0;
                    listNuLoadEndCo2[indice] = 0;
                    listNuLoadErrCo2[indice] = 0;
                    listNuWaitCo2[indice] = 0;
                }
                listLoadedCo2[istep] = "loading";
                           
                tileSourceCo2[index].setUrl(urlTuile);
                tileSourceCo2[index].refresh();
                tileLayersCo2[index].setOpacity(0.0);
             } 
        }
    } 
}
// ________________________________________________________________________________
/**
 * Configure les écouteurs d'événements de chargement de tuiles pour une source donnée
 * et initialise les listes de suivi des chargements.
 * ...
 */
function setupTileLoadingEvents(
    source,
    listLoaded,
    listNuLoadStart,
    listNuLoadEnd,
    listNuLoadErr,
    listNuWait,
    layerName,
    index
) {
    // 1. Détacher les écouteurs précédents (s'ils existent)
    // C'est CRUCIAL si cette fonction est appelée à plusieurs reprises pour la MÊME SOURCE
    // (par exemple, si tu réinitialises la configuration d'une source existante).
    if (source._customTileLoadStartHandler) {
        source.un('tileloadstart', source._customTileLoadStartHandler);
    }
    if (source._customTileLoadEndHandler) {
        source.un('tileloadend', source._customTileLoadEndHandler);
    }
    if (source._customTileLoadErrorHandler) {
        source.un('tileloaderror', source._customTileLoadErrorHandler);
    }

    // 2. Initialisation des listes (logique inchangée)
    // ...

    // 3. Définition des nouveaux handlers et stockage de leur référence sur la source
    source._customTileLoadStartHandler = function () {
        const nHour = forecastTimes[currentForecastIndex];
        const message = `tileload start fired for ${layerName} for hour: ${nHour}`;
        // console.log(message);
        if (currentForecastIndex !== -1 && currentForecastIndex < listNuLoadStart.length) {
            listNuLoadStart[currentForecastIndex]++;
        }
    };
    source.on('tileloadstart', source._customTileLoadStartHandler);


    source._customTileLoadEndHandler = function () {
        const nHour = forecastTimes[currentForecastIndex];
        const message = `tileload end fired for ${layerName} for hour: ${nHour}`;
        // console.log(message);
        if (currentForecastIndex !== -1 && currentForecastIndex < listNuLoadEnd.length) {
            listNuLoadEnd[currentForecastIndex]++;
        }
    };
    source.on('tileloadend', source._customTileLoadEndHandler);


    source._customTileLoadErrorHandler = function () {
        const nHour = forecastTimes[currentForecastIndex];
        const message = `tileload error fired for ${layerName} for hour: ${nHour}`;
        console.log(message);
        if (currentForecastIndex !== -1 && currentForecastIndex < listNuLoadErr.length) {
            listNuLoadErr[currentForecastIndex]++;
        }
    };
    source.on('tileloaderror', source._customTileLoadErrorHandler);
}

function setEcouteursSource(sourceTile, i_couche, coucheCo) {

   if ( i_couche == "1" && coucheCo == "mainLayer" ) {
            sourceTile.on('tileloadstart', ecouteStart1);
            sourceTile.on('tileloadend', ecouteEnd1); 
            sourceTile.on('tileloaderror', ecouteErr1); 
   } else if ( i_couche == "1" && coucheCo == "coLayer" ) {
            sourceTile.on('tileloadstart', ecouteStartCo1);
            sourceTile.on('tileloadend', ecouteEndCo1); 
            sourceTile.on('tileloaderror', ecouteErrCo1); 
   } else if ( i_couche == "2" && coucheCo == "mainLayer" ) {
            sourceTile.on('tileloadstart',  ecouteStart2);
            sourceTile.on('tileloadend', ecouteEnd2); 
            sourceTile.on('tileloaderror', ecouteErr2); 
   } else if ( i_couche == "2" && coucheCo == "coLayer" ) {
            sourceTile.on('tileloadstart', ecouteStartCo2);
            sourceTile.on('tileloadend', ecouteEndCo2); 
            sourceTile.on('tileloaderror', ecouteErrCo2); 
   }
}
function unsetEcouteursSource(sourceTile, i_couche, coucheCo) {

   if ( i_couche == "1" && coucheCo == "mainLayer" ) {
            sourceTile.un('tileloadstart', ecouteStart1);
            sourceTile.un('tileloadend', ecouteEnd1); 
            sourceTile.un('tileloaderror', ecouteErr1); 
   } else if ( i_couche == "1" && coucheCo == "coLayer" ) {
            sourceTile.un('tileloadstart', ecouteStartCo1);
            sourceTile.un('tileloadend', ecouteEndCo1); 
            sourceTile.un('tileloaderror', ecouteErrCo1); 
   } else if ( i_couche == "2" && coucheCo == "mainLayer" ) {
            sourceTile.un('tileloadstart',  ecouteStart2);
            sourceTile.un('tileloadend', ecouteEnd2); 
            sourceTile.un('tileloaderror', ecouteErr2); 
   } else if ( i_couche == "2" && coucheCo == "coLayer" ) {
            sourceTile.un('tileloadstart', ecouteStartCo2);
            sourceTile.un('tileloadend', ecouteEndCo2); 
            sourceTile.un('tileloaderror', ecouteErrCo2); 
   }
}

// ________________________________________________________________________________
function ecouteStart1() {
              listNuLoadStart1[ISTEP_ecout1] = listNuLoadStart1[ISTEP_ecout1] + 1;
              var message=" Ecouteur 1 START main 1: " + listNuLoadStart1[ISTEP_ecout1] +  " for step: " + ISTEP_ecout1; // console.log(message);
              if ( listNuLoadStart1[ISTEP_ecout1] == 1 ) { console.log(message); }
}
function ecouteEnd1() {
              listNuLoadEnd1[ISTEP_ecout1] = listNuLoadEnd1[ISTEP_ecout1] + 1;
              var message=" Ecouteur 1 END main 1: " + listNuLoadEnd1[ISTEP_ecout1] +  " for step: " + ISTEP_ecout1; // console.log(message);
              if ( listNuLoadEnd1[ISTEP_ecout1] >= listNuLoadStart1[ISTEP_ecout1] ) { console.log(message); }
}
function ecouteErr1() {
              listNuLoadErr1[ISTEP_ecout1] = listNuLoadErr1[ISTEP_ecout1] + 1;
              var message=" Ecouteur 1 ERROR main 1: " + listNuLoadErr1[ISTEP_ecout1] +  " for step: " + ISTEP_ecout1;  console.log(message);
}
function ecouteStartCo1() {
              listNuLoadStartCo1[ISTEP_ecout1] = listNuLoadStartCo1[ISTEP_ecout1] + 1;
              var message=" Ecouteur 1 START co1: " + listNuLoadStartCo1[ISTEP_ecout1] + " for step: " + ISTEP_ecout1; // console.log(message);
              if ( listNuLoadStartCo1[ISTEP_ecout1] == 1 ) { console.log(message); }
}
function ecouteEndCo1() {
              listNuLoadEndCo1[ISTEP_ecout1] = listNuLoadEndCo1[ISTEP_ecout1] + 1;
              var message=" Ecouteur 1 END co1: " + listNuLoadEndCo1[ISTEP_ecout1] +  " for step: " + ISTEP_ecout1; //  console.log(message);
              message = " Ecouteur 1 END main co1: " + listNuLoadEndCo1[ISTEP_ecout1] +  " for step: " + ISTEP_ecout1;
              if ( listNuLoadEndCo1[ISTEP_ecout1] >= listNuLoadStartCo1[ISTEP_ecout1] ) { console.log(message); }
}
function ecouteErrCo1() {
              listNuLoadErrCo1[ISTEP_ecout1] = listNuLoadErrCo1[ISTEP_ecout1] + 1;
              var message=" Ecouteur 1 ERROR co1: " + listNuLoadErrCo1[ISTEP_ecout1] + " for step: " + ISTEP_ecout1;  console.log(message);
}
function ecouteStart2() {
              listNuLoadStart2[ISTEP_ecout2] = listNuLoadStart2[ISTEP_ecout2] + 1;
              var message=" Ecouteur 2 start main 2: " + listNuLoadStart2[ISTEP_ecout2] + " for step: " + ISTEP_ecout2;//  console.log(message);
              if ( listNuLoadStart2[ISTEP_ecout2] == 1 ) { console.log(message); }
}
function ecouteEnd2() {
              listNuLoadEnd2[ISTEP_ecout2] = listNuLoadEnd2[ISTEP_ecout2] + 1;
              var message=" Ecouteur 2 END main 2: " + listNuLoadEnd2[ISTEP_ecout2] + " for step: " + ISTEP_ecout2;// console.log(message);
              message = " Ecouteur 2 END main 2: " + listNuLoadEnd2[ISTEP_ecout2] +  " for step: " + ISTEP_ecout2;
              if ( listNuLoadEnd2[ISTEP_ecout2] >= listNuLoadStart2[ISTEP_ecout2] ) { console.log(message); }
}
function ecouteErr2() {
              listNuLoadErr2[ISTEP_ecout2] = listNuLoadErr2[ISTEP_ecout2] + 1;
              var message=" Ecouteur 2 ERROR main 2: " + listNuLoadErr2[ISTEP_ecout2] + " for step: " + ISTEP_ecout2;  console.log(message);
}
function ecouteStartCo2() {
              listNuLoadStartCo2[ISTEP_ecout2] = listNuLoadStartCo2[ISTEP_ecout2] + 1;
              var message=" Ecouteur 2 start Co2: " + listNuLoadStartCo2[ISTEP_ecout2] + " for step: " + ISTEP_ecout2;//  console.log(message);
              if ( listNuLoadStartCo2[ISTEP_ecout2] == 1 ) { console.log(message); }
}
function ecouteEndCo2() {
              listNuLoadEndCo2[ISTEP_ecout2] = listNuLoadEndCo2[ISTEP_ecout2] + 1;
              var message=" Ecouteur 2 END Co2: " + listNuLoadEndCo2[ISTEP_ecout2] + " for step: " + ISTEP_ecout2; // console.log(message);
              message = " Ecouteur 2 END main co2: " + listNuLoadEndCo2[ISTEP_ecout2] +  " for step: " + ISTEP_ecout2;
              if ( listNuLoadEndCo2[ISTEP_ecout2] >= listNuLoadStartCo2[ISTEP_ecout2] ) { console.log(message); }
}
function ecouteErrCo2() {
              listNuLoadErrCo2[ISTEP_ecout2] = listNuLoadErrCo2[ISTEP_ecout2] + 1;
              var message=" Ecouteur 2 ERROR Co2: " + listNuLoadErrCo2[ISTEP_ecout2] + " for step: " + ISTEP_ecout2;  console.log(message);
}

//   TileLoadFunction series C   from the following source:
//   https://gis.stackexchange.com/questions/466467/retrying-failed-xyz-tile-load-in-openlayers
//   
       async function myTileLoadFunctionC1(tile, src)  {
//      retry codes for tileloadfunction...
///                 https://neilpatel.com/blog/http-response-codes/
//      code 404 for missing file will be catch explicitely in the tileLoadFunction
//      the others in the following list will trigger a retry

       const retryCodes = [408, 429, 500, 502, 503, 504];
         const image = tile.getImage();
         let response;
         let attempts = 0;
         let valid = false;
         try {
           while (true) {
             attempts++;
             response = await fetch (src);
             valid = !retryCodes.includes(response.status);

             if ( response.status == 404 ){
                let message = " Image tile 1 tagged as missing 404 by tileLoadFunction:  " + listUrl1[ISTEP_ecout1];
                console.log(message);
                listLoaded1[ISTEP_ecout1] = "missing";
                valid = false;
                break;
             } else if ( valid ) { 
               break;
             } else if ( attempts === 2) {

                let message = " To many tileLoadFunction attempts, tile1 will be assigned to missing:  " + listUrl1[ISTEP_ecout1];
                console.log(message);
                listLoaded1[ISTEP_ecout1] = "missing";
                valid = false;
                break;
             }
             let message = " tile1 load retried attempts: " + attempts + " by tileLoadFunction, step: " + listUrl1[ISTEP_ecout1];
             console.log(message);
             await new Promise((resolve) => setTimeout(resolve, attempts*250));
           }
           if (valid) {
             const blob = await response.blob();
             const imageUrl = URL.createObjectURL(blob);
             image.addEventListener('load', () => URL.revokeObjectURL(imageUrl));
             image.src = imageUrl;
           } else {
             tile.setState(3);     // error
           }
         } catch (error) {
           let message = " Error in the tileLoadFunction, tile1 will be assigned to missing:  " + listUrl1[ISTEP_ecout1];
           console.log(message);
           listLoaded1[ISTEP_ecout2] = "missing";

           tile.setState(3);     //  error
         }
       }

       async function myTileLoadFunctionCCo1(tile, src)  {
//      retry codes for tileloadfunction...
///                 https://neilpatel.com/blog/http-response-codes/
//      code 404 for missing file will be catch explicitely in the tileLoadFunction
//      the others in the following list will trigger a retry

       const retryCodes = [408, 429, 500, 502, 503, 504];
         const image = tile.getImage();
         let response;
         let attempts = 0;
         let valid = false;
         try {
           while (true) {
             attempts++;
             response = await fetch (src);
             valid = !retryCodes.includes(response.status);

             if ( response.status == 404 ){
                let message = " Image tile Co1 tagged as missing 404 by tileLoadFunction:  " + listUrlCo1[ISTEP_ecout1];
                console.log(message);
                listLoadedCo1[ISTEP1_ecout1] = "missing";
                valid = false;
                break;
             } else if ( valid ) { 
               break;
             } else if ( attempts === 2) {

                let message = " To many tileLoadFunction attempts, tile Co1 will be assigned to missing:  " + listUrlCo1[ISTEP_ecout1];
                console.log(message);
                listLoadedCo1[ISTEP_ecout1] = "missing";
                valid = false;
                break;
             }
             let message = " tileCo1 load retried attempts: " + attempts + " by tileLoadFunction, step: " + listUrlCo1[ISTEP_ecout1];
             console.log(message);
             await new Promise((resolve) => setTimeout(resolve, attempts*250));
           }
           if (valid) {
             const blob = await response.blob();
             const imageUrl = URL.createObjectURL(blob);
             image.addEventListener('load', () => URL.revokeObjectURL(imageUrl));
             image.src = imageUrl;
           } else {
             tile.setState(3);     // error
           }
         } catch (error) {
           let message = " Error in the tileLoadFunction, tileCo1 will be assigned to missing:  " + listUrlCo1[ISTEP_ecout1];
           console.log(message);
           listLoadedCo1[ISTEP_ecout1] = "missing";

           tile.setState(3);     //  error
         }
       }

       async function myTileLoadFunctionC2(tile, src)  {
//      retry codes for tileloadfunction...
///                 https://neilpatel.com/blog/http-response-codes/
//      code 404 for missing file will be catch explicitely in the tileLoadFunction
//      the others in the following list will trigger a retry

       const retryCodes = [408, 429, 500, 502, 503, 504];
         const image = tile.getImage();
         let response;
         let attempts = 0;
         let valid = false;
         try {
           while (true) {
             attempts++;
             response = await fetch (src);
             valid = !retryCodes.includes(response.status);

             if ( response.status == 404 ){
                let message = " Image tile 2 tagged as missing 404 by tileLoadFunction:  " + listUrl2[ISTEP_ecout2];
                console.log(message);
                listLoaded2[ISTEP_ecout2] = "missing";
                valid = false;
                break;

             } else if ( valid ) { 
               break;
             } else if ( attempts === 2) {

                let message = " To many tileLoadFunction attempts, tile 2 will be assigned to missing:  " + listUrl2[ISTEP_ecout2];
                console.log(message);
                listLoaded2[ISTEP_ecout2] = "missing";
                valid = false;
                break;
             }
             let message = " tile2 load retried attempts: " + attempts + " by tileLoadFunction, step: " + listUrl2[ISTEP_ecout2];
             console.log(message);
             await new Promise((resolve) => setTimeout(resolve, attempts*250));
           }
           if (valid) {
             const blob = await response.blob();
             const imageUrl = URL.createObjectURL(blob);
             image.addEventListener('load', () => URL.revokeObjectURL(imageUrl));
             image.src = imageUrl;
           } else {
             tile.setState(3);     // error
           }
         } catch (error) {
           let message = " Error in the tileLoadFunction, tile2 will be assigned to missing:  " + listUrl2[ISTEP_ecout2];
           console.log(message);
           listLoaded2[ISTEP_ecout2] = "missing";

           tile.setState(3);     //  error
         }
       }

       async function myTileLoadFunctionCCo2(tile, src)  {
//      retry codes for tileloadfunction...
///                 https://neilpatel.com/blog/http-response-codes/
//      code 404 for missing file will be catch explicitely in the tileLoadFunction
//      the others in the following list will trigger a retry

       const retryCodes = [408, 429, 500, 502, 503, 504];
         const image = tile.getImage();
         let response;
         let attempts = 0;
         let valid = false;
         try {
           while (true) {
             attempts++;
             response = await fetch (src);
             valid = !retryCodes.includes(response.status);

             if ( response.status == 404 ){
                let message = " Image tile Co2 tagged as missing 404 by tileLoadFunction:  " + listUrlCo2[ISTEP_ecout2];
                console.log(message);
                listLoadedCo2[ISTEP_ecout2] = "missing";
                valid = false;
                break;
             } else if ( valid ) { 
               break;
             } else if ( attempts === 2) {

                let message = " To many tileLoadFunction attempts, tile Co2 will be assigned to missing:  " + listUrlCo2[ISTEP_ecout2];
                console.log(message);
                listLoadedCo2[ISTEP_ecout2] = "missing";
                valid = false;
                break;
             }
             let message = " tileCo2 load retried attempts: " + attempts + " by tileLoadFunction, step: " + listUrlCo2[ISTEP_ecout2];
             console.log(message);
             await new Promise((resolve) => setTimeout(resolve, attempts*250));
           }
           if (valid) {
             const blob = await response.blob();
             const imageUrl = URL.createObjectURL(blob);
             image.addEventListener('load', () => URL.revokeObjectURL(imageUrl));
             image.src = imageUrl;
           } else {
             tile.setState(3);     // error
           }
         } catch (error) {
           let message = " Error in the tileLoadFunction, tileCo2 will be assigned to missing:  " + listUrlCo2[ISTEP_ecout2];
           console.log(message);
           listLoadedCo2[ISTEP_ecout2] = "missing";
           tile.setState(3);     //  error
         }
       }
// ________________________________________________________________________________

// --- Création des Sources Globales

const tileSource1 = [];
const tileSource2 = [];
const tileSourceCo1 = [];
const tileSourceCo2 = [];
var SourcesAreCreated1 = false;
var SourcesAreCreated2 = false;
// ________________________________________________________________________________
function resetSource(urlCo_, url_, istep, couche, i_couche) {

    let attribution = AttributionMeteo1;
    if ( i_couche == "2" ) { attribution = AttributionMeteo2; }

    var verbose_ = true;
    var resolutions;
    var tileNX = ModToDimX.get(couche.modeleZoom);
    var tileNY = ModToDimY.get(couche.modeleZoom);
    var extent_ = couche.getExtent();
    var proj_ = couche.getProjection();
   
    var returnLoading = false;
    var index = istep % NoOfLayers;
    var indice =0;
    var message="";
    var urlTuile;

//     +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//-------------------------------------------------------------------------------------/

    if ( verbose_ ) {
          console.log( "++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
          console.log( " Debut resetSource ... tiles for layer no: ", i_couche );
          console.log( " extent: ", extent_);
          console.log( " projection: ", proj_);
          console.log( " istep: ", istep, "  index: ", index, "  NoOfLayers: ", NoOfLayers);
          console.log( "----------------------------------------------------------------------");
    }
    if ( i_couche == "1" ) {

            ISTEP_ecout1 = istep;

            message="resetSource   Url : " + url_; console.log(message);
            resolutions = Resolutions1;
            urlTuile = url_ + '/{z}/{x}/{y}.png';

            if ( verbose_ ) {
              console.log( " couche 1 ");
              console.log( " dimX: ", tileNX);
              console.log( " dimY: ", tileNY);
              console.log( " Resolutions: ", resolutions);
              console.log( " couche 1 ");
            } 

            if ( tileSource1[index] != null ) {
                unsetEcouteursSource(tileSource1[index], i_couche, 'mainLayer')
            }
            tileSource1[index] = new XYZ({
                        url: urlTuile,
                        crossOrigin: 'anonymous',
                        projection: proj_,
                        tileGrid: new TileGrid({
                            extent: extent_,
                            resolutions: resolutions,
                            tileSize: [tileNX, tileNY],
                        }),
                        zDirection: 1,
                        transition: 0,
                        attributions: attribution,
            });
            setEcouteursSource(tileSource1[index], i_couche, 'mainLayer')
            tileSource1[index].setTileLoadFunction(myTileLoadFunctionC1);

            if ( verbose_ ) {
               message="resetSource   Url : " + url_;
               console.log(message);
               message="resetSource  tileload Requested, for layer no: " + i_couche.toString() + ' step:' + istep  ;
            }

            if ( listLoaded1[istep] == "non" || listLoaded1[istep] == "lazyLoading" ) {
                 if ( verbose_ ) {  console.log(message); }
                
//              Ici tous les pas de temps dont le  modulo vaut la valeur index seront mis a non
//              l image corrspondant a l<index sera en mode loading                

                 for ( indice = index; indice <= ISTEP_max; indice=indice+NoOfLayers ) {
                    listLoaded1[indice] = "non"; 
                    listNuLoadStart1[indice] = 0;
                    listNuLoadEnd1[indice] = 0;
                    listNuLoadErr1[indice] = 0;
                    listNuWait1[indice] = 0;
                 }
                 listLoaded1[istep] = "loading";
                 returnLoading = true;
                 tileLayers1[index].setSource(tileSource1[index]);
            }
            tileLayers1[index].setOpacity(0.0);

            message="resetSource   Url : " + urlCo_; console.log(message);
            resolutions = ResolutionsCo1;
            urlTuile = urlCo_ + '/{z}/{x}/{y}.png';

            if ( tileSourceCo1[index] != null ) {
                unsetEcouteursSource(tileSourceCo1[index], i_couche, 'coLayer')
            }
            tileSourceCo1[index] = new XYZ({
                        url: urlTuile,
                        crossOrigin: 'anonymous',
                        projection: proj_,
                        tileGrid: new TileGrid({
                            extent: extent_,
                            resolutions: resolutions,
                            tileSize: [tileNX, tileNY],
                        }),
                        zDirection: 1,
                        transition: 0,
                        attributions: attribution,
            });
            setEcouteursSource(tileSourceCo1[index], i_couche, 'coLayer')
            tileSourceCo1[index].setTileLoadFunction(myTileLoadFunctionCCo1);

            if ( listLoadedCo1[istep] == "non" || listLoadedCo1[istep] == "lazyLoading" ) {
//                  Ici tous les pas de temps dont le  modulo vaut la valeur index seront mis a non
//                  l image corrspondant a l<index sera en mode loading                

              for ( indice = index; indice <= ISTEP_max; indice=indice+NoOfLayers ) {
                   listLoadedCo1[indice] = "non"; 
                   listNuLoadStartCo1[indice] = 0;
                   listNuLoadEndCo1[indice] = 0;
                   listNuLoadErrCo1[indice] = 0;
                   listNuWaitCo1[indice] = 0;
               }
               listLoadedCo1[istep] = "loading";
               returnLoading = true;
               tileLayersCo1[index].setSource(tileSourceCo1[index]);
            }
            tileLayersCo1[index].setOpacity(0.0);

            SourcesAreCreated1 = true;
    } 
    if ( i_couche == "2"  &&  !Couche2Void ) {

           ISTEP_ecout2 = istep;
            message="resetSource   Url : " + url_; console.log(message);
            resolutions = Resolutions2;
            urlTuile = url_ + '/{z}/{x}/{y}.png';

           if ( verbose_ ) {
              console.log( " 2 ");
              console.log( " dimX: ", tileNX);
              console.log( " dimY: ", tileNY);
              console.log( " Resolutions: ", resolutions);
              console.log( " 2 ");
           } 

            if ( tileSource2[index] != null ) {
                unsetEcouteursSource(tileSource2[index], i_couche, 'mainLayer')
            }
            tileSource2[index] = new XYZ({
                        url: urlTuile,
                        crossOrigin: 'anonymous',
                        projection: proj_,
                        tileGrid: new TileGrid({
                            extent: extent_,
                            resolutions: resolutions,
                            tileSize: [tileNX, tileNY],
                        }),
                        zDirection: 1,
                        transition: 0,
                        attributions: attribution,
            });
            setEcouteursSource(tileSource2[index], i_couche, 'mainLayer')
            tileSource2[index].setTileLoadFunction(myTileLoadFunctionC2);

            if ( verbose_ ) {
                message="resetSource   Url : " + url_;
                console.log(message);
                message="resetSource  tileload Requested, for layer no: " + i_couche.toString() + ' step:' + istep  ;
            }

            if ( listLoaded2[istep] == "non" || listLoaded2[istep] == "lazyLoading" ) {

                for ( indice = index; indice <= ISTEP_max; indice=indice+NoOfLayers ) {
                        listLoaded2[indice] = "non";
                        listNuLoadStart2[indice] = 0;
                        listNuLoadEnd2[indice] = 0;
                        listNuLoadErr2[indice] = 0;
                        listNuWait2[indice] = 0;
                }
                listLoaded2[istep] = "loading";
                returnLoading = true;
                tileLayers2[index].setSource(tileSource2[index]);
            }
            tileLayers2[index].setOpacity(0.0);

            message="resetSource   Url : " + urlCo_; console.log(message);
            resolutions = ResolutionsCo2;
            urlTuile = urlCo_ + '/{z}/{x}/{y}.png';

            if ( tileSourceCo2[index] != null ) {
                unsetEcouteursSource(tileSourceCo2[index], i_couche, 'coLayer')
            }
            tileSourceCo2[index] = new XYZ({
                        url: urlTuile,
                        crossOrigin: 'anonymous',
                        projection: proj_,
                        tileGrid: new TileGrid({
                            extent: extent_,
                            resolutions: resolutions,
                            tileSize: [tileNX, tileNY],
                        }),
                        zDirection: 1,
                        transition: 0,
                        attributions: attribution,
            });
            setEcouteursSource(tileSourceCo2[index], i_couche, 'coLayer')
            tileSourceCo2[index].setTileLoadFunction(myTileLoadFunctionCCo2);

            if ( listLoadedCo2[istep] == "non" || listLoadedCo2[istep] == "lazyLoading" ) {
                for ( indice = index; indice <= ISTEP_max; indice=indice+NoOfLayers ) {
                   listLoadedCo2[indice] = "non"; 
                   listNuLoadStartCo2[indice] = 0;
                   listNuLoadEndCo2[indice] = 0;
                   listNuLoadErrCo2[indice] = 0;
                   listNuWaitCo2[indice] = 0;
               }
               listLoadedCo2[istep] = "loading";
               returnLoading = true;
               tileLayersCo2[index].setSource(tileSourceCo2[index]);
            }
            tileLayersCo2[index].setOpacity(0.0);

            SourcesAreCreated2 = true;
    }
    return  returnLoading;
}

//  --------------------------------------------------------------------------
//   Legends settings et preparation 
//   ------------------------------------------------------------------------
var Lgnd1Url = " ";
var Lgnd2Url = " ";
var Lgnd1Large = true;
var Lgnd2Large = true;

const lgnd1Select = document.getElementById('lgnd1Button');
const lgnd2Select = document.getElementById('lgnd2Button');

const lgnd1Img = document.getElementById("lgnd1Image");
const lgnd2Img = document.getElementById("lgnd2Image");

lgnd1Img.onload = function(){ showLgnd(1); showLgnd(1); };
lgnd2Img.onload = function(){ showLgnd(2); showLgnd(2); };

// ________________________________________________________________________________
function showLgnd(lgndNumber) {

  var lgndId = "lgnd1Image";
  var lgndIdOther = "lgnd2Image";
  if ( lgndNumber == 2 )  { 
      lgndId = "lgnd2Image"; 
      lgndIdOther = "lgnd1Image"; 
  }
  
  const x = document.getElementById( lgndId );
  const xo = document.getElementById( lgndIdOther );
  const frame = document.getElementById( "panel" );

  const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  
  var  gauche = true;
  var  haut= true;
  var  distH, distV, milieu ;

////  findout in which quadrant the legend is prior to modification
// for positionning at the end of the resizing process
////  want to ensure the collapsing-expanding is toward-from de edges - corners
    
   distH = parseInt( frame.style.left.replace('px','') );
   milieu = (viewwidth - (x.width + xo.width))/2;

  if ( distH > milieu ) {  gauche = false; }

  distV = parseInt( frame.style.top.replace('px','') ); 
  milieu = (viewheight - (x.height + xo.height)) /2;

  if ( distV > milieu ) {  haut = false;  }

//    store the previous sizes for later use before resizing    
  var deltaX = x.width;
  var deltaY = x.height;

  var fact = Math.min( Math.max(  (viewwidth/1000.), 0.6 ), 1 );
  
  if ( Lgnd1Large && (lgndNumber == 1) )  {

      Lgnd1Large =false; 
      x.width = x.naturalWidth/10;
      x.height= x.naturalHeight/10;

  } else if ( !Lgnd1Large && (lgndNumber == 1) )  {

      Lgnd1Large =true;
      x.width = parseInt( x.naturalWidth * fact );
          x.height= parseInt( x.naturalHeight * fact );

  } else  if ( Lgnd2Large && (lgndNumber == 2) )  {

      Lgnd2Large =false; 
      x.width = x.naturalWidth/10;
      x.height= x.naturalHeight/10;
          
  } else if ( !Lgnd2Large && (lgndNumber == 2) )  {

      Lgnd2Large =true;
      x.width = parseInt( x.naturalWidth * fact );
          x.height= parseInt( x.naturalHeight * fact );
  }

//  the resize is made but we need to manage the position of the legend panel
//  the default is to collaspe towards the top-left and expand towards the lower right
//  We want to have collapsing toward the nearest corner and expanding inversely
//  we need to take into account the size and position of the other legend 
    
// if the other legend has higher height than the current 
// the other legend is dertermining the vertical position 
  if ( xo.height > x.height ) {
      // If other legend was not higher then this is a change
          // previous height is stored in deltaY 
      if ( xo.height < deltaY ) {
          deltaY = xo.height - deltaY;
      } else {
          deltaY = 0;
          } 
  } else {
      // In this case the current legend is determinant
      // If other legend was higher then this is a change
          if ( xo.height > deltaY ) {
              deltaY = x.height - xo.height;
          } else {
          //  In this case the cyrrent is the determinant all the way
              deltaY = x.height -deltaY;
          }
  }
  deltaX = x.width - deltaX;

  if ( !gauche ) {
      distH =  distH  - deltaX;
      frame.style.left = distH  + "px";
//    console.log("distH et deltax" + distH + " " + deltaX) ;
  }
  if ( !haut ) {
    distV  =  distV - deltaY;   
    frame.style.top = distV + "px"; 
//    console.log("distV et deltaY" + distV + " " + deltaY) ;
  }
}
// ----------------------------------------------------------------------------
// Handle change event.
//
lgnd1Select.onchange = function () { showLgnd(1) };
lgnd2Select.onchange = function () { showLgnd(2) };

 $("#lgnd1Button").click(function(){
  console.log('click lgnd1 button');
  showLgnd(1);
});
 $("#lgnd2Button").click(function(){
  console.log('click lgnd2 button');
  showLgnd(2);
});
// Make the legend DIV container a draggable:
dragElement(document.getElementById("lgndMButton"),
            document.getElementById("panel"), "legende");

// Make some other feature draggable:
dragElement(document.getElementById("moveAfficheInfo"),
            document.getElementById("afficheInfo"), "NIL");

dragElement(document.getElementById("moveAfficheInit"),
            document.getElementById("afficheInit"), "NIL");

dragElement(document.getElementById("moveChoixDuoA"),
            document.getElementById("choixDuoA"), "NIL");

dragElement(document.getElementById("moveChoixDuoB"),
            document.getElementById("choixDuoB"), "NIL");

dragElement(document.getElementById("moveChoixDuoC"),
            document.getElementById("choixDuoC"), "NIL");

dragElement(document.getElementById("moveChoixDuoD"),
            document.getElementById("choixDuoD"), "NIL");

dragElement(document.getElementById("moveChoixDuoN"),
            document.getElementById("choixDuoN"), "NIL");

dragElement(document.getElementById("moveBtnGroup"),
            document.getElementById("btn-group"), "btnGroup");

dragElement(document.getElementById("moveAfficheHor"),
               document.getElementById("divAfficheHor"), "afficheHor");

dragElement(document.getElementById("moveAfficheHor1"),
               document.getElementById("divAfficheHor1"), "afficheHor1");

dragElement(document.getElementById("moveAfficheHor2"),
            document.getElementById("divAfficheHor2"), "afficheHor2");

// ________________________________________________________________________________
// Handle change event.
//
function RefreshLgnd(no) {
    
           var mapId = Couche1.getMapId();

    if ( no == 1 ) {

       // if ( !Couche1CoVoid ) { mapId = Couche1.getMapIdCo + " " + mapId; }

        Lgnd1Url = CreerUrlImageLeg( Tronc, Couche1.getModele(), 
        Couche1.getZoomId(), mapId , Couche1.getHourOId() ); 
        lgnd1Img.src = Lgnd1Url;

    } else if ( no == 2 ) {

        if ( Couche2Void ) {
                Lgnd2Url = "../missing.png";
        } else {
                mapId = Couche2.getMapId();
                       // if ( !Couche2CoVoid ) { mapId = Couche2.getMapIdCo + " " + mapId; }
                Lgnd2Url = CreerUrlImageLeg( Tronc, Couche2.getModele(),
                Couche2.getZoomId(), mapId, Couche2.getHourOId() );
            lgnd2Img.src = Lgnd2Url;
        }  
     }
}

// ________________________________________________________________________________
//
function dragElement(elmnt_anchor, elmnt2Move, initialPosition) {
  var posX1 = 0, posY1 = 0, posX2 = 0, posY2 = 0;
  var message = " ";

    if ( initialPosition == "afficheHor1" )  {
           console.log(" add event listener mousedown and touchstart = dragMouseDown1 ");
        elmnt_anchor.addEventListener("mousedown", dragMouseDown1);
        elmnt_anchor.addEventListener("touchstart", dragMouseDown1);
    } else if ( initialPosition == "afficheHor2" )  {
           console.log(" add event listener mousedown and touchstart = dragMouseDown2 ");
        elmnt_anchor.addEventListener("mousedown", dragMouseDown2);
        elmnt_anchor.addEventListener("touchstart", dragMouseDown2);
    } else {
           console.log(" add event listener mousedown and touchstart = dragMouseDown ");
        elmnt_anchor.addEventListener("mousedown", dragMouseDown);
        elmnt_anchor.addEventListener("touchstart", dragMouseDown);
    }

  //-----------------------
  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
      
    posX1 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
    posY1 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;

      document.addEventListener("mouseup", closeDragElement);
      elmnt_anchor.addEventListener("touchend", closeDragElement);
    // call a function whenever the cursor moves:
     document.addEventListener("mousemove", elementDrag);   
       elmnt_anchor.addEventListener("touchmove", elementDrag);   
    
  }
  //-----------------------
  function elementDrag(e) {
    
    e = e || window.event;
    e.preventDefault();
   // calculate the new cursor position:
    posX2 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
    posY2 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;

    var deltaX = posX2 - posX1;
    var deltaY = posY2 - posY1;
    const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    const limitEnBas = viewheight - elmnt2Move.offsetHeight;
    const limitADroite = viewwidth -elmnt2Move.offsetWidth-30;

    // set the element's new position:
    elmnt2Move.style.top = Math.max( Math.min( (elmnt2Move.offsetTop + deltaY), limitEnBas ) , 100) + "px";
    elmnt2Move.style.left = Math.max( Math.min( (elmnt2Move.offsetLeft+ deltaX), limitADroite ) , 10 ) + "px";

     //  Storing current positions into latest position for next iteration
    posX1 = posX2;
    posY1 = posY2;
  }
  //-----------------------
  function closeDragElement() {
    // stop moving when mouse button is released:
    document.removeEventListener("mouseup", closeDragElement);
    elmnt_anchor.removeEventListener("touchend", closeDragElement);
    document.removeEventListener("mousemove", elementDrag);
    elmnt_anchor.removeEventListener("touchmove", elementDrag);
  }
  //-----------------------
  function dragMouseDown1(e) {
    e = e || window.event;
    e.preventDefault();
      
    posX1 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
    posY1 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;

      document.addEventListener("mouseup", closeDragElement1);
      elmnt_anchor.addEventListener("touchend", closeDragElement1);
    // call a function whenever the cursor moves:
     document.addEventListener("mousemove", elementDrag1);   
       elmnt_anchor.addEventListener("touchmove", elementDrag1);   
    
  }
  //-----------------------
  //-----------------------
  function elementDrag1(e) {
    
    e = e || window.event;
    e.preventDefault();
   // calculate the new cursor position:
    posX2 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
    posY2 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;

    var deltaX = posX2 - posX1;
    var deltaY = posY2 - posY1;
    const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    const limitEnBas = viewheight - elmnt2Move.offsetHeight;
    const limitADroite = (viewwidth * 0.48) - elmnt2Move.offsetWidth;

    // set the element's new position:
    elmnt2Move.style.top = Math.max( Math.min( (elmnt2Move.offsetTop + deltaY), limitEnBas ) , 100) + "px";
    elmnt2Move.style.left = Math.max( Math.min( (elmnt2Move.offsetLeft+ deltaX), limitADroite ) , 10 ) + "px";

     //  Storing current positions into latest position for next iteration
    posX1 = posX2;
    posY1 = posY2;
  }
  //-----------------------
  function closeDragElement1() {
    // stop moving when mouse button is released:
    document.removeEventListener("mouseup", closeDragElement1);
    elmnt_anchor.removeEventListener("touchend", closeDragElement1);
    document.removeEventListener("mousemove", elementDrag1);
    elmnt_anchor.removeEventListener("touchmove", elementDrag1);
  }
  //-----------------------
  function dragMouseDown2(e) {
    e = e || window.event;
    e.preventDefault();
      
    posX1 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
    posY1 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;

      document.addEventListener("mouseup", closeDragElement2);
      elmnt_anchor.addEventListener("touchend", closeDragElement2);
    // call a function whenever the cursor moves:
     document.addEventListener("mousemove", elementDrag2);   
       elmnt_anchor.addEventListener("touchmove", elementDrag2);   
    
  }
  //-----------------------
  function elementDrag2(e) {
    
    e = e || window.event;
    e.preventDefault();
   // calculate the new cursor position:
    posX2 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
    posY2 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;

    var deltaX = posX2 - posX1;
    var deltaY = posY2 - posY1;
    const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    const limitEnBas = viewheight - elmnt2Move.offsetHeight;
    const limitADroite = (viewwidth * 0.48) - elmnt2Move.offsetWidth;

    // set the element's new position:
    elmnt2Move.style.top = Math.max( Math.min( (elmnt2Move.offsetTop + deltaY), limitEnBas ) , 10) + "px";
    elmnt2Move.style.left = Math.max( Math.min( (elmnt2Move.offsetLeft+ deltaX), limitADroite ) , 10 ) + "px";

     //  Storing current positions into latest position for next iteration
    posX1 = posX2;
    posY1 = posY2;
  }
  //-----------------------
  function closeDragElement2() {
    // stop moving when mouse button is released:
    document.removeEventListener("mouseup", closeDragElement2);
    elmnt_anchor.removeEventListener("touchend", closeDragElement2);
    document.removeEventListener("mousemove", elementDrag2);
    elmnt_anchor.removeEventListener("touchmove", elementDrag2);
  }
  //-----------------------

          // set the element's  Initial position as requested by the 3 rd parameter 
    //
  var viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  var viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  var limitEnBas = Math.max( 0, viewheight - elmnt2Move.offsetHeight);
  var limitADroite = Math.max( 0, viewwidth -elmnt2Move.offsetWidth);

  if ( initialPosition == "legende" ) {

    var basDeLegende= limitEnBas - 350;
    elmnt2Move.style.top = Math.max( basDeLegende, 150) + "px";
    elmnt2Move.style.left= Math.min( limitADroite, 30 ) + "px";

  } else if ( initialPosition == "btnGroup" )  {

    var basDeBtnGroup= limitEnBas - 100;
    elmnt2Move.style.top = Math.max( basDeBtnGroup, 100) + "px";
    elmnt2Move.style.left= Math.min( limitADroite, 400)  + "px";

  } else if ( initialPosition == "afficheHor" )  {
    
    limitADroite = Math.max( 0,  viewwidth -elmnt2Move.offsetWidth);
    elmnt2Move.style.top = Math.min( limitEnBas, 100) + "px";
    elmnt2Move.style.left= Math.min( limitADroite, 50) + "px";

  } else if ( initialPosition == "afficheHor1" )  {
    
    limitADroite = Math.max( 0,  (viewwidth*0.45) -elmnt2Move.offsetWidth);
    elmnt2Move.style.top = Math.min( limitEnBas, 100) + "px";
    elmnt2Move.style.left= Math.min( limitADroite, 50) + "px";

  } else if ( initialPosition == "afficheHor2" )  {

    limitADroite = Math.max( 0,  (viewwidth*0.45)  -elmnt2Move.offsetWidth);
    elmnt2Move.style.top = Math.min( limitEnBas, 0) + "px";
    elmnt2Move.style.left= Math.min( limitADroite, 50 ) + "px";
  }
}

// _________________________________________________________________________________
//
//
function nombrePassesHistoriques(model) {

  var nb_histo = 0;

    if ( model == "GDPS" ) {
            nb_histo = 20 ;  // nombre de temps de départ en archive
        if ( ArchivesVerif ) { nb_histo = 20  }
    } else if ( model == "GDPSIA" ) {
            nb_histo = 20 ;  // nombre de temps de départ en archive
        if ( ArchivesVerif ) { nb_histo = 20  }
    } else if ( model == "GDPSE" ) {
            nb_histo = 20 ;  // nombre de temps de départ en archive
    } else if ( model == "GDPSIAE" ) {
            nb_histo = 20 ;  // nombre de temps de départ en archive
        if ( ArchivesVerif ) { nb_histo = 20  }
    } else if ( model == "GFS" ) {
            nb_histo = 20 ;  // nombre de temps de départ en archive
    } else if ( model == "AIFS" ) {
            nb_histo = 20 ;  // nombre de temps de départ en archive
    } else if ( model == "AIFSE" ) {
            nb_histo = 20 ;  // nombre de temps de départ en archive
    } else if ( model == "ECMWF" ) {
            nb_histo = 20 ;  // nombre de temps de départ en archive
    } else if ( model == "ECMWFE" ) {
            nb_histo = 20 ;  // nombre de temps de départ en archive
    } else if ( model == "ECMWF3" ) {
            nb_histo = 9 ;  // nombre de temps de départ en archive
        if ( ArchivesVerif ) { nb_histo = 20  }
    } else if ( model == "RDPS" || model == "RAQDPS" ) {
            nb_histo = 9 ;  // nombre de temps de départ en archive
        if ( ArchivesVerif ) { nb_histo = 56  }
    } else if ( model == "HRDPS E" || model == "HRDPS S" || model == "HRDPS S0" || model == "HRDPS S1" || model == "HRDPS S2" || model == "HRDPS S3" || model == "CIOPS" ) {
            nb_histo = 9 ;  // nombre de temps de départ en archive
        if ( ArchivesVerif ) { nb_histo = 32  }
    } else if ( model == "HRDPS W" ) {
            nb_histo = 9 ;  // nombre de temps de départ en archive
        if ( ArchivesVerif ) { nb_histo = 32  }
    } else if ( model == "WCPS" ) {
            nb_histo = 8 ;  // nombre de temps de départ en archive
    } else if ( model == "RDWPS" ) {
            nb_histo = 8 ;  // nombre de temps de départ en archive
    } else if ( model == "DIAGW" ) {
            nb_histo = 8 ;  // nombre de temps de départ en archive
    } else if ( model == "SHOP" ) {
            nb_histo = 4 ;  // nombre de temps de départ en archive
        if ( ArchivesVerif ) { nb_histo = 4  }
    } else if (( model == "GOESR GLM" ) || ( model == "GOESR CO" ) || ( model == "GOESR_PLUS" )  ) {
            nb_histo = 288 ;  // nombre de temps de départ en archive
    } else if ( model == "FOUDRE CO" ) {
            nb_histo = 288 ;  // nombre de temps de départ en archive
    } else if (( model == "RADART CO" ) || ( model == "RADAR CO")) {
            nb_histo = 240 ;  // nombre de temps de départ en archive
    }
    return nb_histo;
}
// _________________________________________________________________________________
//
//
function nombreMinutesEntrePasses(model) {

    var minutes_ecart_t0 = 0;

    if ( model == "GDPS" ) {
          minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "GDPSIA" ) {
          minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "GDPSE" ) {
          minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "GDPSIAE" ) {
          minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "GFS" ) {
            minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "AIFS" ) {
            minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "AIFSE" ) {
            minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "ECMWF" ) {
            minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "ECMWFE" ) {
            minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "ECMWF3" ) {
            minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "RDPS" ) { 
            minutes_ecart_t0 = 360;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "RAQDPS" ) {
            minutes_ecart_t0 = 720;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "HRDPS E" || model == "HRDPS S" ||  model == "HRDPS S0" || model == "HRDPS S1" || model == "HRDPS S2" || model == "HRDPS S3" || model == "CIOPS" ) {
            minutes_ecart_t0 = 360;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "HRDPS W" ) {
            minutes_ecart_t0 = 360;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "WCPS" ) {
            minutes_ecart_t0 = 360;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "RDWPS" ) {
            minutes_ecart_t0 = 360;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "DIAGW" ) {
            minutes_ecart_t0 = 360;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if ( model == "SHOP" ) {
            minutes_ecart_t0 = 360;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if (( model == "GOESR GLM" ) || ( model == "GOESR CO" ) || ( model == "FOUDRE CO" )  || ( model == "GOESR_PLUS" )) {
            minutes_ecart_t0 = 5;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    } else if (( model == "RADART CO" ) || ( model == "RADAR CO")) {
            minutes_ecart_t0 = 6;     //  écart en minutes_ecart_t0 entre les temps de départ t0
    }
    return minutes_ecart_t0; 
}
//
// ________________________________________________________________________________
//
    function getHourOIdPlusMoinsNbHeures(houroid_, nb_heure, plus)  {

        let extra_string=":00:00";

        if ( houroid_.length == 12 ) {
            extra_string=houroid_.substr(10,2) + ":00";
        }
  
        var string= houroid_.substr(4,2) +  "/" + houroid_.substr(6,2) + "/" + houroid_.substring(0,4) + " " + houroid_.substr(8,2) + extra_string;
        var d1 = new Date(string);

        if ( !plus ) { 
                nb_heure=-nb_heure;
        }
        if ( houroid_.length == 12 ) {
               d1.setHours(d1.getHours() + nb_heure);
        } else {
               let nb_minutes= Math.round( nb_heure * 60 );
               d1.setMinutes(d1.getMinutes() + nb_minutes);
        }

        let year = d1.getFullYear();
        let month = d1.getMonth() + 1 ;
        let day = d1.getDate();
        let hour = d1.getHours();

        let syear = year.toString();
        let smonth = month.toString();
        if ( smonth.length < 2 ) { smonth = "0"+smonth }

        let sday = day.toString();
        if ( sday.length < 2 ) { sday = "0"+sday }
        let shour = hour.toString();
        if ( shour.length < 2 ) { shour = "0"+shour }
        if ( shour.length < 2 ) { shour = "0"+shour }

        let string_ = syear + smonth + sday + shour;

        if ( houroid_.length == 12 ) {
            let minutes = d1.getminutes();
            let sminutes = minutes.toString();
            if ( sminutes.length < 2 ) { sminutes="0"+sminutes; }
            string_ = string_ + sminutes 
        }
       return string_
}

        //var nb_heure_ms = nb_heure * 36e5;
//
        //var string= houroid_.substr(4,2) +  "/" + houroid_.substr(6,2) + "/" + houroid_.substring(0,4) + " " + houroid_.substr(8,2) + ":00:00";
        //var d1 = new Date(string);     
    //var delta_ms = 0;
//
    //if (plus) {
               //delta_ms = d1.getTime() + nb_heure_ms; 
    //} else {
           //delta_ms = d1.getTime() - nb_heure_ms;
    //}
//
        //var d2 = new Date( delta_ms );
//
        //var year = d2.getFullYear();
        //var month = d2.getMonth() + 1 ;
        //var day = d2.getDate();
        //var hour = d2.getHours();
//
        //var syear = year.toString();
        //var smonth = month.toString();
        //if ( smonth.length < 2 ) { smonth = "0"+smonth } 
                                  //
        //var sday = day.toString();
        //if ( sday.length < 2 ) { sday = "0"+sday }
        //var shour = hour.toString();
        //if ( shour.length < 2 ) { shour = "0"+shour }
        //if ( shour.length < 2 ) { shour = "0"+shour }
        //
        //var string_ = syear + smonth + sday + shour;
//
        //return string_
    //}
//
// ________________________________________________________________________________
//
// ________________________________________________________________________________
//
    function getHourOIdPlusMoinsNbMinutes(houroid_, nbMinutes, plus)  {

        let string="";

        if ( !plus ) { 
                nbMinutes=-nbMinutes;
         }
        if ( houroid_.length == 12 ) {
            string= houroid_.substr(4,2)+ "/" +houroid_.substr(6,2)+ "/" +houroid_.substring(0,4)+ " " +houroid_.substr(8,2)+ ":" +houroid_.substr(10,2)+ ":00";
        } else {
            string= houroid_.substr(4,2)+ "/" +houroid_.substr(6,2)+ "/" +houroid_.substring(0,4)+ " " +houroid_.substr(8,2)+ ":00:00";
        }

            let d1 = new Date(string);

            d1.setMinutes(d1.getMinutes() + nbMinutes);

            let syear = d1.getFullYear().toString();
            let smonth = (d1.getMonth() + 1).toString() ;
            let sday = d1.getDate().toString();
            let shour = d1.getHours().toString();
            let sminutes =d1.getMinutes().toString();

        if ( smonth.length < 2 ) { smonth = "0"+smonth }
        if ( sday.length < 2 ) { sday = "0"+sday }
        if ( shour.length < 2 ) { shour = "0"+shour }

        string = syear + smonth + sday + shour;

        if ( houroid_.length == 12 ) {
            if ( sminutes.length < 2 ) { sminutes = "0"+sminutes }
            string = string + sminutes 
        }
       return string
}

//
// ________________________________________________________________________________
function GuessHourOId(model, fact_nb_minutes_a_reculer)  {

    // On retourne le mielleur guess pour le Houriod actuel pour le model et le fact_nb_heure_a_reculer
    // nb_heure_a_reculer est un facteur qui s'applique à l'écart entre les t0 ( heure_ecart_t0)
    // Habituellment il est égale à zéro pour le meilleur guess à l'heure courante
    // Si on cherche le houroid précédente,  alors il est égale à -1
    // Si l'on cherche le houroid précédent, le précédent il sera égale à -2,  etc
    
    var minutes_ecart_t0 = 0;
    var minutes_dispo_t0_plus = 0;

    minutes_ecart_t0 =  nombreMinutesEntrePasses(model);

    if ( model == "GDPS" ) { minutes_dispo_t0_plus = -300;  // délai minimum de disponibilité après t0

    } else if ( model == "GDPSIA" ) { minutes_dispo_t0_plus = -330;
    } else if ( model == "GDPSE" ) { minutes_dispo_t0_plus = -300;
    } else if ( model == "GDPSIAE" ) { minutes_dispo_t0_plus = -330;
    } else if ( model == "GFS" ) { minutes_dispo_t0_plus = -300;

    } else if ( model == "AIFS" ) { minutes_dispo_t0_plus = -420;
    } else if ( model == "AIFSE" ) { minutes_dispo_t0_plus = -420;
    } else if ( model == "ECMWF" ) { minutes_dispo_t0_plus = -420;
    } else if ( model == "ECMWFE" ) { minutes_dispo_t0_plus = -420;
    } else if ( model == "ECMWF3" ) { minutes_dispo_t0_plus = -420;

    } else if ( model == "RDPS" ) { minutes_dispo_t0_plus = -180;
    } else if ( model == "RAQDPS" ) { minutes_dispo_t0_plus = -280;

    } else if ( model == "HRDPS E" || model == "HRDPS S" || model == "HRDPS S0" || model == "HRDPS S1" || model == "HRDPS S2" || model == "HRDPS S3" ) { minutes_dispo_t0_plus = -240;

    } else if ( model == "HRDPS W" ) { minutes_dispo_t0_plus = -300;

    } else if ( model == "WCPS" ) { minutes_dispo_t0_plus = -420;
    } else if ( model == "RDWPS" ) { minutes_dispo_t0_plus = -180;
    } else if ( model == "DIAGW" ) { minutes_dispo_t0_plus = -420;
    } else if ( model == "SHOP" ) { minutes_dispo_t0_plus = -420;
    } else if ( model == "CIOPS" ) { minutes_dispo_t0_plus = -360;
    } else if (( model == "GOESR GLM" ) || (model == "GOESR CO" ) || (model == "FOUDRE CO" ) || ( model == "GOESR_PLUS" )) { minutes_dispo_t0_plus = -6;
    } else if (( model == "RADART CO" ) || (model == "RADAR CO")) { minutes_dispo_t0_plus = -10;
    }   
        var d1 = new Date();
        var offset_UTC_ms = Math.round(d1.getTimezoneOffset() * 1000 * 60.);

        var d2 = new Date( d1.getTime() + offset_UTC_ms + (minutes_dispo_t0_plus + (fact_nb_minutes_a_reculer*minutes_ecart_t0))*6e4  );
        var year = d2.getFullYear();
        var syear = year.toString();
        var month = d2.getMonth() + 1 ;
        var smonth = month.toString();
        if ( smonth.length < 2 ) { smonth = "0"+smonth }

        var day = d2.getDate();
        var sday = day.toString();
        if ( sday.length < 2 ) { sday = "0"+sday }

        let chaine_a_retourner = syear + smonth + sday ;

        let hour = d2.getHours();
        let shour = hour.toString();

        let nowcast=isNowcast(model);

        if ( nowcast ) { 
           if ( shour.length < 2 ) { shour = "0"+shour }
           let minutes = d2.getMinutes() - ( d2.getMinutes() % minutes_ecart_t0 );
           let sminutes = minutes.toString();
           if ( sminutes.length < 2 ) { sminutes = "0"+sminutes }
           chaine_a_retourner = chaine_a_retourner + shour + sminutes;
        } else {
           let hours_ecart_t0 = Math.round( minutes_ecart_t0/60. );
           hour = hour - ( hour % hours_ecart_t0 ); 
           shour = hour.toString();
           if ( shour.length < 2 ) { shour = "0"+shour }
           chaine_a_retourner = chaine_a_retourner + shour;
        }
        return chaine_a_retourner
} 
// ________________________________________________________________________________
//
function soustractionHourOId(hourOId1_, hourOId2_, couches1et2) {

    let difference = 0;
    let diff = 0;

    if ( couches1et2 && ( Couche2.modeleZoom == "void" ) ) {
       return diff

    } else {

       if ( hourOId1_ != hourOId2_ ) {

           let string1= hourOId1_.substr(4,2) +  "/" + hourOId1_.substr(6,2) + "/" + hourOId1_.substring(0,4) + " " + hourOId1_.substr(8,2);
           let string2= hourOId2_.substr(4,2) +  "/" + hourOId2_.substr(6,2) + "/" + hourOId2_.substring(0,4) + " " + hourOId2_.substr(8,2);

           if ( hourOId1_.length == 10 ) {
              string1= string1 + ":00:00";
           } else {
              string1= string1 + ":" + hourOId1_.substr(10,2) + ":00";
           }
           if ( hourOId2_.length == 10 ) {
              string2= string2 + ":00:00";
           } else {
              string2= string2 + ":" + hourOId2_.substr(10,2)+ ":00";
           }

           let d1 = new Date(string1);
           let d2 = new Date(string2);
           diff = d1 - d2;
                  
           let d1_offset_UTC_m = parseInt(d1.getTimezoneOffset());
           let d2_offset_UTC_m = parseInt(d2.getTimezoneOffset());

           diff = Math.round(diff/6e4) - (d1_offset_UTC_m - d2_offset_UTC_m) ;
       }
       return diff 
   }
}

// ________________________________________________________________________________
//
function getAfficheValidDateTime(houroid_, nb_minutes)  {
        
        let nb_ms = nb_minutes * 6e4;

        //console.log(" getAfficheValidTime,  houroid_ : " + houroid_);
        //console.log(" getAfficheValidTime,  nb_minutes : " + nb_minutes);

        let string= houroid_.substring(0,4) + "-" + houroid_.substr(4,2) + "-" + houroid_.substr(6,2) + "T" + houroid_.substr(8,2);
        //console.log(" getAfficheValidTime,  string 1 : " + string);

        //console.log(" getAfficheValidTime, houroid_.length: " + houroid_.length);
        if ( houroid_.length == 10 ) {
              string= string + ":00:00";
        } else {
              string= string + ":" + houroid_.substr(10,2) + ":00";
        }
        //console.log(" getAfficheValidTime,  string 2 : " + string);

        let d1 = new Date(string);     
        let days = ["Dim.", "Lun.","Mar.","Mer.","Jeu.","Ven.","Sam."];

        d1.setMinutes(d1.getMinutes() + parseInt(nb_minutes));

        let offset_UTC_m =  d1.getTimezoneOffset()  ;

        d1.setMinutes(d1.getMinutes() - offset_UTC_m);

        offset_UTC_m = Math.round( offset_UTC_m/60. );
        let offset_UTC_string = offset_UTC_m.toString();

        //console.log(" d1: " + d1);

        let d4 = d1.toLocaleDateString("en-GB");
        let d5 = d1.toLocaleTimeString("en-US",{hour12: false } );

        //console.log(" d4: " + d4);
        //console.log(" d5: " + d5);

        if ( d5.slice(0, 2) == 24 ) { d5="00" +  d5.slice(2, 5) }
        d4 = d4.slice(0, 15) + " ";

        //console.log(" d4: " + d4);
        //console.log(" d5: " + d5);

        let d6 = days[d1.getDay()] + " le " + d4 + " à " + d5.slice(0, 5) + "h (UTC-" + offset_UTC_string + "h)" ;
        
        //console.log(" d6: " + d6);
    return d6
}
// ________________________________________________________________________________
//
function isNowcast(modele_) {

  var nowcast_ = false;

  if ( (modele_ == "GOESR GLM")  || (modele_ == "GOESR CO")  || (modele_ == "GOESR_PLUS" ) || 
       (modele_ == "RADART CO" ) || (modele_ == "RADAR CO" ) || (modele_ == "FOUDRE CO" ) ) { nowcast_ = true; }

  return nowcast_
}
// -----------------------------------------------------------------------------------
//   Selector  for Prediction systems

const ModeleZoom1Select = document.getElementById('modelezoom1');
const ModeleZoom2Select = document.getElementById('modelezoom2');
setMenuModeleZoom(1, ModeleZoom1Select);
setMenuModeleZoom(2, ModeleZoom2Select);

// ________________________________________________________________________________
// Handle change event.
//
ModeleZoom1Select.onchange = function () { updateModeleZoomFromMenu(1) };
ModeleZoom2Select.onchange = function () { updateModeleZoomFromMenu(2) };
// ________________________________________________________________________________
function updateModeleZoomFromMenu(no_) {

        var couche_change_pas = true;
        var message= "";
        var verbose_= true;

    StopAnimate();
    
    let modele1 = ModeleZoom1Select.options[ModeleZoom1Select.options.selectedIndex].value ;
    let modele2 = ModeleZoom2Select.options[ModeleZoom2Select.options.selectedIndex].value ;
    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);

    if ( verbose_ ) {
                console.log( "+++++++++++++++++++++++++++++++++++++++++++++++");
                console.log( "     updateModeleZoomFromMenu                  ");
                console.log( "-----------------------------------------------");
    }

    if ( (nowcast1 || nowcast2)  &&  DprogDt ) {
        alert(" Les couches Nowcasting, Radar ou satellite, ne sont pas encore disponibles en mode DprogDt" ); 
        for ( let ii =0; ii < ModeleZoom1Select.options.length; ii++ ) {
             if ( ModeleZoom1Select.options[ii].value == Couche1.modele ) { 
                  ModeleZoom1Select.options.selectedIndex = ii;
                  console.log(" modele layer 1 is set back to:" + Couche1.modele + " ii: " + ii);
             }
        } 
        for ( let ii =0; ii < ModeleZoom2Select.options.length; ii++ ) {
             if ( ModeleZoom2Select.options[ii].value == Couche2.modele ) { 
                  ModeleZoom2Select.options.selectedIndex = ii ;
                  console.log(" modele layer 2 is set to:" + Couche2.modele + " ii: " + ii);
             }
        } 

    } else {
         if ( no_ == 1  || no_ == 0 ) {

             var prevModel = Couche1.modele;        

             message="Update Model,  Couche1.modeleZoom: " + Couche1.modeleZoom;
 
             Couche1.modeleZoom  = ModeleZoom1Select.options[ModeleZoom1Select.options.selectedIndex].value ;
             Couche1.modele = ModToId.get( Couche1.getModeleZoom() );
             Couche1.zoomId = ModToZoom.get( Couche1.getModeleZoom() );
             Couche1.extent = ZoomToExtent.get( ModToZoom.get( Couche1.getModeleZoom() ));
             Couche1.projection = ZoomToProjec.get( ModToZoom.get( Couche1.getModeleZoom() ));
        
             if ( verbose_ ) {
                console.log(" modeleZoom: ", Couche1.modeleZoom);
                console.log(" modele: ", Couche1.modele);
                console.log(" zoomid: ", Couche1.zoomId);
                console.log(" extent: ", Couche1.extent);
                console.log(" projection: ", Couche1.projection);
             }

             if ( Couche1.modele == "WCPS" && prevModel != "WCPS" ) {

                  OpaciteSelect1.options.selectedIndex = OpaciteSelect1.options.length - 1;
                  Opacitee1 = parseInt( OpaciteSelect1.options[OpaciteSelect1.options.selectedIndex].value )/10. ;

             } else  if ( Couche1.modele != "WCPS" && prevModel == "WCPS" ) {

                  OpaciteSelect1.options.selectedIndex = OpaciteSelect1.options.length - 1;
                  Opacitee1 = parseInt( OpaciteSelect1.options[OpaciteSelect1.options.selectedIndex].value )/10. ;

             }
             if ( Couche1.modeleZoom == Couche2.modeleZoom ) { 
                                ResetModeleDefaults = true; 
                                couche_change_pas = setMenuHourOId(true, 2, HourOId2Select);
             } else { 
                                ResetModeleDefaults = false;
             }

             couche_change_pas = setMenuMapIdH(1,   MapIdH1Select );
             couche_change_pas = setMenuMapIdCo(1,   MapIdCo1Select );
             couche_change_pas = setMenuHourOId(false, 1, HourOId1Select);
         
             setMenuValeurs(1, ValeurSelect1);

             AttributionMeteo1 = SetAttribution( Couche1.modele, "1" );  
    
             if ( (Couche1.modeleZoom == "ECMWF") || (Couche1.modeleZoom == "ECMWF3") || (Couche1.modeleZoom == "AIFS") ) {
                  messageECMWF(Couche1.getMapIdH() );
             }
         } 
         if ( no_ == 2  || no_ == 0 ) {

             var prevModel = Couche2.modele;     

             Couche2.modeleZoom  = ModeleZoom2Select.options[ModeleZoom2Select.options.selectedIndex].value ;
             if ( Couche2.modeleZoom == "void" ) { 
                 Couche2Void = true; 
                 //setMenuInterca("storage");

                  if ( L_Interca ) {
                       // set to superpo,  since Interca is not allowed when second layer is off
                       IntercaSelect.options.selectedIndex = 1;
                       updateIntercaFromMenu("Refresh");
                  }

                 document.getElementById('mapidh2').disabled = true;
                 document.getElementById('mapidh2').style.visibility ="hidden";
                 document.getElementById('mapidco2').disabled = true;
                 document.getElementById('mapidco2').style.visibility ="hidden";
                 document.getElementById('houroid2').disabled = true;
                 document.getElementById('houroid2').style.visibility ="hidden";
                 document.getElementById('valeur2').disabled = true;
                 document.getElementById('valeur2').style.visibility ="hidden";
                 document.getElementById('opacite2').disabled = true;
                 document.getElementById('opacite2').style.visibility ="hidden";

                 if ( Lgnd2Large ) { showLgnd(2); }
                 RefreshLgnd(2);
            } else { 
                if ( Couche2Void ) {
                   Couche2Void = false;
                   document.getElementById('mapidh2').disabled = false;
                   document.getElementById('mapidh2').style.visibility ="visible";
                   document.getElementById('mapidco2').disabled = false;
                   document.getElementById('mapidco2').style.visibility ="visible";
                   document.getElementById('houroid2').disabled = false;
                   document.getElementById('houroid2').style.visibility ="visible";
                   document.getElementById('valeur2').disabled = false;
                   document.getElementById('valeur2').style.visibility ="visible";
                   document.getElementById('opacite2').disabled = false;
                   document.getElementById('opacite2').style.visibility ="visible";
                }
                Couche2.modele = ModToId.get( Couche2.getModeleZoom() );
                Couche2.zoomId = ModToZoom.get( Couche2.getModeleZoom() );
                Couche2.extent = ZoomToExtent.get( ModToZoom.get( Couche2.getModeleZoom() ));
                Couche2.projection = ZoomToProjec.get( ModToZoom.get( Couche2.getModeleZoom() ) );
        
                if ( verbose_ ) {
                    console.log(" modeleZoom: ", Couche2.modeleZoom);
                    console.log(" modele: ", Couche2.modele);
                    console.log(" zoomid: ", Couche2.zoomId);
                    console.log(" extent: ", Couche2.extent);
                    console.log(" projection: ", Couche2.projection);
                 }
                if ( Couche2.modele == "WCPS" && prevModel != "WCPS" ) {

                     OpaciteSelect2.options.selectedIndex = OpaciteSelect2.options.length - 1;
                     Opacitee2 = parseInt( OpaciteSelect2.options[OpaciteSelect2.options.selectedIndex].value )/10. ;

                } else  if ( Couche2.modele != "WCPS" && prevModel == "WCPS" ) {

                     OpaciteSelect2.options.selectedIndex = OpaciteSelect2.options.length - 1;
                     Opacitee2 = parseInt( OpaciteSelect2.options[OpaciteSelect2.options.selectedIndex].value )/10. ;
                }

                if ( Couche1.modeleZoom == Couche2.modeleZoom ) { ResetModeleDefaults = true;
                    couche_change_pas = setMenuHourOId(true, 1, HourOId1Select);
        
                } else                                            { ResetModeleDefaults = false;
                }
                couche_change_pas = setMenuMapIdH(2,  MapIdH2Select);
                couche_change_pas = setMenuMapIdCo(2,  MapIdCo2Select);
                couche_change_pas = setMenuHourOId(false, 2, HourOId2Select);
                setMenuValeurs(2, ValeurSelect2);

                AttributionMeteo2 = SetAttribution( Couche2.modele, "2" );  

                if ( (Couche2.modeleZoom == "ECMWF") || (Couche2.modeleZoom == "ECMWF3") || (Couche2.modeleZoom == "AIFS") ) {
                       messageECMWF(Couche2.getMapIdH() );
                }
           }
        } 
          //archives
         if ( ModAInterv.get( Couche1.getModeleZoom() ) < ModAInterv.get( prevModel ) ) {
            ResetModeleDefaults = true;
         }
         couche_change_pas = setMenuInterval();

         if ( nowcast1 && nowcast2 ) { ResetModeleDefaults = false; Couche1.Debut = -180; }
         couche_change_pas = setMenuDebut();
     
         if ( ModAFin.get( Couche1.getModeleZoom() ) > ModAFin.get( prevModel ) ) {
                 ResetModeleDefaults = true;
         } 

         couche_change_pas = setMenuFin();
         setListProgTimes();
         ResetModeleDefaults = false;

         //if ( (ViewProjSelect.value == "Syst.Prev")  &&  ( (no_ == 1) || (no_ == 0) ) )  {
                //SetVu(  Couche1.projection, ZoomToViewExtent.get( Couche1.zoomId ), false) ;
         //} 
         updateViewProjection();

        // Ici mettre le LoadLayers de toute les couches 
         LoadLayers(ISTEP, 0);
         LoadLayers(ISTEP_next, 0);

         if ( ActiveLoop  ) {
             setTimeout( StartAnimate, 500);
         } else {
            if ( no_ == 0 ) {
                          console.log(" UpdateModeleZoomFromMenu no 0  juste apres SetVu"); 
            } else {
                          console.log(" UpdateModeleZoomFromMenu no 1 ou 2 ");
            }
            setTimeout(Refresh, 500);
         }
         setTimeout(RefreshSpotWx, 510);

         if ( WindMaps ) {
             localStorage.setItem("Model1_V", Couche1.modeleZoom);
             localStorage.setItem("Model2_V", Couche2.modeleZoom);
         } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
             localStorage.setItem("Model1_N", Couche1.modeleZoom);
             localStorage.setItem("Model2_N", Couche2.modeleZoom);
         } else {
             localStorage.setItem("Model1", Couche1.modeleZoom);
             localStorage.setItem("Model2", Couche2.modeleZoom);
         }
   }
    if ( verbose_ ) {
                console.log( "+++++++++++++++++++++++++++++++++++++++++++++++");
                console.log( " FIN updateModeleZoomFromMenu  FIN FIN         ");
                console.log( "-----------------------------------------------");
    }
}

// ________________________________________________________________________________
//
function setMenuModeleZoom(no, modeleZoomSelect) {

    var layerModeleZoom = Couche1.getModeleZoom();

    if ( no == 2 ) {
        layerModeleZoom = Couche2.getModeleZoom();
    } 

    modeleZoomSelect.options.length  = 0;

    if ( WindMaps ) {
        document.getElementById("labelSystPrev").innerHTML="système" 

        modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'Air', 'HRDPS S0');
        modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'NEMO', 'WCPS');
        modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'RDWPS', 'RDWPS');
        modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'DIAGW', 'DIAGW');
    if ( L_SHOP ) {
        modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'SHOP', 'SHOP');
    }
    } else {
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'RDPS', 'RDPS');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'HRDPS E', 'HRDPS E');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'HRSUDQC', 'HRDPS S0');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'GDPS', 'GDPS');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'GFS', 'GFS');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'AIFS', 'AIFS');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'ECMWF', 'ECMWF');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'ECMWF3', 'ECMWF3');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'NEMO', 'WCPS');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'RDWPS', 'RDWPS');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'DIAGW', 'DIAGW');
    if ( L_SHOP ) {
        modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'SHOP', 'SHOP');
    }
//  retrait RAQDPS ici
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'RAQDPS', 'RAQDPS');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'GOES', 'GOESR CO');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'GOES+', 'GOESR_PLUS');
    ////modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'GLM', 'GOESR GLM');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'FOUDRE', 'FOUDRE CO');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'RADAR', 'RADAR CO');
    modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'RADART', 'RADART CO');
    if ( L_GDPSE ) {
       modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'GDPSE', 'GDPSE');
       modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'ECMWFE', 'ECMWFE');
       modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'AIFSE', 'AIFSE');
    }

    }
    if ( no == 2 ) {
        modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'void', 'void');
    }

    var altModeleZoom = modeleZoomSelect.options[0].value;
    var changee = resetMenuModeleZoom(no, layerModeleZoom,  altModeleZoom, modeleZoomSelect);
}

// ________________________________________________________________________________
//
function resetMenuModeleZoom(no, layerModeleZoom,  altModeleZoom, modeleZoomSelect)  {

/// la   fonction cherche dans le menu,  la valeur du ModeleZoom de la couche (layerModeleZoom)
//  si elle est trouvée,  cet indice du menu sera "selected".
// sinon, ce sera le ModeleZoom  passé sous altModeleZoom  qui sera  "selected"
//  et dans ce cas la valeur de modeleZoom de la couche sera changé !!!
// ------------------------------------------------------------------------------
       
    var trouve=false;
    var indice =0;
    var indice2iem =0;

    for ( indice = 0; indice < modeleZoomSelect.options.length; indice++ ) {

        if (   altModeleZoom == modeleZoomSelect.options[indice].value ) { indice2iem = indice; }
            if ( layerModeleZoom == modeleZoomSelect.options[indice].value ) {
                modeleZoomSelect.options.selectedIndex = indice;
                trouve=true;
            }
     }
     if ( !trouve ) { 

        modeleZoomSelect.options.selectedIndex = indice2iem; 
     
        var message = " Le systeme " + layerModeleZoom +  "(couche " + no + ") change et devient: " + altModeleZoom ;
        console.log(message);
        //openAfficheInfo(message,10);
     }
     if ( no == 1 ) {

        Couche1.modeleZoom = modeleZoomSelect.options[modeleZoomSelect.options.selectedIndex].value ;
     } else {
        Couche2.modeleZoom = modeleZoomSelect.options[modeleZoomSelect.options.selectedIndex].value ;
     } 
     return trouve
}

// -----------------------------------------------------------------------------------
//   Selector  for MapIdH

const MapIdH1Select = document.getElementById('mapidh1');
const MapIdH2Select = document.getElementById('mapidh2');
var change_pas = setMenuMapIdH(1, MapIdH1Select);
var change_pas = setMenuMapIdH(2, MapIdH2Select);

// -----------------------------------------------------------------------------------
//   Selector  for MapIdCo

const MapIdCo1Select = document.getElementById('mapidco1');
const MapIdCo2Select = document.getElementById('mapidco2');
 change_pas = setMenuMapIdCo(1, MapIdCo1Select);
 change_pas = setMenuMapIdCo(2, MapIdCo2Select);

// ________________________________________________________________________________
function updateMapIdHFromMenu(no) {

        StopAnimate();

        var      oldMapIdH= " ";    
        var      otherMapIdH= " ";    
        var      newMapIdH= " ";    
    var unchangedInterval = true;
    var unchangedDebut = true;
    var unchangedFin = true;
    var message = " ";

    let modele1 = Couche1.getModeleZoom();
    let modele2 = Couche2.getModeleZoom();
    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);

    if ( no == 1 || no == 0) {
        oldMapIdH = Couche1.getMapIdH();  
        Couche1.mapIdH = MapIdH1Select.options[MapIdH1Select.options.selectedIndex].value ;
        newMapIdH = Couche1.getMapIdH();
        otherMapIdH = Couche2.getMapIdH();

        message="newMapIdH: " + newMapIdH + "oldMapId: " + oldMapIdH + " otherMapIdH: " + otherMapIdH;
        console.log(message);

        if ( WindMaps ) {
           localStorage.setItem("MapIdH1_V", Couche1.mapIdH);
        } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
           localStorage.setItem("MapIdH1_N", Couche1.mapIdH);
           localStorage.setItem("MapIdH2_N", Couche2.mapIdH);
        } else {
           localStorage.setItem("MapIdH1", Couche1.mapIdH);
           localStorage.setItem("MapIdH2", Couche2.mapIdH);
        }


             //  check for possible new constraints on current,  interval, debut and fin
                //  when introducing a cumulative precipation on layer 1 while it was not present neither on layer 2 (otherMapIdH)

                if  ( ( newMapIdH.indexOf("_h") != -1) && (oldMapIdH.indexOf("_h") == -1) && ( otherMapIdH.indexOf("_h") == -1) ) {

                unchangedInterval = checkInterv( Couche1.getInterval(), parseInt(IntervalSelect.options[0].value) );
                unchangedDebut = checkDebut( Couche1.getDebut(), parseInt(DebutSelect.options[0].value) ); 
            unchangedFin = checkFin( Couche1.getFin(), parseInt(FinSelect.options[0].value) );  
                }
//windmap
           if ( WindMaps ) {
                if ( ( oldMapIdH.indexOf("WDIR") != -1 ) && ( oldMapIdH.indexOf("WIN") == -1 ) ) {

                      OpaciteSelect1.options.selectedIndex = OpaciteSelect1.options.length - 1;
                      Opacitee1 = parseInt( OpaciteSelect1.options[OpaciteSelect1.options.selectedIndex].value )/10. ;
                }
                if ( ( newMapIdH.indexOf("WDIR") != -1) && ( newMapIdH.indexOf("WIN") == -1 ) && ( Couche2.modeleZoom != "void" ) ) {

                      OpaciteSelect1.options.selectedIndex = OpaciteSelect1.options.length - 1;
                      Opacitee1 = parseInt( OpaciteSelect1.options[OpaciteSelect1.options.selectedIndex].value )/10. ;
                }
            }

                if ( (Couche1.modeleZoom == "ECMWF") || (Couche1.modeleZoom == "ECMWF3") || (Couche1.modeleZoom == "AIFS") ) {
                     messageECMWF(newMapIdH);
                }

            if ( L_Interca )  { AfficheraLayer2 = true;  AfficheraLayer1 = false; } ;
    } 
    if ( no == 2 || no == 0 ) {
                oldMapIdH = Couche2.getMapIdH();  
            Couche2.mapIdH = MapIdH2Select.options[MapIdH2Select.options.selectedIndex].value ;
                newMapIdH = Couche2.getMapIdH();  
                otherMapIdH = Couche1.getMapIdH();  
                if ( WindMaps ) {
                   localStorage.setItem("MapIdH2_V", Couche2.mapIdH);
                } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
                   localStorage.setItem("MapIdH2_N", Couche2.mapIdH);
                } else {
                   localStorage.setItem("MapIdH2", Couche2.mapIdH);
                }

            //  check for possible new constraints on current,  interval, debut and fin
                //  when introducing a cumulative precipation on layer 2 while it was not present neither on layer 1 (otherMapIdH)#

                if ( ( newMapIdH.indexOf("_h") != -1) && ( oldMapIdH.indexOf("_h") == -1) && ( otherMapIdH.indexOf("_h") == -1) ) {

                unchangedInterval = checkInterv( Couche2.getInterval(), parseInt(IntervalSelect.options[0].value) );
                unchangedDebut = checkDebut( Couche2.getDebut(), parseInt(DebutSelect.options[0].value) ); 
            unchangedFin = checkFin( Couche2.getFin(), parseInt(FinSelect.options[0].value) );  
                 }
                 if ( (Couche2.modeleZoom == "ECMWF") || (Couche2.modeleZoom == "ECMWF3") || (Couche2.modeleZoom == "AIFS") ) {
                      messageECMWF(newMapIdH);
                 }
             if ( L_Interca )  { AfficheraLayer1 = true;  AfficheraLayer2 = false; } ;
    } 
   
    if ( nowcast1 ) { resetDebutFinInterNowcast(); }  
    RefreshLgnd(no);

    setListProgTimes();

    // Ici mettre le LoadLayers de toute les couches 
    LoadLayers(ISTEP, 0);
    LoadLayers(ISTEP_next, 0);

    if ( ActiveLoop  ) {
             setTimeout( StartAnimate, 500);
    } else {
             setTimeout(Refresh, 500);
    }
}
// ________________________________________________________________________________
function updateMapIdCoFromMenu(no) {

        StopAnimate();

        var      oldMapIdCo= " ";    
        var      newMapIdCo= " ";    
    var unchangedInterval = true;
    var unchangedDebut = true;
    var unchangedFin = true;
    var message = " ";

    let modele1 = Couche1.getModeleZoom();
    let modele2 = Couche2.getModeleZoom();

    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);

    if ( no == 1 || no == 0) {
        oldMapIdCo = Couche1.mapIdCo;  
        Couche1.mapIdCo = MapIdCo1Select.options[MapIdCo1Select.options.selectedIndex].value ;
        newMapIdCo = Couche1.mapIdCo;
        if ( WindMaps ) {
           localStorage.setItem("MapIdCo1_V", Couche1.mapIdCo);
        } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
           localStorage.setItem("MapIdCo1_N", Couche1.mapIdCo);
        } else {
           localStorage.setItem("MapIdCo1", Couche1.mapIdCo);
        }
        if ( Couche1.mapIdCo == "void" ) { 
                       Couche1CoVoid = true;
        } else {
                       Couche1CoVoid = false;
        }
//windmap
        if ( WindMaps ) {
                if ( ( oldMapIdCo.indexOf("WDIR") != -1 ) && ( newMapIdCo.indexOf("WDIR") == -1 ) ) {
                      OpaciteSelect1.options.selectedIndex = OpaciteSelect1.options.length - 1;
                      Opacitee1 = parseInt( OpaciteSelect1.options[OpaciteSelect1.options.selectedIndex].value )/10. ;
                }
                if ( ( oldMapIdCo.indexOf("WDIR") == -1) && ( newMapIdCo.indexOf("WDIR") != -1 ) ) {
                      OpaciteSelect1.options.selectedIndex = OpaciteSelect1.options.length - 1;
                      Opacitee1 = parseInt( OpaciteSelect1.options[OpaciteSelect1.options.selectedIndex].value )/10. ;
                }
         }

         if ( L_Interca )  { AfficheraLayer2 = true;  AfficheraLayer1 = false; } ;
    } 
    if ( no == 2 || no == 0 ) {
         oldMapIdCo = Couche2.mapIdCo;  
         Couche2.mapIdCo = MapIdCo2Select.options[MapIdCo2Select.options.selectedIndex].value ;
         console.log(" Couche2.mapIdCo ", Couche2.mapIdCo);
         newMapIdCo = Couche2.mapIdCo;  
         if ( WindMaps ) {
                   localStorage.setItem("MapIdCo2_V", Couche2.mapIdCo);
         } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
                   localStorage.setItem("MapIdCo2_N", Couche2.mapIdCo);
         } else {
                   localStorage.setItem("MapIdCo2", Couche2.mapIdCo);
         }
        if ( Couche2.mapIdCo == "void" ) { 
                       Couche2CoVoid = true;
        } else {
                       Couche2CoVoid = false;
        }
        if ( WindMaps ) {
                if ( ( oldMapIdCo.indexOf("WDIR") != -1 ) && ( newMapIdCo.indexOf("WDIR") == -1 ) ) {
                      OpaciteSelect2.options.selectedIndex = OpaciteSelect1.options.length - 1;
                      Opacitee2 = parseInt( OpaciteSelect2.options[OpaciteSelect2.options.selectedIndex].value )/10. ;
                }
                if ( ( oldMapIdCo.indexOf("WDIR") == -1) && ( newMapIdCo.indexOf("WDIR") != -1 ) ) {
                      OpaciteSelect2.options.selectedIndex = OpaciteSelect2.options.length - 1;
                      Opacitee2 = parseInt( OpaciteSelect2.options[OpaciteSelect2.options.selectedIndex].value )/10. ;
                }
         }

        if ( L_Interca )  { AfficheraLayer1 = true;  AfficheraLayer2 = false; } ;
    } 
   
    if ( nowcast1 ) { 
                 resetDebutFinInterNowcast(); 
                 //RefreshLgnd(no);
     }  

    setListProgTimes();

    // Ici mettre le LoadLayers de toute les couches 
    LoadLayers(ISTEP, 0);
    LoadLayers(ISTEP_next, 0);

    if ( ActiveLoop  ) {
             setTimeout( StartAnimate, 500);
    } else {
             setTimeout(Refresh, 500);
    }
}
// ________________________________________________________________________________
// Handle change event.
//
MapIdH1Select.onchange = function () { updateMapIdHFromMenu(1) };
MapIdH2Select.onchange = function () { updateMapIdHFromMenu(2) };

MapIdCo1Select.onchange = function () { updateMapIdCoFromMenu(1) };
MapIdCo2Select.onchange = function () { updateMapIdCoFromMenu(2) };

// ________________________________________________________________________________
//
function setMenuMapIdH(no, mapIdHSelect) {

    var model = "";
    var layerMapIdH = "";
    
    if ( no == 1 ) {
         model = Couche1.getModeleZoom();
         layerMapIdH = Couche1.getMapIdH();
    }  else if ( no == 2 ) { 
         model = Couche2.getModeleZoom();
         layerMapIdH = Couche2.getMapIdH();
    } 

    mapIdHSelect.options.length  = 0;

    if ( ( model == "GDPS" ) || ( model == "GDPSE" ) || ( model == "GDPSIA" ) || ( model == "GDPSIAE" ) )  {

        if ( !ArchivesVerif ) {
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vort500', 'ABSV_500_ABSV_500');  
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Épai500', 'HGT_1000-500_HGT_1000-500'); 
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Nuages', 'TCDC_');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ250mb', 'HGT_250');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ850mb', 'HGT_850');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
            if (  model == "GDPSIA"  || model == "GDPSIAE" )  {
               mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Del500', 'D-HGT_500');  
            }
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V+ 10m', 'WIND_10');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V- 10m', 'WIN-_10');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'VD 10m', 'WDIR_10');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vraf', 'GUST_10');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V 250', 'WIND_250');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'VD 250', 'WDIR_250');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V 850', 'WIND_850');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'VD 850', 'WDIR_850');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 850', 'TMP_850');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 1,2m', 'TMP_sfc');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TD 1,2m', 'DPT_sfc');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'CAPE', 'CAPE_10000');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'HUMIDEX', 'HUDX_sfc');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Li indX', 'MU-VT-LI_500');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Cum5Jr-', 'APCP-_');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Cum5Jr', 'APCP_');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Pluie', 'WEARN__h');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Neige', 'WEASN__h');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Verglas', 'WEAFR__h');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Gresil', 'WEAPE__h');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
       } else  {
                mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
                mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
                mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
       }

    } else if ( model == "GFS" ) {

       if ( !ArchivesVerif ) {
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vort500', 'ABSV_500_ABSV_500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Épai500', 'HGT_1000-500_HGT_1000-500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Nuages', 'TCDC_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ850mb', 'HGT_850');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ250mb', 'HGT_250');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Del500', 'D-HGT_500');  //Overlay Couleur UNique
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 850', 'TMP_850');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 1,2m', 'TMP_sfc');
        //mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Cum5Jr-', 'APCP-_');
        //mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Cum5Jr', 'APCP_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Pluie', 'WEARN__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Neige', 'WEASN__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Verglas', 'WEAFR__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Gresil', 'WEAPE__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
       } else  {
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
       }

   } else if ( ( model == "ECMWF" ) || ( model == "ECMWF3" ) || ( model == "ECMWFE" ) ) {

        if ( !ArchivesVerif ) {
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vort500', 'ABSV_500_ABSV_500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Épai500', 'HGT_1000-500_HGT_1000-500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ850mb', 'HGT_850');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ250mb', 'HGT_250');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Del500', 'D-HGT_500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 850', 'TMP_850');   
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 1,2m', 'TMP_sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TD 1,2m', 'DPT_sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Cum5Jr-', 'APCP-_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Cum5Jr', 'APCP_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Pluie', 'WEARN__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Neige', 'WEASN__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Verglas', 'WEAFR__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Gresil', 'WEAPE__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
        } else  {
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
        }

   } else if ( model == "AIFS"  || model == "AIFSE")  {

      if ( !ArchivesVerif ) {
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Épai500', 'HGT_1000-500_HGT_1000-500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Nuages', 'TCDC_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ850mb', 'HGT_850');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ250mb', 'HGT_250');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Del500', 'D-HGT_500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 850', 'TMP_850');   
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 1,2m', 'TMP_sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TD 1,2m', 'DPT_sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Cum5Jr-', 'APCP-_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Cum5Jr', 'APCP_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Pluie', 'WEARN__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Neige', 'WEASN__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Verglas', 'WEAFR__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Gresil', 'WEAPE__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
      } else  {
                mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
      }

   } else if ( model == "RDPS" ) {

        if ( !ArchivesVerif ) {
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vort500', 'ABSV_500_ABSV_500');  
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Épai500', 'HGT_1000-500_HGT_1000-500'); 
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Nuages', 'TCDC_');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ250mb', 'HGT_250');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ850mb', 'HGT_850');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V+ 10m', 'WIND_10');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V- 10m', 'WIN-_10');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'VD 10m', 'WDIR_10');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Raf', 'GUST_10');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V 250', 'WIND_250');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'VD 250', 'WDIR_250');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V 850', 'WIND_850');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'VD 850', 'WDIR_850');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 850', 'TMP_850');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 1,2m', 'TMP_sfc');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TD 1,2m', 'DPT_sfc');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'CAPE', 'CAPE_10000');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'HUMIDEX', 'HUDX_sfc');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Li indX', 'MU-VT-LI_500');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Pluie', 'WEARN__h');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Neige', 'WEASN__h');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Verglas', 'WEAFR__h');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Gresil', 'WEAPE__h');
            mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
             } else  {
                mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
                mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
                mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
             }

        } else if ( model == "HRDPS E" || model == "HRDPS W" ) {

        if ( !ArchivesVerif ) {
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Nuages tot', 'TCDC_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ 500mb', 'HGT_500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V+ (10m)', 'WIND_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V- (10m)', 'WIN-_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Raf (10m)', 'GUST_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'V 850', 'WIND_850');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vd (10m)', 'WDIR_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vd 850', 'WDIR_850');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT 850mb', 'TMP_850');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TT (1,2m)', 'TMP_sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TD (1,2m)', 'DPT_sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Nei o sol', 'SNOD_sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Pluie', 'WEARN__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Neige', 'WEASN__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Verglas', 'WEAFR__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Gresil', 'WEAPE__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( '4 Types', 'COMPO__h');
            } else  {
                mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ 500mb', 'HGT_500');
                mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'cumul Types', 'COMPO__h');
            }

        } else if ( model == "HRDPS S" ) {

        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Nuages tot', 'HGT_500_TCDC_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GZ 500mb', 'HGT_500');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Wind+ (10m)', 'WIND_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Wind- (10m)', 'WIN-_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Wraf (10m)', 'GUST_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Wdir (10m)', 'WDIR_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TMP (1,2m)', 'TMP_sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'DPT (1,2m)', 'DPT_sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Neige o sol', 'SNOD_sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'cumul Pluie', 'WEARN__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'cumul Neige', 'WEASN__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'cumul Vergl.', 'WEAFR__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'cumul Gresil', 'WEAPE__h');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'cumul Types', 'PRMSL__COMPO__h');
        
        } else if ( model == "HRDPS S0" || model == "HRDPS S1" || model == "HRDPS S2" || model == "HRDPS S3" ) {

        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vit_Rafal_10m', 'GUST_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vit_Vent+_10m', 'WIND_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vit_Vent_10m', 'WIN-_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Dir_Vent_10m', 'WDIR_10');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PNM', 'PRMSL_');

    } else if ( model == "RAQDPS" ) {

        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PM2.5 Sfc', 'PM2.5_SFC');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PM10 Sfc', 'PM10_SFC');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PM2.5 Atm', 'PM2.5_ATM');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'PM10 Atm', 'PM10_ATM');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'NO Sfc', 'NO_SFC');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'NO2 Sfc', 'NO2_SFC');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'SO2 Sfc', 'SO2_SFC');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'O3 Sfc', 'O3_SFC');


    } else if ( model == "WCPS" ) {

        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Glace', 'IICECONC_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TMP 50cm', 'VOTEMPER_0.5');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Dir_Cou', 'CDIR_0.5');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vit_Cou', 'CSPEED_0.5');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Niveau', 'SOSSHEIG_');

    } else if ( model == "DIAGW" ) {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option('Courants', '');
        // 2. On cible cette option (qui est maintenant la dernière du tableau) pour la désactiver
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Dir_Cou', 'CDIR_0.5');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vit_Cou', 'CSPEED_0.5');
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option('Bath+marée', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Profond', 'Bathy_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option('Vague Vent', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'L0V', 'L0V_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'LcV', 'LcV_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'CambV', 'CmbrV_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'X_V', 'Ic_V_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'VW Dir', 'WVDIR_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'VW H', 'WVHGT_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'AmpliV', 'AMPLV_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Agita_V', 'Ia_V_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option(' Houle 1 ', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'L01H', 'L01H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Lc1H', 'Lc1H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Camb1H', 'Cmbr1H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'X_1H', 'Ic_1H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'H1W Dir', 'H1DIR_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'H1W H', 'SWHFSWEL_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Agita_1H', 'Ia_1H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Ampli1H', 'AMPL1H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option(' Houle 2 ', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'L02H', 'L02H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Lc2H', 'Lc2H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Camb2H', 'Cmbr2H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'X_2H', 'Ic_2H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'H2W Dir', 'H2DIR_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'H2W H', 'SWHSSWEL_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Ampli2H', 'AMPL2H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Agita_2H', 'Ia_2H_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option('Combinés  ', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'AmpliX', 'AMPL_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'AgitaH', 'IaH_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option('Groupes', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option('__________', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option('2ie groupe', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option('__________', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Agita2Mask', 'Ia2_mask_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Agita2Dir', 'Ia2Dir_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Agita2G', 'Ia2G_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option('1ie groupe', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option('__________', '');
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = 'titre-menu';
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'AgitaLc', 'IaLc_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'AgitaMask', 'Ia_mask_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'AgitaDir', 'IaDir_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'AgitaG', 'IaG_Sfc');

    } else if ( model == "RDWPS" ) {

        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GWavH', 'HTSGW_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'WWavH', 'WVHGT_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'H1WavH', 'SWHFSWEL_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'H2WavH', 'SWHSSWEL_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GWavPer', 'PWPER_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'WWavPer', 'PPERWW_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'H1WavPer', 'PWPFSWEL_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'H2WavPer', 'PWPSSWEL_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GWavDir', 'PWAVEDIR_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'WWavDir', 'WVDIR_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'H1WavDir', 'MWDFSWEL_Sfc');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'H2WavDir', 'MWDSSWEL_Sfc');
        
    } else if ( model == "SHOP" ) {

        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Niveau', 'SOSSHEIG_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Dir_Cou', 'CDIR_Avg');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vit_Cou', 'CSPEED_Avg');
        
    } else if ( model == "CIOPS" ) {

        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Ice Con.', 'IICECONC_');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TMP 50cm', 'VOTEMPER_0.5');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Dir_Cou', 'CDIR_0.5');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Vit_Cou', 'CSPEED_0.5');

    } else if ( model == "FOUDRE CO" ) {

        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'FOUDRE', 'FOUDRE_PTS_CO');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'FOUDRE', 'FOUDRE_PTS_CO');

    } else if ( model == "GOESR CO" || ( model == "GOESR_PLUS" ) ) {

        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'VI 02', 'C02_CO');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'IR 13', 'C13_CO');

    ////} else if ( model == "GOESR GLM" ) {

        ////mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GLM', 'GLM_G19');

    } else if ( model == "RADAR CO" ) {
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'S Net', 'RSNO_NET');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'S', 'RSNO');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'R Net', 'RRAI_NET');
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'R', 'RRAI');

    } else if ( model == "RADART CO" ) {
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'TYPE', 'RTYP');

    } else if ( model == "void" ) {
        mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'void', 'void');
    }
    var altMapIdH = mapIdHSelect.options[mapIdHSelect.options.length - 1].value;
    var inchangee = "true";
    if ( model != "void"  ) {
        inchangee = resetMenuMapIdH(no, layerMapIdH,  altMapIdH, mapIdHSelect);
    }         
    var message = " Le menu Carte météo de la couche " + no.toString() + " a été mis à jour ";  
         console.log(message);
    
//   The legend is always refreshed here to reflect either map menu initialisation or model change (calling the present function)
     RefreshLgnd(no);

     if ( inchangee )  { 
         var message = " Le choix de la Carte météo demeure intacte";  
         console.log(message);
     } else {
         var message = " Le choix de la Carte météo a due être modifiée";
         console.log(message);
     } 
    return inchangee
}

// ________________________________________________________________________________
//
function setMenuMapIdCo(no, mapIdCoSelect) {

    var model = "";
    var layerMapIdCo = "";
    
    if ( no == 1 ) {
         model = Couche1.modeleZoom;
         layerMapIdCo = Couche1.mapIdCo;
    }  else if ( no == 2 ) { 
         model = Couche2.modeleZoom;
         layerMapIdCo = Couche2.mapIdCo;
    } 

    mapIdCoSelect.options.length  = 0;

    if ( ( model == "GDPS" ) || ( model == "GDPSE" ) || ( model == "RDPS" ) || ( model == "GDPSIA" ) || ( model == "GDPSIAE" ) ) {

        if ( !ArchivesVerif ) {
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ250mb', 'HGT_250');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ850mb', 'HGT_850');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'VD 10m', 'WDIR_10');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'VD 250', 'WDIR_250');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'VD 850', 'WDIR_850');
            } else  {
                mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
                mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
            }

    } else if ( model == "GFS" ) {

        if ( !ArchivesVerif ) {
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ250mb', 'HGT_250');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ850mb', 'HGT_850');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
            } else  {
                mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
                mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
            }
    } else if ( ( model == "ECMWF" ) || ( model == "ECMWF3" ) || ( model == "ECMWFE" ) ) {

        if ( !ArchivesVerif ) {
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ250mb', 'HGT_250');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ850mb', 'HGT_850');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
            } else  {
                mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
                mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
            }
    } else if ( model == "AIFS" || model == "AIFSE")  {

        if ( !ArchivesVerif ) {
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ250mb', 'HGT_250');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ850mb', 'HGT_850');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
            } else  {
                mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
                mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
            }
    } else if ( model == "HRDPS E" || model == "HRDPS W" ) {

        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GZ500mb', 'HGT_500');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'VD 10m', 'WDIR_10');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'VD 850', 'WDIR_850');

    } else if ( model == "HRDPS S" ) {

        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'VD 10m', 'WDIR_10');

    } else if ( model == "HRDPS S0" || model == "HRDPS S1" || model == "HRDPS S2" || model == "HRDPS S3" ) {

        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'Dir_Vent (10m)', 'WDIR_10');
    mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'PNM', 'PRMSL_');

    } else if ( model == "WCPS" ) {

        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'Dir_Cou', 'CDIR_0.5');

    } else if ( model == "DIAGW" ) {

        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'Dir_Cou', 'CDIR_0.5');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'VW Dir', 'WVDIR_Sfc');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'H1W Dir', 'H1DIR_Sfc');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'H2W Dir', 'H2DIR_Sfc');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'AgitaDir', 'IaDir_Sfc');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'Agita2Dir', 'Ia2Dir_Sfc');

    } else if ( model == "RDWPS" ) {

        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GWavDir', 'PWAVEDIR_Sfc');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'WWavDir', 'WVDIR_Sfc');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'H1WavDir', 'MWDFSWEL_Sfc');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'H2WavDir', 'MWDSSWEL_Sfc');

    } else if ( model == "SHOP" ) {

        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'Dir_Cou', 'CDIR_Avg');

    } else if ( model == "CIOPS" ) {

        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'Dir_Cou', 'CDIR_0.5');

    } else if ( model == "GOESR_PLUS" ) {

        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'FOUDRE', 'FOUDRE_PTS_CO');
        ////mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GLM', 'GLM_G19');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'S Net', 'RSNO_NET');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'S', 'RSNO');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'R Net', 'RRAI_NET');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'R', 'RRAI');

    } else if ( model == "RADAR CO" ) {

        //mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'FOUDRE', 'FOUDRE_PTS_CO');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'S Net', 'RSNO_NET');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'S', 'RSNO');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'R Net', 'RRAI_NET');
        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'R', 'RRAI');

    } else if ( model == "RADART CO" ) {

        mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'TYPE', 'RTYP');
    }

    mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'void', 'void');

    var altMapIdCo = mapIdCoSelect.options[mapIdCoSelect.options.length - 1].value;
    var inchangee = "true";

    if ( model != "void"  ) {
        inchangee = resetMenuMapIdCo(no, layerMapIdCo,  altMapIdCo, mapIdCoSelect);
    }         
    var message = " Le menu Carte météo Flèches et Contours de la couche " + no.toString() + " a été mis à jour ";  
         console.log(message);
    
//   The legend is always refreshed here to reflect either map menu initialisation or model change (calling the present function)
     RefreshLgnd(no);

     if ( inchangee )  { 
         var message = " Le choix de la Carte météo Flèches et Contours demeure intacte";  
         console.log(message);
     } else {
         var message = " Le choix de la Carte météo Flèches et Contours a due être modifiée";
         console.log(message);
     } 
    return inchangee
}
// ________________________________________________________________________________
//
function resetMenuMapIdH(no, layerMapIdH,  altMapIdH, mapIdHSelect)  {

/// la   fonction cherche dans le menu,  la valeur du MapIdH de la couche (layerMapIdH)
//  si elle est trouvée,  cet indice du menu sera "selected".
// sinon, ce sera le mapid  passé sous altMapIdH  qui sera  "selected"
//  et dans ce cas la valeur de mapidh de la couche sera changé !!!
// ------------------------------------------------------------------------------
       
    var trouve=false;
    var indice =0;
    var indice2iem =0;

    for ( indice = 0; indice < mapIdHSelect.options.length; indice++ ) {
   
            if (   altMapIdH == mapIdHSelect.options[indice].value ) { indice2iem = indice; }
            if ( layerMapIdH == mapIdHSelect.options[indice].value ) {
                mapIdHSelect.options.selectedIndex = indice;
                trouve=true;
            }
     }
     if ( !trouve ) { 

        mapIdHSelect.options.selectedIndex = indice2iem; 
     
        var message = " La carte " + layerMapIdH + " (couche " + no + ") change et devient: " + altMapIdH ;
        console.log("message");
        //openAfficheInfo(message,10);
     }
     if ( no == 1 ) {
        Couche1.mapIdH = mapIdHSelect.options[mapIdHSelect.options.selectedIndex].value ;
     } else {
        Couche2.mapIdH = mapIdHSelect.options[mapIdHSelect.options.selectedIndex].value ;
     }
     return trouve
}

// ________________________________________________________________________________
//
function resetMenuMapIdCo(no, layerMapIdCo,  altMapIdCo, mapIdCoSelect)  {

/// la   fonction cherche dans le menu,  la valeur du MapIdCo de la couche (layerMapIdCo)
//  si elle est trouvée,  cet indice du menu sera "selected".
// sinon, ce sera le mapid  passé sous altMapIdCo  qui sera  "selected"
//  et dans ce cas la valeur de mapidCo de la couche sera changé !!!
// ------------------------------------------------------------------------------
       
    var trouve=false;
    var indice =0;
    var indice2iem =0;

    let modele1 = Couche1.getModeleZoom();
    let modele2 = Couche2.getModeleZoom();

    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);

    for ( indice = 0; indice < mapIdCoSelect.options.length; indice++ ) {
   
            if (   altMapIdCo == mapIdCoSelect.options[indice].value ) { indice2iem = indice; }
            if ( layerMapIdCo == mapIdCoSelect.options[indice].value ) {
                mapIdCoSelect.options.selectedIndex = indice;
                trouve=true;
            }
     }
     if ( !trouve ) { 

        mapIdCoSelect.options.selectedIndex = indice2iem; 
     
        var message = " La carte " + layerMapIdCo + " (couche " + no + ") change et devient: " + altMapIdCo ;
        console.log("message");
        //openAfficheInfo(message,10);
     }
     if ( no == 1 ) {
        Couche1.mapIdCo = mapIdCoSelect.options[mapIdCoSelect.options.selectedIndex].value ;
        if ( WindMaps ) {
           localStorage.setItem("MapIdCo1_V", Couche1.mapIdCo);
        } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
           localStorage.setItem("MapIdCo1_N", Couche1.mapIdCo);
        } else {
           localStorage.setItem("MapIdCo1", Couche1.mapIdCo);
        }
        if ( Couche1.mapIdCo == "void" ) { 
                       Couche1CoVoid = true;
        } else {
                       Couche1CoVoid = false;
        }
     } else {
        Couche2.mapIdCo = mapIdCoSelect.options[mapIdCoSelect.options.selectedIndex].value ;
        if ( WindMaps ) {
           localStorage.setItem("MapIdCo2_V", Couche2.mapIdCo);
        } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
           localStorage.setItem("MapIdCo2_N", Couche2.mapIdCo);
        } else {
           localStorage.setItem("MapIdCo2", Couche2.mapIdCo);
        }
        if ( Couche2.mapIdCo == "void" ) { 
                       Couche2CoVoid = true;
        } else {
                       Couche2CoVoid = false;
        }
     }
     return trouve
}

// -----------------------------------------------------------------------------------
//   Selector  for houroid

const HourOId1Select = document.getElementById('houroid1');
const HourOId2Select = document.getElementById('houroid2');
change_pas = setMenuHourOId(true, 1, HourOId1Select);
change_pas = setMenuHourOId(true, 2, HourOId2Select);
    
// ________________________________________________________________________________
function updateHourOIdFromMenu(no) {

    StopAnimate();
    UnsetValeurs("0");

    let modele1=Couche1.getModeleZoom();
    let modele2=Couche2.getModeleZoom();
    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);
    if ( DprogDt ) {
          alert(" Menu inactif en mode Dprog Dt puisque l'animation porte sur la date d origine!");
    } else if ( nowcast1 && (no == 1) ) {
          alert(" Menu inactif lorsque GOESR, FOUDRE ou RADAR est sélectionné sur la couche 1 puisque l'animation porte sur la date d origine!");
    } else if ( nowcast2 && (no == 2) ) {
          alert(" Menu inactif lorsque GOESR, FOUDRE ou RADAR est sélectionné sur la couche 2 puisque l'animation porte sur la date d origine!");
    } else {
          var message=" Changing houroid: " + no.toString();
          console.log(message); 

          var unchangedInterval = true;
          var unchangedDebut = true;
          var unchangedFin = true;

          var proposedHourOId = HourOId1Select.options[HourOId1Select.options.selectedIndex].value ;
          var altHourOId      = Couche1.getHourOId();
          var proposedOk = false;

          if ( no == 1 ) {
            proposedOk = checkHourOId(no, proposedHourOId, altHourOId, HourOId1Select );

          } else if ( no == 2) {

             proposedHourOId = HourOId2Select.options[HourOId2Select.options.selectedIndex].value;
             altHourOId      = Couche2.getHourOId();
             proposedOk = checkHourOId(no, proposedHourOId, altHourOId, HourOId2Select );
          }
          if ( proposedOk && (  proposedHourOId != altHourOId ) ) { 

        if ( Couche1.getHourOId()== Couche2.getHourOId() ) { ResetModeleDefaults = true; }
        else                                               { ResetModeleDefaults = false;}

            unchangedInterval = checkInterv( Couche1.getInterval(), parseInt(IntervalSelect.options[0].value) );
            unchangedDebut = checkDebut( Couche1.getDebut(), parseInt(DebutSelect.options[0].value) ); 
            unchangedFin = checkFin( parseInt(FinSelect.options[0].value), parseInt(FinSelect.options[0].value) );  
          }
          RefreshLgnd(no);
          setListProgTimes();
          ResetModeleDefaults = false;


            if ( ActiveLoop  ) {
                if ( no == 1 ) {
                   updateLayers(ISTEP, 1);
                   updateLayers(ISTEP_next, 1);
                } else if ( no == 2) {
                   updateLayers(ISTEP, 2);
                   updateLayers(ISTEP_next, 2);
                }
                setTimeout( StartAnimate, 500)
             } else {
                    Refresh();
             } 
    }
}
// ________________________________________________________________________________
// Handle change event.
//
HourOId1Select.onchange = function () { updateHourOIdFromMenu(1) };
HourOId2Select.onchange = function () { updateHourOIdFromMenu(2) };

// ________________________________________________________________________________
//
function setMenuHourOId(init, no, hourOIdSelect) {

    var message = " ";

    if ( no == 1 )  {
    SetMenuHourOIdRun1 = true;
    } else {
        SetMenuHourOIdRun2 = true;
    }
    HourOId1Select.disabled = false;

    if ( DprogDt && no == 1 ) { 

        var modele1 = Couche1.getModeleZoom();
        var modele2 = Couche2.getModeleZoom();

        let nowcast1=isNowcast(modele1);
        let nowcast2=isNowcast(modele2);

        var iHourOId1Hist = nombrePassesHistoriques(modele1);
        var iHourOId2Hist = nombrePassesHistoriques(modele2);
        var hourOId1 = "";
        var hourOId2 = "";

        HourOId1Select.options.length = 0;
        HourOId2Select.options.length = 0;

        var i1 = 0;
        var i2 = 0;
        for ( i1 = 0; i1 < iHourOId1Hist; i1++ ) {

            ecart_= i1 * nombreMinutesEntrePasses(modele1);
            hourOId1 = getHourOIdPlusMoinsNbMinutes(  ModAHourOId.get(modele1), ecart_, false); 

            if ( Couche2Void ) {
                HourOId1Select.options[HourOId1Select.options.length] = new Option(hourOId1, hourOId1);

             } else {
                for ( i2 = 0; i2 < iHourOId2Hist; i2++ ) {
                
                    ecart_= i2 * nombreMinutesEntrePasses(modele2);;
                    hourOId2 = getHourOIdPlusMoinsNbMinutes(  ModAHourOId.get(modele2), ecart_, false);

                    if ( nowcast1 || nowcast2 ) { 
                       HourOId1Select.options[HourOId1Select.options.length] = new Option(hourOId1, hourOId1);
                       HourOId2Select.options[HourOId2Select.options.length] = new Option(hourOId1, hourOId1);
                    } else {
                      if ( hourOId1 == hourOId2 ) {
                    HourOId1Select.options[HourOId1Select.options.length] = new Option(hourOId1, hourOId1);
                    HourOId2Select.options[HourOId2Select.options.length] = new Option(hourOId1, hourOId1);
                       }
                    }
                 }
            }
        }
        if ( HourOId1Select.options.length == 0 ) {

            message=" Problème ici, avec le menu de la date d'origine, je dois repartir le tout, désolé";
            alert(message);
             location.reload(true);
         }
         HourOId1Select.disabled = true;       
    } else {
    
    var layerHourOId = Couche1.getHourOId();
    var modele = Couche1.getModeleZoom();
    if ( no == 2 ) {
        layerHourOId = Couche2.getHourOId();
        modele = Couche2.getModeleZoom();
    } 

        var hourOIdEcart = nombreMinutesEntrePasses(modele);
        var HourOIdHist = nombrePassesHistoriques(modele);

    //  getting the latest houroid for this model  and update the menu
    
        var hourOId_latest = ModAHourOId.get(modele);

    hourOIdSelect.options.length = 0;
    hourOIdSelect.options[hourOIdSelect.options.length] = new Option( hourOId_latest, hourOId_latest );
    var i=0;
    var houroid_m_ =" ";
    var ecart_ = 0;
    var message = " ";

        for ( i = 1; i < HourOIdHist; i++ ) {
                ecart_= i* hourOIdEcart;
                houroid_m_ = getHourOIdPlusMoinsNbMinutes(  hourOId_latest, ecart_, false); 
                hourOIdSelect.options[hourOIdSelect.options.length] = new Option(houroid_m_, houroid_m_);
                }
    
        message = " Le menu date d'origine de la couche " + no + " a été mis à jour ";  
        console.log(message);
    //   try to establish coherence between the menu and the current layer houroid  except if init is true,  then reset
        var proposedOk = true;  
        if ( (init || ResetModeleDefaults )  && ( layerHourOId != hourOId_latest ) ) { 
        proposedOk = checkHourOId(no, hourOId_latest, hourOId_latest, hourOIdSelect );
        } else  {
            proposedOk = checkHourOId(no, layerHourOId, hourOId_latest, hourOIdSelect );
        }

    if (    ( (no == 1)  && (Couche1.hourOId == layerHourOId) )
         || ( (no == 2)  && (Couche2.hourOId == layerHourOId) ) ) {

        message = " La valeur de la date d'origine de cette couche demeure intacte";  
        console.log(message);
            proposedOk = true;
    } else {
        message = " La valeur de la date d'origine a due être modifiée";
        console.log(message);
            proposedOk = false;
    } 
    if ( no == 1 )  {
        SetMenuHourOIdRun1 = false;
    } else {
            SetMenuHourOIdRun2 = false;
    }
   }
   RefreshLgnd(no);
   return proposedOk
} 
// ________________________________________________________________________________
//
function checkHourOId(no, proposedHourOId, altHourOId, hourOIdSelectO) {

    var ihourOId =0; 
    var ihourOId_correcte =0;
    var message = " ";

    var  proposedOkA = resetMenuHourOId(no, proposedHourOId, altHourOId, hourOIdSelectO);
     return  proposedOkA    
}

// ________________________________________________________________________________
//
function resetMenuHourOId(no, proposedHourOId,  altHourOId, hourOIdSelect)  {

/// la   fonction cherche dans le menu,  la valeur du houroid (proposedHourOId)
//  si elle est trouvé,  cet indice du menu sera "selected".
// sinon, ce sera l'houroid  passé sous altHourOId_   qui sera  "selected"
//  et dans ce cas la valeur de houroid de la couche sera changé !!!
// ------------------------------------------------------------------------------
       
    var trouve=false;
    var indice =0;
    var indice2iem =0;
    var indice_limite =  hourOIdSelect.options.length;

    for ( indice = 0; indice < indice_limite; indice++ ) {

        if ( altHourOId      == hourOIdSelect.options[indice].value ) { indice2iem = indice; }
            if ( proposedHourOId == hourOIdSelect.options[indice].value ) {

                hourOIdSelect.options.selectedIndex = indice;
                trouve=true;
            }
     }
     if ( !trouve ) { hourOIdSelect.options.selectedIndex = indice2iem; }

     if ( no == 1 ) {
        Couche1.hourOId = hourOIdSelect.options[hourOIdSelect.options.selectedIndex].value ;
     } else {
        Couche2.hourOId = hourOIdSelect.options[hourOIdSelect.options.selectedIndex].value ;
     }
     return trouve
} 
// ________________________________________________________________________________
//
function resetMenuDprogSurDt(no, istep) {

    var trouve1 = true;
    var trouve2 = true;

    if ( L_Interca )  {
        if ( no == 1 ) {
         trouve1 = resetMenuHourOId(1, listHourOId1[istep],  listHourOId1[istep], HourOId1Select);
        } else {
         trouve2 = resetMenuHourOId(2, listHourOId2[istep],  listHourOId2[istep], HourOId2Select);
        }
    } else {
        trouve1 = resetMenuHourOId(1, listHourOId1[istep],  listHourOId1[istep], HourOId1Select);
        if ( !Couche2Void ) {
        trouve2 = resetMenuHourOId(2, listHourOId2[istep],  listHourOId2[istep], HourOId2Select);
        }
    }
}

// -----------------------------------------------------------------------------------
//   Selector  for Fin

const FinSelect = document.getElementById('fin');

// ________________________________________________________________________________
function updateFinFromMenu() {

    StopAnimate();

    var proposedFin  = parseInt(FinSelect.options[FinSelect.options.selectedIndex].value) ;
    var changeFin = checkFin( proposedFin, Couche1.getFin() );

    if ( changeFin ) { 
        setListProgTimes();

            if ( ActiveLoop  ) {
                   updateLayers(ISTEP, 0);
                   updateLayers(ISTEP_next, 0);
                setTimeout( StartAnimate, 500)
             } else {
                    Refresh();
             } 
    }  else {

     console.log(" updateFinFromMenu: proposedFin: "+ proposedFin + " Not accepted ");

    }
}
// --------------------------------------------------------------------------------
// Handle change event.
//
FinSelect.onchange = function () { updateFinFromMenu() };

// ________________________________________________________________________________
//
function setMenuFin() {

     let changement = false;
     let layerFin = Couche1.getFin();
     let modelFin = ModAFin.get( Couche1.getModeleZoom() );
     let modelDebut = ModADebut.get( Couche1.getModeleZoom() );

     let interv_ = ModAInterv.get( Couche1.getModeleZoom() );
     let delta_ =0;

     let fin_for_=0;
     let sFin_ = "";

     let modelFinH=0;
     let modelFinM=0;
     let smodelFinH= "";
     let smodelFinM= "";

     let nowcast1=isNowcast( Couche1.getModeleZoom() );

     if ( nowcast1 || (Couche1.getModeleZoom() == "HRDPS E") || (Couche1.getModeleZoom() == "SUDQC") || (Couche1.getModeleZoom() == "SLFE")  ) {
         delta_ = Math.max( interv_, 60);
     } else {
         delta_ = Math.max( interv_, 180);
     }

     fin_for_=Math.round( (modelFin-modelDebut) / delta_) + 1 ;

     FinSelect.options.length = 0;
     let i=0;
     let fin_suivant=modelFin;

     for ( i = 0; i < fin_for_; i++ ) {

         modelFinH=Math.abs( Math.round(fin_suivant / 60. ));
         modelFinM=Math.abs( Math.round(fin_suivant % 60  ));
         smodelFinH=modelFinH.toString();
         smodelFinM=modelFinM.toString();

         if ( smodelFinH.length < 2 ){ smodelFinH="0"+smodelFinH; }
         if ( smodelFinM.length < 2 ){ smodelFinM="0"+smodelFinM; }

         if ( modelFin == 0 ) { 
                   sFin_ = "-"; 
         } else {
                   sFin_ = "";
         }
    
         if ( Math.abs(fin_suivant) >= modelDebut )  {
            if ( nowcast1 ) { 
                sFin_ = sFin_ + smodelFinH + ":" + smodelFinM + "h";
             } else {
                sFin_ = sFin_ + smodelFinH + "h";
             }
             FinSelect.options[FinSelect.options.length] = new Option( sFin_, fin_suivant.toString() );
         }
         fin_suivant = fin_suivant - delta_ ;
     }

     if ( ResetModeleDefaults ) { 
         if ( layerFin != modelFin ) { 
             changement = true;
             layerFin = modelFin;
         }
     }

     let unchangedFin = checkFin( layerFin, modelFin );

     if ( changement )  { unchangedFin = false; } 

     return unchangedFin
}
// ________________________________________________________________________________
//
function resetMenuFin(layerFin,  modelFin)  {

/// la   fonction cherche dans le menu,  la valeur de fin (layerFin)
//  si elle est trouvée,  cet indice du menu sera "selected".
// sinon, ce sera la fin  passée sous modelFin   qui sera  "selected"
    //  et dans ce cas la valeur de fin de la couche sera changé !!!
// ------------------------------------------------------------------------------
       
    let trouve=false;
    let indice =0;
    let indice2iem =0;

    for ( indice = 0; indice < parseInt( FinSelect.options.length ); indice++ ) {

        if ( modelFin == parseInt(FinSelect.options[indice].value) ) { indice2iem = indice; }
            if ( layerFin == parseInt(FinSelect.options[indice].value) ) {
                FinSelect.options.selectedIndex = indice;
                trouve=true;
            }
    }
    if ( !trouve ) { 
        FinSelect.options.selectedIndex = indice2iem; 
    }

    Couche1.fin = parseInt(FinSelect.options[FinSelect.options.selectedIndex].value );
    
    let differenceHourOId = soustractionHourOId(  Couche1.getHourOId(),  Couche2.getHourOId(), true );
    Couche2.fin =  Couche1.getFin() + differenceHourOId;

    return trouve
}

// ________________________________________________________________________________
function checkFin(proposedFin, altFin)  {

    //   la fin doit s'ajuster au début,  à l'interval et au décalage du temps d'origine entre les couches.
    //   la couche 2 s'ajuste à la couche 1
    //
    //   Cette fonction établie les valeurs de fin de couche 1 et 2
    //   Elle établie la fin la plus éloignée en fonction de la demande de fin : proposedFin 
    //
    //   La demande proposedFin peut toutefois être diminuée ...
    //   afin de s'ajuster à la limite maximale de la couche 2 (fin_1_max)
    //   ou afin de s'ajuster à l'un ou l'autre des début de boucle ( couche 1 ou 2: fin_1_min
    //   ou bien finalment afin d etre un multiple entier d interval entre le début et la fin
    //
    //   Une fois la fin correcte établie,   on en dédui fin_2_correcte
    //   via le décalage entre les temps d'origine
    
    let modele1 = Couche1.getModeleZoom();
    let modele2 = Couche2.getModeleZoom();

    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);

    let interv_ = Couche1.getInterval();
    let interv_min = ModAInterv.get( modele1 );

     if ( ( Couche1.getMapIdH().indexOf("_h") != -1) ||
        ( ( Couche2.getMapIdH().indexOf("_h") != -1) && (  !Couche2Void) ) ) {

            interv_min = interv_;
     } 

    let fin_correcte = 0;
    let fin_min = Couche1.getDebut();
    let fin_max = ModAFin.get(modele1);

    let shouroid_latest = "";
    let houroid_fin = 0;
    let shouroid_fin = "";
    let shouroid1_min = "";
    let shouroid2_min = "";
    let shouroid1_max = "";
    let shouroid2_max = "";

    if ( !Couche2Void ) {
       if ( nowcast1 || nowcast2 ) {

       if ( nowcast1 ) {
          shouroid_latest = (ModAHourOId.get(modele1)).slice(0,10) + "00";
          shouroid1_min = getHourOIdPlusMoinsNbMinutes(ModAHourOId.get(modele1), ModADebut.get(modele1), true);
       } else {
          shouroid_latest = ( Couche1.getHourOId() ).slice(0,10) + "00";
          shouroid1_min = getHourOIdPlusMoinsNbMinutes(Couche1.getHourOId(), interv_, true);
       }
       if ( nowcast2 ) {
          shouroid2_min = getHourOIdPlusMoinsNbMinutes(ModAHourOId.get(modele2), ModADebut.get(modele2), true);
       } else {
          shouroid2_min = getHourOIdPlusMoinsNbMinutes(Couche2.getHourOId(), ModADebut.get(modele2), true);
       }

       shouroid1_min = shouroid1_min.slice(0,10) + "00";
       shouroid2_min = shouroid2_min.slice(0,10) + "00";
       houroid_fin = Math.max( parseInt(shouroid1_min), parseInt(shouroid2_min) ); 
       shouroid_fin = (houroid_fin.toString()).slice(0,10) + "00";
       fin_min = Math.max( fin_min, soustractionHourOId( shouroid_fin, shouroid_latest, false ) );

       shouroid1_max = getHourOIdPlusMoinsNbMinutes(ModAHourOId.get(modele1), ModAFin.get(modele1), true);
       shouroid1_max = shouroid1_max.slice(0,10) + "00";
       shouroid2_max = getHourOIdPlusMoinsNbMinutes(ModAHourOId.get(modele2), ModAFin.get(modele2), true);

       shouroid1_max = shouroid1_max.slice(0,10) + "00";
       shouroid2_max = shouroid2_max.slice(0,10) + "00";
       houroid_fin = Math.min( parseInt(shouroid1_max), parseInt(shouroid2_max) );
       shouroid_fin = (houroid_fin.toString()).slice(0,10) + "00";
       fin_max = Math.min( fin_max, soustractionHourOId( shouroid_fin, shouroid_latest, false ) );

       } else {

         let differenceHourOId = soustractionHourOId(  Couche1.getHourOId(),  Couche2.getHourOId(), true );
         fin_min = Math.max( fin_min, Math.max( Couche2.getDebut(), (  Couche2.getDebut() - differenceHourOId)) );
         fin_max = Math.min( fin_max, Math.min( ModAFin.get(modele2),   ( ModAFin.get(modele2)   - differenceHourOId)) );
      }
    }
     fin_correcte = Math.min( fin_max,  proposedFin );
     console.log(" fin_correct: " + fin_correcte + " proposed: " + proposedFin + " max: " + fin_max);
     fin_correcte = Math.max( fin_min, fin_correcte)
     console.log(" fin_correct: " + fin_correcte + " min: " + fin_min);
     fin_correcte = fin_correcte - parseInt( (fin_correcte - Couche1.getDebut() ) % interv_ );
     console.log(" fin_correct: " + fin_correcte + " interv " + interv_);

      let acceptProposed = true;
     if ( fin_correcte != proposedFin ) {  acceptProposed = false; }

     let acceptProposed2 = resetMenuFin(fin_correcte,  altFin);    

     return acceptProposed && acceptProposed2
}
// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//   Selector  for Debut

const DebutSelect = document.getElementById('debut');
    
// ________________________________________________________________________________
function updateDebutFromMenu() {

    StopAnimate();

        var proposedDebut  = parseInt(DebutSelect.options[DebutSelect.options.selectedIndex].value) ;
        var changeDebut = checkDebut( proposedDebut, Couche1.getDebut() );

    if ( changeDebut ) { 
        var unchangedFin = checkFin( Couche1.getFin(), parseInt(FinSelect.options[0].value) );
                setListProgTimes(); 
            if ( ActiveLoop  ) {
                   updateLayers(ISTEP, 0);
                   updateLayers(ISTEP_next, 0);
                setTimeout( StartAnimate, 500)
             } else {
                    Refresh();
             } 
    }  else {
        console.log(" updateDebutFromMenu , proposedDebuT: " + proposedDebut + " not accepted" );

    }
}
// ________________________________________________________________________________
// Handle change event.
//
DebutSelect.onchange = function () { updateDebutFromMenu() };

// ________________________________________________________________________________
function updateDebut(proposedDebut) {

    var changeDebut = checkDebut( proposedDebut, Couche1.getDebut() );

    if ( changeDebut ) { 
        var unchangedFin = checkFin( Couche1.getFin(), parseInt(FinSelect.options[0].value) );
                setListProgTimes(); 
            if ( ActiveLoop  ) {
                   updateLayers(ISTEP, 0);
                   updateLayers(ISTEP_next, 0);
                setTimeout( StartAnimate, 500)
             } else {
                    Refresh();
             } 
    }  else {
        console.log(" updateDebutFromMenu , proposedDebuT: " + proposedDebut + " not accepted" );
    }
}

// ________________________________________________________________________________
//
function setMenuDebut() {

    let changement = false;
    let layerDebut = Couche1.getDebut();

    let modelDebut = ModADebut.get( Couche1.getModeleZoom() );
    let modelFin = ModAFin.get( Couche1.getModeleZoom() );
    let interv_ = ModAInterv.get( Couche1.getModeleZoom() );
    let interv_inc= Math.max(60, interv_);
    
    let fin_for_=0;

    let sdebut_ = "";

    let modelDebutH = 0;
    let modelDebutM = 0;
    let smodelDebutH = "";
    let smodelDebutM = "";
    let debut_suivant=modelDebut;

    let nowcast1=isNowcast( Couche1.getModeleZoom() );
    if ( nowcast1 ) { 
        fin_for_=Math.round( (modelFin-modelDebut) / interv_inc) ;
        debut_suivant=-1*fin_for_*interv_inc;
    } else {
        fin_for_= Math.round(modelFin / interv_inc) ;
    }

     DebutSelect.options.length = 0;
     let i=0;

     for ( i = 0; i < fin_for_; i++ ) {
                                  
        modelDebutH = Math.abs(Math.round(debut_suivant / 60.));
        modelDebutM = Math.abs(Math.round(debut_suivant % 60 ));
        smodelDebutH = modelDebutH.toString();
        smodelDebutM = modelDebutM.toString();
    
        if ( smodelDebutH.length < 2 ){ smodelDebutH="0"+smodelDebutH; }
        if ( smodelDebutM.length < 2 ){ smodelDebutM="0"+smodelDebutM; }

        if ( modelDebut < 0 ) { 
                   sdebut_ = "-"; 
        } else {
                   sdebut_ = "";
        }
    
       if ( debut_suivant <= modelFin )  {
           if ( nowcast1 ) { 
               sdebut_ = sdebut_ + smodelDebutH + ":" + smodelDebutM + "h";
           } else {
               sdebut_ = sdebut_ + smodelDebutH + "h";
           }
          DebutSelect.options[DebutSelect.options.length] = new Option( sdebut_, debut_suivant.toString());
       }   
       debut_suivant = debut_suivant + interv_inc ;
     }

     if ( ResetModeleDefaults ) {

           if ( nowcast1 ) { 
                modelDebut = -60;
           }
             if ( layerDebut != modelDebut ) {
                     changement = true;
                     layerDebut = modelDebut;
             }
     }

     var unchangedDebut = checkDebut( layerDebut, modelDebut );

     if ( changement )  { unchangedDebut = false; }

     return unchangedDebut
}
// ________________________________________________________________________________
//
function resetMenuDebut(layerDebut,  modelDebut)  {

/// la   fonction cherche dans le menu,  la valeur de debut (layerDebut)
//  si elle est trouvée,  cet indice du menu sera "selected".
// sinon, ce sera la debut  passée sous modelDebut   qui sera  "selected"
    //  et dans ce cas la valeur de debut de la couche sera changé !!!
// ------------------------------------------------------------------------------
       
    let trouve=false;
    let indice =0;
    let indice2iem =0;

   let differenceHourOId = soustractionHourOId(  Couche1.getHourOId(),  Couche2.getHourOId(), true );

    for ( indice = 0; indice < parseInt(DebutSelect.options.length) ; indice++ ) {

        if ( modelDebut == parseInt(DebutSelect.options[indice].value ) ){ indice2iem = indice; }
            if ( layerDebut == parseInt(DebutSelect.options[indice].value ) ) {
                DebutSelect.options.selectedIndex = indice;
                trouve=true;
            }
    }
    if ( !trouve ) { 
        DebutSelect.options.selectedIndex = indice2iem; 
    }
    Couche1.debut = parseInt(DebutSelect.options[DebutSelect.options.selectedIndex].value ) ;
    Couche2.debut =  Couche1.getDebut() + differenceHourOId;
    return trouve
}
// ________________________________________________________________________________
//
function checkDebut( proposedDebut, altDebut)  {

    //   le Debut doit s'ajuster à l'interval et au décalage de temps d'origine entre les couche 1 et 2
    //   la couche 2 s'ajuste à la couche 1
    //
    //   Cette fonction établie les valeurs de Debut de couche 1 qui tient compte de la couche 2. 
    //   Elle établie le debut le plus près de l'origine en fonction de la demande de Debut :  proposedDebut
    //
    //   La demande proposedDebut peut toutefois être  retarder (augmenté)
    //   afin de s'ajuster à la limite maximale de fin des couche  1 et 2:  debut_1_max
    //   ou afin de s'ajuster à l'un ou l'autre des début de boucle ( couche 1 ou 2: debut_1_min
    //   ou bien finalment afin d etre plus grand ou egal à l interval dans le cas ou il y a des accumulations
    //
    //   Une fois le debut correcte établie, on fait appel au menu pour trouver
    //
    let modele1 = Couche1.getModeleZoom();
    let modele2 = Couche2.getModeleZoom();

    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);

    let interv_ = Couche1.getInterval();
    let interv_min = ModAInterv.get( modele1 );

     if ( ( Couche1.getMapIdH().indexOf("_h") != -1) ||
        ( ( Couche2.getMapIdH().indexOf("_h") != -1) && (  !Couche2Void) ) ) {

            interv_min = interv_;
     } 

    let debut_correct = 0;
    let debut_min = ModADebut.get(modele1);
    let debut_max = ModAFin.get(modele1);

    let shouroid_latest = "";
    let houroid_debut = 0;
    let shouroid_debut = "":
    let shouroid1_min = "";
    let shouroid2_min = "";
    let shouroid1_max = "";
    let shouroid2_max = "";

    if ( !Couche2Void ) {
       if ( nowcast1 || nowcast2 ) {

          if ( nowcast1 ) {
             shouroid_latest = (ModAHourOId.get(modele1)).slice(0,10) + "00";
             shouroid1_min = getHourOIdPlusMoinsNbMinutes(ModAHourOId.get(modele1), ModADebut.get(modele1), true);
          } else {
             shouroid_latest = ( Couche1.getHourOId() ).slice(0,10) + "00";
             shouroid1_min = getHourOIdPlusMoinsNbMinutes(Couche1.getHourOId(), interv_, true);
          }
          if ( nowcast2 ) {
             shouroid2_min = getHourOIdPlusMoinsNbMinutes(ModAHourOId.get(modele2), ModADebut.get(modele2), true);
          } else {
             shouroid2_min = getHourOIdPlusMoinsNbMinutes(Couche2.getHourOId(), Math.max(ModADebut.get(modele2), interv_), true);
          }

          shouroid1_min =  shouroid1_min.slice(0,10) + "00";
          shouroid2_min =  shouroid2_min.slice(0,10) + "00";
          houroid_debut = Math.max( parseInt(shouroid1_min), parseInt(shouroid2_min) ); 
          shouroid_debut = (houroid_debut.toString()).slice(0,10) + "00";
          debut_min = Math.max( debut_min, soustractionHourOId( shouroid_debut, shouroid_latest, false ) );

          shouroid1_max = getHourOIdPlusMoinsNbMinutes(ModAHourOId.get(modele1), ModAFin.get(modele1), true);
          shouroid1_max = shouroid1_max.slice(0,10) + "00";
          shouroid2_max = getHourOIdPlusMoinsNbMinutes(ModAHourOId.get(modele2), ModAFin.get(modele2), true);

          shouroid1_max =  shouroid1_max.slice(0,10) + "00";
          shouroid2_max =  shouroid2_max.slice(0,10) + "00";
          houroid_debut = Math.min( parseInt(shouroid1_max), parseInt(shouroid2_max) );
          shouroid_debut = (houroid_debut.toString()).slice(0,10) + "00";
          debut_max = Math.min( debut_max, soustractionHourOId( shouroid_debut, shouroid_latest, false ) );

       } else {
         let differenceHourOId = soustractionHourOId(  Couche1.getHourOId(),  Couche2.getHourOId(), true );
         debut_min = Math.max( debut_min, Math.max( ModADebut.get(modele2), ( ModADebut.get(modele2) - differenceHourOId)) );
         debut_max = Math.min( debut_max, Math.min( ModAFin.get(modele2),   ( ModAFin.get(modele2)   - differenceHourOId)) );
       }
    }
    if ( Math.abs(debut_min) < interv_min ) {
        if ( debut_min > 0 ) {
            debut_min = interv_min;
        } else {
            debut_min = -interv_min;
        }
    } else if (Math.abs(debut_min) % interv_min != 0 ) { 
        debut_min = (debut_min + interv_min) - ( Math.abs(debut_min) % interv_min);  
    } 
    if ( Math.abs(debut_max) < interv_min ) {
        if ( debut_max > 0 ) {
           debut_max = interv_min;
        } else {
           debut_max = -interv_min;
        }
    } else if (debut_max % interv_min != 0 ) { 
           debut_max = debut_max - ( Math.abs(debut_max) % interv_min);
    } 
    debut_correct = proposedDebut - ( proposedDebut % interv_min );

     debut_correct = Math.max( debut_min, debut_correct );
     debut_correct = Math.min( debut_max, debut_correct );

     var acceptProposed = true;
     if ( debut_correct != proposedDebut ) { acceptProposed = false; }

     var acceptProposed2 = resetMenuDebut(debut_correct,  altDebut);

     return  acceptProposed && acceptProposed2
}
// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//   Selector  for Interval

    const IntervalSelect = document.getElementById('interval');
    change_pas = setMenuInterval();
    change_pas = setMenuDebut();
    change_pas = setMenuFin();
    
// ________________________________________________________________________________
function updateIntervalFromMenu() {

    StopAnimate();

    var proposedInterval  = parseInt( IntervalSelect.options[IntervalSelect.options.selectedIndex].value) ;
    var changeInterval = checkInterv( proposedInterval, Couche1.getInterval() );

    var unchangedDebut = true;
    var unchangedFin = true;

        if ( changeInterval ) { 
            unchangedDebut = checkDebut( Couche1.getDebut(), parseInt(DebutSelect.options[0].value) ); 
            unchangedFin =   checkFin( Couche1.getFin(), parseInt(FinSelect.options[0].value) );    
            setListProgTimes();

            if ( ActiveLoop  ) {
                   updateLayers(ISTEP, 0);
                   updateLayers(ISTEP_next, 0);
                setTimeout( StartAnimate, 500)
             } else {
                    Refresh();
             } 
                
        if ( ( Couche1.getMapIdH().indexOf("_h") != -1) ) { RefreshLgnd(1); }
        if ( ( Couche2.getMapIdH().indexOf("_h") != -1) && ( !Couche2Void ) ) { RefreshLgnd(2); }
    } else {
       console.log(" updateInrevalFromMenu , proposedInterval " + proposedInterval + " not accepted" ); 
    } 
}
// ________________________________________________________________________________
// Handle change event.
//
IntervalSelect.onchange = function () { updateIntervalFromMenu() };

// ________________________________________________________________________________
//
function setMenuInterval() {

    var changement = false;
    var layerInterval = Couche1.getInterval();

    var model1 = Couche1.getModeleZoom();
    var model2 = Couche2.getModeleZoom();

    var interv_min = ModAInterv.get( model1 );

    var interv_max  = 0;
    if      ( model1 == "GDPS" || model1 == "ECMWF" || model1 == "AIFS" || model1 == "GDPSIA" || model1 == "GFS" )  {  interv_max=2880; } 
    else if ( model1 == "GDPSE" || model1 == "GDPSIAE" || model1 == "ECMWFE" || model1 == "AIFSE" )  {  interv_max=2880; } 
    else if ( model1 == "RDPS" ||  model1 == "ECMWF3" || model1 == "RAQDPS"   )  {  interv_max=1440; } 
    else if ( model1 == "HRDPS E" ||  model1 == "HRDPS W" ) { interv_max = 720; } 
    else if ( model1 == "HRDPS S" ) { interv_max = 720; } 
    else if ( model1 == "HRDPS S0" || model1 == "HRDPS S1" || model1 == "HRDPS S2" || model1 == "HRDPS S3" ) { interv_max = 720; } 
    else if ( model1 == "WCPS" || model1 == "CIOPS" || model1 == "SHOP" || model1 == "RDWPS" || model1 == "DIAGW"  ) { interv_max = 720; } 
    else if (( model1 == "GOESR GLM" ) || (model1 == "GOESR CO") || (model1 == "FOUDRE CO" ) || ( model1 == "GOESR_PLUS" )) { interv_max = 720; } 
    else if (( model1 == "RADART CO" ) || (model1 == "RADAR CO" )) { interv_max = 720; } 


    let nowcast1=isNowcast(model1);
    if ( !Couche2Void && !nowcast1 ) {
        interv_min = Math.max( interv_min, ModAInterv.get( model2 ) );

        if      ( model2 == "GDPS" || model2 == "ECMWF" || model2 == "AIFS" || model2 == "GDPSIA" || model2 == "GFS" )  {  interv_max= Math.min( 2880, interv_max ); } 
    else if ( model2 == "GDPSE" || model2 == "GDPSIAE" || model2 == "ECMWFE" || model2 == "AIFSE")  {  interv_max= Math.min( 2880, interv_max ); } 
        else if ( model2 == "RDPS" || model2 == "ECMWF3"  || model2 == "RAQDPS")  {  interv_max= Math.min( 1440, interv_max ); } 
        else if ( model2 == "HRDPS E" ||  model2 == "HRDPS W" ) { interv_max = Math.min( 720, interv_max ); } 
        else if ( model2 == "HRDPS S" ) { interv_max = Math.min( 720, interv_max ); } 
        else if ( model2 == "HRDPS S0" || model2 == "HRDPS S1" || model2 == "HRDPS S2" || model2 == "HRDPS S3" ) { interv_max = Math.min( 720, interv_max ); } 
        else if ( model2 == "WCPS" || model2 == "CIOPS" || model2 == "SHOP"  || model2 == "RDWPS" || model2 == "DIAGW" ) { interv_max = Math.min( 720, interv_max ); } 
        else if (( model2 == "GOESR GLM" ) || (model2 == "GOESR CO" ) || (model2 == "FOUDRE CO" ) || ( model2 == "GOESR_PLUS" )) { interv_max = Math.min( 720, interv_max ); } 
        else if (( model2 == "RADART CO" ) || (model2 == "RADAR CO" )) { interv_max = Math.min( 720, interv_max ); } 
    }

     let intervalH= Math.round( interv_min/60. );
     let sinterval = intervalH.toString() + "h";

     IntervalSelect.options.length = 0;

     if ( !nowcast1) {
              sinterval = intervalH.toString() + "h";
              IntervalSelect.options[IntervalSelect.options.length] = new Option( sinterval, interv_min);
     } else {
              sinterval = interv_min.toString() + "m";
              IntervalSelect.options[IntervalSelect.options.length] = new Option( sinterval, interv_min);
     }

     let interval_suivant=interv_min;

     let i=0;
     for ( i = 1; i < 5; i++ ) {
                                  
       interval_suivant = interval_suivant * 2   ;
       if ( interval_suivant == 10 )  { interval_suivant = 30 }      // 5m, 30m, 60m, 180m, 360m pour GOES  
       if ( interval_suivant == 12 )  { interval_suivant = 30 }    //  6m, 30m, 60m, 180m, 360m pour RADAR
       if ( interval_suivant == 120)  { interval_suivant = 180 }    // 60m, 180m, 360m, 720m pour HRDPS-S 

       if ( interval_suivant <  interv_max + 1 )  {

          if ( !nowcast1 ) {
              intervalH= Math.round( interval_suivant/60. );
              sinterval = intervalH.toString() + "h";
              IntervalSelect.options[IntervalSelect.options.length] = new Option( sinterval, interval_suivant);
          } else {
              sinterval = interval_suivant.toString() + "m";
              IntervalSelect.options[IntervalSelect.options.length] = new Option( sinterval, interval_suivant);
          }
       }   
     }
     if ( ResetModeleDefaults ) {

             if ( layerInterval != interv_min ) {
                     changement = true;
                     layerInterval = interv_min;
             }
     }

     var unchangedInterval = checkInterv( layerInterval, interv_min );

     if ( changement )  { unchangedInterval = false; }

    if ( ( Couche1.getMapIdH().indexOf("_h") != -1) ) { RefreshLgnd(1); } 
    if ( !Couche2Void ) {
        if (  Couche2.getMapIdH().indexOf("_h") != -1)  { RefreshLgnd(2); }
    }
}
// ________________________________________________________________________________
//
function resetMenuInterval(layerInterval,  modelInterval)  {

/// la   fonction cherche dans le menu,  la valeur de Interval (layerInterval)
//  si elle est trouvée,  cet indice du menu sera "selected".
// sinon, ce sera la interval  passée sous modelInterval   qui sera  "selected"
    //  et dans ce cas la valeur de L interval de la couche sera changé !!!
// ------------------------------------------------------------------------------
       
    var trouve=false;
    var indice =0;
    var indice2iem =0;

    for ( indice = 0; indice < parseInt(IntervalSelect.options.length); indice++ ) {

        if ( modelInterval == parseInt(IntervalSelect.options[indice].value) ) { indice2iem = indice; }
            if ( layerInterval == parseInt(IntervalSelect.options[indice].value) ) {
                IntervalSelect.options.selectedIndex = indice;
                trouve=true;
            }
    }
    if ( !trouve ) { 
        IntervalSelect.options.selectedIndex = indice2iem; 
    }
    Couche1.interval = parseInt(IntervalSelect.options[IntervalSelect.options.selectedIndex].value );
    Couche2.interval = parseInt(IntervalSelect.options[IntervalSelect.options.selectedIndex].value );

    return trouve
}
// ________________________________________________________________________________
//
function checkInterv( proposedInterval,  altInterval )  {

    var differenceHourOId = soustractionHourOId(  Couche1.getHourOId(),  Couche2.getHourOId(), true );

    var interv_correcte = 0;
    var interv_max = 0;
    var interv_max2 = 0;
    var model1 = Couche1.getModeleZoom();
    var model2 = Couche2.getModeleZoom();

    var interv_min = ModAInterv.get(model1);

    if      ( model1 == "GDPS" || model1 == "ECMWF" || model1 == "AIFS" || model1 == "GDPSIA" || model1 == "GFS" )  { interv_max=2880; } 
    else if ( model1 == "GDPSE" || model1 == "GDPSIAE" || model1 == "ECMWFE" || model1 == "AIFSE" )  { interv_max=2880; } 
    else if ( model1 == "RDPS"  || model1 == "ECMWF3" || model1 == "RAQDPS" )  {  interv_max=1440; } 
    else if ( model1 == "HRDPS E" ||  model1 == "HRDPS W" ) { interv_max = 720; } 
    else if ( model1 == "HRDPS S" || model1 == "CIOPS" ) { interv_max = 720; } 
    else if ( model1 == "HRDPS S0" || model1 == "HRDPS S1" || model1 == "HRDPS S2" || model1 == "HRDPS S3" ) { interv_max = 720; } 
    else if ( model1 == "WCPS" || model1 == "SHOP" || model1 == "RDWPS"  || model1 == "DIAGW") { interv_max = 720; } 
    else if ((model1 == "GOESR GLM" ) || (model1 == "GOESR CO" ) || (model1 == "FOUDRE CO" ) || ( model1 == "GOESR_PLUS" )) { interv_max = 720; } 
    else if ((model1 == "RADART CO" ) || (model1 == "RADAR CO" )) { interv_max = 720; } 
    
    let nowcast1=isNowcast(model1);

    if ( !Couche2Void && !nowcast1 ) {
        interv_min = Math.max( interv_min, ModAInterv.get(model2) );
    if      ( model2 == "GDPS" || model2 == "ECMWF" || model2 == "AIFS"  || model2 == "GDPSIA" || model2 == "GFS" )  {interv_max= Math.min( 2880, interv_max ); } 
    else if ( model2 == "GDPSE" || model2 == "GDPSIAE" || model2 == "ECMWFE" || model2 == "AIFSE" )  {interv_max= Math.min( 2880, interv_max ); } 
    else if ( model2 == "RDPS"  || model2 == "ECMWF3" || model2 == "RAQDPS" )  {interv_max= Math.min( 1440, interv_max ); } 
    else if ( model2 == "HRDPS E" ||  model2 == "HRDPS W" ) { interv_max = Math.min( 720, interv_max ); } 
    else if ( model2 == "HRDPS S" || model2 == "CIOPS" ) { interv_max = Math.min( 720, interv_max ); } 
    else if ( model2 == "HRDPS S0" || model2 == "HRDPS S1" || model2 == "HRDPS S2" || model2 == "HRDPS S3" ) { interv_max = Math.min( 720, interv_max ); } 
    else if ( model2 == "WCPS" || model2 == "SHOP"  || model2 == "RDWPS" || model2 == "DIAGW" ) { interv_max = Math.min( 720, interv_max ); } 
        else if ((model2 == "GOESR GLM" ) || (model2 == "GOESR CO" ) || ( model2 == "GOESR_PLUS" )) { interv_max = Math.min( 720, interv_max ); }
    else if ( ( model2 == "RADART CO" ) || ( model2 == "RADAR CO" ) ) { interv_max = Math.min( 720, interv_max ); } 
    }

    interv_max2 = interv_max ;

    if ( differenceHourOId != 0 )  { 
        if ( (  Couche1.getMapIdH().indexOf("_h") != -1) || 
         (( Couche2.getMapIdH().indexOf("_h") != -1) && ( !Couche2Void && !nowcast1 )  ) ) {

        // when a layer has precip accum, and there is difference between the  between the origin hour (houroid) 
    // then the interval must be smaller or equal to the difference between the origin hour (houroid)  
        //   then the max interv should not exceed the difference between houroid
        //
        interv_max2 = Math.min( Math.abs(differenceHourOId), interv_max ); 
          }
      } 
     interv_correcte = Math.min( Math.max( proposedInterval, interv_min),  interv_max2 );

     var unchangedInterval = true;
     if ( interv_correcte != proposedInterval ) { unchangedInterval = false; }

     var unchangedInterval2 = resetMenuInterval(interv_correcte,  altInterval);

     return unchangedInterval &&  unchangedInterval2
}
// ________________________________________________________________________________
function refreshHouroid(no) {

    var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = DprogDt;
    let ResetModeleDefaultsWasTrue = ResetModeleDefaults;

    message = " refreshHouroid est en action ";
    console.log(message);

    StopAnimate();

    if (( no == 1 ) || (no == 0 )) { couche_change_pas = setMenuHourOId(true, 1, HourOId1Select);    }
    if ( !Couche2Void  && ((no == 2) || (no == 0 ) )) { couche_change_pas = setMenuHourOId(true, 2, HourOId2Select); }

    couche_change_pas = setMenuInterval();
    couche_change_pas = setMenuDebut();
    couche_change_pas = setMenuFin();
    setListProgTimes();
        
            if ( ActiveLoop  ) {
                if ( no == 1 || no == 0 ) {
                   updateLayers(ISTEP, 1);
                   updateLayers(ISTEP_next, 1);
                } 
                if ( no == 2 || no == 0 ) {
                   updateLayers(ISTEP, 2);
                   updateLayers(ISTEP_next, 2);
                }
                setTimeout( StartAnimate, 500)
             } else {
                    Refresh();
             } 
}

// ________________________________________________________________________________

$("#resetHouroid").click(function(){
                               let model_ = Couche1.modeleZoom;
                               readSetLatestHourOId(ModAHourOId.get( model_ ), model_, true, true );                                                                                                       
                               if ( Couche2.modeleZoom != Couche1.modeleZoom ) {
                                       model_=Couche2.modeleZoom;
                                       readSetLatestHourOId( ModAHourOId.get( model_ ), model_, true, true );
                               }
                         });

$("#resetInterv").click(function(){ resetInterv(); });
$("#resetDebut").click(function(){ resetDebut(); });
$("#resetFin").click(function(){ resetFin(); });
// ________________________________________________________________________________
function resetInterv() {

        var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = DprogDt;

//  if ( DprogDt ) {
        
//   DprogDtSelect.options.selectedIndex = 0;
 //        updateDprogDtFromMenu();
//  } 
    
    message = " resetInterv est en action ";
    console.log(message);

    StopAnimate();

    ResetModeleDefaults = true;
    couche_change_pas = setMenuInterval();
    ResetModeleDefaults = false;
    couche_change_pas = setMenuDebut();
    couche_change_pas = setMenuFin();

//  if ( dprogDTwasTrue ) {
 //     DprogDtSelect.options.selectedIndex = 1;
  //        updateDprogDtFromMenu();
   //     }
    
    setListProgTimes();
        
            if ( ActiveLoop  ) {
                   updateLayers(ISTEP, 0);
                   updateLayers(ISTEP_next, 0);
                   setTimeout( StartAnimate, 500)
             } else {
                    Refresh();
             } 
}
// ________________________________________________________________________________
function resetDebut() {

        var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = DprogDt;

//  if ( DprogDt ) {
        
//   DprogDtSelect.options.selectedIndex = 0;
 //        updateDprogDtFromMenu();
//  } 
    
    message = " resetDebut est en action ";
    console.log(message);

    StopAnimate();

    ResetModeleDefaults = true;
    couche_change_pas = setMenuDebut();
    ResetModeleDefaults = false;
    couche_change_pas = setMenuFin();

//  if ( dprogDTwasTrue ) {
 //     DprogDtSelect.options.selectedIndex = 1;
  //        updateDprogDtFromMenu();
   //     }
    
    setListProgTimes();
        
            if ( ActiveLoop  ) {
                   updateLayers(ISTEP, 0);
                   updateLayers(ISTEP_next, 0);
                   setTimeout( StartAnimate, 500)
             } else {
                    Refresh();
             } 
}
//_____________________________________________________________________________________
function resetFin() {

        var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = DprogDt;

//  if ( DprogDt ) {
        
//   DprogDtSelect.options.selectedIndex = 0;
 //        updateDprogDtFromMenu();
//  } 
    
    message = " resetFin est en action ";
    console.log(message);

    StopAnimate();

    ResetModeleDefaults = true;
    couche_change_pas = setMenuFin();
    ResetModeleDefaults = false;

//  if ( dprogDTwasTrue ) {
 //     DprogDtSelect.options.selectedIndex = 1;
  //        updateDprogDtFromMenu();
   //     }
    
    setListProgTimes();
        
            if ( ActiveLoop  ) {
                   updateLayers(ISTEP, 0);
                   updateLayers(ISTEP_next, 0);
                setTimeout( StartAnimate, 500)
             } else {
                    Refresh();
             } 
}

// ________________________________________________________________________________
function resetDebutFinInterNowcast() {

    var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = DprogDt;
    let ResetModeleDefaultsWasTrue = ResetModeleDefaults;

    message = " resetDebutFinInt est en action ";
    console.log(message);

    StopAnimate();

    ResetModeleDefaults = true;
    couche_change_pas = setMenuInterval();
    ResetModeleDefaults = false;
    couche_change_pas = setMenuDebut();
    ResetModeleDefaults = true;
    couche_change_pas = setMenuFin();
    ResetModeleDefaults = ResetModeleDefaultsWasTrue;

    setListProgTimes();
        
            if ( ActiveLoop  ) {
                   updateLayers(ISTEP, 0);
                   updateLayers(ISTEP_next, 0);
                   setTimeout( StartAnimate, 500)
             } else {
                    Refresh();
             } 
}
// ________________________________________________________________________________
function resetTimeMenus() {

        var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = DprogDt;

    message = " resetTimesMenus est en action ";
    console.log(message);

    StopAnimate();

    ResetModeleDefaults = true;
    couche_change_pas = setMenuHourOId(true, 1, HourOId1Select);
    if ( !Couche2Void  ) { couche_change_pas = setMenuHourOId(true, 2, HourOId2Select); }

    couche_change_pas = setMenuInterval();
    couche_change_pas = setMenuDebut();
    couche_change_pas = setMenuFin();
    ResetModeleDefaults = false;

    setListProgTimes();

    if ( ActiveLoop  ) {
         updateLayers(ISTEP, 0);
         updateLayers(ISTEP_next, 0);
         setTimeout( StartAnimate, 500);
    } else {
         setTimeout( Refresh, 500);
    } 
}

// -----------------------------------------------------------------------------------
$("#resetTimeMenus").click(function(){ resetTimeMenus(); });

// ________________________________________________________________________________
function AfficheEffaceChoixDuo(lettre) {
    var message = " ";

    if ( DprogDt ) {
        message = " Cette action ne fonctionne pas en mode valid constant ";
        alert(message);
    } else {
        message = " Presets est en action ";
        console.log(message);

        StopAnimate();
        if ( lettre == "A" )  {
             document.getElementById("choixDuoA").style.display = "block";
        } else if ( lettre == "B" ) {
             document.getElementById("choixDuoB").style.display = "block";
        } else if ( lettre == "C" ) {
           document.getElementById("choixDuoC").style.display = "block";
        } else if ( lettre == "D" ) {
             document.getElementById("choixDuoD").style.display = "block";
        } else if ( lettre == "N" ) {
             document.getElementById("choixDuoN").style.display = "block";
        }
    } 
}

// -----------------------------------------------------------------------------------
$("#ChoixDuoA").click(function(){ AfficheEffaceChoixDuo("A"); });
$("#ChoixDuoB").click(function(){ AfficheEffaceChoixDuo("B"); });
$("#ChoixDuoC").click(function(){ AfficheEffaceChoixDuo("C"); });
$("#ChoixDuoD").click(function(){ AfficheEffaceChoixDuo("D"); });
$("#ChoixDuoN").click(function(){ AfficheEffaceChoixDuo("N"); });

// -----------------------------------------------------------------------------------
//   Selector  for Valeur

const ValeurSelect1 = document.getElementById('valeur1');
const ValeurSelect2 = document.getElementById('valeur2');
    
var Valeur1 = "off";
var Valeur2 = "off";
var Valeur1Hist = "off";
var Valeur2Hist = "off";

// ________________________________________________________________________________
// Handle change event.
//
ValeurSelect1.onchange = function () { updateValeurFromMenu(1) };
ValeurSelect2.onchange = function () { updateValeurFromMenu(2) };

setMenuValeurs(1, ValeurSelect1);
setMenuValeurs(2, ValeurSelect2);

// ________________________________________________________________________________
//
function setMenuValeurs(no, valeurSelect) {

    var model = "";
    var layerValeur = "";
    
    if ( no == 1 ) {
         model = Couche1.getModeleZoom();
         layerValeur = Valeur1
    }  else 

    if ( no == 2 ) {
         model = Couche2.getModeleZoom();
         layerValeur = Valeur2
    } 

    valeurSelect.options.length  = 0;

    if  ( ( model == "GDPS" ) ||  ( model == "GDPSE" ) || ( model == "GDPSIA" ) || ( model == "GDPSIAE" ) ) {

        valeurSelect.options[valeurSelect.options.length]  = new Option( 'off', 'off');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'Popup', 'Popup');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'TimSer', 'TimSer');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'TimSer_e', 'TimSer_e');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'MeteoGrm', 'MeteoGrm');

    } else if ( model == "WCPS" ) {
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'off', 'off');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'Popup', 'Popup');

    } else if ( model == "RDWPS" ) {
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'off', 'off');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'Popup', 'Popup');

    } else if ( model == "DIAGW" ) {
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'off', 'off');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'Popup', 'Popup');

    } else if ( model == "SHOP" ) {
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'off', 'off');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'Popup', 'Popup');

    } else if ( model == "ECMWF" || model == "ECMWF3" || model == "ECMWFE" ) {

        valeurSelect.options[valeurSelect.options.length]  = new Option( 'off', 'off');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'Popup', 'Popup');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'TimSer', 'TimSer');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'TimSer_e', 'TimSer_e');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'MeteoGrm', 'MeteoGrm');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'ProfVert', 'ProfVert');

    } else if ( model == "AIFS" || model == "AIFSE" ) {

        valeurSelect.options[valeurSelect.options.length]  = new Option( 'off', 'off');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'Popup', 'Popup');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'TimSer', 'TimSer');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'TimSer_e', 'TimSer_e');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'MeteoGrm', 'MeteoGrm');

    } else {
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'off', 'off');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'Popup', 'Popup');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'TimSer', 'TimSer');
        valeurSelect.options[valeurSelect.options.length]  = new Option( 'TimSer_e', 'TimSer_e');
    }

    var altValeur = valeurSelect.options[0].value;
    var inchangee = resetMenuValeurs(no, layerValeur,  altValeur, valeurSelect);
         
    var message = " Le menu Valeurs de la couche " + no.toString() + " a été mis à jour ";  
    console.log(message);
    
     if ( inchangee )  { 
         var message = " Le choix de Valeurs demeure intact";  
         console.log(message);
     } else {
         var message = " Le choix de valeur a due être modifié";
         console.log(message);
     } 
    return inchangee
}
// ________________________________________________________________________________
//
function resetMenuValeurs(no, layerValeur,  altValeur, valeurSelect)  {

/// la   fonction cherche dans le menu,  la valeur de valeur de la couche ()
//  si elle est trouvée,  cet indice du menu sera "selected".
// sinon, ce sera le Valeur  passé sous altValeur  qui sera  "selected"
//  et dans ce cas la valeur de Valeur de la couche sera changé !!!
// ------------------------------------------------------------------------------
       
    var trouve=false;
    var indice =0;
    var indice2iem =0;

    for ( indice = 0; indice < valeurSelect.options.length; indice++ ) {
   
            if (   altValeur == valeurSelect.options[indice].value ) { indice2iem = indice; }
            if ( layerValeur == valeurSelect.options[indice].value ) {
                valeurSelect.options.selectedIndex = indice;
                trouve=true;
            }
     }
     if ( !trouve ) { 

        valeurSelect.options.selectedIndex = indice2iem; 
     
        var message = " (resetMenuValeurs) La Valeur: " + layerValeur + " (couche " + no + ") change et devient: " + altValeur ;
        console.log(message);
        //openAfficheInfo(message,10);

          UnsetValeurs("0");
          Valeur1Hist = "off";
          Valeur2Hist = "off";
     }
     if ( no == 1 ) {
        Valeur1 = valeurSelect.options[valeurSelect.options.selectedIndex].value ;
     } else {
        Valeur2 = valeurSelect.options[valeurSelect.options.selectedIndex].value ;
     }
     return trouve
}
// ________________________________________________________________________________
function ResetValeurs() {

       if ( ( Valeur1Hist != "off" ) && ( ! L_Juxtapo ) ) {
//                                   si Valeur1Hist est autre que off,  alors Valeur1 est off et on va le réactiver
//                                   réactivation du menu
          resetMenuValeurs(1, Valeur1Hist, "off",  ValeurSelect1); 
//                                    ici le menu a été réajusté à ValeurHist,   mais Valeur1 a été mis à jour trop tot...
          Valeur1 = "off";
//                          Valeur1 a été remis a off ci-haut pour réfleter le vrai passage de off à Valeur1Hist dans l appel qui suit
//                          réactivation de Valeur1 à partir du menu et organisation des callback, fenetres
          updateValeurFromMenu(1);
          Valeur1Hist = "off";
       } 
        if ( ( Valeur2Hist != "off" )  && ( ! L_Juxtapo ) ) {
//                                   si Valeur2Hist est autre que off,  alors Valeur2 est off et on va le réactiver
//                                   réactivation du menu
          resetMenuValeurs(2, Valeur2Hist, "off",  ValeurSelect2);
//                                    ici le menu a été réajusté à ValeurHist,   mais Valeur2 a été mis à jour trop tot...
          Valeur2 = "off";
//                          Valeur2 a été remis a off ci-haut pour réfleter le vrai passage de off à Valeur1Hist dans l appel qui suit
//                          réactivation de Valeur1 à partir du menu et organisation des callback, fenetres
          updateValeurFromMenu(2);
          Valeur2Hist = "off";
       }
}
// ________________________________________________________________________________
function UnsetValeurs(no_) {

//   no_ == 0  ou 1
      if ( no_ != "2" &&  Valeur1 != "off" ) {
       Valeur1Hist = Valeur1;
       ValeurSelect1.options.selectedIndex = 0;
       updateValeurFromMenu(1);
      } 
//   no_  == 0 ou 2
      if ( no_ != "1" && Valeur2 != "off" ) {
       Valeur2Hist = Valeur2;
       if ( Couche2Void ) {   Valeur2Hist ="off"; }
       ValeurSelect2.options.selectedIndex = 0;
       updateValeurFromMenu(2);
     }
}
// ________________________________________________________________________________
function updateValeurFromMenu(no) {

    var model_1= Couche1.getModele();
    var model_2= Couche2.getModele();
    ActiveLoop = false;
    StopAnimate();
    document.getElementById('StopAnimate').style.display = "none";
    document.getElementById('StartAnimate').style.display = "initial";
        

    document.getElementById("spot_iframe").style.display = "inherit";
    document.getElementById("spot_iframe").style.visibility = "hidden";

    var message=" Change valeur pour la couche  " + no.toString();
    console.log(message); 

    const otherWrapper = document.getElementById("map_et_map2_wrapper");

    //      Before updating Valeur1 and Valeur2, 
    //      remove previous singleclick event
    //      and remove spotwx screen space if needed

//map2
    if ( Valeur1 == "Popup" && no == "1" ) {

        Popup1Overlay.setPosition(undefined);
        Popup1Closer.blur();
        map.un('singleclick', ValeurClick);

        message=" Retire l action Popup pour singleClic  pour la couche  " + no.toString();
        console.log(message); 

        clearInterval(RunToggleLgnd1);
        RefreshLgnd(1);
    } 
    if ( Valeur2 == "Popup" && no == "2" ) {

        Popup2Overlay.setPosition(undefined);
        Popup2Closer.blur();
//map2-
        if ( L_Juxtapo ) {
           map2.un('singleclick', ValeurClick);
        } else {
           map.un('singleclick', ValeurClick);
        }

        message=" Retire l action Popup pour singleClic  pour la couche  " + no.toString();
        console.log(message); 

        clearInterval(RunToggleLgnd2);
        RefreshLgnd(2);
    }
    if ( ( Valeur1 == "TimSer_e" || Valeur1 == "MeteoGrm" || Valeur1 == "ProfVert" || Valeur1 == "TimSer" ) && no == "1" ) {

        Popup1Overlay.setPosition(undefined);
        Popup1Closer.blur();

        map.un('singleclick', callSpotWX);

        message=" Retire l action affichage fenetre externe (TimeSer_e, MeteoGrm ou ProfVert  pour singleClic  pour la couche  " + no.toString();
        console.log(message); 
    }
    if ( ( Valeur2 == "TimSer_e" || Valeur2 == "MeteoGrm" || Valeur2 == "ProfVert" || Valeur2 == "TimSer" ) && no == "2" ) {

        Popup2Overlay.setPosition(undefined);
        Popup2Closer.blur();

        if ( L_Juxtapo ) {
           map2.un('singleclick', callSpotWX);
        } else {
           map.un('singleclick', callSpotWX);
        }
        message=" Retire l action affichage fenetre externe (TimeSer_e, MeteoGrm ou ProfVert  pour singleClic  pour la couche  " + no.toString();
        console.log(message); 
    }
    if ( Valeur1 == "TimSer" || Valeur2 == "TimSer" ) {

         otherWrapper.style.width = "100%";
         document.getElementById("spot_wrapper").style.width = "0%";
         window.dispatchEvent(new Event('resize'));
    }
    if ( no == 1 ) {
// 2 valeurs
    //    ValeurSelect2.options.selectedIndex = 0;
    //     Valeur2 = "off";

         Valeur1 = ValeurSelect1.options[ValeurSelect1.options.selectedIndex].value;

         message=" active l action Popup pour singleClic  pour la couche  " + no.toString();
         console.log(message); 

         if ( Valeur1 == "Popup" ) {

                map.on('singleclick', ValeurClick );

         } else if ( Valeur1 == "TimSer" || Valeur1 == "TimSer_e"  ||
                     Valeur1 == "MeteoGrm" || Valeur1 == "ProfVert"
                   ) {
                map.on('singleclick', callSpotWX );
         }
     } else if ( no == 2) {
// 2 valeurs
//       ValeurSelect1.options.selectedIndex = 0;
//       Valeur1 = "off";

         if ( Couche2Void ) { 
              ValeurSelect2.options.selectedIndex = 0;
              console.log("Valeur désactivées.  La couche 2 est inactive (Voir menu Syst Prev)");
         }

         Valeur2 = ValeurSelect2.options[ValeurSelect2.options.selectedIndex].value;

         if ( Valeur2 == "Popup" ) {

             if ( L_Juxtapo ) {  map2.on('singleclick', ValeurClick );
             } else {             map.on('singleclick', ValeurClick );
             }
             message=" active l action Popup pour singleClick  pour la couche  " + no.toString();
             console.log(message); 

         } else if ( Valeur2 == "TimSer" || Valeur2 == "TimSer_e" ||
                     Valeur2 == "MeteoGrm" || Valeur2 == "ProfVert"
                    ) {

             if ( L_Juxtapo ) {  map2.on('singleclick', callSpotWX );
             } else {            map.on('singleclick', callSpotWX );
             }
             message=" active l action spotWx  pour singleClick  pour la couche  " + no.toString();
             console.log(message); 
         }
     }

    // prepare and assign space on the screen for the spotwx graphs or meteogram graphs
    if ( Valeur1 == "TimSer" || Valeur2 == "TimSer" ) { 

        const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        var w_spotwx = parseInt(  Math.min( Math.max( viewwidth/2, 500 ), 1220  ) );

        if (  (( model_1 == "GDPS" || model_1 == "GDPSE" || model_1 == "GFS" || model_1 == "ECMWF" ) && ( Valeur1 == "TimSer" )) ||
              (( model_2 == "GDPS" || model_2 == "GDPSE" || model_2 == "GFS" || model_2 == "ECMWF" ) && ( Valeur2 == "TimSer" ))  ) {
               w_spotwx = parseInt(  Math.min( Math.max( 0.66*viewwidth, 666 ), 1220  ) ); 
        }
        var w_maps = viewwidth - w_spotwx ;

        if ( viewwidth < 800 ) {
                                    w_spotwx = 100;
                                    w_maps = 100;
        } else {
                                    w_spotwx = parseInt( 100. * parseFloat(w_spotwx ) /  parseFloat(viewwidth) );
                                    w_maps = 100 -  w_spotwx ;
        }
        otherWrapper.style.width = w_maps.toString() + "%";
        document.getElementById("spot_wrapper").style.width = w_spotwx.toString() + "%";

        window.dispatchEvent(new Event('resize'));

        map.updateSize();
        if ( L_Juxtapo ) {  map2.updateSize(); }
        //map2
        RefreshSpotWx();

    // preload layers image prior to click for color extraction
    } else if ( Valeur1 == "Popup" ) {
        RefreshValeur();
        if ( !Lgnd1Large )  { showLgnd(1); }
    } else if ( Valeur2 == "Popup" ) {
        RefreshValeur();
        if ( !Lgnd2Large )  { showLgnd(2); }

    } else if ( Valeur1 !="off" || Valeur2 != "off" ) {
        RefreshSpotWx();
    }
}

//-----------------------------------------------------------------------------------------
//

var LgndCanvas1 = false;
var LgndCanvas2 = false;
var RunToggleLgnd1 = setInterval(function() {ToggleLgnd("1")}, 10000);
var RunToggleLgnd2 = setInterval(function() {ToggleLgnd("2")}, 10000);
clearInterval(RunToggleLgnd1);
clearInterval(RunToggleLgnd2);

let MyWindow_ecmwf;
let MyWindow_aifs;
let MyWindow_gdps;
let MyWindow_gefs;
let MyWindow_rdps;
let MyWindow_hrdps;
let MyWindow_gfs;

//
/**
 * Elements that make up the popup.
 */
const Popup1Container = document.getElementById('popup');
const Popup1Content = document.getElementById('popup-content');
const Popup1Closer = document.getElementById('popup-closer');
const Popup1Hider = document.getElementById('popup-hider');

const Popup2Container = document.getElementById('popup2');
const Popup2Content = document.getElementById('popup2-content');
const Popup2Closer = document.getElementById('popup2-closer');
const Popup2Hider = document.getElementById('popup2-hider');

const ImgValeur1 = new Image();
const Canvas1 = document.createElement('canvas');
//const Canvas1Context = document.createElement('canvas0');
const CanvasL1 = document.createElement('canvas');
ImgValeur1.onload = function () {
            console.log("image Valeur 1 is loaded");
            Canvas1.width  = ImgValeur1.width;
            Canvas1.height = ImgValeur1.height;
            message = " Largeur: " + Canvas1.width + " Hauteur: " + Canvas1.height; console.log(message);
            Canvas1.getContext('2d', { willReadFrequently: true }).drawImage(ImgValeur1,0,0,ImgValeur1.width, ImgValeur1.height);
            message = " Canvas got the context" ; console.log(message);
            UpdateToggleValeur("1");
            }
const ImgValeur2 = new Image();
const Canvas2 = document.createElement('canvas');
const CanvasL2 = document.createElement('canvas');
ImgValeur2.onload = function () {
            console.log("image Valeur 2 is loaded");
            Canvas2.width  = ImgValeur2.width;
            Canvas2.height = ImgValeur2.height;
            message = " Largeur: " + Canvas2.width + " Hauteur: " + Canvas2.height; console.log(message);
            Canvas2.getContext('2d', { willReadFrequently: true }).drawImage(ImgValeur2,0,0,ImgValeur2.width, ImgValeur2.height);
            message = " Canvas got the context" ; console.log(message);
            UpdateToggleValeur("2");
            }
var PopupLat = 45.0;
var PopupLon = -73.0;
let TuileZXY1 = [0, 0, 0];
let TuileZXY2 = [0, 0, 0];

if ( WindMaps ) {
     PopupLat = localStorage.getItem("PopupLat_V");
     PopupLon = localStorage.getItem("PopupLon_V");
} else {
     PopupLat = localStorage.getItem("PopupLat");
     PopupLon = localStorage.getItem("PopupLon");
     console.log(" local Items PopupLat: " + PopupLat + " PopupLon: " + PopupLon)
}

/**
 * Create overlays to anchor the popup to the maps.
 */
const Popup1Overlay = new Overlay({
  element: Popup1Container,
  autoPan: false,
  autoPanAnimation: {
    duration: 250,
  },
});

const Popup2Overlay = new Overlay({
  element: Popup2Container,
  autoPan: false,
  autoPanAnimation: {
    duration: 250,
  },
});

/**    Closer is here
 * Add a click handler to hide the popup.
 * @return {boolean} Don't follow the href.
 */
Popup1Closer.onclick = function () {
  UnsetValeurs("1");
  Valeur1Hist = "off";
  return false;
};
Popup2Closer.onclick = function () {
  UnsetValeurs("2");
  Valeur2Hist = "off";
  return false;
};

Popup1Hider.onclick = function () {
  Popup1Overlay.setPosition(undefined);
  Popup1Hider.blur();
  return false;
};
Popup2Hider.onclick = function () {
  Popup2Overlay.setPosition(undefined);
  Popup2Hider.blur();
  return false;
};
map.addOverlay(Popup1Overlay);
map.addOverlay(Popup2Overlay);
//map2 
///________________________________________________________________________________________
///________________________________________________________________________________________
//
function getZLayerCoLayer(no_) {

    var message ="";
    var zDirection1_=1;
    var zDirection2_=1;
    var zDirection_=1;

    let seuil =0;
    let zLayer = [0,0];
    zLayer[0] = 0 ;
    zLayer[1] = zLayer[0];

    if ( no_ == "1" || ( no_ == "2"  && !Couche2Void ) ) { 

        var viewResol = map.getView().getResolution();
        const viewProj_ = map.getView().getProjection().getCode();

        var coucheCoVoid = Couche1CoVoid;
        var coucheProj_ = ZoomToProjec.get( Couche1.zoomId );

        var resolutions_ = Resolutions1;
        var resol_ = Resolutions1;
        var resolutionsCo_ = Resolutions1;
        var resolCo_ = Resolutions1;

        if ( !Couche1CoVoid ) { 
            resolutionsCo_ = ResolutionsCo1;
            resolCo_ = ResolutionsCo1;
        }

        if ( no_ == "2"  && !Couche2Void ) {

            zDirection_= zDirection2_;
            resolutions_ = Resolutions2;
            resol_ = Resolutions2;
            coucheCoVoid = Couche2CoVoid;

            resolutionsCo_ = Resolutions2;
            resolCo_ = Resolutions2;
            if ( !Couche2CoVoid ) { 
               resolutionsCo_ = ResolutionsCo2;
               resolCo_ = ResolutionsCo2;
            }
            coucheProj_ = ZoomToProjec.get( Couche2.zoomId );
        }
    
        if ( viewProj_ != coucheProj_ ) {
            let coucheMPU = coucheProj_.getMetersPerUnit(); 
            let viewMPU = viewProj_.getMetersPerUnit(); 
            viewResol = viewResol * viewMPU / coucheMPU; 
        }
        if ( zDirection_ == -1 ) {
           for ( let iz=1 ; iz <= (resol_.length-1) ; iz = iz + 1) { 
               seuil = resol_[iz-1];
               if ( viewResol < seuil ) {
                       zLayer[0] = iz;
               }
           }
        } else if ( zDirection_ == 0 ) { 
           for ( let iz=1 ; iz <= (resol_.length-1) ; iz = iz + 1) { 
                seuil = ( resol_[iz-1] + resol_[iz] ) /2;
                if ( viewResol < seuil ) {
                       zLayer[0] = iz;
                }  
           }
        } else if ( zDirection_ == 1 ) { 
           for ( let iz=1 ; iz <= (resol_.length-1) ; iz = iz + 1) { 
                seuil = resol_[iz] ;
                if ( viewResol < seuil ) {
                       zLayer[0] = iz;
                }  
           }
        } 
        if ( !coucheCoVoid ) {

           if ( zDirection_ == -1 ) {
              for ( let iz=1 ; iz <= (resolCo_.length-1) ; iz = iz + 1) { 
                  seuil = resolCo_[iz-1];
                  if ( viewResol < seuil ) {
                          zLayer[1] = iz;
                  }
              }
           } else if ( zDirection_ == 0 ) { 
              for ( let iz=1 ; iz <= (resolCo_.length-1) ; iz = iz + 1) { 
                   seuil = ( resolCo_[iz-1] + resolCo_[iz] ) /2;
                   if ( viewResol < seuil ) {
                          zLayer[1] = iz;
                   }  
              }
           } else if ( zDirection_ == 1 ) { 
              for ( let iz=1 ; iz <= (resolCo_.length-1) ; iz = iz + 1) { 
                   seuil = resolCo_[iz] ;
                   if ( viewResol < seuil ) {
                          zLayer[1] = iz;
                   }  
              }
           } 

        } else {
            zLayer[1] = -1;
        }
   } else {
            zLayer[0] = -1;
            zLayer[1] = -1;
   }

   message =  " getZLayerCoLayer--Zoom level layer: " + zLayer[0] + " and coLayer: " + zLayer[1];
   console.log(message);

   return zLayer
}
///________________________________________________________________________________________
//
/////function getNuTileLoaded() {

    /////var message ="";

    /////let varNuTiles = [-1,-1,-1,-1];

    ///////const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    ///////const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);                           
/////
   // var viewnter = map.getView().getCenter();
    /////var viewResol_ = map.getView().getResolution();
    /////let viewExtent_ = map.getView().calculateExtent(map.getSize());

    //    let viewZoom_ = map.getView().getZoom();

    //let upperLeft[0] = viewCenter[0] - viewResol * viewwidth / 2;
    //let upperLeft[1] = viewCenter[1] + viewResol * viewHeight /2;
    //let lowerRight[0] = viewCenter[0] + viewResol * viewwidth / 2;
    //let lowerRight[1] = viewCenter[1] - viewResol * viewHeight /2;

    /////let resolutions_ = Resolutions1;
    /////let coucheExtent_ = ZoomToExtent.get( Couche1.zoomId );
    /////let coucheProj_ = ZoomToProjec.get( Couche1.zoomId ) ;
    /////let coucheModeleZoom_ = Couche1.modeleZoom;
    /////let zoomTuile_ = 0;

    /////if ( no_ == "2" ) {
        /////resolutions_ = Resolutions2;
        /////coucheExtent_ = ZoomToExtent.get( Couche2.zoomId );
        /////coucheProj_ = ZoomToProjec.get( Couche2.zoomId ) ;
        /////coucheModeleZoom = Couche2.modeleZoom;
        /////if ( coucheProj_ != viewProj_) { coucheExtent_ = transformExtent(coucheExtent_, coucheProj_, viewProj_); }
    /////}
    
    /////let viewProj_ = map.getView().getProjection();

    /////if ( viewProj_ == coucheProj_ ) {

       /////var  coucheResol=resolutions_[0];
       /////var diffMoin = Math.abs(resolutions_[0] - viewResol );
       /////var diffPlus; 

       /////for ( let iz=1 ; iz <= (resolutions_.length-1) ; iz = iz + 1) { 
             /////diffPlus = Math.abs(resolutions_[iz] - viewResol); 
             /////if ( diffPlus < diffMoin ) { 
                       /////coucheResol = resolutions_[iz];
                       /////zoomTuile_ = iz;
                       /////diffMoin = diffPlus;
             /////}
       /////}
       /////message =  " -- from Resolution array :  closest Zoom level " + zoomTuile + " and closest Resol: " + coucheResol;
       /////console.log(message);

       /////// minlon = extent_[0]=West; minlat = extent_[1]=Sud; maxlon = extent_[2]=Est; maxlat = extent_[3]=Nord; 
       /////var deltaPix = (viewExtent_[0] - coucheExtent_[0])/coucheResol;
       /////if ( deltaPix <= 0 ) { 
                /////west_ = 0;
       /////} else {
                /////west_ = Math.floor( deltaPix/ModToDimX.get(coucheModeleZoom) ); 
       /////}
       ///////maxlon = extent_[2]=Est
       /////deltaPix = (coucheExtent_[2] - viewExtent_[2])/coucheResol;
       /////if ( deltaPix <= 0 ) { 
                /////est_ = Math.pow(2, zoomTuile_);
       /////} else {
                /////est_ = Math.floor( deltaPix/ModToDimX.get(coucheModeleZoom) ); 
       /////}
       /////// minlat = extent_[1]=Sud; maxlat = extent_[3]=Nord; 
       /////var deltaPix = (viewExtent_[1] - coucheExtent_[1])/coucheResol;
       /////if ( deltaPix <= 0 ) { 
                /////sud_ = Math.pow(2, zoomTuile_);
       /////} else {
                /////sud_ = Math.floor( deltaPix/ModToDimY.get(coucheModeleZoom) ); 
       /////}
       /////// minlat = extent_[1]=Sud; maxlat = extent_[3]=Nord; 
       /////deltaPix = (coucheExtent_[3] - viewExtent_[3])/coucheResol;
       /////if ( deltaPix <= 0 ) { 
                /////nord_ = 0;
       /////} else {
                /////nord_ = Math.floor( deltaPix/ModToDimX.get(coucheModeleZoom) ); 
       /////}
       
       /////var est_west_ = est_ - west;
       /////var sud_nord = sud_ - nord_;

       /////message = " Nomber of horizontal tiles: " + est_west_;
       /////console.log(message);
       /////message = " Nomber of vertical tiles: " + sud_nord;
       /////console.log(message);

       /////varNuTiles[0] = est_west * sud_nord;
   /////} 
   /////return varNuTiles
/////}
// ________________________________________________________________________________
function CountTilesInView(no_) {
       
//
  var viewExtent_ = map.getView().calculateExtent(map.getSize());
  var viewProj_ = map.getView().getProjection();

  var message = "";
  let nu = [0,0];

  var nTiles_ = 0;
  var tileHorWidth = 0;
  var tileVerHeight = 0;

  // minlon = extent_[0]=West; minlat = extent_[1]=Sud; maxlon = extent_[2]=Est; maxlat = extent_[3]=Nord; 
  var coucheExtent_ = ZoomToExtent.get( Couche1.zoomId );
  var coucheProj_ = ZoomToProjec.get( Couche1.zoomId );

  if ( ( no_ == 2 ) && ( !Couche2Void) ) {

      coucheExtent_ = ZoomToExtent.get( Couche2.zoomId );
      coucheProj_ = ZoomToProjec.get( Couche2.zoomId );
  }

  var tuileExtent_ = coucheExtent_;
  var west_ = coucheExtent_[0];
  var sud_ = coucheExtent_[1];

  if ( ( no_ == 1 ) || (( no_ == 2 ) && ( !Couche2Void)) ) {

     let zLevel_= getZLayerCoLayer(no_);

     for ( let ii_= 0 ; ii_ <= 1 ; ii_ = ii_ + 1 ) { 

         if ( zLevel_[ii_] >= 0 ) {
           nTiles_ = Math.pow(2,zLevel_[ii_]);
           tileHorWidth =  (coucheExtent_[2] - coucheExtent_[0])/ nTiles_;
           tileVerHeight = (coucheExtent_[3] - coucheExtent_[1])/ nTiles_;

           for ( let iTileY=0 ; iTileY <= nTiles_-1; iTileY = iTileY + 1) {
               for ( let iTileX=0 ; iTileX <= nTiles_-1; iTileX = iTileX + 1) { 

                   west_ = coucheExtent_[0] + (iTileX * tileHorWidth);
                   sud_ =  coucheExtent_[1] + (iTileY * tileVerHeight);
                   tuileExtent_ = [ west_, sud_, west_ + tileHorWidth, sud_ + tileVerHeight];

                   if ( coucheProj_ != viewProj_ ) { tuileExtent_ = transformExtent(tuileExtent_, coucheProj_, viewProj_); }

                   if ( IsCoucheExtentInExtent( viewExtent_, tuileExtent_) ) { 

                       //message=" viewExtent: " + viewExtent_;
                       //console.log(message);
                       //message=" tuileExtent : " + tuileExtent_;
                       //console.log(message);
                       message=" tile XY no: " + iTileX + " , " + iTileY + " is in view";
                       //console.log(message);
                       nu[ii_] = nu[ii_] + 1;
                   } else {
                       message=" tile XY no: " + iTileX + " , " + iTileY + " is not in view";
                       //console.log(message);
                   }
               }
           }
         } else {
                       nu[ii_] = -1;
         }
     }
  } else {
    
    nu[0] = -1;
    nu[1] = -1;
  }
  return nu;
}
///________________________________________________________________________________________
//
function LonLat2ZXY(what, no_) {

   //  what peut etre les coordonnée de la tuile en Z Y et X (nombres entiers)  qui identifie l image contenant les Lon et Lat du popup
   //  what peut aussi etre les coordonnée en pixelles a l intérieur de la tuile (l Image) 

    var message ="";

    let varZXY = [0,0,0];
    let popupProj = [0,0];

    var viewResol = map.getView().getResolution();
    message = " -- Resolution from view : " + viewResol;
    console.log(message);

    let resolutions_ = Resolutions1;
    let coucheExtent_ = ZoomToExtent.get( Couche1.zoomId );
    let coucheProj_ = ZoomToProjec.get( Couche1.zoomId ) ;
    let coucheModeleZoom = Couche1.modeleZoom;

    if ( no_ == "2" && Valeur2 == "Popup" ) {
        resolutions_ = Resolutions2;
        coucheExtent_ = ZoomToExtent.get( Couche2.zoomId );
        coucheProj_ = ZoomToProjec.get( Couche2.zoomId ) ;
        coucheModeleZoom = Couche2.modeleZoom;
    }
    
    if ( (no_ == "2" && Valeur2 == "Popup" ) || (no_ == "1" && Valeur1 == "Popup" ) ) {

       var  coucheResol=resolutions_[0];
       varZXY[0] = 0;

       let zLevel_= getZLayerCoLayer(no_);
       varZXY[0] = zLevel_[0];

       let coucheResol = resolutions_[varZXY[0]];

       message =  " -- Zoom level " + varZXY[0] + " and Layer Resol: " + coucheResol;
       console.log(message);

       if ( coucheProj_ != "EPSG:4326" ) { 
           popupProj = transform([PopupLon, PopupLat], "EPSG:4326", coucheProj_);
       }

       // minlon = extent_[0]=West; minlat = extent_[1]=Sud; maxlon = extent_[2]=Est; maxlat = extent_[3]=Nord; 
       var deltaPixLon = (popupProj[0] - coucheExtent_[0])/coucheResol;
       var deltaPixLat = (coucheExtent_[3] - popupProj[1])/coucheResol;

       message = " Nomber of pixels from western limit: " + deltaPixLon;
       console.log(message);
       message = " Nomber of pixels from Northern limit: " + deltaPixLat;
       console.log(message);

       var tileSizeNX = ModToDimX.get(coucheModeleZoom);
       var tileSizeNY = ModToDimY.get(coucheModeleZoom); 

       message = " -- From couche no " + no_ + "  TileSize w et h : " +  tileSizeNX + " " + tileSizeNY;
       console.log(message);

       varZXY[1] = Math.floor(deltaPixLon/tileSizeNX);
       varZXY[2] = Math.floor(deltaPixLat/tileSizeNY);
       message=" -- coord of tile Z, Y, X: " + varZXY ;
       console.log(message)

      if ( what == "pixelles" ) {
        varZXY[1] = parseInt(deltaPixLon % tileSizeNX); 
        varZXY[2] = parseInt(deltaPixLat % tileSizeNY); 
        message=" -- pixels ii and jj :  " + varZXY[1] + " " + varZXY[2];
        console.log(message)
      }
      return varZXY

   } else {
     return [0,0,0]
   }
}
///________________________________________________________________________________________
//
function ImgValeurLoad(no_) {

    var message ="";

    if ( no_ == "1" && Valeur1 == "Popup" ) {

                TuileZXY1 = LonLat2ZXY("tuiles", "1");
                var newString = listUrl1[ISTEP] + "/" + TuileZXY1[0]  + "/" +  TuileZXY1[1] + "/" +  TuileZXY1[2] + ".png"
                message=" -- Image Valeur 1: " + newString + "  loading" ;
                console.log(message)

                ImgValeur1.src = newString;

    } 
    if ( no_ == "2" && Valeur2 == "Popup" ) {

                TuileZXY2 = LonLat2ZXY("tuiles", "2");
                var newString = listUrl2[ISTEP] + "/" + TuileZXY2[0]  + "/" +  TuileZXY2[1] + "/" +  TuileZXY2[2] + ".png"
                message=" -- Image Valeur 2: " + newString + "  loading" ;
                console.log(message)

                ImgValeur2.src = newString;
    }
}
///________________________________________________________________________________________
//
function UpdatePopupValeur(evt) {

     var message ="";

// get the click  lat&lon and display the popup
    var lon_lat =transform(evt.coordinate, evt.map.getView().getProjection(), 'EPSG:4326');
    PopupLon = lon_lat[0].toFixed(3);
    PopupLat = lon_lat[1].toFixed(3);
//map2
    if ( WindMaps ) {
         localStorage.setItem("PopupLat_V", PopupLat);
         localStorage.setItem("PopupLon_V", PopupLon);
    } else {
         localStorage.setItem("PopupLat", PopupLat);
         localStorage.setItem("PopupLon", PopupLon);
    }
    message = " <br> Lat et Lon: " + PopupLat + " " + PopupLon + " <br> Valeur ";
    console.log(message);

     if ( Image1_est_visible && Valeur1 == "Popup" ) {
        Popup1Content.innerHTML = message + " 1 ...;
        Popup1Overlay.setPosition(evt.coordinate);

     } else if ( Valeur1 == "Popup" ) {

            message = message + " 1: couche invisible";
            Popup1Overlay.setPosition(undefined);
     }
     if ( Image2_est_visible && Valeur2 == "Popup" ) {
        Popup2Content.innerHTML = message + " 2 ...";
        Popup2Overlay.setPosition(evt.coordinate);

     } else if ( Valeur2 == "Popup" ) {

            message = message + " 2: couche invisible";
            Popup2Overlay.setPosition(undefined);
     }

    return message
}
///________________________________________________________________________________________
//
//
function RefreshPopupValeur(no_) {

     var message ="";

     if ( Valeur1 == "Popup" && no_ == "1" ) {            

        var viewProj_ = map.getView().getProjection();
        var coord_ = [ PopupLon, PopupLat];

        if ( viewProj_ != 'EPSG:4326' ) {
            coord_ = transform([ PopupLon, PopupLat], 'EPSG:4326', viewProj_);
        }

        if ( Image1_est_visible ) {

            message = " <br> lat et lon: " + PopupLat + " " + PopupLon + " <br> Valeur 1:...";
            Popup1Content.innerHTML = message;
            Popup1Overlay.setPosition( coord_ );

        } else {

            message = message + " <br> refresh Valeur 1: couche invisible..."; console.log(message);
            Popup1Overlay.setPosition(undefined);
        }
      }

     if ( Valeur2 == "Popup" && no_ == "2" ) {            

        var viewProj_ = map.getView().getProjection();
        var coord_ = [ PopupLon, PopupLat];

        if ( viewProj_ != 'EPSG:4326' ) {
            coord_ = transform([ PopupLon, PopupLat], 'EPSG:4326', viewProj_);
        }

        if ( Image2_est_visible ) {

            message = " <br> lat et lon: " + PopupLat + " " + PopupLon + " <br> Valeur 2...";
            Popup2Content.innerHTML = message;
            Popup2Overlay.setPosition( coord_ );

        } else {
            message = message + " <br> refresh Valeur 2: couche invisible..."; console.log(message);
            Popup2Overlay.setPosition(undefined);
        }
   }
   return message
}
///________________________________________________________________________________________
//
//
function ValeurClick(evt) {

    var message =" ";
    var messagePop =" ";

    if ( Valeur1 == "Popup" || Valeur2 == "Popup" ) {
    messagePop = UpdatePopupValeur(evt);
    }

    if ( Valeur1 == "Popup" ) {
        let sameTile = true; 
        let tileZXY_ = LonLat2ZXY("tuile", "1");
        for ( let ii = 0; ii < tileZXY_.length ; ii = ii + 1 ) {
             if ( tileZXY_[ii] != TuileZXY1[ii] ) {
                sameTile = false;
             }
        } 
                message= " Check if Tile 1 has changed. Old: ZXY " + TuileZXY1 + " new ZXY: " + tileZXY_ + " sameTile: " + sameTile;
            console.log(message);
        if ( !sameTile ) {
                message= " Tile has changed,  need to reload new tile: ";
            console.log(message);
                ImgValeurLoad("1");

        } else if ( ImgValeur1.complete ) {

          UpdateToggleValeur("1");

    } else {
        message = messagePop + " <br> lecture de l image 1 non completée, (avancez et reculez, ou recliquz) " ;
            Popup1Content.innerHTML = message;
    }
    }
    message =" ";

    if ( Valeur2 == "Popup" ) {

        let sameTile = true; 
        let tileZXY_ = LonLat2ZXY("tuile", "2");
        for ( let ii = 0; ii < tileZXY_.length ; ii = ii + 1 ) {
             if ( tileZXY_[ii] != TuileZXY2[ii] ) {
                sameTile = false;
             }
        } 
                message= " Check if Tile 2 has changed. Old: ZXY " + TuileZXY2 + " new ZXY: " + tileZXY_ + " sameTile: " + sameTile;
            console.log(message);
        if ( !sameTile ) {
                message= " Tile has changed,  need to reload new tile: ";
            console.log(message);
                ImgValeurLoad("2");

        } else if ( ImgValeur2.complete ) {

          UpdateToggleValeur("2");

    } else {
        message = messagePop + " <br> lecture de l image 2 non completée, (avancez et reculez, ou recliquz) " ;
            Popup2Content.innerHTML = message;
    }
    }
}
///________________________________________________________________________________________
//
//
function RefreshValeur() {

    if ( Valeur1 == "Popup" ) {
    var message =   RefreshPopupValeur("1");

    message = message + " <br> lecture de l image 1 est en cours,  patientez SVP! " ;
    Popup1Content.innerHTML = message;

    ImgValeurLoad("1");
    }
    if ( Valeur2 == "Popup" ) {
    var message =   RefreshPopupValeur("2");

    message = message + " <br> lecture de l image 2 est en cours,  patientez SVP! " ;
    Popup2Content.innerHTML = message;

    ImgValeurLoad("2");
    }
}
///________________________________________________________________________________________
//
function ToggleLgnd(no_) {
   if ( no_ == "1" && Valeur1 == "Popup" &&  LgndCanvas1  ) {
        RefreshLgnd(1);
        LgndCanvas1 = false;
   } else if ( no_ == "1" &&  Valeur1 == "Popup" ) {
        lgnd1Img.src = CanvasL1.toDataURL("image/png");
        LgndCanvas1 = true;
   } 
   if ( no_ == "2" && Valeur2 == "Popup" &&  LgndCanvas2  )  {
        RefreshLgnd(2);
            LgndCanvas2 = false;
   } else if ( no_ == "2" && Valeur2 == "Popup" ) {
        lgnd2Img.src = CanvasL2.toDataURL("image/png");
            LgndCanvas2 = true;
   }
}
///________________________________________________________________________________________
//
function UpdateToggleValeur(no_) {
   
     var message ="";
     var messageRGB ="";
     var messagePop = "" ;

     var imgWidth =0;
     var imgHeight =0;

     var mapid = Couche1.getMapIdH();
     var interval = Couche1.getInterval();

    if ( no_ == "1" && Valeur1 != "Popup" ) {
       message = " Valuer 1 n est pas activé..."; console.log(message);
       return
    }
    if ( no_ == "2" && Valeur2 != "Popup" ) {
       message = " Valuer 2 n est pas activé..."; console.log(message);
       return
    }

    // stop the toggling of legend &modified legend  and refresh the unmodified legend
    if ( no_ == "1" ) {

      clearInterval(RunToggleLgnd1);
      LgndCanvas1 = true;
      ToggleLgnd(no_);
 
            if ( !Image1_est_visible ) {
                    message = message + " <br> Valeurs Popup activées pour la couche1 qui est invisible...";
                    Popup1Content.innerHTML = message; console.log(message);
                    return
            } else if ( !ImgValeur1.complete ) {
                    message = " <br> lecture de l image non completée ! (avancez puis reculez pour revenir sur l image) " ;
                    Popup1Content.innerHTML = message; console.log(message);
                    return
            }
     imgWidth = ImgValeur1.width;
     imgHeight = ImgValeur1.height;

    } else if ( no_ == "2" ) { 

      mapid = Couche2.getMapIdH();
      interval = Couche2.getInterval();

      clearInterval(RunToggleLgnd2);
      LgndCanvas2 = true;
      ToggleLgnd(no_);

            if ( !Image2_est_visible ) {
                    message = message + " <br> Valeurs Popup activées pour la couche1 qui est invisible...";
                    Popup2Content.innerHTML = message; console.log(message);
                    return
            } else if ( !ImgValeur2.complete ) {
                    message = " <br> lecture de l image non completée ! (avancez puis reculez pour revenir sur l image) " ;
                    Popup2Content.innerHTML = message; console.log(message);
                    return
            }
     imgWidth = ImgValeur2.width;
     imgHeight = ImgValeur2.height;

    }


///   Ici si une image n'a pas la dimension de la trame de tuile.....
///   prendre en considereation  imgWidth   et imgHeight.... ci-haut pour corriger le PosJ et PosI
     let varZXY = LonLat2ZXY("pixelles", no_ );
     let PosJ = varZXY[2];
     let PosI = varZXY[1];

     message = "J: " + PosJ + " I: " + PosI;                          console.log(message);
    
    if ( ( PosI < 1 ) || ( PosJ < 1 ) || (PosI > imgWidth-1) || (PosJ > imgHeight-1) ) { 
         message = " <br> click à l'extérieur de la superfie de la couche " + no_;
         messagePop = message;
         if ( no_ == "1" ) {
             Popup1Content.innerHTML = messagePop; 
         } else if ( no_ == "2" ) {
             Popup2Content.innerHTML = messagePop;
         }
         console.log(message);
         return
     }
          
     if ( mapid.indexOf("WDIR") != -1) {

         message = " <br> Valeurs Popup ne fonctionne pas en présence de flèches de vents.  Activez Popup pour une autre carte. ";
         messagePop = message;
         if ( no_ == "1" ) {
             Popup1Content.innerHTML = messagePop; 
         } else if ( no_ == "2" ) {
             Popup2Content.innerHTML = messagePop;
         }
         console.log(message);
         return
     } 

////    context = canvas.getContext('2d' [, { [ alpha: true ] [, desynchronized: false ] [, colorSpace: 'srgb'] [, willReadFrequently: false ]} ])
////    Returns a CanvasRenderingContext2D object that is permanently bound to a particular canvas element.

////    If the alpha member is false, then the context is forced to always be opaque.
////    If the desynchronized member is true, then the context might be desynchronized.
////    The colorSpace member specifies the color space of the rendering context.
////    If the willReadFrequently member is true, then the context is marked for readback optimization.

     ///Canvas.width = ImgValeur.width;
     ///Canvas.height = ImgValeur.height;
     ///message = " Largeur: " + Canvas.width + " Hauteur: " + Canvas.height + " Nombre: "; console.log(message);

     ///Canvas.getContext('2d', { willReadFrequently: true }).drawImage(ImgValeur,0,0,ImgValeur.width, ImgValeur.height);


          // extract the pixel clicked colors
    
    let pixelData = [];
    let CanvasLdata = [];

    if ( no_ == "1" ) {

            //Canvas1.width  = imgWidth;
            //Canvas1.height = imgHeight;
            //message = " Largeur: " + Canvas1.width + " Hauteur: " + Canvas1.height; console.log(message);
            //Canvas1.getContext('2d', { willReadFrequently: true }).drawImage(ImgValeur1,0,0,imgWidth, imgHeight);
            //message = " Canvas got the context" ; console.log(message);

         pixelData = Canvas1.getContext('2d', { willReadFrequently: true }).getImageData(PosI,PosJ,1,1).data;

          message = "R: " + pixelData[0] + " G: " + pixelData[1] + " B: " + pixelData[2] + " O: " + pixelData[3];
          console.log(message);

          message = " pixelle data length: " + pixelData.length; console.log(message);

                // prepare Legend Canvas assign Legend image and color data
          showLgnd(1); showLgnd(1);
          CanvasL1.width = lgnd1Img.naturalWidth;
          CanvasL1.height = lgnd1Img.naturalHeight;

          CanvasL1.getContext('2d', { willReadFrequently: true }).drawImage(lgnd1Img, 0, 0, lgnd1Img.naturalWidth, lgnd1Img.naturalHeight)
          CanvasLdata = CanvasL1.getContext('2d').getImageData(0,0,lgnd1Img.naturalWidth, lgnd1Img.naturalHeight);

          message = " Largeur: " + CanvasL1.width + " Hauteur: " + CanvasL1.height + " Nombre: " + CanvasLdata.data.length; console.log(message);

     } else if ( no_ == "2" )  {

            //Canvas2.width  = imgWidth;
            //Canvas2.height = imgHeight;
            //message = " Largeur: " + Canvas2.width + " Hauteur: " + Canvas2.height; console.log(message);
            //Canvas2.getContext('2d', { willReadFrequently: true }).drawImage(ImgValeur2,0,0,imgWidth, imgHeight);
            //message = " Canvas got the context" ; console.log(message);

         pixelData = Canvas2.getContext('2d', { willReadFrequently: true }).getImageData(PosI,PosJ,1,1).data;

          message = "R: " + pixelData[0] + " G: " + pixelData[1] + " B: " + pixelData[2] + " O: " + pixelData[3];
          console.log(message);
          message = " pixelle data length: " + pixelData.length; console.log(message);

                // prepare Legend Canvas assign Legend image and color data
           showLgnd(2); showLgnd(2);
           CanvasL2.width = lgnd2Img.naturalWidth;
           CanvasL2.height = lgnd2Img.naturalHeight;

           CanvasL2.getContext('2d', { willReadFrequently: true }).drawImage(lgnd2Img, 0, 0, lgnd2Img.naturalWidth, lgnd2Img.naturalHeight)
           CanvasLdata = CanvasL2.getContext('2d').getImageData(0,0,lgnd2Img.naturalWidth, lgnd2Img.naturalHeight);

          message = " Largeur: " + CanvasL2.width + " Hauteur: " + CanvasL2.height + " Nombre: " + CanvasLdata.data.length; console.log(message);
     }

     message = " data:  " + CanvasLdata.data[ CanvasLdata.data.length/2 ] ;  console.log(message);

            //  look for a match between the layer's click color (pixelData) throughout the legend pixels and assign black color if match is close enough
     var trouve = false;
     var precision = 10;
     if ( mapid == 'HGT_500_TCDC_' )  { precision = 5; } 

            var precisionOpacite = 30;

     if ( (pixelData[0]<10) && (pixelData[1]<10) && (pixelData[2]<10) ) {

        message="  Couleur absente ";
        message =  message + " " + pixelData[0] + " " + pixelData[1] + " " + pixelData[2]; 
            console.log(message);
            messagePop = " <br> Couleur absente " + " <br> " + " Possiblement une valeur sous le seuil le plus bas. ";

     } else if ( (pixelData[0]>250) && (pixelData[1]>250) && (pixelData[2]>250) ) {

                message=" Couleur ambigue ";
                message=  message + " " + pixelData[0] + " " + pixelData[1] + " " + pixelData[2];
                console.log(message);
                messagePop = " <br> Couleur ambigue " + " <br> " + " Possiblement près d'un contour,  veuillez essayer sur une pixelle voisine. ";
    } else {
            for (var i = 0; i < CanvasLdata.data.length; i += 4) {

                    if ( Math.abs( pixelData[0]-parseInt(CanvasLdata.data[i]) ) < precision ) {
                     if ( Math.abs( pixelData[1]-parseInt(CanvasLdata.data[i+1]) ) < precision ) {
                         if ( Math.abs( pixelData[2]-parseInt(CanvasLdata.data[i+2]) ) < precision ) {
                             if ( Math.abs( pixelData[3]-parseInt(CanvasLdata.data[i+3]) ) < precisionOpacite ) {
                       CanvasLdata.data[i] = "0";
                       CanvasLdata.data[i+1] = "0";
                       CanvasLdata.data[i+2] = "0";
                       CanvasLdata.data[i+3] = "255";
                       trouve = true;
                         }
                     }
                     }
                      }
            }
            if ( trouve ) {

                       if ( no_ == "1" ) {
                //  assign the modifified legend colors back into the Legend Canvas
                CanvasL1.getContext('2d').putImageData(CanvasLdata, 0, 0);
                //  trigger a toggle display of the original lgend and the modified legend ( Legend Canavas)
                LgndCanvas1 = false;
                RunToggleLgnd1 = setInterval(function() {ToggleLgnd("1")}, 250);
                       } else {
                //  assign the modifified legend colors back into the Legend Canvas
                CanvasL2.getContext('2d').putImageData(CanvasLdata, 0, 0);
                //  trigger a toggle display of the original lgend and the modified legend ( Legend Canavas)
                LgndCanvas2 = false;
                RunToggleLgnd2 = setInterval(function() {ToggleLgnd("2")}, 250);
                       }
            } else {
                    message = " pas trouve couleur dans la legende couche  " + no_;
                        messagePop = message;
                    console.log(message);
                }
                messageRGB = RGB2Valeur(  pixelData[0], pixelData[1],  pixelData[2], pixelData[3], mapid, interval);
            console.log(messageRGB);
                messagePop = messageRGB;
       }

    if ( no_ == "1" ) {
                Popup1Content.innerHTML = messagePop;
    } else if ( no_ == "2" ) {
            console.log(" update of popup 2 here message RGB: " + messageRGB);
            console.log(" update of popup 2 here message Pop : " + messagePop);
                Popup2Content.innerHTML = messagePop;
            console.log(" Popup2Content.innerHTML  " + Popup2Content.innerHTML);
    }
}
// ________________________________________________________________________________
//
//    \|/
function RGB2Valeur(rouge, vert, bleu, opac, mapid, interval) {

    var Liste_RGB= [0];
    var Liste_VAL= [0];
    var indice_trouve=[-1];
    var precision = 10;
    var unite = " ";
    var str_debut = " ";
    var unite = " ";
    var message = " ";
    var plein = false;
    var raison_pas_trouve = " ";
    var valeur_a_afficher, valeur_a_afficher_plus

    interval = Math.round( interval/60. );

    if ( mapid == 'WIND_10') {

                Liste_RGB = ["#D0D0FF66", "#C5C5FF99", "#BABAFFaa", "#9ACBFFff", "#8BF4FFff", "#57FFA4ff", "#18FF2Dff", "#00E300ff", "#00B600ff",
                             "#3CB600ff", "#B4E300ff", "#FFEC00ff", "#FFBD00ff", "#FF8700ff", "#FF3F00ff", "#FF000Eff", "#FF0086ff", "#FF00FFff"];
                Liste_VAL = [  9,  12 , 15  ,18  ,21 , 24 , 27 , 30 , 35 , 40  ,45 , 50, 60 , 70 , 80 , 90, 120, 150,  210 ];
                str_debut = " Vents à 10m <br />";
                unite = " noeuds ";
                plein=false;
                raison_pas_trouve=" Vous pointez sur une flèche, ou sur un contour...";

    } else if ( mapid == 'WIN-_10') {

//seuil <- c(seq(4, 30, 2), seq(35, 45, 5), 55, 200)

                Liste_RGB = ["#D0D0FF66", "#C5C5FF99", "#BABAFFaa", "#9ACBFFff", "#8BF4FFff", "#57FFA4ff", "#18FF2Dff", "#00E300ff", "#00B600ff",
                             "#3CB600ff", "#B4E300ff", "#FFEC00ff", "#FFBD00ff", "#FF8700ff", "#FF3F00ff", "#FF000Eff", "#FF0086ff", "#FF00FFff"];
                Liste_VAL = [ 4, 6, 8, 10, 12 ,14, 16, 18, 20, 22, 24, 26, 28, 30, 35, 40, 45, 55, 200 ];
                str_debut = " Vents à 10m <br />";
                unite = " noeuds ";
                plein=false;
                raison_pas_trouve=" Vous pointez sur une flèche, ou sur un contour...";

    } else if ( mapid == 'GUST_10') {

                Liste_RGB = ["#D0D0FF66", "#C5C5FF99", "#BABAFFaa", "#9ACBFFff", "#8BF4FFff", "#57FFA4ff", "#18FF2Dff", "#00E300ff", "#00B600ff",
                             "#3CB600ff", "#B4E300ff", "#FFEC00ff", "#FFBD00ff", "#FF8700ff", "#FF3F00ff", "#FF000Eff", "#FF0086ff", "#FF00FFff"];
                Liste_VAL = [ 4, 6, 8, 10, 12 ,14, 16, 18, 20, 22, 24, 26, 28, 30, 35, 40, 45, 55, 200 ];
                str_debut = " Rafales à 10m <br />";
                unite = " noeuds ";
                plein=false;
                raison_pas_trouve=" Vous pointez sur un contour...";

    } else if ( mapid == 'GUST_MAX_10') {

                Liste_RGB = ["#D0D0FF66", "#C5C5FF99", "#BABAFFaa", "#9ACBFFff", "#8BF4FFff", "#57FFA4ff", "#18FF2Dff", "#00E300ff", "#00B600ff",
                             "#3CB600ff", "#B4E300ff", "#FFEC00ff", "#FFBD00ff", "#FF8700ff", "#FF3F00ff", "#FF000Eff", "#FF0086ff", "#FF00FFff"];
                Liste_VAL = [3,  6,   9,  12 , 15  ,18  ,21 , 24 , 27 , 30 , 35 , 40  ,45 , 50, 60 , 70 , 80 , 90, 200 ];
                str_debut = " Rafales maximale à 10m <br />";
                unite = " noeuds ";
                plein=false;
                raison_pas_trouve=" Vous pointez sur un contour....";

    } else if ( mapid == 'WIND_850') {

                Liste_RGB = ["#D0D0FF66", "#C5C5FF96", "#BABAFFc8", "#9ACBFFdf", "#8BF4FFff", "#57FFA4ff", "#18FF2Dff", "#00E300ff", "#00B600ff",
                             "#3CB600ff", "#B4E300ff", "#FFEC00ff", "#FFBD00ff", "#FF8700ff", "#FF3F00ff", "#FF000Eff", "#FF0086ff", "#FF00FFff"];
                Liste_VAL = [12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 70, 80, 100, 120, 140, 200]; 
                str_debut = " Vents à 850mb <br />";
                unite = " noeuds <br />";
                plein =false;
                raison_pas_trouve=" Vous pointez sur une flèche, ou sur un contour...";

    } else if ( mapid == 'WIND_250') {

                Liste_RGB = ["#D0D0FF66", "#C5C5FF96", "#BABAFFc8", "#9ACBFFdf", "#8BF4FFff", "#57FFA4ff", "#18FF2Dff", "#00E300ff", "#00B600ff",
                             "#3CB600ff", "#B4E300ff", "#FFEC00ff", "#FFBD00ff", "#FF8700ff", "#FF3F00ff", "#FF000Eff", "#FF0086ff", "#FF00FFff"];
                Liste_VAL = [50,  65, 75,  85,  95, 105, 115, 125, 135, 145, 155, 165, 175, 185, 195, 205, 215, 225, 300]; 
                str_debut = " Vents à 250mb <br />";
                unite = " noeuds ";
                plein =false;
                raison_pas_trouve=" Vous pointez sur une flèche, ou sur un contour...";

    } else if ( mapid == 'TMP_850') {
    
Liste_RGB = ["#AA60FA","#A86CFA","#A778FA","#A683FA",
            "#A590FA","#A49CFA","#A3A8FA","#A2B3FA",
            "#A1C0FA","#A0CCFA","#A0CCFA","#98C0FA",
            "#91B4FA","#8AA8FA","#839CFA","#7C90FA",
            "#7584FA","#6E78FA","#676CFA","#6060FA",
            "#6070FA","#607FFA","#608EFA","#609EFA",
            "#60ADFA","#60BCFA","#60CBFA","#60DBFA",
            "#60EAFA","#60FAFA","#60FAF0","#60FAD3",
            "#60FAB6","#60FA99","#60FA7C","#60FA60",
            "#60F060","#60E060","#60D060","#60C060",
            "#70CA70","#7CCF7C","#88D488","#95DA95",
            "#A1DFA1","#AEE4AE","#BAEABA","#C7EFC7",
            "#D3F4D3","#E0FAE0","#FAFAFA","#FAFAE0",
            "#FAFAD4","#FAFAC8","#FAFABC","#FAFAB0",
            "#FAFAA5","#FAFA99","#FAFA8D","#FAFA81",
            "#FAFA75","#FAFA6A","#FAFA5E","#FAFA52",
            "#FAFA46","#FAFA3A","#FAFA2F","#FAFA23",
            "#FAFA17","#FAFA0B","#FAFA00","#FFFF00",
            "#FFF400","#FFE900","#FFDF00","#FFD400",
            "#FFCA00","#FFBF00","#FFB500","#FFAA00",
            "#FFA000","#FF8000","#FF7100","#FF6300",
            "#FF5500","#FF4700","#FF3800","#FF2A00",
            "#FF1C00","#FF0E00","#FF0000","#FA6060",
            "#FA7272","#FA8484","#FA9797","#FAAAAA",
            "#FD6C30","#FA00AA","#FC4060","#FD6C30",
            "#FF9900"];

Liste_VAL = [-50, -48, -46, -44, -42, -40, -38, -36, -34, -32, 
             -30, -29, -28, -27, -26, -25, -24, -23, -22, -21,
             -20, -19, -18, -17, -16, -15, -14, -13, -12, -11,
             -10, -9.5, -9, -8.5, -8, -7.5, -7, -6.5, -6, -5.5,
              -5, -4.5, -4, -3.5, -3, -2.5, -2, -1.5, -1, -0.5,
         0,  0.5,   1,  1.5,  2,  2.5,  3,  3.5,  4,  4.5, 5.0,
             5.5,   6,  6.5,  7,  7.5,  8,  8.5,  9,  9.5, 10,
              11,  12,   13,  14,  15,  16,  17,  18,  19, 20,
              21,  22,   23,  24,  25,  26,  27,  28,  29, 30,
              32,  34,   36,  38,  40,  42,  44,  46,  48, 50, 52 ]; 


//                Liste_RGB = ["#a056A7", "#A086a0", "#B9B7D9", "#4040f0", "#7070f5", "#a0a0ff", "#85CA7B", "#B8E194", 
//                             "#EEEEEE", "#F7F4AD", "#FBD179", "#FDAB49", "#F67334", "#F03B20", "#fa9fb5", "#c51b8a"];
//                Liste_VAL = [-50, -40, -35, -30, -25, -20, -15, -10, -5, 0, 5,  10,  15,  20,  25,  30,  35 ];
                str_debut = " Température à 850mb <br /> ";
                unite = " deg. C ";
                plein = true;
                raison_pas_trouve=" Vous pointez sur un contour...";
                precision = 10;  

    } else if ( ( mapid == 'TMP_sfc') || ( mapid == 'PRMSL__TMP_sfc' ) ) {

//Liste_RGB = ["#AA60FA","#A86CFA","#A778FA","#A683FA","#A590FA","#A49CFA","#A3A8FA",
 //            "#A2B3FA","#A1C0FA","#A0CCFA","#A0CCFA","#98C0FA","#91B4FA","#8AA8FA",
  //           "#839CFA","#7C90FA","#7584FA","#6E78FA","#676CFA","#6060FA","#6060FA",
   //          "#6071FA","#6082FA","#6093FA","#60A4FA","#60B5FA","#60C6FA","#60D7FA",
    //         "#60E8FA","#60FAFA","#60FAFA","#60FAE8","#60FAD7","#60FAC6","#60FAB5",
     //        "#60FAA4","#60FA93","#60FA82","#60FA71","#60FA60","#60FA60","#6EFA6E",
      //       "#7CFA7C","#8AFA8A","#98FA98","#A7FAA7","#B5FAB5","#C3FAC3","#D1FAD1",
       //      "#E0FAE0","#FAFAFA","#FAFAE8","#FAFAD7","#FAFAC6","#FAFAB5","#FAFAA4",
//             "#FAFA93","#FAFA82","#FAFA71","#FAFA60","#FAFA60","#FAF160","#FAE860",
 //            "#FADF60","#FAD660","#FACD60","#FAC460","#FABB60","#FAB260","#FAAA60",
  //           "#FAAA60","#FAA160","#FA9960","#FA9160","#FA8960","#FA8060","#FA7860",
   //          "#FA7060","#FA6860","#FA6060","#FA6060","#FA6C67","#FA786E","#FA8375",
    //         "#FA907C","#FA9C83","#FAA88A","#FAB391","#FAC098","#FACCA0","#FACCA0",
     //        "#FAC0A1","#FAB4A2","#FAA8A3","#FA9CA4","#FA90A5","#FA84A6","#FA78A7",
      //       "#FA6CA8","#FA60AA"];

Liste_RGB = ["#AA60FA","#A86CFA","#A778FA","#A683FA",
            "#A590FA","#A49CFA","#A3A8FA","#A2B3FA",
            "#A1C0FA","#A0CCFA","#A0CCFA","#98C0FA",
            "#91B4FA","#8AA8FA","#839CFA","#7C90FA",
            "#7584FA","#6E78FA","#676CFA","#6060FA",
            "#6070FA","#607FFA","#608EFA","#609EFA",
            "#60ADFA","#60BCFA","#60CBFA","#60DBFA",
            "#60EAFA","#60FAFA","#60FAF0","#60FAD3",
            "#60FAB6","#60FA99","#60FA7C","#60FA60",
            "#60F060","#60E060","#60D060","#60C060",
            "#70CA70","#7CCF7C","#88D488","#95DA95",
            "#A1DFA1","#AEE4AE","#BAEABA","#C7EFC7",
            "#D3F4D3","#E0FAE0","#FAFAFA","#FAFAE0",
            "#FAFAD4","#FAFAC8","#FAFABC","#FAFAB0",
            "#FAFAA5","#FAFA99","#FAFA8D","#FAFA81",
            "#FAFA75","#FAFA6A","#FAFA5E","#FAFA52",
            "#FAFA46","#FAFA3A","#FAFA2F","#FAFA23",
            "#FAFA17","#FAFA0B","#FAFA00","#FFFF00",
            "#FFF400","#FFE900","#FFDF00","#FFD400",
            "#FFCA00","#FFBF00","#FFB500","#FFAA00",
            "#FFA000","#FF8000","#FF7100","#FF6300",
            "#FF5500","#FF4700","#FF3800","#FF2A00",
            "#FF1C00","#FF0E00","#FF0000","#FA6060",
            "#FA7272","#FA8484","#FA9797","#FAAAAA",
            "#FD6C30","#FA00AA","#FC4060","#FD6C30",
            "#FF9900"];

Liste_VAL = [-50, -48, -46, -44, -42, -40, -38, -36, -34, -32, 
             -30, -29, -28, -27, -26, -25, -24, -23, -22, -21,
             -20, -19, -18, -17, -16, -15, -14, -13, -12, -11,
             -10, -9.5, -9, -8.5, -8, -7.5, -7, -6.5, -6, -5.5,
              -5, -4.5, -4, -3.5, -3, -2.5, -2, -1.5, -1, -0.5,
         0,  0.5,   1,  1.5,  2,  2.5,  3,  3.5,  4,  4.5, 5.0,
             5.5,   6,  6.5,  7,  7.5,  8,  8.5,  9,  9.5, 10,
              11,  12,   13,  14,  15,  16,  17,  18,  19, 20,
              21,  22,   23,  24,  25,  26,  27,  28,  29, 30,
              32,  34,   36,  38,  40,  42,  44,  46,  48, 50, 52 ]; 

//                Liste_RGB = ["#754CC8", "#88DDDD", "#a056A7", "#A086a0", "#B9B7D9", "#4040f0", "#7070f5", "#a0a0ff", "#85CA7B", "#B8E194", 
//                             "#EEEEEE", "#F7F4AD", "#FBD179", "#FDAB49", "#F67334", "#F03B20", "#fa9fb5", "#E05DA0", "#c51b8a", "#996633"];
//                Liste_VAL = [-50, -45, -40, -35, -30, -25, -20, -15, -10, -5, 0, 5,  10,  15,  20,  25,  30,  35, 40, 45, 50 ];
                str_debut = " Température à 1,5m <br />";
                unite = " deg. C ";
                plein = true;
                raison_pas_trouve=" Vous pointez sur un contour...";
                precision = 10;  

    } else if ( mapid == 'DPT_sfc') {

//                Liste_RGB = ["#7070f5", "#a0a0ff", "#85CA7B", "#B8E194", 
//                             "#EEEEEE", "#F7F4AD", "#FBD179", "#FDAB49", "#F67334", "#F03B20", "#fa9fb5", "#c51b8a"];
//                Liste_VAL = [-5., 0., 5., 10., 12., 14., 16., 18., 20., 22., 24., 26., 28. ];
//                Liste_RGB = ["#754CC8", "#88DDDD", "#a056A7", "#A086a0", "#B9B7D9", "#4040f0", "#7070f5", "#a0a0ff", "#85CA7B", "#B8E194", 
//                             "#EEEEEE", "#F7F4AD", "#FBD179", "#FDAB49", "#F67334", "#F03B20", "#fa9fb5", "#E05DA0", "#c51b8a", "#996633"];
//                Liste_VAL = [-50, -45, -40, -35, -30, -25, -20, -15, -10, -5, 0, 5,  10,  15,  20,  25,  30,  35, 40, 45, 50 ];

Liste_RGB = ["#AA60FA","#A86CFA","#A778FA","#A683FA",
            "#A590FA","#A49CFA","#A3A8FA","#A2B3FA",
            "#A1C0FA","#A0CCFA","#A0CCFA","#98C0FA",
            "#91B4FA","#8AA8FA","#839CFA","#7C90FA",
            "#7584FA","#6E78FA","#676CFA","#6060FA",
            "#6070FA","#607FFA","#608EFA","#609EFA",
            "#60ADFA","#60BCFA","#60CBFA","#60DBFA",
            "#60EAFA","#60FAFA","#60FAF0","#60FAD3",
            "#60FAB6","#60FA99","#60FA7C","#60FA60",
            "#60F060","#60E060","#60D060","#60C060",
            "#70CA70","#7CCF7C","#88D488","#95DA95",
            "#A1DFA1","#AEE4AE","#BAEABA","#C7EFC7",
            "#D3F4D3","#E0FAE0","#FAFAFA","#FAFAE0",
            "#FAFAD4","#FAFAC8","#FAFABC","#FAFAB0",
            "#FAFAA5","#FAFA99","#FAFA8D","#FAFA81",
            "#FAFA75","#FAFA6A","#FAFA5E","#FAFA52",
            "#FAFA46","#FAFA3A","#FAFA2F","#FAFA23",
            "#FAFA17","#FAFA0B","#FAFA00","#FFFF00",
            "#FFF400","#FFE900","#FFDF00","#FFD400",
            "#FFCA00","#FFBF00","#FFB500","#FFAA00",
            "#FFA000","#FF8000","#FF7100","#FF6300",
            "#FF5500","#FF4700","#FF3800","#FF2A00",
            "#FF1C00","#FF0E00","#FF0000","#FA6060",
            "#FA7272","#FA8484","#FA9797","#FAAAAA",
            "#FD6C30","#FA00AA","#FC4060","#FD6C30",
            "#FF9900"];

Liste_VAL = [-50, -48, -46, -44, -42, -40, -38, -36, -34, -32, 
             -30, -29, -28, -27, -26, -25, -24, -23, -22, -21,
             -20, -19, -18, -17, -16, -15, -14, -13, -12, -11,
             -10, -9.5, -9, -8.5, -8, -7.5, -7, -6.5, -6, -5.5,
              -5, -4.5, -4, -3.5, -3, -2.5, -2, -1.5, -1, -0.5,
         0,  0.5,   1,  1.5,  2,  2.5,  3,  3.5,  4,  4.5, 5.0,
             5.5,   6,  6.5,  7,  7.5,  8,  8.5,  9,  9.5, 10,
              11,  12,   13,  14,  15,  16,  17,  18,  19, 20,
              21,  22,   23,  24,  25,  26,  27,  28,  29, 30,
              32,  34,   36,  38,  40,  42,  44,  46,  48, 50, 52 ]; 

                str_debut = " Température du point de rosé à 1,5m <br />";
                unite = " deg. C ";
                plein = true;
                raison_pas_trouve=" Vous pointez sur un contour...";
                precision = 10;  

     } else if ( mapid == 'HGT_500_TCDC_') {

                Liste_RGB = ["#D0D0FF33", "#C5C5FF4c", "#BABAFF66", "#B0B0FF7f", "#A5A5FF9f", "#A4A9F9bf", "#ADBCEFdf",
                             "#B6CFE5ff", "#BFE2DBff", "#C8F6D1ff"];

                Liste_VAL = [10,20,30,40,50,60,70,80,90,100,105];
                str_debut = " Fraction nuageuse totale <br />";
                unite = " % ";
                plein = false;
                precision = 5;
                raison_pas_trouve=" Vous pointez sur un contour...";

    } else if (  mapid == 'APCP_' ) {

                Liste_RGB = ["#B2FF66", "#66CC00", "#00aa00", "#FFFF00", "#00FF00", "#00CC00", "#009900"];

                if ( interval == 1 )  {
                    Liste_VAL = [0.125, .5,  1. ,  2.5,  5,  10, 20,  90 ];
                } else if ( interval == 3 ) {
                    Liste_VAL = [ 0.25, .5,  1.,  5.,    10, 20, 30, 90];
                 } else if ( interval == 6 ) {
                    Liste_VAL = [ 0.5,  1,   5 , 10,  15,  25, 40, 90];
                 } else if ( interval == 12 ) {
                    Liste_VAL = [1,   5,  20,  35, 50, 65, 80, 150  ];
                 } else if ( interval == 24 ) {
                    Liste_VAL = [ 1,  10,  25, 35, 50, 75, 100, 200 ];
                } else if ( interval == 48 ) {
                    Liste_VAL = [1,   10, 25, 50, 75, 100, 150, 250 ];
                }    
                str_debut = " Précipitation totale cumulative sur " + interval +"h :" ;
                unite = " mm <br />";
                plein = false;
                raison_pas_trouve=" Vous pointez sur un contour...";

    } else if (  mapid == 'WEARN__h' || mapid == 'PRMSL__WEARN__h' ) {

                Liste_RGB = ["#B2FF66", "#66CC00", "#00aa00", "#FFFF00", "#00FF00", "#00CC00", "#009900"];

                if ( interval == 1 )  {
                    Liste_VAL = [0.125, .5,  1. ,  2.5,  5,  10, 20, 90 ];
                } else if ( interval == 3 ) {
                    Liste_VAL = [ 0.25,  1., 2.5,  5.,   10, 20, 30, 120];
                 } else if ( interval == 6 ) {
                    Liste_VAL = [ 0.5,  2.5,   5 , 10,  20, 30, 50, 150];
                 } else if ( interval == 12 ) {
                    Liste_VAL = [1,      5,  10,   20,  30, 50, 75, 180];
                 } else if ( interval == 24 ) {
                    Liste_VAL = [ 1,     5,  15,   30,  50, 75, 100, 200 ];
                } else if ( interval == 48 ) {
                    Liste_VAL = [5,     20,  50,   75,  100, 150, 200, 400 ];
                }    

                str_debut = " Pluie cumulative sur " + interval +"h :" ;
                unite = " mm <br />";
                plein = false;
                raison_pas_trouve=" Vous pointez sur un contour...";

    } else if (  mapid == 'WEASN__h' || mapid == 'PRMSL__WEASN__h' ) {

                Liste_RGB = ["#99FFFF", "#3399FF", "#0066CC", "#004C99", "#00FFFF", "#6666FF", "#3366CC"];

                 if ( interval == 1 )  {
                    Liste_VAL = [ 0.125, 0.25, 0.5, 1,  1.25, 2.5,  5, 95 ];
                } else if ( interval == 3 ) {
                    Liste_VAL = [ 0.25, 0.5,  1 ,  2.5,  5 ,  7.5,  15, 95];
                 } else if ( interval == 6 ) {
                    Liste_VAL = [ 0.5,   1,   2.5,   5,  7.5,  15,  30, 95];
                 } else if ( interval == 12 ) {
                    Liste_VAL = [ 0.5, 2.5,  5,  10,  15,  25,  40, 95 ];
                 } else if ( interval == 24 ) {
                    Liste_VAL = [ 1,    5,  15,  25,  35,  45,  60, 95 ];
                } else if ( interval == 48 ) {
                    Liste_VAL = [ 1,   10, 20, 30, 40, 60, 75, 90 ];
                }     
                str_debut = " Neige cumulative sur " + interval +"h : <br />  (équivalent en eau) <br />" ;
                unite = " mm <br /> ";
                plein = false;
                raison_pas_trouve=" Vous pointez sur un contour...";

    } else if (  mapid == 'WEAFR__h' || mapid == 'PRMSL__WEAFR__h' ) {

                Liste_RGB = ["#FF9999", "#FF3333", "#CC0000", "#990000", "#FF0000", "#FF6666", "#FFcccc"];

                 if ( interval == 1 )  {
                    Liste_VAL = [ 0.125, 0.25, 0.5, 1,  1.25, 2.5,  5, 95 ];
                } else if ( interval == 3 ) {
                    Liste_VAL = [ 0.25, 0.5,  1 ,  2.5,  5 ,  7.5,  15, 95];
                 } else if ( interval == 6 ) {
                    Liste_VAL = [ 0.5,   1,   2.5,   5,  7.5,  15,  30, 95];
                 } else if ( interval == 12 ) {
                    Liste_VAL = [ 0.5, 2.5,  5,  10,  15,  25,  40, 95 ];
                 } else if ( interval == 24 ) {
                    Liste_VAL = [ 1,    5,  15,  25,  35,  45,  60, 95 ];
                } else if ( interval == 48 ) {
                    Liste_VAL = [ 1,   10, 20, 30, 40, 60, 75, 90 ];
                }     
                str_debut = " Pluie vergalçante cumulative sur " + interval +"h :<br /> (équivalent en eau) <br />" ;
                unite = " mm <br /> ";
                plein = false;
                raison_pas_trouve=" Vous pointez sur un contour...";

    } else if ( mapid == 'WEAPE__h' || mapid == 'PRMSL__WEAPE__h' ) {

                Liste_RGB = ["#FF99FF", "#FF33FF", "#CC00CC", "#990099", "#FF00FF", "#FF66FF", "#FFCCFF"];

                 if ( interval == 1 )  {
                    Liste_VAL = [ 0.125, 0.25, 0.5, 1,  1.25, 2.5,  5, 95 ];
                } else if ( interval == 3 ) {
                    Liste_VAL = [ 0.25, 0.5,  1 ,  2.5,  5 ,  7.5,  15, 95];
                 } else if ( interval == 6 ) {
                    Liste_VAL = [ 0.5,   1,   2.5,   5,  7.5,  15,  30, 95];
                 } else if ( interval == 12 ) {
                    Liste_VAL = [ 0.5, 2.5,  5,  10,  15,  25,  40, 95 ];
                 } else if ( interval == 24 ) {
                    Liste_VAL = [ 1,    5,  15,  25,  35,  45,  60, 95 ];
                } else if ( interval == 48 ) {
                    Liste_VAL = [ 1,   10, 20, 30, 40, 60, 75, 90 ];
                }     
                str_debut = " Grésil cumulatif sur " + interval +"h : <br />  (équivalent en eau) <br />" ;
                unite = " mm <br /> ";
                plein = false;
                raison_pas_trouve=" Vous pointez sur un contour...";

    } else if ( mapid == 'COMPO__h' || mapid == 'PRMSL__COMPO__h' ) {

                Liste_RGB = ["#FF9999", "#FF3333", "#CC0000", "#990000", "#FF0000", "#FF6666", "#FFcccc","#ffffff",
                            "#FF99FF", "#FF33FF", "#CC00CC", "#990099", "#FF00FF", "#FF66FF", "#FFCCFF","#ffffff",
                            "#99FFFF", "#3399FF", "#0066CC", "#004C99", "#00FFFF", "#6666FF", "#3366CC","#ffffff",
                            "#B2FF66", "#66CC00", "#00aa00", "#FFFF00", "#00FF00", "#00CC00", "#009900","#ffffff",
                            "#f0f0d0", "#e0e090", "#c0c010", "#a0a000", "#f0f0a0", "#c0c060" ];

                if ( interval == 1 )  {
                    Liste_VAL = [ 0.125,    0.25,   0.5,    1,     1.5,   2.5,   5,   95.,     
                                100.125,  100.25, 100.5,  101.,  101.5, 102.5, 105., 195.,
                                200.125,  200.25, 200.5,  201.,  201.5, 202.5, 205., 295., 
                                300.125,  300.5,  301.,   302.5, 305.,  310.,  320., 390.,
                                600.125,  600.5,  601.,   602.5, 605,   610.,  690. ];
                } else if ( interval == 3 ) {
                    Liste_VAL = [ 0.25,   0.5,   1. ,   2.5,   5.,   7.5,  15.,  95.,
                                100.25, 100.5, 101. , 102.5, 105., 107.5, 115., 195.,
                                200.25, 200.5, 201. , 202.5, 205., 207.5, 215., 295.,
                                300.25, 301.0, 302.5, 305.0, 310., 320.0, 330., 390.,
                                600.25, 601.0, 602.5, 605.0, 610., 620.0, 690.];
                 } else if ( interval == 6 ) {
                    Liste_VAL = [ 0.5,   1,     2.5 ,  5.,   7.5,   15,  30,  95.,
                                100.5, 101,   102.5, 105., 107.5,  115, 130, 195.,
                                200.5, 201,   202.5, 205., 207.5,  215, 230, 295.,
                                300.5, 302.5, 305.,  310., 320.,   330, 350, 390.,
                                600.5, 602.5, 605.,  610., 620.,   630, 690.];
                 } else if ( interval == 12 ) {
                    Liste_VAL = [ 0.5,   2.5,   5.,   10.,   15.,   25.,  40.,  90.,
                                100.5, 102.5, 105.,  110.,  115.,  125., 140., 190.,
                                200.5, 202.5, 205.,  210.,  215.,  225., 240., 290.,
                                301.0, 305.,  310.,  320.,  330.,  350., 375., 490.,
                                601.0, 605.,  610.,  620.,  630.,  650., 690. ];
                 } else if ( interval == 24 ) {
                    Liste_VAL = [   1.,   5.,   15.,   25.,  35.,   45,   60,  95.,
                                  101., 105.,  115.,  125.,  135., 145., 160, 195.,
                                  201., 205.,  215.,  225.,  235., 245., 260, 295.,
                                  301.0,305.,  315.,  330.,  350., 375., 400.,500.,
                                  601.0,605.,  615.,  630.,  650., 675., 690. ];
                } else if ( interval == 48 ) {
                    Liste_VAL = [ 1,   10.,   20.,   30.,  40.,  60.,  75.,  90.,
                                101.,  110.,  120.,  130., 140., 160., 175., 190.,
                                201.,  210.,  220.,  230., 240., 260., 275., 290.,
                                301.0, 310.,  325.,  350., 375., 400., 450., 590.,
                                601.0, 610.,  625.,  650., 675., 700., 750.];
                }    

                str_debut = " Précipitation cumulative dominante sur " + interval +"h :<br /> (équivalent en eau) <br />" ;
               unite = " mm <br /> ";
                plein = false;
                raison_pas_trouve=" Vous pointez sur un contour...";

    }

    
    var RGBlength = Liste_RGB.length;

    if ( RGBlength == 1 ) {

        message = " <br> voir légende";
         
    } else if ( RGBlength == 2 )  {

        message = " <br> Cette couche n'a pas de plages de valeurs colorées,  Choisir une autre couche pour obtenir des valeurs";

    }  else if ( rouge <= 10 && vert <= 10 && bleu <= 10 ) {
          if ( plein ) {
              message = "<br> pas de valeur trouvées";
          } else {
              message = " <br> pas de valeur trouvées OU " + str_debut + " plus petit que " + Liste_VAL[0] + unite ;
          }
    }  else {

     var rouge_clique, vert_clique, bleu_clique, opac_clique

         var j = -1;
         for (var i = 0; i < RGBlength; i++) {

                rouge_clique=parseInt( Liste_RGB[i].substr(1,2), 16 );
                vert_clique=parseInt( Liste_RGB[i].substr(3,2), 16 );
                bleu_clique=parseInt( Liste_RGB[i].substr(5,2), 16 );

            if ( mapid == 'HGT_500_TCDC_' ||
                 mapid == 'WIND_10'       ||
                 mapid == 'WIND_850'      ||
             mapid == 'WIND_250'      ||
                 mapid == 'GUST_10'       ||
             mapid == 'GUST_MAX_10'   
               )  {

                opac_clique=parseInt( Liste_RGB[i].substr(7,2), 16 );

                if (  (rouge> (rouge_clique - precision) ) &&  (rouge < ( rouge_clique + precision) )  &&
                      (vert > (vert_clique - precision) )  && (vert < (vert_clique + precision) )  &&
                      (bleu > (bleu_clique  - precision) )  && (bleu < (bleu_clique + precision) ) &&
                      (opac > (opac_clique  - precision) )  && (opac < (opac_clique + precision) )
                          ) {
                                     j = j + 1;
                                     indice_trouve = i;
                                   }       
             } else {
                if (    (rouge> (rouge_clique - precision) ) &&  (rouge < ( rouge_clique + precision) )  &&
                        (vert > (vert_clique - precision) )  && (vert < (vert_clique + precision) )  &&
                        (bleu > (bleu_clique  - precision) )  && (bleu < (bleu_clique + precision) )
                          ) {
                                  j = j + 1;
                                  if ( j < 1 ) {  indice_trouve = i; } 
                                 }       
             }
         }  
         if ( j < 0 )  {
                                 message = raison_pas_trouve;
         } else if ( (j > 0) && ( (mapid != 'TMP_sfc') && (mapid != 'PRMSL__TMP_sfc') && (mapid != 'TMP_850') && (mapid != 'DPT_sfc')  ) )  {
                                 message = "valeur ambigue: voir si la legende aide dans ce cas. " + j ;
         } else {

             if ( mapid == 'COMPO__h' || mapid == 'PRMSL__COMPO__h' ) {

                    if ( Liste_VAL[indice_trouve] < 100 ) {

                        str_debut = str_debut + " Verglas ";
                        unite = " mm <br /> ";
                        valeur_a_afficher= Liste_VAL[indice_trouve];
                        valeur_a_afficher_plus= Liste_VAL[indice_trouve+1];

                    } else if ( Liste_VAL[indice_trouve] < 200 ) {

                        str_debut = str_debut + " Grésil ";
                        unite = " mm  <br /> ";
                        valeur_a_afficher= Liste_VAL[indice_trouve] - 100 ;
                        valeur_a_afficher_plus= Liste_VAL[indice_trouve+1] - 100;               

                    } else if ( Liste_VAL[indice_trouve] < 300 ) {

                        str_debut = str_debut + " Neige ";
                        unite = " mm <br /> ";
                        valeur_a_afficher= Liste_VAL[indice_trouve] - 200 ;
                        valeur_a_afficher_plus= Liste_VAL[indice_trouve+1] - 200;      
                        
                    } else if ( Liste_VAL[indice_trouve] < 600 ) {

                        str_debut = str_debut + " Pluie";
                        unite = " mm ";
                        valeur_a_afficher= Liste_VAL[indice_trouve] - 300 ;
                        valeur_a_afficher_plus= Liste_VAL[indice_trouve+1] - 300;   

                    } else if ( Liste_VAL[indice_trouve] > 600  ) {

                        str_debut = str_debut + " Pluie et-ou Neige fondante <br /> ou autre mélange ";
                        unite = " mm <br />" ;
                        valeur_a_afficher= Liste_VAL[indice_trouve] - 600 ;
                        valeur_a_afficher_plus= Liste_VAL[indice_trouve+1] - 600;   

                    }

               } else {

                valeur_a_afficher= Liste_VAL[indice_trouve];
                valeur_a_afficher_plus= Liste_VAL[indice_trouve+1+j];
               }


            if ( indice_trouve < RGBlength ) {
                message = "<br>" + str_debut + " entre  " + valeur_a_afficher + " et  " + valeur_a_afficher_plus  + unite;
            } else if ( indice_trouve == RGBlength ) {
                message = "<br>" + str_debut + " plus grand que:  " + valeur_a_afficher ;
            } else {
                message = " <br> error";
            }
          }
    } 
    return message ;
} 

// ________________________________________________________________________________
//
function callSpotWX(evt) {

    updateSpotWxPopup(evt);

    if ( Valeur1 == "TimSer" || Valeur1 == "TimSer_e" || Valeur1 == "ProfVert" || Valeur1 == "MeteoGrm" ) {

        var message = " RefreshTimSer for layer 1; console.log(message);
        RefreshSpotWxGraph( "1");
     }
     if ( Valeur2 == "TimSer" || Valeur2 == "TimSer_e" ||  Valeur2 == "ProfVert" || Valeur2 == "MeteoGrm" ) {

        var message = " RefreshTimSer for layer 1; console.log(message);
        RefreshSpotWxGraph( "2");
    }   
}
// ________________________________________________________________________________
//
function updateSpotWxPopup(evt) {

    let lat_lon = [];
    let message = "";

    lat_lon =transform(evt.coordinate, evt.map.getView().getProjection(), 'EPSG:4326');

    PopupLon = lat_lon[0].toFixed(3);
    PopupLat = lat_lon[1].toFixed(3);

    if ( Valeur1 == "TimSer"   || Valeur1 == "TimSer_e" || Valeur1 == "MeteoGrm" || Valeur1 == "ProfVert" ) {

        if (        !Image1_est_visible ) {
                    message = " <br> Valeurs graphiques activées pour la couche1 qui est invisible...";
                    console.log(message);
        }

        message = " <br> ValeurClick1: " + PopupLat + " " + PopupLon + " <br> Voir graphiques couche 1 ";
        console.log(message);

        Popup1Content.innerHTML = message;
        Popup1Overlay.setPosition(evt.coordinate);
    }
    if ( Valeur2 == "TimSer"   || Valeur2 == "TimSer_e" || Valeur2 == "MeteoGrm" || Valeur2 == "ProfVert" ) {

        if ( !Image2_est_visible ) {
                    message = " <br> Valeurs graphiques activées pour la couche2 qui est invisible... ";
                    console.log(message);
        }

        message = " <br> ValeurClick2: " + PopupLat + " " + PopupLon + " <br> Voir graphiques couche 2 ";
        console.log(message);

        Popup2Content.innerHTML = message;
        Popup2Overlay.setPosition(evt.coordinate);
    }
    if ( WindMaps ) {
             localStorage.setItem("PopupLat_V", PopupLat);
             localStorage.setItem("PopupLon_V", PopupLon);
    } else {
             localStorage.setItem("PopupLat", PopupLat);
             localStorage.setItem("PopupLon", PopupLon);
    }
}
// ________________________________________________________________________________
//
function RefreshSpotWx() {

    RefreshSpotWxPopup();

    if ( Valeur1 == "TimSer" || Valeur1 == "TimSer_e" || Valeur1 == "ProfVert" || Valeur1 == "MeteoGrm" ) {

        var message = " RefreshTimSer for layer 1;" console.log(message);
        RefreshSpotWxGraph( "1");
     }
     if ( Valeur2 == "TimSer" || Valeur2 == "TimSer_e" ||  Valeur2 == "ProfVert" || Valeur2 == "MeteoGrm" ) {

        var message = " RefreshTimSer for layer 2;" console.log(message);
        RefreshSpotWxGraph( "2");
    }   
}
// ________________________________________________________________________________
//
function RefreshSpotWxPopup() {

    var message = "";

    if ( Valeur1 == "TimSer"   || Valeur1 == "TimSer_e" || Valeur1 == "MeteoGrm" || Valeur1 == "ProfVert" ) { 

        if (        !Image1_est_visible ) {
                    message = " <br> Graphique demandé pour couche 1 invisible ";
                    console.log(message);
        }

        var lat_lon = [];
        lat_lon[0] = PopupLon;
        lat_lon[1] = PopupLat;
        var coord_ = transform(lat_lon, 'EPSG:4326', map.getView().getProjection() );

        message = " <br> ValeurClick(r1): " + PopupLat + " " + PopupLon + " <br> Voir graphiques pour couche 1";

        Popup1Overlay.setPosition(coord_);
        Popup1Content.innerHTML = message;
    }
    if ( Valeur2 == "TimSer"   || Valeur2 == "TimSer_e" || Valeur2 == "MeteoGrm" || Valeur2 == "ProfVert" ) { 

        if ( !Image2_est_visible ) {
                    message = " <br> Graphique demandé pour couche2 invisible ";
                    console.log(message);
        }

        var lat_lon = [];
        lat_lon[0] = PopupLon;
        lat_lon[1] = PopupLat;
        var coord_ = transform(lat_lon, 'EPSG:4326', map.getView().getProjection() );

        message = " <br> ValeurClick(r2): " + PopupLat + " " + PopupLon + " <br> Voir graphiques pour couche 2";

        Popup2Overlay.setPosition(coord_);
        Popup2Content.innerHTML = message;
   }
}

// ________________________________________________________________________________
function WillOpenWin(link, model_, myWin) {

     if (myWin) {
         console.log(" Call for opening window. It was opened in the past!");

        if ( myWin.closed ) {
          console.log(" but it was closed ...Re-opening with settings to defaults");
          OpenWin(link, model_, "init");
        } else {
          console.log(" it is still opened, just refreshing ");
          OpenWin(link, model_, "refresh");
        }
     } else {
       console.log(" Call for opening window, was not opened before,  setting to defaults");
       OpenWin(link, model_, "init");
     }
}
// ________________________________________________________________________________
function OpenWin(link_, model, todo_) {
  
  if ( todo_ == "refresh" ) {

      if (  model == "ECMWF" || model == "ECMWF3" || model == "ECMWFE" ) {
            MyWindow_ecmwf = window.open(link_, model);
      } else if ( model == "AIFS" || model == "AIFSE" ) {
            MyWindow_aifs = window.open(link_, model);
      } else if ( model == "GDPS" ) {
            MyWindow_gdps = window.open(link_, model);
      } else if ( model == "GDPSE" ) {
            MyWindow_gdps = window.open(link_, model);
      } else if ( model == "GEFS" ) {
            MyWindow_gefs = window.open(link_, model);
      } else if ( model == "RDPS" ) {
            MyWindow_rdps = window.open(link_, model);
      } else if ( model == "HRDPS" ) {
            MyWindow_hrdps = window.open(link_, model);
      } else if ( model == "GFS" ) {
            MyWindow_gfs = window.open(link_, model);
      } 

  } else {

       var specs = "";
       var w_ = 0;
       var h_ = 0;
       const viewwidth = Math.max( screen.availWidth || 0, document.documentElement.clientWidth || 0);
       const viewheight = Math.max( screen.availHeight || 0, document.documentElement.clientHeight || 0);

       w_ = parseInt(  Math.min( Math.max( viewwidth/3, 600 ), 1500  ) );
       w_ = Math.min( viewwidth-30, w_);
       var left_ = Math.max( (viewwidth-w_), 0) 

       h_ = parseInt(  Math.min( Math.max( viewheight-30, 600 ), 2000  ) );
       h_ = Math.min( viewheight-50, h_);
       var top_ =  50;

       specs = "width=" + w_ + ",height=" + h_ + ",left=" + left_ + ",top=" + top_;

       if (  model == "ECMWF" || model == "ECMWF3" || model == "ECMWFE" ) {
            MyWindow_ecmwf = window.open(link_, model, specs);
       } else if ( model == "AIFS" || model == "AIFSE" ) {
            MyWindow_aifs = window.open(link_, model, specs);
       } else if ( model == "GDPS" ) {
            MyWindow_gdps = window.open(link_, model, specs);
       } else if ( model == "GDPSE" ) {
            MyWindow_gdps = window.open(link_, model, specs);
       } else if ( model == "GEFS" ) {
            MyWindow_gefs = window.open(link_, model, specs);
       } else if ( model == "RDPS" ) {
            MyWindow_rdps = window.open(link_, model, specs);
       } else if ( model == "HRDPS" ) {
            MyWindow_hrdps = window.open(link_, model, specs);
       } else if ( model == "GFS" ) {
            MyWindow_gfs = window.open(link_, model, specs);
       }
  }
}

// ________________________________________________________________________________
//
function RefreshSpotWxGraph( no_) {

         var    model_ = Couche1.getModele();
         var    hourOId_ = Couche1.getHourOId();
         var   progMin_ = listProg1minu[ISTEP];

        if ( no_ == "2" ) {

            model_ = Couche2.getModele();
            hourOId_ = Couche2.getHourOId();
            progMin_ = listProg2minu[ISTEP];
        }
        var timSer   = (no_ == "1" && Valeur1 == "TimSer")   || (no_ == "2" && Valeur2 == "TimSer");
        var timSer_e = (no_ == "1" && Valeur1 == "TimSer_e") || (no_ == "2" && Valeur2 == "TimSer_e");
        var meteoGrm =  (no_ == "1" && Valeur1 == "MeteoGrm") || (no_ == "2" && Valeur2 == "MeteoGrm");

    var spotwx_model = "void";
    var link_prev = "https://spotwx.com/products/grib_index.php?model=" 
                    + spotwx_model  + "&lat=" + PopupLat + "&lon=" + PopupLon + "&tz=America/Montreal";
        var myWindow = false;

    if ( model_ == "HRDPS") {
            spotwx_model="gem_lam_continental";
            link_prev = "https://spotwx.com/products/grib_index.php?model=" 
                        + spotwx_model   + "&lat=" + PopupLat + "&lon=" + PopupLon + "&tz=America/Montreal";
                    
                     if ( timSer_e ) { WillOpenWin(link_prev, model_, MyWindow_hrdps); }

    } else if ( model_ == "RDPS" )  {
            spotwx_model="gem_reg_10km";
            link_prev = "https://spotwx.com/products/grib_index.php?model=" 
                        + spotwx_model   + "&lat=" + PopupLat + "&lon=" + PopupLon + "&tz=America/Montreal";

                     if ( timSer_e) { WillOpenWin(link_prev, model_, MyWindow_rdps); }

    }  else if ( model_ == "GDPS" )  {

                    if ( meteoGrm ) {
                       spotwx_model="geps_0p5_raw";
               link_prev = "https://spotwx.com/products/grib_index.php?model=" 
                        + spotwx_model   + "&lat=" + PopupLat + "&lon=" + PopupLon + "&tz=America/Montreal";

                       WillOpenWin(link_prev, "GEFS" , MyWindow_gefs);

                    } else {
                       spotwx_model="gem_glb_25km";
                       link_prev = "https://spotwx.com/products/grib_index.php?model=" 
                        + spotwx_model   + "&lat=" + PopupLat + "&lon=" + PopupLon + "&tz=America/Montreal";

                        if ( timSer_e ) { WillOpenWin(link_prev, model_, MyWindow_gdps); }
                    }
                    
    }  else if ( model_ == "GFS" )  {
            spotwx_model="gfs_pgrb2_0p25_f";
            link_prev = "https://spotwx.com/products/grib_index.php?model=" 
                        + spotwx_model   + "&lat=" + PopupLat + "&lon=" + PopupLon + "&tz=America/Montreal";

                     if ( timSer_e ) { WillOpenWin(link_prev, model_, MyWindow_gfs); }

    }  else if ( model_ == "ECMWF" || model_ == "ECMWF3" )  {
                    if ( meteoGrm ) {

                        link_prev = "https://charts.ecmwf.int/products/opencharts_meteogram?base_time=" + hourOId_ 
                                     + "00&epsgram=classical_10d&lat=" +  PopupLat + "&lon=" + PopupLon;

                        message = " Lien ECMWF: " +  link_prev;
                        console.log(message);
                        WillOpenWin(link_prev, model_, MyWindow_ecmwf);            

                    } else if ( (no_ == "1" && Valeur1 == "ProfVert") || (no_ == "2" && Valeur2 == "ProfVert")  ) {

                        var valid_time_=getHourOIdPlusMoinsNbMinutes( hourOId_ , progMin_ , true );
                        
                        if (  parseInt(progMin_ / 60 ) > 120 ) {
                           //alert( " Les profils verticaux ECMWF ne sont pas produit au delà de 120 heures d'échéance");
                           openAfficheInfo(" Les profils verticaux ECMWF ne sont pas produit au delà de 120 heures d'échéance", 6);
                                    
                        } else { 

                            link_prev = "https://charts.ecmwf.int/products/opencharts_vertical-profile-meteogram?base_time=" + hourOId_ 
                                         + "00&lat=" +  PopupLat + "&lon=" + PopupLon +"&valid_time=" + valid_time_ + "00";

                            message = " Lien ECMWF: " +  link_prev;
                            console.log(message);
                            WillOpenWin(link_prev, model_, MyWindow_ecmwf);   
                        }
                    } else {
                        spotwx_model="ecmwf_ifs";
                        link_prev = "https://spotwx.com/products/grib_index.php?model=" 
                            + spotwx_model   + "&lat=" + PopupLat + "&lon=" + PopupLon + "&tz=America/Montreal";

                        if ( timSer_e ) { WillOpenWin(link_prev, model_, MyWindow_ecmwf); }
                    }
                      //   https://charts.ecmwf.int/products/opencharts_vertical-profile-meteogram?base_time=202401160000&lat=51.4333&lon=-1.0&station_name=Reading&valid_time=202401160000
                      //            https://charts.ecmwf.int/products/opencharts_meteogram?base_time=202302040000&epsgram=classical_10d&lat=45.4333&lon=-73&valid_time=yyyymmddhh00
    }  else if ( model_ == "AIFS" )  {
                    if ( meteoGrm ) {
///                    https://charts.ecmwf.int/products/aifs_opencharts_meteogram?base_time=202412100000&epsgram=aifs_classical_10d&lat=51.4333&lon=-1.0&station_name=Reading

                        link_prev = "https://charts.ecmwf.int/products/aifs_opencharts_meteogram?base_time=" + hourOId_ 
                                     + "00&epsgram=aifs_classical_10d&lat=" +  PopupLat + "&lon=" + PopupLon;

                        message = " Lien AIFS: " +  link_prev;
                        console.log(message);
                        WillOpenWin(link_prev, model_, MyWindow_aifs);            

                     } else {

                       spotwx_model="ecmwf_aifs_single";
                       link_prev = "https://spotwx.com/products/grib_index.php?model=" 
                            + spotwx_model   + "&lat=" + PopupLat + "&lon=" + PopupLon + "&tz=America/Montreal";

                        if ( timSer_e ) { WillOpenWin(link_prev, model_, MyWindow_aifs); }
                     }
    } 
        if ( timSer )  {

            document.getElementById("spot_iframe").style.display = "inherit";
            document.getElementById("spot_iframe").style.visibility = "hidden";
            document.getElementById("spot_iframe").src = link_prev;
        }
}

// ________________________________________________________________________________
// ________________________________________________________________________________

document.getElementById("spot_iframe").onload = function()  {

    document.getElementById("spot_iframe").style.visibility = "visible";
    console.log("TimSer loaded");
};

// ________________________________________________________________________________

// -----------------------------------------------------------------------------------
//   Selector  for Opacitee

const OpaciteSelect1 = document.getElementById('opacite1');
const OpaciteSelect2 = document.getElementById('opacite2');

if ( WindMaps ) {   
     OpaciteSelect1.options.selectedIndex = OpaciteSelect1.options.length - 1;
}
Opacitee1 = parseInt( OpaciteSelect1.options[OpaciteSelect1.options.selectedIndex].value )/10. ;
Opacitee2 = parseInt( OpaciteSelect2.options[OpaciteSelect2.options.selectedIndex].value )/10. ;

// ________________________________________________________________________________
function updateOpaciteeFromMenu(no, resume) {

    StopAnimate();
    var message=" Changing opacité de la couche: " + no.toString();
    console.log(message); 

    if ( no == 1 ) {
         Opacitee1 = parseInt( OpaciteSelect1.options[OpaciteSelect1.options.selectedIndex].value )/10. ;
        } else if ( no == 2) {
         Opacitee2 = parseInt( OpaciteSelect2.options[OpaciteSelect2.options.selectedIndex].value )/10. ;
        }
    if ( resume ) {

            if ( ActiveLoop  ) {
                StartAnimate();
             } else {
                    Refresh();
             } 
    }
}
// ________________________________________________________________________________
// Handle change event.
//
OpaciteSelect1.onchange = function () { updateOpaciteeFromMenu(1, true) };
OpaciteSelect2.onchange = function () { updateOpaciteeFromMenu(2, true) };

// -----------------------------------------------------------------------------------
//   Selector  for Ani mod => Animation mode

const DprogDtSelect = document.getElementById('dprogdt');
    
var DprogDt = false;
var DprogDt_ferme = false;
var DprogDt_ouvre = false;
var SDprogDt = DprogDtSelect.options[DprogDtSelect.options.selectedIndex].value;
if ( SDprogDt == "true" ) { DprogDt = true; };  
var DprogDt_ISTEP = 0;
var DprogDt_ISTEP_max = ISTEP_max;

// ________________________________________________________________________________
function updateDprogDtFromMenu() {

    let modele1 = Couche1.getModeleZoom();
    let modele2 = Couche2.getModeleZoom();

    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);

    if ( nowcast1 || nowcast2 ) { 
       SDprogDt = "false" 
        DprogDt = false;
        DprogDtSelect.options.selectedIndex = 0;
        alert(" Le mode DprogDt n est pas disponible lorsqu une couche nowcasting est présente Radar ou satellite). ");
       
    }  else {

       ActiveLoop = false;
       StopAnimate();
       document.getElementById('StopAnimate').style.display = "none";
       document.getElementById('StartAnimate').style.display = "initial";

        var couche_change_pas = true;
        var message=" Changement du mode d'animation " ;
        console.log(message); 

        DprogDt = false;
        SDprogDt = DprogDtSelect.options[DprogDtSelect.options.selectedIndex].value;
        if ( SDprogDt == "true" ) { 
            DprogDt_ISTEP = ISTEP;
            DprogDt_ISTEP_max = ISTEP_max;
            DprogDt = true;
            DebutSelect.style.display = "none";
            FinSelect.style.display = "none"; 
            document.getElementById('resetDebut').style.display = "none";
            document.getElementById('resetFin').style.display = "none";
            setMenuHourOId(true, 1, HourOId1Select);
            ISTEP = HourOId1Select.options.length - 1;
            ISTEP_max = ISTEP;
                DprogDt_ouvre = true;
        } else {
            DprogDt = false;
            DebutSelect.style.display = "block";
            FinSelect.style.display = "block"; 
            document.getElementById('resetDebut').style.display = "block";
            document.getElementById('resetFin').style.display = "block";
            ResetModeleDefaults = true;
            couche_change_pas = setMenuHourOId(true, 1, HourOId1Select)
        
            if ( !Couche2Void ) {
            couche_change_pas = setMenuHourOId(true, 2, HourOId2Select)
            }
        couche_change_pas = setMenuInterval();
        couche_change_pas = setMenuDebut();
        couche_change_pas = setMenuFin();
                ISTEP = DprogDt_ISTEP;
            ISTEP_max = DprogDt_ISTEP_max;
            DprogDt_ferme = true;
        }
        ResetModeleDefaults = false;
        setListProgTimes();
        Refresh();
    }
}
// ________________________________________________________________________________
// Handle change event.
//

if ( WindMaps ) {
   document.getElementById("dprogdt").style.display = "none";
   document.getElementById("labelAnimMode").style.display = "none";
} else {
   DprogDtSelect.onchange = function () { updateDprogDtFromMenu() };
}

// ________________________________________________________________________________
//
//   couche Intercallé superposé  ou juxtaposé ------------------------------------------------------
//    couche superposées par défaut
//
var L_Interca = false;
var L_Juxtapo = false;
var Intercalage = "non";
var Juxtaposition = "non";

//   Selector  for L_Interca   et L_Juxtapo

const IntercaSelect = document.getElementById('interca');
setMenuInterca("noStorage");

// ________________________________________________________________________________
function gereFenetreJuxtapo(ouvre) {

  const map_et_map2_Wrapper = document.getElementById("map_et_map2_wrapper");
  const map2_Target = document.getElementById("map2");
  const map_Target = document.getElementById("map");

  const affiche_temps_valide2 = document.getElementById("affiche_temps_valide2");
  const affiche_temps_valide1 = document.getElementById("affiche_temps_valide1");
  const affiche_temps_valide  = document.getElementById("affiche_temps_valide");
  const afficheHor2 = document.getElementById("divAfficheHor2");
  const afficheHor = document.getElementById("divAfficheHor");

  const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  
  if (ouvre) {

      L_Juxtapo = true;
      L_Interca = false;
      
      UnsetValeurs("0");

        map.removeLayer(imageLayers2Group);
        map2.addLayer(imageLayers2Group);
        map.removeLayer(tileLayers2Group);
        map2.addLayer(tileLayers2Group);

        map.removeOverlay(Popup2Overlay);
        map2.addOverlay(Popup2Overlay);

      var                      largeur = 50;
      if ( viewwidth < 800 ) { largeur = 100; }
     
      map_Target.style.width = largeur.toString() + "%";
      map2_Target.style.width = largeur.toString() + "%";

      map2_Target.style.display = "inherit";

      affiche_temps_valide2.style.display = "inherit";
      affiche_temps_valide1.style.display = "inherit";
      affiche_temps_valide.style.display = "none";

      window.dispatchEvent(new Event('resize'));
      map.updateSize();
      map2.updateSize();

      updateViewProjection();

  } else {

      L_Juxtapo = false;
       
      ResetValeurs();

        map2.removeLayer(imageLayers2Group);
        map.addLayer(imageLayers2Group);
        map2.removeLayer(tileLayers2Group);
        map.addLayer(tileLayers2Group);

        map2.removeOverlay(Popup2Overlay);
        map.addOverlay(Popup2Overlay);

      map_Target.style.width = "100%";
      map2_Target.style.display = "none";

      affiche_temps_valide2.style.display = "none";
      affiche_temps_valide1.style.display = "none";
      affiche_temps_valide.style.display = "inherit";

      window.dispatchEvent(new Event('resize'));
      map.updateSize();
  }
}

// ________________________________________________________________________________
function updateIntercaFromMenu(wantRefresh) {

        StopAnimate();
        var proposedInterca  = IntercaSelect.options[IntercaSelect.options.selectedIndex].value ;

    let modele1 = Couche1.getModeleZoom();
    let modele2 = Couche2.getModeleZoom();

    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);

    if ( proposedInterca == "interca" ) { 
        if ( Couche2Void ) {
           L_Interca = false;
           if ( L_Juxtapo ) { 
                     IntercaSelect.options.selectedIndex = 2;
           } else {
                     IntercaSelect.options.selectedIndex = 1;
           }

           alert(" Le mode Intercalé fonctionne uniquement lorsque la couche 2 est présente. ");

        } else {
           L_Interca = true; 
           if ( L_Juxtapo ) { gereFenetreJuxtapo(false); }

           if ( WindMaps ) { 
             localStorage.setItem("Intercalage_V", "oui");
             localStorage.setItem("Juxtaposition_V", "non");
           } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
             localStorage.setItem("Intercalage_N", "oui");
             localStorage.setItem("Juxtaposition_N", "non");
           } else {
             localStorage.setItem("Intercalage", "oui");
             localStorage.setItem("Juxtaposition", "non");
           }
        }
    } else {
        L_Interca = false;
        affichage_meta_informations(-1);
        AfficheraLayer1 = true;
        AfficheraLayer2 = true;
           if ( WindMaps ) { 
             localStorage.setItem("Intercalage_V", "non");
           } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
             localStorage.setItem("Intercalage_N", "non");
           } else {
             localStorage.setItem("Intercalage", "non");
           }

        if ( proposedInterca == "juxtap" ) {

//              Juxtapo
           gereFenetreJuxtapo(true);

           if ( WindMaps ) { 
             localStorage.setItem("Juxtaposition_V", "oui");
           } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
             localStorage.setItem("Juxtaposition_N", "oui");
           } else {
             localStorage.setItem("Juxtaposition", "oui");
           }

        } else {
//              superpo
           if ( L_Juxtapo ) { gereFenetreJuxtapo(false); } 

           if ( WindMaps ) { 
             localStorage.setItem("Juxtaposition_V", "non");
           } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
             localStorage.setItem("Juxtaposition_N", "non");
           } else {
             localStorage.setItem("Juxtaposition", "non");
           }
        }
    }
    
    if (  ActiveLoop  ) {
        StartAnimate();
    } else if ( wantRefresh == "refresh" ) {  
        Refresh(); 
    }
}
// ________________________________________________________________________________
// Handle change event.
//
////if ( WindMaps ) {
////   document.getElementById("interca").style.display = "none";
////   document.getElementById("labelCouches").style.display = "none";
////} else {
   IntercaSelect.onchange = function () { updateIntercaFromMenu("refresh") };

   if ( Nowcast ) {
      Intercalage = localStorage.getItem("Intercalage_N");
      Juxtaposition = localStorage.getItem("Juxtaposition_N");
   } else {
      Intercalage = localStorage.getItem("Intercalage");
      Juxtaposition = localStorage.getItem("Juxtaposition");
   }

   if ( Intercalage == "oui" ) {
      IntercaSelect.options.selectedIndex = 0;
      updateIntercaFromMenu("noRefresh");
   } else if ( Juxtaposition == "oui" ) {
      IntercaSelect.options.selectedIndex = 2;
      updateIntercaFromMenu("noRefresh");
   }
////}

// ________________________________________________________________________________
//
function setMenuInterca(storage_) {

     IntercaSelect.options.length = 0;
     IntercaSelect.options[IntercaSelect.options.length] = new Option( "Interca", "interca");
     IntercaSelect.options[IntercaSelect.options.length] = new Option( "Superp", "superp");
     IntercaSelect.options[IntercaSelect.options.length] = new Option( "Juxtap", "juxtap");
     IntercaSelect.options.selectedIndex = 1;
     L_Interca = false;
     L_Juxtapo = false;
     AfficheraLayer1 = true;
     AfficheraLayer2 = true;
     affichage_meta_informations(-1);

    let modele1 = Couche1.getModeleZoom();
    let modele2 = Couche2.getModeleZoom();

    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);

     if ( storage_ != "noStorage" ) {
           if ( WindMaps ) { 
             localStorage.setItem("Intercalage_V", "non");
           } else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
             localStorage.setItem("Intercalage_N", "non");
           } else {
             localStorage.setItem("Intercalage", "non");
           }
     }
}

// ________________________________________________________________________________
//


//
//   TIME   ------------------------------------------------------
//

const listProg1minu = [];      //  pronostic time en minutes
const listProg2minu = [];
const listProg1 = [];          //  pronostic time en heures (string 3 caract'eres)
const listProg2 = [];
const listHourOId1 = [];       // heure d origines YYYYMMDD sauf pour GOESR et RADAR YYYYMMDDHH
const listHourOId2 = [];
const listUrl1 = [];           //   full path vers les images a aficher
const listUrl2 = [];
const listLoaded1 = [];        //  flag a propos du load de l image
const listLoaded2 = [];
const listNuLoadEnd1 = [];        //  flag a propos du nombre de tuile loaded
const listNuLoadEnd2 = [];
const listNuLoadStart1 = [];        //  flag a propos du nombre de tuile load started
const listNuLoadStart2 = [];
const listNuLoadErr1 = [];        //  flag a propos du nombre de tuile load en erreur
const listNuLoadErr2 = [];
const listNuWait1 = [];        // compteur du nombre de fois ou l image n etait pas prete a afficher
const listNuWait2 = [];

const listUrlCo1 = [];           //   full path vers les Co images a afich
const listUrlCo2 = [];
const listLoadedCo1 = [];        //  flag a propos du load de l image Co
const listLoadedCo2 = [];
const listNuLoadEndCo1 = [];        //  flag a propos du nombre de tuile Co loaded
const listNuLoadEndCo2 = [];
const listNuLoadStartCo1 = [];        //  flag a propos du nombre de tuile Co load started
const listNuLoadStartCo2 = [];
const listNuLoadErrCo1 = [];        //  flag a propos du nombre de tuile Co load en erreur
const listNuLoadErrCo2 = [];
const listNuWaitCo1 = [];        // compteur du nombre de fois ou l image n etait pas prete a afficher
const listNuWaitCo2 = [];

// ________________________________________________________________________________

function feedListProgTimes( no_, ii_, houroid_, progMinutes) {
  
  let hours = 0;
  let s_hours = "":

  if ( ( no_ == "0" ) || ( no_ == "1" ) ) {

    listProg1minu[ii_] = progMinutes;
    hours=Math.round( progMinutes/60. );
    s_hours=hours.toString();
    if ( s_hours.length < 3 )  { s_hours = "0"+ s_hours }
    if ( s_hours.length < 3 )  { s_hours = "0"+ s_hours }
    listProg1[ii_] = s_hours;
    listHourOId1[ii_] = houroid_;
    listUrl1[ii_] = CreerUrlImage( Tronc, Couche1.getModele(), Couche1.getZoomId(), Couche1.getMapId(),
                                       listHourOId1[ii_], listProg1[ii_] );
    listLoaded1[ii_] = "non";
    listNuWait1[ii_] = 0;
    listNuLoadEnd1[ii_] = 0;
    listNuLoadStart1[ii_] = 0;
    listNuLoadErr1[ii_] = 0;

    if ( !Couche1CoVoid ) {
       listUrlCo1[ii_] = CreerUrlImage( Tronc, Couche1.getModele(), Couche1.getZoomId(), Couche1.mapIdCo,
                                       listHourOId1[ii_], listProg1[ii_] );
    } else {
       listUrlCo1[ii_] = CreerUrlImage( Tronc, Couche1.getModele(), Couche1.getZoomId(), Couche1.getMapId(),
                                       listHourOId1[ii_], listProg1[ii_] );
    }
       listLoadedCo1[ii_] = "non";
       listNuLoadEndCo1[ii_] = 0;
       listNuLoadStartCo1[ii_] = 0;
       listNuLoadErrCo1[ii_] = 0;
       listNuWaitCo1[ii_] = 0;
  } 
  if ( ( no_ == "0" ) || ( no_ == "2" ) ) {

    listProg2minu[ii_] = progMinutes;
    hours=Math.round( progMinutes/60. );
    s_hours=hours.toString();
    if ( s_hours.length < 3 )  { s_hours = "0"+ s_hours }
    if ( s_hours.length < 3 )  { s_hours = "0"+ s_hours }
    listProg2[ii_] = s_hours;
    listHourOId2[ii_] = houroid_;
    listUrl2[ii_] = CreerUrlImage( Tronc , Couche2.getModele(), Couche2.getZoomId(), Couche2.getMapId(),
                                       listHourOId2[ii_], listProg2[ii_] );
    listLoaded2[ii_] = "non";
    listNuWait2[ii_] = 0;
    listNuLoadEnd2[ii_] = 0;
    listNuLoadStart2[ii_] = 0;
    listNuLoadErr2[ii_] = 0;

    if ( !Couche2CoVoid ) {
       listUrlCo2[ii_] = CreerUrlImage( Tronc, Couche2.getModele(), Couche2.getZoomId(), Couche2.mapIdCo,
                                       listHourOId2[ii_], listProg2[ii_] );
    } else {
       listUrlCo2[ii_] = CreerUrlImage( Tronc, Couche2.getModele(), Couche2.getZoomId(), Couche2.getMapId(),
                                       listHourOId2[ii_], listProg2[ii_] );
    }
       listLoadedCo2[ii_] = "non";
       listNuLoadEndCo2[ii_] = 0;
       listNuLoadStartCo2[ii_] = 0;
       listNuLoadErrCo2[ii_] = 0;
       listNuWaitCo2[ii_] = 0;
  }                                           
}
// ________________________________________________________________________________

function setListProgTimes() {

    //  recalcul des liste de houroid et prog time pour la séqunce tem,portelles de cartes pour
    //  les couches 1 et 2
    //
    //
    StopAnimate();

    let minutes1=0;
    let minutes2=0;
    var hours1 = 0;
    var hours2 = 0;
    var ii = 0;
    var s_heure_prog = 0;
    var istep_max = 0;
    var istep_max_1 = 0;
    var istep_max_2 = 0;
    var message = " ";
    var validTime1 = " ";
    var validTime2 = " ";
    var trouve = false;

    var debut_1 = Couche1.getDebut();    
    var debut_2 = Couche2.getDebut();   
    var fin_1 = Couche1.getFin();
    var fin_2 =  Couche2.getFin();
    var houroid_1= Couche1.getHourOId();
    var houroid_2= Couche2.getHourOId(); 
    var modele1 = Couche1.getModeleZoom();
    var modele2 = Couche2.getModeleZoom();

    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);

    var zoomMax = 0;
    var oldZoomMax = 0;
    var verbose_ = true;

    if ( ModToLyrTyp.get( modele1 ) != "Image" ) {

            oldZoomMax = Resolutions1.length-1;
        for (let ii = oldZoomMax; ii >= 0; ii = ii - 1 ) {   Resolutions1.pop(); }
            oldZoomMax = ResolutionsCo1.length-1;
        for (let ii = oldZoomMax; ii >= 0; ii = ii - 1 ) { ResolutionsCo1.pop(); }

           message = "++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++";
           console.log(message);
        message = "SetListProg: Resolutions des tuiles couche 1 au départ:" + Couche1.mapIdH + " " + Resolutions1;
        console.log(message);

        zoomMax = 2;
        for ( let ii = 0; ii <= (ListCarteCon.length-1) ;  ii = ii + 1 ) {
            if (  Couche1.mapIdH.indexOf(ListCarteCon[ii]) != -1 ) {
               zoomMax = 3;
            }  
        }
        for ( let ii = 0; ii <= (ListCartePix.length-1) ;  ii = ii + 1 ) {
            if (  Couche1.mapIdH.indexOf(ListCartePix[ii]) != -1 ) {
               zoomMax = 2;
            }  
        }

        if ( verbose_ ) {
           console.log( " dimx: ", ModToDimX.get(modele1), " dimY: ", ModToDimY.get(modele1), " extent: ", Couche1.extent, "Zmax: ", zoomMax)
        }

        Resolutions1=calculResolutions( ModToDimX.get(modele1), ModToDimY.get(modele1), Couche1.extent, Resolutions1, zoomMax);

        zoomMax = 2;
        if ( !Couche1CoVoid ) { 
           for ( let ii = 0; ii <= (ListCarteCon.length-1) ;  ii = ii + 1 ) {
               if ( Couche1.mapIdCo.indexOf(ListCarteCon[ii]) != -1 ) { zoomMax = 3; }
           }
           for ( let ii = 0; ii <= (ListCartePix.length-1) ;  ii = ii + 1 ) {
               if (  Couche1.mapIdCo.indexOf(ListCartePix[ii]) != -1 ) { zoomMax = 2; }
           }
        }
        ResolutionsCo1=calculResolutions(ModToDimX.get(modele1), ModToDimY.get(modele1), Couche1.extent, ResolutionsCo1, zoomMax);

        message = "################################################################################";
        console.log(message);
        message = "SetListProg: mapId couche 1:" + Couche1.mapIdH + "  zoomMax: " + zoomMax + " MapIdCo: " + Couche1.mapIdCo;
        console.log(message); 
        message = "SetListProg: Resolutions des tuiles couche 1:" + Couche1.mapIdH + " " + Resolutions1;
        console.log(message);
        message = "SetListProg: Resolutions des Co tuiles couche 1:" + Couche1.mapIdCo + " " + ResolutionsCo1;
        console.log(message);

    } else {
            message = "SetListProg, couche 1: " + modele1 + " Image simple ";
            console.log(message);
            message = "SetListProg: mapId couche 1:" + Couche1.mapIdH;
            console.log(message);
    }

    if ( ModToLyrTyp.get( modele2 ) != "Image" ) {

        zoomMax = 0;
            oldZoomMax = Resolutions2.length-1;
        for (let ii = oldZoomMax;   ii >= 0;  ii = ii - 1 ) {   Resolutions2.pop(); }
            oldZoomMax = ResolutionsCo2.length-1;
        for (let ii = oldZoomMax; ii >= 0;  ii = ii - 1 ) { ResolutionsCo2.pop(); }

        if ( !Couche2Void ) {  

           zoomMax = 2;
           for ( let ii = 0; ii <= (ListCarteCon.length-1) ;  ii = ii + 1 ) {
               if ( Couche2.mapIdH.indexOf(ListCarteCon[ii]) != -1 ) { zoomMax = 3; }
           }
           for ( let ii = 0; ii <= (ListCartePix.length-1) ;  ii = ii + 1 ) {
               if (  Couche2.mapIdH.indexOf(ListCartePix[ii]) != -1 ) { zoomMax = 2; }
           }

           Resolutions2=calculResolutions(ModToDimX.get(modele2), ModToDimY.get(modele2), Couche2.extent, Resolutions2, zoomMax);

           zoomMax = 2;
           if ( !Couche2CoVoid ) { 
                 for ( let ii = 0; ii <= (ListCarteCon.length-1) ;  ii = ii + 1 ) {
                     if ( Couche2.mapIdCo.indexOf(ListCarteCon[ii]) != -1 ) { zoomMax = 3; }
                 }
                 for ( let ii = 0; ii <= (ListCartePix.length-1) ;  ii = ii + 1 ) {
                     if (  Couche2.mapIdCo.indexOf(ListCartePix[ii]) != -1 ) { zoomMax = 2; }
                 }
           }
           ResolutionsCo2=calculResolutions(ModToDimX.get(modele2), ModToDimY.get(modele2), Couche2.extent, ResolutionsCo2, zoomMax);

           message = "################################################################################";
           console.log(message);
           message = "SetListProg: mapId couche 2:" + Couche2.mapIdH + "  zoomMax: " + zoomMax + " MapIdCo: " + Couche2.mapIdCo;
           console.log(message); 
           message = "SetListProg: Resolutions des tuiles couche 2:" + Couche2.mapIdH + " " + Resolutions2;
           console.log(message);
           message = "SetListProg: Resolutions des Co tuiles couche 2:" + Couche2.mapIdCo + " " + ResolutionsCo2;
           console.log(message);
         }
    } else {
            message = "SetListProg, couche 2: " + modele2 + " Image simple ";
            console.log(message);
            message = "SetListProg: mapId couche 2:" + Couche1.mapIdH;
            console.log(message); 
    }

//-----------------------------------------------------------------------------------
    var interval = Couche1.getInterval();

        //  Dans un contexte où l houroid  ou l'interval entre les pas de temps changent
        //  il arrive que le pas de temps ISTEP actuel ne corresponde pas
        //  du tout au même temps valide avant et après le changement.
        //  Exemple, si l'intervale de temps passe du 3 heures à 24 heures,
        //  on doit s'attendre à ce que le ISTEP soit 8 fois plus petit pour le même temps valide.
        //  Le but ici est de tenter de fournir un ISTEP qui préserve
        //  autant que possible le temps valide suite à un changement de houroid et-ou interval
    //   ou encore un changement de modèle
    //  la variable step est ce guess du pas de temps à la sortie de la fonction
    //
    var step = 0;
    var delta_t;

    // delta_t est le nombre d'heure à partir du houroid jusqu'au temps valide actuel
    // puisque les couches ont été mise à jour avant l'appel de la présente fonction
    // on utilise les listes listProg  et listHourOId afin de retrouver les valeurs
    // précédentes du temps de prog (listProg1minu[ISTEP]) en minutes et du debut (listProg1minu[0]) 
    // et ainsi estimer la valeur de step pour préserver le temps valid avec le nouvel interval.
    // et compte tenu d'un possible changement de la date d'origine (listHourOId1[0]  )
    //
    if ( DprogDt_ferme ) {
            
            DprogDt_ferme=false;
            step = Math.min( ISTEP, ISTEP_max);
            
    } else if ( DprogDt )  {

            message = "SetListProg: ValidTime au debut..." + ValidTime;
            console.log(message);
            var tempsValid = getHourOIdPlusMoinsNbMinutes( listHourOId1[ISTEP], listProg1minu[ISTEP], true ); 
            ValidTime = getAfficheValidDateTime(listHourOId1[ISTEP], listProg1minu[ISTEP]);
            if ( DprogDt_ouvre )  { 
                DprogDt_ouvre=false;
                    tempsValid =  getHourOIdPlusMoinsNbMinutes( listHourOId1[DprogDt_ISTEP], listProg1minu[DprogDt_ISTEP], true )  ;
                    ValidTime = getAfficheValidDateTime(listHourOId1[DprogDt_ISTEP], listProg1minu[DprogDt_ISTEP]);
                }

            message = "SetListProg:   temps valide au debut... "+ tempsValid;
            console.log(message);
            message = "SetListProg:   ValidTime recalcule au debut... "+ ValidTime;
            console.log(message);

            var portee = parseInt( getHourOIdPlusMoinsNbMinutes( houroid_1, parseInt(fin_1), true ) ); 
            if ( portee < tempsValid ) {
               message = " Le temps valide demandé est au delà de la portee maximale de la couche 1";
               alert(message);
               ValidTime = getAfficheValidDateTime(  houroid_1,  fin_1 );
            }
            if ( !Couche2Void) { 
                portee = parseInt( getHourOIdPlusMoinsNbMinutes( houroid_2, parseInt(fin_2), true ) );
                if ( portee < tempsValid ) {
                   message = " Le temps valide demandé est au delà de la portee maximale de la couche 2";
                   ValidTime = getAfficheValidDateTime(  houroid_2,  fin_2 );
                }
            }
            step = ISTEP_max;

    } else if ( nowcast1 ) {

                ISTEP =0; 
                step=0;
                delta_t=0;

    } else if ( ISTEP != 0 ) {
            delta_t = parseInt(listProg1minu[Math.min( Math.min(ISTEP, ISTEP_max),listProg1minu.length-1)]) + soustractionHourOId(listHourOId1[0], houroid_1, false);
                step  = Math.max( parseInt( ( delta_t - parseInt(debut_1) ) /interval ) , 0 );
    }
    

        // destruction des anciennes listes
    for ( ii = 0; ii <= (listProg1.length-1) ;  ii = ii + 1 ) {
            listProg1.pop(); listProg1minu.pop(); listHourOId1.pop(); listUrl1.pop(); listUrlCo1.pop(); 
            listLoaded1.pop(); listLoadedCo1.pop();
            listNuWait1.pop(); listNuWaitCo1.pop(); 
            listNuLoadStart1.pop(); listNuLoadStartCo1.pop(); 
            listNuLoadEnd1.pop(); listNuLoadEndCo1.pop(); 
            listNuLoadErr1.pop(); listNuLoadErrCo1.pop(); 
    }

    for ( ii = 0; ii <= (listProg2.length-1) ;  ii = ii + 1 ) {
         listProg2.pop(); listProg2minu.pop(); listHourOId2.pop(); listUrl2.pop(); listUrlCo2.pop();
         listLoaded2.pop(); listLoadedCo2.pop();
         listNuWait2.pop(); listNuWaitCo2.pop();
         listNuLoadStart2.pop(); listNuLoadStartCo2.pop(); 
         listNuLoadEnd2.pop(); listNuLoadEndCo2.pop(); 
         listNuLoadErr2.pop(); listNuLoadErrCo2.pop(); 
    }
    for ( ii = 0 ; ii <= NoLimitOfLayers-1 ; ii++ ) {
        imageLayers2[ii].setOpacity(0.);
        imageLayers1[ii].setOpacity(0.);
        tileLayers2[ii].setOpacity(0.);
        tileLayers1[ii].setOpacity(0.);
        tileLayersCo2[ii].setOpacity(0.);
        tileLayersCo1[ii].setOpacity(0.);
    }

//    Ok menage complété on va ré essigner des valeurs dans les listes...

//    Debut de la grande section
//    #######################################################

    if ( DprogDt && nowcast1 ) {
      let shouroid1= "";
      let shouroid2= "";
      let iicount = 0;

      for ( ii = HourOId1Select.options.length - 1; ii >= 0; ii-- ) {

          shouroid1 = HourOId1Select.options[ii].value;

          if ( getAfficheValidDateTime(shouroid1, 0) == ValidTime ) {
//            ici on a trouve le shouroid qui correspond au temps valide...que l'on cherche
//            il faut trouver les prog qui y correspondent sur la couche 2

              // ici on change temporairement l interval pour obtenir une interval de pcpn correct  si c est le cas
              Couche2.interval=Math.max( ModAInterv.get( modele2 ), interval); 

              for ( let ii2 = HourOId2Select.options.length - 1; ii2 >= 0; ii2-- ) {
                  shouroid2 = HourOId2Select.options[ii2].value;

                  for ( minutes2 = ModAInterv.get(modele2) ; minutes2 <= ModAFin.get(modele2); minutes2 = minutes2 + ModAInterv.get(modele2) ) { 
                      if ( getAfficheValidDateTime(shouroid2, minutes2) ==  ValidTime ) {

                                  feedListProgTimes( "1", iicount, shouroid1, 0);
                                  feedListProgTimes( "2", iicount, shouroid2, minutes2);
                                  iicount = iicount + 1;
                      }                       
                  }
              }
          }
       }
       //  ici on remet l intervale de la couche 2 a sa valeur
       Couche2.interval=interval;
       istep_max_1 = iicount-1;
       istep_max_2 = iicount-1;

//      fin de DprogDt && Nowcast1

    } else if ( DprogDt && nowcast2 ) {

      let shouroid1= "";
      let shouroid2= "";
      let iicount = 0;

      for ( let ii2 = HourOId2Select.options.length - 1; ii2 >= 0; ii2-- ) {
          shouroid2 = HourOId2Select.options[ii2].value;
                      
          if ( getAfficheValidDateTime(shouroid2, 0) == ValidTime ) {
      
             for ( ii = HourOId1Select.options.length - 1; ii >= 0; ii-- ) {
                 shouroid1 = HourOId1Select.options[ii].value;

                 for ( minutes1 = interval ; minutes1 <= ModAFin.get(modele1); minutes1 = minutes1 + interval ) {
                     if ( getAfficheValidDateTime(shouroid1, minutes1) ==  ValidTime ) { 
                                feedListProgTimes( "1", iicount, shouroid1, minutes1);
                                feedListProgTimes( "2", iicount, shouroid2, 0);
                                iicount = iicount + 1;
                     } 
                 }
             }
          }
      }
      istep_max_1 = iicount-1;
      istep_max_2 = iicount-1;

//      fin de DprogDt && Nowcast2

    } else if ( DprogDt ) {

      let houroid_ = "";
      let iicount = 0;

      for ( ii = HourOId1Select.options.length - 1; ii >= 0; ii-- ) {
         houroid_ = HourOId1Select.options[ii].value;

            for ( minutes1 = debut_1 ; minutes1 <= fin_1; minutes1 = minutes1 + interval ) {

               if ( getAfficheValidDateTime(houroid_, minutes1) ==  ValidTime ) { 
                  if ( !Couche2Void ) {
                      trouve = false;
                      for ( var ii2 = HourOId2Select.options.length - 1; ii2 >= 0; ii2-- ) {
                          if ( houroid_ == HourOId2Select.options[ii2].value) {
                         trouve = true;
                       }
                      }
                      if ( trouve ) {
                      for ( minutes2 = debut_2 ; minutes2 <= fin_2; minutes2 = minutes2 + interval ) {

                          if ( getAfficheValidDateTime(houroid_, minutes2) ==  ValidTime ) {
                                  feedListProgTimes( "1", iicount, houroid_, minutes1)
                                  feedListProgTimes( "2", iicount, houroid_, minutes2)
                           iicount = iicount + 1;
                           }
                       }
                       }
                  } else {
                      feedListProgTimes( "1", iicount, houroid_, minutes1)
                     iicount = iicount + 1;
                  }
           }
        }
      } 
      istep_max_1 = iicount-1;
      istep_max_2 = iicount-1;

//   fin de DprogDt 

    } else if ( nowcast1 ) {

        let shouroid_debut=getHourOIdPlusMoinsNbMinutes(HourOId1Select.options[0].value, debut_1, true);
        let shouroid_fin =getHourOIdPlusMoinsNbMinutes(HourOId1Select.options[0].value, fin_1, true);
        let houroid_debut=parseInt(shouroid_debut);
        let houroid_fin=parseInt(shouroid_fin);
        let houroid_=houroid_debut;
        let nb_min_int=0;
        let  snb_min="";
        let nb_min=0;
        let nb_hour_int=0;
        let snb_hour="";

        if (  interval != ModAInterv.get( modele1 ) ) {

//         ici on cherche l houroid de debut qui donnera un nombre d interval entier pour arriver a la fin
//         notons que la fin est le temps le plus pres du temps reel  alors que le debut est le plus loin dans le temps passe

           nb_min=parseInt(shouroid_fin.substring(8,10))*60 + parseInt((shouroid_fin.toString()).slice(-2));

           nb_hour_int= parseInt((parseInt(nb_min/interval)*interval)/60);
           snb_hour=nb_hour_int.toString();
           if ( snb_hour.length < 2 ) { snb_hour= "0" + snb_hour}

           nb_min_int= (parseInt(nb_min/interval)*interval)%60;
           snb_min=nb_min_int.toString();
           if ( snb_min.length < 2 ) { snb_min= "0" + snb_min}

           shouroid_fin = shouroid_fin.substring(0,8) + snb_hour + snb_min;
           houroid_fin=parseInt(shouroid_fin);

           shouroid_debut =getHourOIdPlusMoinsNbMinutes(shouroid_fin, (parseInt(fin_1)-parseInt(debut_1)), false);
           houroid_debut=parseInt(shouroid_debut);
           
           houroid_ = houroid_debut;
           
        } else {

           houroid_=Math.max( parseInt(HourOId1Select.options[HourOId1Select.options.length-1].value), houroid_);
        }

        let shouroid_=houroid_.toString();
        let iicount = 0;
        let jj =0;

        for ( ii= HourOId1Select.options.length - 1; ii>=0; ii--) {
   
            if (houroid_ <= houroid_fin) {
           if ( shouroid_ == HourOId1Select.options[ii].value ) {

                  feedListProgTimes( "1", iicount, shouroid_, 0);

                  nb_min=parseInt(shouroid_.slice(-2));
                  nb_hour_int= parseInt(shouroid_.substring(8,10));

                  if ( nowcast2 )  {

                     nb_min_int=  Math.round( nb_min/ (ModAInterv.get(modele2)) ) * ModAInterv.get(modele2);
                     if ( nb_min_int >= 60 ) { 
                            nb_min_int=parseInt(nb_min/(ModAInterv.get(modele2))) * ModAInterv.get(modele2);
                     }  
                     snb_min=nb_min_int.toString();
                     if ( snb_min.length < 2 ) { snb_min= "0" + snb_min}
              
                     feedListProgTimes( "2", iicount, (shouroid_.substring(0,10) + snb_min), 0);
                     //console.log( " houroid1 " + listHourOId1[iicount] + " houroid2 " + listHourOId2[iicount] + " icount " + iicount); 

                   } else if ( !Couche2Void ) {

                     minutes2 = soustractionHourOId( shouroid_, houroid_2, true);
                     nb_min = Math.round( minutes2/ (ModAInterv.get(modele2)) ) * ModAInterv.get(modele2);
                
                      // ici on change temporairement l interval pour obtenir une interval de pcpn correct  si c est le cas
                     Couche2.interval=Math.max( ModAInterv.get( modele2 ), interval); 

                     feedListProgTimes( "2", iicount, houroid_2, nb_min); 

                      //  ici on remet l intervale de la couche 2 a sa valeur
                     Couche2.interval=interval;
                  } 
                  iicount = iicount + 1;
                  shouroid_=getHourOIdPlusMoinsNbMinutes( shouroid_, interval, true );
                  houroid_ = parseInt(shouroid_);
               } 
            } 
        }
        istep_max_1 = iicount-1;
        istep_max_2 = istep_max_1;

//    fin de nowcast  et debut de mode prog

    } else {
    
        ii = 0;
        for ( minutes1 = debut_1 ; minutes1 <= fin_1 ; minutes1 = minutes1 + interval ) {

           feedListProgTimes( "1", ii, houroid_1, minutes1 )
           if ( nowcast2 ) {
              feedListProgTimes( "2", ii, houroid_1, 0 )
              listHourOId2[ii] =getHourOIdPlusMoinsNbMinutes( (houroid_1+"00"), minutes1, true );
              listUrl2[ii] = CreerUrlImage( Tronc, Couche2.getModele(), Couche2.getZoomId(), Couche2.getMapId(),
                                                                    listHourOId2[ii], listProg2[ii] );
              listUrlCo2[ii] = CreerUrlImage( Tronc, Couche2.getModele(), Couche2.getZoomId(), Couche2.mapIdCo,
                                                                    listHourOId2[ii], listProg2[ii] );
           }
           ii = ii + 1;
        }
        istep_max_1 = ii - 1;

        if ( !Couche2Void  && !nowcast2 ) {
            ii = 0;
            for ( minutes2 = debut_2 ; minutes2 <= fin_2 ; minutes2 = minutes2 + interval ) {
                feedListProgTimes( "2", ii, houroid_2, minutes2 ) 
            ii = ii + 1;
            }
        }
        istep_max_2 = ii - 1;
    }

///   FIN de la grande boucle 
//   ##########################

    NoOfLayers = parseInt( Math.min( (istep_max_1 + 1), NoLimitOfLayers) );

    let nu_steps_ = istep_max_1 + 1;

        message=" number of time steps: " + nu_steps_ +  "Initial NoOfLayers = " + NoOfLayers; 
        console.log(message);

    while ( ( nu_steps_  % NoOfLayers) != 0 ) {
        message=" number of time steps: " + nu_steps_ +  "In while NoOfLayers = " + NoOfLayers; 
        console.log(message);

        NoOfLayers = NoOfLayers - 1;
        }

        message=" number of time steps: " + nu_steps_ +  "after while NoOfLayers = " + NoOfLayers; 
        console.log(message);

    if (  NoOfLayers == 1 ) { 

                      // ici on change temporairement l interval pour obtenir une interval de pcpn correct  si c est le cas
                     Couche2.interval=Math.max( ModAInterv.get( modele2 ), interval); 
           feedListProgTimes( "1", istep_max_1 + 1, listHourOId1[istep_max_1 ], listProg1minu[istep_max_1] );
           istep_max_1 = istep_max_1 + 1;

            if ( !Couche2Void ) {   
                feedListProgTimes( "2", istep_max_2 + 1, listHourOId2[istep_max_2 ], listProg2minu[istep_max_2]);
                istep_max_2 = istep_max_2 + 1;
            } else {
                istep_max_2 = istep_max_1;
            }
            NoOfLayers = 2;
                      //  ici on remet l intervale de la couche 2 a sa valeur
                     Couche2.interval=interval;
    }

    if ( nowcast1 ) { step=istep_max_1; }

    if ( ActiveLoop ) {
       step = step - 1;
       if ( step < 0 ) { step = istep_max_1 }
    }

    ISTEP = Math.max( 0, step);
    ISTEP = Math.min( istep_max_1, ISTEP);

    message=" istep_max_1: " + istep_max_1 +  " ISTEP = " + ISTEP; 
    console.log(message);

    ISTEP_max = istep_max_1;

    message=" SetListProgTimes:  ISTEP_max = " + ISTEP_max + " NoOfLayers = " + NoOfLayers;
    console.log(message);
        
    if ( Avance ) {  
            ISTEP_next = ISTEP + 1; 
    } else { 
            ISTEP_next = ISTEP - 1;
    }
        if (ISTEP_next > ISTEP_max ) { ISTEP_next = 0 }
        if (ISTEP_next < 0 )         { ISTEP_next = ISTEP_max }

    message=" SetListProgTimes:  ISTEP_max = " + ISTEP_max + " ISTEP = " + ISTEP +  " ISTEP_next = " + ISTEP_next;
    console.log(message);
    message =" 1: range = HourOId, Prog: " + listHourOId1[0] + " , " + listProg1[0] + " à " + listHourOId1[ISTEP_max] + " , " + listProg1[ISTEP_max];
    console.log(message);
    message =" 2: range = HourOId, Prog: " + listHourOId2[0] + " , " + listProg2[0] + " à " + listHourOId2[ISTEP_max] + " , " + listProg2[ISTEP_max];
    console.log(message);

    if ( !Couche2Void ) {
        if ( istep_max_1 != istep_max_2 ) {
        message=" Re-initialisation conseillee, et SVP rapporter à l administrateur (istep_max).";
        alert(message); 
        }
        if ( !nowcast1 ) {
           if (  getAfficheValidDateTime(listHourOId1[0], listProg1minu[0]) != getAfficheValidDateTime(listHourOId2[0], listProg2minu[0]) )  {
           message=" Re-initialisation conseillee, et SVP rapporter à l administrateur (depart incoherent).";
           alert(message); 
           }
           if (  getAfficheValidDateTime(listHourOId1[istep_max_1], listProg1minu[istep_max_1]) != getAfficheValidDateTime(listHourOId2[istep_max_2], listProg2minu[istep_max_2]) )  {
           message=" Re-initialisation conseillee, et SVP rapporter à l administrateur (fin incoherente).";
           alert(message); 
           }
        }
    }

   CountTiles1=CountTilesInView("1");
               document.getElementById("zoomLvl1").innerHTML = CountTiles1[0];
               document.getElementById("zoomLvlCo1").innerHTML = CountTiles1[1];
   CountTiles2=CountTilesInView("2");
               document.getElementById("zoomLvl2").innerHTML = CountTiles2[0];
               document.getElementById("zoomLvlCo2").innerHTML = CountTiles2[1];
}
//
// ------------------------------------------------------------------------------
//  TIME et    ANIMATION ----------------------------------------------------------
//

var ISTEP = 0;
var ISTEP_max = 0;
var ISTEP_next = 1;
var ISTEP_ecout1 = ISTEP_next;
var ISTEP_ecout2 = ISTEP_next;


//------------------------------------------------------------------
// --- Preparing for the animation trigger

var ISTEP_increment = 0;
var ISTEP_repeatEndLoop = 5;

var Avance = true;
var LoopRunning = false;
var ActiveLoop = false;

var AfficheraLayer1 = true;
var AfficheraLayer2 = true;

setListProgTimes();
var ValidTime = getAfficheValidDateTime(listHourOId1[0], listProg1minu[0]);

//


// ___________________________________________________________________________________________________________________
//
function TimeStep(increment, rafraichir) {
     
    var verbose_=true;
    var ii =0;
    var message=""; 
    let message2=""; 
    let validTime2= "";
    var index = ISTEP % NoOfLayers;
    var index_next = ISTEP_next % NoOfLayers;

    var indexPrev = index;
    var istep_prev

    let stringAffi1 = Couche1.modele + " Prog: ";
    let stringAffi2 = Couche2.modele + " Prog: ";

    let nowcast1=isNowcast( Couche1.getModeleZoom() );
    let nowcast2=isNowcast( Couche2.getModeleZoom() );
    if ( nowcast1 ) { stringAffi1=Couche1.modele + ": " }
    if ( nowcast2 ) { stringAffi2=Couche2.modele + ": " }

    var changeStep = ( !L_Interca || ( L_Interca && AfficheraLayer2 && Avance ) || ( L_Interca && AfficheraLayer1 && !Avance ) );
    var allLoadedOk = false;

    var ISTEP1 = ISTEP_next;
    var ISTEP2 = ISTEP_next;
    if ( L_Interca ) {
           if        ( AfficheraLayer2 && Avance ) {  ISTEP2 = ISTEP_next;
           } else if ( AfficheraLayer2 ) {            ISTEP2 = ISTEP;
           } else if ( AfficheraLayer1 && Avance ) {  ISTEP1 = ISTEP;
           } else if ( AfficheraLayer1 ) {            ISTEP1 = ISTEP_next;
           }
    }

    //if ( !L_Interca ) {
    
        if ( ( AfficheraLayer1 ) && (ISTEP_ecout1 !== ISTEP1) ) {
            console.log('...............................................................................' );
            console.log('===============================================================================' );
            console.log('...............................................................................' );
            console.log('Error TimeStep: écouteur couche 1:' + ISTEP_ecout1 + ' et ISTEP1: ' + ISTEP1 + ' doivent etre égaux' );
            console.log('...............................................................................' );
            console.log('===============================================================================' );
            console.log('...............................................................................' );
//            if ( LoopRunning && !L_Interca ) {
//              DesactiveAndStopAnimate();
//              return
//            }
        }
        if (( !Couche2Void ) && ( AfficheraLayer2) && ( ISTEP_ecout2 !== ISTEP2 )) {
            console.log('...............................................................................' );
            console.log('===============================================================================' );
            console.log('...............................................................................' );
            console.log('Error TimeStep: écouteur couche 2:' + ISTEP_ecout2 + ' et ISTEP_next: ' + ISTEP_next + ' doivent etre égaux' );
            console.log('...............................................................................' );
            console.log('===============================================================================' );
            console.log('...............................................................................' );
//            if ( LoopRunning && !L_Interca ) {
//              DesactiveAndStopAnimate();
//              return
//            }
        }
    //}
    if ( AfficheraLayer1 ) {

            message=" +++++++++++++++++++++++++++++++++++++++++++++++++++++++";console.log(message);
            message=" ----------- TIME STEP : " + ISTEP1 + " ------------";console.log(message);
            message=" -- Start1 End1 Err1 nuTiles: "; console.log(message);
            message="     " + listNuLoadStart1[ISTEP1] + "     " + listNuLoadEnd1[ISTEP1] + "     " + listNuLoadErr1[ISTEP1] + "     " + CountTiles1[0] ;console.log(message);
            if ( !Couche1CoVoid ) {
               message=" -- StartCo1 EndCo1 ErrCo1 nuTiles: "; console.log(message);
               message="       " + listNuLoadStartCo1[ISTEP1] + "       " + listNuLoadEndCo1[ISTEP1] + "       " + listNuLoadErrCo1[ISTEP1] + "       " + CountTiles1[1] ;console.log(message);
        }

            if ( ( listLoaded1[ISTEP1] != "missing" ) && ( listLoaded1[ISTEP1] != "yes" ) ) {

               if ( (listNuLoadStart1[ISTEP1] != 0) && ( listNuLoadStart1[ISTEP1] == ( listNuLoadEnd1[ISTEP1] + listNuLoadErr1[ISTEP1] )) ) {
                     if ( listNuLoadEnd1[ISTEP1] ==  listNuLoadStart1[ISTEP1] ) {  
                          listLoaded1[ISTEP1] = "yes"; listNuWait1[ISTEP1] = 0; 
                     } else if ( listNuLoadErr1[ISTEP1] > 0 ) {
                          listLoaded1[ISTEP1] = "some_errors";
                          if ( listNuLoadErr1[ISTEP1] == listNuLoadStart1[ISTEP1] ) {   listLoaded1[ISTEP1] = "full_errors" }
                     }
               } else if ( listNuLoadEnd1[ISTEP1] == CountTiles1[0] ) {
                                listLoaded1[ISTEP1] = "yes"; listNuWait1[ISTEP1] = 0;
                                message=" The 1 end count balance the requirements " + listNuLoadEnd1[ISTEP1] + " " + CountTiles1[0] + " <<========== ";console.log(message);
               } else {
                  if ( listNuLoadEnd1[ISTEP1] > 0 ) {  listLoaded1[ISTEP1] = "still_loading" }
                  if ( listNuLoadEnd1[ISTEP1] == 0 && listLoaded1[ISTEP1] == "loading" ) {  listLoaded1[ISTEP1] = "still_loading" }
                  if ( listNuLoadStart1[ISTEP1] == 0) { 
                       listLoaded1[ISTEP1] = "still_loading";
                        message=" The start of loading counts were not resgistered  1 <<========== ";console.log(message);
                  }
               }
            }
            message=" --------- ListLoaded1 is now:  " + listLoaded1[ISTEP1] + " ------------";console.log(message);

            if ( rafraichir ) {
                if (( listLoaded1[ISTEP1] == "still_loading" ) || ( listLoaded1[ISTEP1] == "loading" )) {
                    message=" --------- ListLoaded1 is forced to yes because the flag rafaichir is true ";console.log(message);
                    listLoaded1[ISTEP1] = "yes"; listNuWait1[ISTEP1] = 0;
                }  
                if ( listLoaded1[ISTEP1] != "yes" ) {
                    message = " <br> Chargement problématique couche 1. (Re) faire un pas avant ou arriere. <br> <br>";
                    openAfficheInfo(message, 10);
                }
            }

            if ( !Couche1CoVoid ) {
               if ( ( listLoadedCo1[ISTEP1] != "missing" ) && ( listLoadedCo1[ISTEP1] != "yes" ) ) {
                   if ( (listNuLoadStartCo1[ISTEP1] != 0) && ( listNuLoadStartCo1[ISTEP1] == ( listNuLoadEndCo1[ISTEP1] + listNuLoadErrCo1[ISTEP1] )) ) {
                         if ( listNuLoadEndCo1[ISTEP1] ==  listNuLoadStartCo1[ISTEP1] ) {  
                              listLoadedCo1[ISTEP1] = "yes"; listNuWaitCo1[ISTEP1] = 0; 
                         } else if ( listNuLoadErrCo1[ISTEP1] > 0 ) {
                              listLoadedCo1[ISTEP1] = "some_errors";
                              if ( listNuLoadErrCo1[ISTEP1] == listNuLoadStartCo1[ISTEP1] ) {   listLoadedCo1[ISTEP1] = "full_errors" }
                         }
                   } else if ( listNuLoadEndCo1[ISTEP1] == CountTiles1[1] ) {
                                listLoadedCo1[ISTEP1] = "yes"; listNuWaitCo1[ISTEP1] = 0;
                                message=" The Co1 end count balance the requirements " + listNuLoadEndCo1[ISTEP1] + " " + CountTiles1[1] + " <<========== ";console.log(message);
                   } else {
                      if ( listNuLoadEndCo1[ISTEP1] > 0 ) {  listLoadedCo1[ISTEP1] = "still_loading" }
                      if ( listNuLoadEndCo1[ISTEP1] == 0 && listLoadedCo1[ISTEP1] == "loading" ) {  listLoadedCo1[ISTEP1] = "still_loading" }
                      if ( listNuLoadStartCo1[ISTEP1] == 0) { 
                           listLoadedCo1[ISTEP1] = "still_loading";
                           message=" The start of loading counts were not resgistered Co1<<========== ";console.log(message);
                      }
                   }
               }
               message=" --------- ListLoadedCo1 is now:  " + listLoadedCo1[ISTEP1] + " ------------";console.log(message);

               if ( rafraichir ) {
                    if (( listLoadedCo1[ISTEP1] == "still_loading" ) || ( listLoadedCo1[ISTEP1] == "loading" )) {
                      message=" --------- ListLoadedCo1 is forced to yes because the flag rafaichir is true ";console.log(message);
                     listLoadedCo1[ISTEP1] = "yes"; listNuWaitCo1[ISTEP1] = 0;
                    }  
                    if ( listLoadedCo1[ISTEP1] != "yes" ) {
                        message = " <br> Chargement problématique Co couche1. (Re) faire un pas avant ou arriere. <br> <br>";
                        openAfficheInfo(message, 10);
                    }
               }
            }
   }
   if ( AfficheraLayer2 && !Couche2Void ) {

            message=" +++++++++++++++++++++++++++++++++++++++++++++++++++++++"; console.log(message);
            message=" ----------- TIME STEP : " + ISTEP2 + " ------------"; console.log(message);
            message=" -- Start2 End2 Err2 nuTiles: "; console.log(message); 
            message="     " + listNuLoadStart2[ISTEP2] + "   " + listNuLoadEnd2[ISTEP2] + "   " + listNuLoadErr2[ISTEP2] + "   " + CountTiles2[0] ; console.log(message);

            if ( !Couche2CoVoid ) { 
               message=" -- StartCo2 EndCo2 ErrCo2 nuTiles: " ; console.log(message);
               message="       " + listNuLoadStartCo2[ISTEP2] + "     " + listNuLoadEndCo2[ISTEP2] + "     " + listNuLoadErrCo2[ISTEP2] + "     " + CountTiles2[1] ; console.log(message);
            }
            if ( ( listLoaded2[ISTEP2] != "missing" ) && ( listLoaded2[ISTEP2] != "yes" ) ) {
               if ( (listNuLoadStart2[ISTEP2] != 0) && ( listNuLoadStart2[ISTEP2] == ( listNuLoadEnd2[ISTEP2] + listNuLoadErr2[ISTEP2] )) ) {
                     if ( listNuLoadEnd2[ISTEP2] ==  listNuLoadStart2[ISTEP2] ) {  
                          listLoaded2[ISTEP2] = "yes"; listNuWait2[ISTEP2] = 0; 
                     } else if ( listNuLoadErr2[ISTEP2] > 0 ) {
                          listLoaded2[ISTEP2] = "some_errors";
                          if ( listNuLoadErr2[ISTEP2] == listNuLoadStart2[ISTEP2] ) {   listLoaded2[ISTEP2] = "full_errors" }
                     }
               } else if ( listNuLoadEnd2[ISTEP2] == CountTiles2[0] ) {
                                listLoaded2[ISTEP2] = "yes"; listNuWait2[ISTEP2] = 0;
                                message=" The end count balance the requirements " + listNuLoadEnd2[ISTEP2] + " " + CountTiles2[0] + " <<========== "; console.log(message);
               } else {
                  if ( listNuLoadEnd2[ISTEP2] > 0 ) {  listLoaded2[ISTEP2] = "still_loading" }
                  if ( listNuLoadEnd2[ISTEP2] == 0 && listLoaded2[ISTEP2] == "loading" ) {  listLoaded2[ISTEP2] = "still_loading" }
                  if ( listNuLoadStart2[ISTEP2] == 0) { 
                       listLoaded2[ISTEP2] = "still_loading";
                       message=" The start of loading counts were not resgistered  2 <<========== "; console.log(message);
                  }
               }
            }
            message=" --------- ListLoaded2 is now:  " + listLoaded2[ISTEP2] + " ------------"; console.log(message);
 
            if ( rafraichir ) {
                if (( listLoaded2[ISTEP2] == "still_loading" ) || ( listLoaded2[ISTEP2] == "loading" )) {
                 message=" --------- ListLoaded2 is forced to yes because the flag rafaichir si true ";console.log(message);
                 listLoaded2[ISTEP2] = "yes"; listNuWait2[ISTEP2] = 0;
                }  
                if ( listLoaded2[ISTEP2] != "yes" ) {
                    message = " <br> Chargement problématique couche 2. (Re) faire un pas avant ou arriere. <br> <br>";
                    openAfficheInfo(message, 10);
                }
            }
            if ( !Couche2CoVoid ) {
               if ( ( listLoadedCo2[ISTEP2] != "missing" ) && ( listLoadedCo2[ISTEP2] != "yes" ) ) {
                   if ( (listNuLoadStartCo2[ISTEP2] != 0) && ( listNuLoadStartCo2[ISTEP2] == ( listNuLoadEndCo2[ISTEP2] + listNuLoadErrCo2[ISTEP2] )) ) {
                         if ( listNuLoadEndCo2[ISTEP2] ==  listNuLoadStartCo2[ISTEP2] ) {  
                              listLoadedCo2[ISTEP2] = "yes"; listNuWaitCo2[ISTEP2] = 0; 
                         } else if ( listNuLoadErrCo2[ISTEP2] > 0 ) {
                              listLoadedCo2[ISTEP2] = "some_errors";
                              if ( listNuLoadErrCo2[ISTEP2] == listNuLoadStartCo2[ISTEP2] ) {   listLoadedCo2[ISTEP2] = "full_errors" }
                         }
                   } else if ( listNuLoadEndCo2[ISTEP2] == CountTiles2[1] ) {
                                listLoadedCo2[ISTEP2] = "yes"; listNuWaitCo2[ISTEP2] = 0;
                                message=" The end count balance the requirements " + listNuLoadEndCo2[ISTEP2] + " " + CountTiles2[1] + " <<========== "; console.log(message);
                   } else {
                      if ( listNuLoadEndCo2[ISTEP2] > 0 ) {  listLoadedCo2[ISTEP2] = "still_loading" }
                      if ( listNuLoadEndCo2[ISTEP2] == 0 && listLoadedCo2[ISTEP2] == "loading" ) {  listLoadedCo2[ISTEP2] = "still_loading" }
                      if ( listNuLoadStartCo2[ISTEP2] == 0) { 
                           listLoadedCo2[ISTEP2] = "still_loading";
                           message=" The start of loading counts were not resgistered Co2<<========== "; console.log(message);
                      }
                   }
               }
               message=" --------- ListLoadedCo2 is now:  " + listLoadedCo2[ISTEP2] + " ------------"; console.log(message);

               if ( rafraichir ) {
                    if (( listLoadedCo2[ISTEP2] == "still_loading" ) || ( listLoadedCo2[ISTEP2] == "loading" )) {
                      message=" --------- ListLoadedCo2 is forced to yes because the flag rafaichir si true ";console.log(message);
                     listLoadedCo2[ISTEP2] = "yes"; listNuWaitCo2[ISTEP2] = 0;
                    }  
                if ( listLoadedCo2[ISTEP2] != "yes" ) {
                    message = " <br> Chargement problématique Co couche 2. (Re) faire un pas avant ou arriere. <br> <br>";
                    openAfficheInfo(message, 10);
                }
               }
            }
    } 
    let go1_next = false;
    go1_next = (listLoaded1[ISTEP_next] == "yes" || listLoaded1[ISTEP_next] == "lazyLoading" || listLoaded1[ISTEP_next] == "some_errors" );
    let go1 = false;
    go1      = (listLoaded1[ISTEP]      == "yes" || listLoaded1[ISTEP]      == "lazyLoading" || listLoaded1[ISTEP]      == "some_errors" );

    let go1Co_next = false;
    let go1Co      = false;
    if ( !Couche1CoVoid ) {
       go1Co_next = (listLoadedCo1[ISTEP_next] == "yes" || listLoadedCo1[ISTEP_next] == "lazyLoading" || listLoadedCo1[ISTEP_next] == "some_errors" );
       go1Co      = (listLoadedCo1[ISTEP]      == "yes" || listLoadedCo1[ISTEP]      == "lazyLoading" || listLoadedCo1[ISTEP]      == "some_errors" );
    }
    let go2_next = false;
    let go2      = false;
    let go2Co_next = false;
    let go2Co      = false;

    if ( !Couche2Void ) {
        go2_next = (listLoaded2[ISTEP_next] == "yes" || listLoaded2[ISTEP_next] == "lazyLoading" || listLoaded2[ISTEP_next] == "some_errors" );
        go2      = (listLoaded2[ISTEP]      == "yes" || listLoaded2[ISTEP]      == "lazyLoading" || listLoaded2[ISTEP]      == "some_errors" );
        if ( !Couche2CoVoid ) {
            go2Co_next = (listLoadedCo2[ISTEP_next] == "yes" || listLoadedCo2[ISTEP_next] == "lazyLoading" || listLoadedCo2[ISTEP_next] == "some_errors" );
            go2Co      = (listLoadedCo2[ISTEP]      == "yes" || listLoadedCo2[ISTEP]      == "lazyLoading" || listLoadedCo2[ISTEP]      == "some_errors" );
        }
    }
    if ( !L_Interca ) {
        if ( !Couche2Void ) {
            allLoadedOk = (  go1_next && go2_next );
            if ( !Couche1CoVoid ) { allLoadedOk =  allLoadedOk && go1Co_next; }
            if ( !Couche2CoVoid ) { allLoadedOk =  allLoadedOk && go2Co_next; }
        } else {
            allLoadedOk =  go1_next;
            if ( !Couche1CoVoid ) { allLoadedOk =  allLoadedOk && go1Co_next; }
        }
    } else {
        if ( AfficheraLayer2 && Avance ) { 
             allLoadedOk = go2_next;
             if ( !Couche2CoVoid ) { allLoadedOk =  allLoadedOk && go2Co_next; }   
        } else if ( AfficheraLayer2 ) {
             allLoadedOk = go2;
             if ( !Couche2CoVoid ) { allLoadedOk =  allLoadedOk && go2Co; }    
        } else if ( AfficheraLayer1 && Avance ) { 
             allLoadedOk = go1
             if ( !Couche1CoVoid ) { allLoadedOk =  allLoadedOk && go1Co; }  
        } else if ( AfficheraLayer1 ) {
            allLoadedOk = go1_next;
            if ( !Couche1CoVoid ) { allLoadedOk =  allLoadedOk && go1Co_next; } 
        }
    }
    if ( allLoadedOk ) { 
        if ( changeStep ) {
            ISTEP = ISTEP + increment;
            if (ISTEP > ISTEP_max + ISTEP_repeatEndLoop  ) { 
                indexPrev = ISTEP_max % NoOfLayers; 
                ISTEP = 0; 
            } 
            if (ISTEP < 0 ) { ISTEP =  ISTEP_max; }

            ISTEP_next = ISTEP + increment;
            if (ISTEP_next > ISTEP_max ) { ISTEP_next = 0 } 
            if (ISTEP_next < 0 )         { ISTEP_next = ISTEP_max } 
        }
        istep_prev = ISTEP - increment; 
        if ( istep_prev < 0 ) { istep_prev =  ISTEP_max; }
        if ( istep_prev > ISTEP_max ) { istep_prev = ISTEP_max - 1;  }

        if ( ISTEP < ISTEP_max + 1 ) {

            index = ISTEP % NoOfLayers;
            index_next = ISTEP_next % NoOfLayers;

            if ( verbose_ ) {
                message=" will be displaying. Istep: " + ISTEP + ' nhour1 : ' + listProg1[ISTEP] + ' nhour2 : ' + listProg2[ISTEP] + "Index: " + index;
                message=" will be displaying. Istep: " + ISTEP + ' houroid1 : ' + listHourOId1[ISTEP] + ' houroid2 : ' + listHourOId2[ISTEP];
                console.log(message);
                message=" will be requesting load. Istep next: " + ISTEP_next + ' nhour1 next: ' + listProg1[ISTEP_next] + 
                              ' nhour2 next: ' + listProg2[ISTEP_next] + "Index next: " + index_next;
                console.log(message);
                message=" will be requesting load. Istep next: " + ISTEP_next + ' houroid1 : ' + listHourOId1[ISTEP_next] + 
                               ' houroid2 : ' + listHourOId2[ISTEP_next];
                console.log(message);
            }
            if ( !L_Interca )  {
                if ( DprogDt ) { resetMenuDprogSurDt(0, ISTEP) };
                if ( nowcast1 ) { resetMenuDprogSurDt(1, ISTEP) };
                if ( nowcast2 ) { resetMenuDprogSurDt(2, ISTEP) };

                ValidTime = getAfficheValidDateTime( listHourOId1[ISTEP], listProg1minu[ISTEP] );
                message= stringAffi1 +  listProg1[ISTEP] + "h valide " + ValidTime;

                if ( !Couche2Void ) {
                    validTime2= getAfficheValidDateTime( listHourOId2[ISTEP], listProg2minu[ISTEP] );
                    message2=stringAffi2 +  listProg2[ISTEP] + "h valide " + validTime2;
                } else {
                    message2=" ";
                }
                if ( L_Juxtapo )  { 
                    document.getElementById("affiche_temps_valide1").innerHTML= " 1- " + message;
                    document.getElementById("affiche_temps_valide2").innerHTML= " 2- " + message2;
                } else {
                    if ( (message != message2) && (message2 != " " ) ) { 
                        document.getElementById("affiche_temps_valide").innerHTML= " 1- " + message + "<br>" + " 2- " + message2;
                    } else {
                        document.getElementById("affiche_temps_valide").innerHTML= " 1- " + message;
                    }
                }
                if ( !Couche2Void ) {
                    tileLayers2[indexPrev].setOpacity(0.); 
                    tileLayers2[index].setOpacity( Opacitee2 ); 
                    if ( !Couche2CoVoid ) { 
                        tileLayersCo2[indexPrev].setOpacity(0.);  
                        tileLayersCo2[index].setOpacity( Opacitee2 ); 
                    }
                }
                tileLayers1[indexPrev].setOpacity(0.);
                tileLayers1[index].setOpacity( Opacitee1 ) ;
                if ( !Couche1CoVoid ) { 
                    tileLayersCo1[indexPrev].setOpacity(0.); 
                    tileLayersCo1[index].setOpacity( Opacitee1 ); 
                }

                AfficheraLayer1 = true;
                AfficheraLayer2 = true;
                updateLayers(ISTEP_next, 0);

            } else if ( AfficheraLayer1 ) {

                if ( DprogDt   ) { resetMenuDprogSurDt(1, ISTEP) };
                if ( nowcast1 ) { resetMenuDprogSurDt(1, ISTEP) };

                affichage_meta_informations(1);

                ValidTime = getAfficheValidDateTime( listHourOId1[ISTEP], listProg1minu[ISTEP] );
                document.getElementById("affiche_temps_valide").innerHTML= " 1- " + stringAffi1 +  listProg1[ISTEP] + "h valide " + ValidTime;

                tileLayers2[indexPrev].setOpacity(0.);
                tileLayers2[index].setOpacity( 0. );
                if ( !Couche2CoVoid ) { tileLayersCo2[indexPrev].setOpacity(0.); }
                if ( !Couche2CoVoid ) { tileLayersCo2[index].setOpacity(0.); }
                        
                tileLayers1[index].setOpacity( Opacitee1 ) ;
                if ( !Couche1CoVoid ) { tileLayersCo1[index].setOpacity( Opacitee1 ); }

                AfficheraLayer1 = false;
                AfficheraLayer2 = true;
                updateLayers(ISTEP_next, 1);

            } else {
                if ( DprogDt    ) { resetMenuDprogSurDt(2, ISTEP) };
                if ( nowcast2 ) { resetMenuDprogSurDt(2, ISTEP) };

                affichage_meta_informations(2);
                ValidTime = getAfficheValidDateTime( listHourOId2[ISTEP], listProg2minu[ISTEP] );
                document.getElementById("affiche_temps_valide").innerHTML= " 2- " + stringAffi2 +  listProg2[ISTEP] + "h valide " + ValidTime;

                tileLayers1[indexPrev].setOpacity(0.);
                tileLayers1[index].setOpacity( 0. );
                if ( !Couche1CoVoid ) { tileLayersCo1[indexPrev].setOpacity(0.); }
                if ( !Couche1CoVoid ) { tileLayersCo1[index].setOpacity(0.); }
                       
                tileLayers2[index].setOpacity( Opacitee2 ) ;
                if ( !Couche2CoVoid ) { tileLayersCo2[index].setOpacity( Opacitee2 ); }
                       
                AfficheraLayer1 = true;
                AfficheraLayer2 = false;
                updateLayers(ISTEP_next, 2);
            }
        }
        if ( CurrentDelay > Delay ) {

            if ( listNuWait1[ISTEP1] < 2 && listNuWaitCo1[ISTEP1] &&
             listNuWait2[ISTEP2] < 2 && listNuWaitCo2[ISTEP2]  ) {

                 message = " All right... gradually resetting pace of animation toward requested "  + Delay + " ms. Current is: " + CurrentDelay + " ms."; console.log(message);
                 CurrentDelay = Math.max( Delay, CurrentDelay/(2*FactLongerDelay));
                 SpeedReset(CurrentDelay);
                 //openAfficheInfo(message, 10);
            }
         }
    } else {
       StopAnimate();

       var goBack2TimeStep1 = false;
       var goBack2TimeStep2 = false;
       var tilesNotOk1 = false;
       var tilesNotOk2 = false;

       message=" *******************************************************"; console.log(message);
       message=" ----------- TIME STEP NOT NOT NOT NOT READY FOR STEP: " + ISTEP_next + " ------------"; console.log(message);
       message=" *******************************************************"; console.log(message);
       message=" ----------- ListLoaded1 :  " + listLoaded1[ISTEP_next] + " ------------"; console.log(message);
 
       if ( !Couche1CoVoid ) { message=" --------- ListLoadedCo1 is:  " + listLoadedCo1[ISTEP_next] + " ------------";console.log(message); }
       if ( !Couche2Void ) { 
             message=" ----------- ListLoaded2 is:  " + listLoaded2[ISTEP_next] + " ------------"; console.log(message);
             if ( !Couche2CoVoid ) {  message=" --------- ListLoadedCo2 is:  " + listLoadedCo2[ISTEP_next] + " ------------"; console.log(message); }
       }
       message=" *******************************************************"; console.log(message); 
       message=" *******************************************************"; console.log(message); 

       if ( AfficheraLayer1 ) {
                  tilesNotOk1 = TilesNotAllOk( ISTEP1, 1);
        }
        if ( AfficheraLayer2  && !Couche2Void ) {
                  tilesNotOk2 = TilesNotAllOk( ISTEP2, 2);
       } 
       if ( ActiveLoop ) { 
                    //CurrentDelay = Math.max( CurrentDelay*FactLongerDelay, Delay);
                    //CurrentDelay = Math.min( CurrentDelay, 20480);
                    //message = " setting slower animation pace at : " + CurrentDelay + " ms compared to requested: " + Delay + " ms.";
                    //console.log(message);
                    //SpeedReset(CurrentDelay);
                    StartAnimate();
       }
    }

    if ( listNuWait1[ISTEP1] > 100 || listNuWaitCo1[ISTEP1] > 100  > 100 ||
         listNuWait2[ISTEP2] > 100 || listNuWaitCo2[ISTEP2] > 100 ) {
                 message = " Warning...the  number of try is too high... need to stop animation"; console.log(message);
       listNuWait1[ISTEP] = 0;
       listNuWait1[ISTEP_next] = 0;
       listNuWait1[istep_prev] = 0; 
       listNuWait2[ISTEP] = 0;
       listNuWait2[ISTEP_next] = 0;
       listNuWait2[istep_prev] = 0; 
       listNuWaitCo1[ISTEP] = 0;
       listNuWaitCo1[ISTEP_next] = 0;
       listNuWaitCo1[istep_prev] = 0; 
       listNuWaitCo2[ISTEP] = 0;
       listNuWaitCo2[ISTEP_next] = 0;
       listNuWaitCo2[istep_prev] = 0; 
       DesactiveAndStopAnimate();
    }
}
// ________________________________________________________________________________
function TilesNotAllOk( istep, no ) {

          let message = "";
          let flag2Return_ = false;
          let flag_ = "";

          if ( no == 1 ) {
                if (  listLoaded1[istep]   == "missing" && listLoadedCo1[istep]   == "missing" ) { 
                       flag_ = "mainLayer_coLayer";
                } else if ( listLoaded1[istep]   == "missing" ) {
                        flag_ = "mainLayer";
                } else if ( listLoadedCo1[istep]   == "missing" ) {
                        flag_ = "coLayer";

                }
                if ( listLoaded1[istep] == "still_loading" || listLoaded1[istep] == "non" ) { 

                     listNuWait1[istep] = listNuWait1[istep] + 1
                     message=" Layer no: " + no + " is not ok  for after " + listNuWait1[istep] + " tries";
                     console.log(message);
                     if ( listNuWait1[istep] > (3000/CurrentDelay) ) {
                         listLoaded1[istep] = "non";
                         flag_ = "reload";
                     }
                } 
                if ( listLoadedCo1[istep] == "still_loading" || listLoadedCo1[istep] == "non" ) { 

                     listNuWaitCo1[istep] = listNuWaitCo1[istep] + 1
                     message=" CoLayer no: " + no + " is not ok after " + listNuWaitCo1[istep] + " tries";
                     console.log(message);
                        if ( listNuWaitCo1[istep] > (3000/CurrentDelay) ) {
                           listLoadedCo1[istep] = "non";
                           flag_ = "reload";
                        }
                 } 
                 if ( listLoaded1[istep] == "full_errors"  && listLoadedCo1[istep] == "full_errors" ) {
                        message=" Layer and colayer no: " + no + " have full errors ";
                        console.log(message);
                        flag_ = "mainLayer_coLayer"; 

                 } else if ( listLoadedCo1[istep] == "full_errors" ) {
                        message=" CoLayer no: " + no + "  has full errors ";
                        console.log(message);
                           if ( flag_ == "mainLayer" ) {
                              flag_ = "mainLayer_coLayer";
                           } else {
                              flag_ = "coLayer"; 
                           }
                 } else if ( listLoaded1[istep] == "full_errors" ) {
                        listNuWait1[istep] = listNuWait1[istep] + 1
                        message=" Layer no: " + no + " has full errors ";
                        console.log(message);
                           if ( flag_ == "coLayer" ) {
                              flag_ = "mainLayer_coLayer";
                           } else {
                              flag_ = "mainLayer"; 
                           }
                 }
           }
          if ( no == 2 ) {
                if (  listLoaded2[istep]   == "missing" && listLoadedCo2[istep]   == "missing" ) { 
                       flag_ = "mainLayer_coLayer";
                } else if ( listLoaded2[istep]   == "missing" ) {
                        flag_ = "mainLayer";
                } else if ( listLoadedCo2[istep]   == "missing" ) {
                        flag_ = "coLayer";

                }
                if ( listLoaded2[istep] == "still_loading" || listLoaded2[istep] == "non" ) {
                     listNuWait2[istep] = listNuWait2[istep] + 1
                     message=" Layer no: " + no + " is still loading after " + listNuWait2[istep] + " tries";
                     console.log(message);
                     if ( listNuWait2[istep] > (3000/CurrentDelay) ) {
                         listLoaded2[istep] = "non";
                            flag_ = "reload";
                     }
                 } 
                if ( listLoadedCo2[istep] == "still_loading" || listLoadedCo2[istep] == "non" ) { 
                     listNuWaitCo2[istep] = listNuWaitCo2[istep] + 1
                     message=" CoLayer no: " + no + " is still loading after " + listNuWaitCo2[istep] + " tries";
                     console.log(message);
                        if ( listNuWaitCo2[istep] > (3000/CurrentDelay) ) {
                            listLoadedCo2[istep] = "non";
                            flag_ = "reload";
                        }
                 } 
                 if ( listLoaded2[istep] == "full_errors"  && listLoadedCo2[istep] == "full_errors" ) {
                        message=" Layer and colayer no: " + no + " have full errors after " + listNuWait2[istep] + " tries";
                        console.log(message);
                           flag_ = "mainLayer_coLayer"; 

                 } else if ( listLoadedCo2[istep] == "full_errors" ) {
                        message=" CoLayer no: " + no + "  has full errors ";
                        console.log(message);
                           if ( flag_ == "mainLayer" ) {
                              flag_ = "mainLayer_coLayer";
                           } else {
                              flag_ = "coLayer"; 
                           }
                        
                 } else if ( listLoaded2[istep] == "full_errors" ) {
                        message=" Layer no: " + no + " has full errors ";
                        console.log(message);
                           if ( flag_ == "coLayer" ) {
                              flag_ = "mainLayer_coLayer";
                           } else {
                              flag_ = "mainLayer"; 
                           }
                 }
           }
           if ( flag_ == "mainLayer_coLayer" ) {
                    flag2Return_ = FixErrorLayer(no, istep, "mainLayer_coLayer");
           } else if ( flag_ == "mainLayer" ) {
                    flag2Return_ = FixErrorLayer(no, istep, "mainLayer");
           } else if ( flag_ == "coLayer" ) {
                    flag2Return_ = FixErrorLayer(no, istep, "coLayer");
           } else if ( flag_ == "reload" ) {
                    flag2Return_ = ReloadBecauseWaiting(no, istep);
           } else {
                flag2Return_ = false;
           } 
           
   return flag2Return_
}
// ________________________________________________________________________________
function ReloadBecauseWaiting(no, istep) {

    var message=" WARNING  Reloading " + istep + " for layer no: " + no + " <========================== "  ;
    console.log(message);

    message = " <br> " + message + " <br> <br>";
    //openAfficheInfo(message, 12);

    if ( no == 1 ) {
       message = " Url: " + listUrl1[istep];
       console.log(message);
       message = " Houroid: " + listHourOId1[istep] + " Prog: " + listProg1[istep] + " istep : " + istep;
       console.log(message);
       message = " Model, zoom, carte: " +  Couche1.getModele() + " " +  Couche1.getZoomId() + " " +  Couche1.getMapId()  
       console.log (message)

          updateSource(istep, 1);

    } else if ( no == 2 ) {
       message = " Url: " + listUrl2[istep];
       console.log(message);
       message = " Houroid: " + listHourOId2[istep] + " Prog: " + listProg2[istep] + " istep : " + istep;
       console.log(message);
       message = " Model, zoom, carte: " +  Couche2.getModele() + " " +  Couche2.getZoomId() + " " +  Couche2.getMapId()  
       console.log (message)

          updateSource(istep, 2);
    }
  return true;
}
// ________________________________________________________________________________
function FixErrorLayer(no, istep, layer_) {

    var message=" Missing tiles will be assigned.  Istep in ERROR" + istep + " layer: " + no + " <========================== "  ;
    console.log(message);

    if ( no == 1 ) {
          message = " Url: " + listUrl1[istep];
          console.log(message);
          message = " Houroid: " + listHourOId1[istep] + " Prog: " + listProg1[istep];
          console.log(message);
          if ( layer_ == "mainLayer" ) {
             message = layer_ + " Model, zoom, carte: " +  Couche1.getModele() + " " +  Couche1.getZoomId() + " " +  Couche1.getMapId()  
             console.log (message)
             listUrl1[istep] = "../missing";
             listLoaded1[istep] = "non";
          } else if ( layer_ == "coLayer" ) {
             message = layer_ + " Model, zoom, carte: " +  Couche1.getModele() + " " +  Couche1.getZoomId() + " " +  Couche1.getMapIdCo()  
             console.log (message)
             listUrlCo1[istep] = "../missing";
             listLoadedCo1[istep] = "non";
          } else if ( layer_ == "mainLayer_coLayer" ) {
             message = layer_ + " Model, zoom, carte: " +  Couche1.getModele() + " " +  Couche1.getZoomId() + " " +  Couche1.getMapId()  
             console.log (message)
             message = layer_ + " Model, zoom, carte: " +  Couche1.getModele() + " " +  Couche1.getZoomId() + " " +  Couche1.getMapIdCo()  
             console.log (message)
             listUrl1[istep] = "../missing";
             listLoaded1[istep] = "non";
             listUrlCo1[istep] = "../missing";
             listLoadedCo1[istep] = "non";
          }
          updateSource(istep, 1);

    } else  {
           message = " Url: " + listUrl2[istep];
           console.log(message);
           message = " Houroid: " + listHourOId2[istep] + " Prog: " + listProg2[istep];
           console.log(message);
          if ( layer_ == "mainLayer" ) {
             message = layer_ + " Model, zoom, carte: " +  Couche2.getModele() + " " +  Couche2.getZoomId() + " " +  Couche2.getMapId()  
             console.log (message)
             listUrl2[istep] = "../missing";
             listLoaded2[istep] = "non";
          } else if ( layer_ == "coLayer" ) {
             message = layer_ + " Model, zoom, carte: " +  Couche2.getModele() + " " +  Couche2.getZoomId() + " " +  Couche2.getMapIdCo()  
             console.log (message)
             listUrlCo2[istep] = "../missing";
             listLoadedCo2[istep] = "non";
          } else if ( layer_ == "mainLayer_coLayer" ) {
             message = layer_ + " Model, zoom, carte: " +  Couche2.getModele() + " " +  Couche2.getZoomId() + " " +  Couche2.getMapId()  
             console.log (message)
             message = layer_ + " Model, zoom, carte: " +  Couche2.getModele() + " " +  Couche2.getZoomId() + " " +  Couche2.getMapIdCo()  
             console.log (message)
             listUrl2[istep] = "../missing";
             listLoaded2[istep] = "non";
             listUrlCo2[istep] = "../missing";
             listLoadedCo2[istep] = "non";
          }
          updateSource(istep, 2);
    }
  return true;
}
// ________________________________________________________________________________
function CheckLazyLoading(no, istep) {
       
//map2
  var viewExtent_ = map.getView().calculateExtent(map.getSize());
  var viewProj_ = map.getView().getProjection();
//  if ( viewProj_ != 'EPSG:4326' ) { viewExtent_ = transformExtent(viewExtent_, viewProj_, 'EPSG:4326'); }

  var message="waiting. istep to be loaded: " +  istep + " layer no: " + no ;
  console.log(message);

  var retour = true;

  if ( no == 1 ) {

     var couche1Extent_ = ZoomToExtent.get( Couche1.zoomId );
     var couche1Proj_ = ZoomToProjec.get( Couche1.zoomId );

     if ( couche1Proj_ != viewProj_ ) { couche1Extent_ = transformExtent(couche1Extent_, couche1Proj_, viewProj_); }
     if ( IsCoucheExtentInExtent( viewExtent_, couche1Extent_) ) { 

               message=" Layer no: 1 is not considered for lazy Loading status";
               console.log(message);

          listNuWait1[istep] = listNuWait1[istep] + 1
          if ( listNuWait1[istep] > 10) {
               //listLoaded1[istep] = "non";
               listLoaded1[istep] = "error";
               listNuWait1[istep] = 0;
               message=" Layer no: 1   had more than 10 iteration in lazy loading check";
               console.log(message);
          } 
     } else {
          listLoaded1[istep] = "lazyLoading" ;
          listLoadedCo1[istep] = "lazyLoading" ;
          message=" Layer no: 1  has acquired lazyLoading status";
          console.log(message);
     }
  } else if ( no == 2 ) {

     var couche2Extent_ = ZoomToExtent.get( Couche2.zoomId );
     var couche2Proj_ = ZoomToProjec.get( Couche2.zoomId )

     if ( couche2Proj_ != viewProj_) { couche2Extent_ = transformExtent(couche2Extent_, couche2Proj_, viewProj_); }
     if ( IsCoucheExtentInExtent( viewExtent_, couche2Extent_) ) { 
               message=" Layer no: 2 is not considered for lazy Loading status";
               console.log(message);

          listNuWait2[istep] = listNuWait2[istep] + 1
          if ( listNuWait2[istep] > 10) {
         //listLoaded2[istep] = "non";
         listLoaded2[istep] = "error";
         listNuWait2[istep] = 0;
               message=" Layer no: 2   had more than 10 iteration in lazy loading check";
               console.log(message);
          } 
    } else {
         listLoaded2[istep] = "lazyLoading" ;
         listLoadedCo2[istep] = "lazyLoading" ;
          message=" Layer no:  2 has acquired lazyLoading status";
          console.log(message);
    } 
  }
  return retour;
}
// ________________________________________________________________________________
function GoToLastTimeStep() {
     
    DesactiveAndStopAnimate();

    var index = ISTEP % NoOfLayers;

    tileLayers1[index].setOpacity(0.);
    tileLayers2[index].setOpacity(0.);
    tileLayersCo1[index].setOpacity(0.);
    tileLayersCo2[index].setOpacity(0.);

    var message=" loading: " + ISTEP_max;
    console.log(message);

//     The last step is loaded above but still not visible. The step toward the last timestep is made via
//     the following call to TimeStep() in forward mode. This will make the last layer of the last timestep visible,  and trigger the load of the 
//     step 0.

    Avance = true;
    let increment = 1;
    AfficheraLayer2 = true;

    ISTEP = ISTEP_max - 1;
    ISTEP_next = ISTEP_max;

    updateSource(ISTEP_next, 2);
    updateSource(ISTEP_next, 1);

    if ( L_Interca ) {
       AfficheraLayer1 = false;
    } else {
       AfficheraLayer1 = true;
    }
    setTimeout(function() { TimeStep(increment, true); RefreshValeur(); }, 500);
}
// ________________________________________________________________________________
//
 $("#GoToLastTimeStep").click(function(){ GoToLastTimeStep(); });

// ________________________________________________________________________________
function GoToFirstTimeStep() {
    
//  if ( ISTEP != 0 ) {

     DesactiveAndStopAnimate();

    var index = ISTEP % NoOfLayers;

    tileLayers1[index].setOpacity(0.);
    tileLayers2[index].setOpacity(0.);
    tileLayersCo1[index].setOpacity(0.);
    tileLayersCo2[index].setOpacity(0.);

    var message=" loading:  step 0";
    console.log(message);

    Avance = true;
    let increment = 1;
    AfficheraLayer2 = true;

    ISTEP = ISTEP_max;
    ISTEP_next = 0;
    ISTEP_repeatEndLoop = 0;  // to ensure the call to TimeStep will be going from ISTEP = ISTEP_max   to ISTEP = 0

    updateSource(ISTEP_next, 1);
    updateSource(ISTEP_next, 2);

//     The 0 step is loaded above but still not visible. In the following, the step from the last timestep to the initial step is made via
//     the following call to TimeStep() from ISTEP = ISTEP_max  to 0. This will make timestep 0 visible,  and trigger the load of the next time step 

    if ( L_Interca ) {
       AfficheraLayer1 = false;
    } else { 
       AfficheraLayer1 = true;
    }
    setTimeout(function() { TimeStep(increment, true);RefreshValeur(); }, 500);
}
// ________________________________________________________________________________
function Reload() {

    DesactiveAndStopAnimate();
    ISTEP_repeatEndLoop = 0;

    var message=" requesting a Relaod for time step: " + ISTEP;
    console.log(message);

    var increment;

        if ( !L_Interca ) {

           ISTEP = Math.min(ISTEP, ISTEP_max);
           ISTEP_next = ISTEP;
           if ( Avance ) {
               ISTEP = ISTEP - 1;
               if ( ISTEP < 0 ) { ISTEP = ISTEP_max  }; 
               increment = 1;
            } else {
               ISTEP = ISTEP + 1;
               if ( ISTEP > ISTEP_max ) { ISTEP = 0 }; 
               increment = -1;
            }        
            resetSource(listUrlCo2[ISTEP_next], listUrl2[ISTEP_next], ISTEP_next, Couche2, 2 );
            resetSource(listUrlCo1[ISTEP_next], listUrl1[ISTEP_next], ISTEP_next, Couche1, 1 );

        } else {

           if (     AfficheraLayer2 && Avance ) {

               AfficheraLayer2 = false;
               AfficheraLayer1 = true;
               ISTEP = Math.min(ISTEP, ISTEP_max);

               resetSource(listUrlCo1[ISTEP], listUrl1[ISTEP], ISTEP, Couche1, 1 );
               resetSource(listUrlCo1[ISTEP_next], listUrl1[ISTEP_next], ISTEP_next, Couche1, 1 );
               increment = 1;

           } else if ( AfficheraLayer2           ) {

               AfficheraLayer2 = false;
               AfficheraLayer1 = true;
               ISTEP = Math.min(ISTEP, ISTEP_max);
               ISTEP_next = ISTEP;
               ISTEP = ISTEP + 1;
               if ( ISTEP > ISTEP_max ) { ISTEP = 0 };

               resetSource(listUrlCo1[ISTEP], listUrl1[ISTEP], ISTEP, Couche1, 1);
               resetSource(listUrlCo1[ISTEP_next], listUrl1[ISTEP_next], ISTEP_next, Couche1, 1 );
               increment = -1;

           } else if ( AfficheraLayer1 && Avance ) {

               AfficheraLayer1 = false;
               AfficheraLayer2 = true;
               ISTEP = Math.min(ISTEP, ISTEP_max);
               ISTEP_next = ISTEP;
               ISTEP = ISTEP - 1;
               if ( ISTEP < 0 ) { ISTEP = ISTEP_max  }; 

               resetSource(listUrlCo2[ISTEP], listUrl2[ISTEP], ISTEP, Couche2, 2 );
               resetSource(listUrlCo2[ISTEP_next], listUrl2[ISTEP_next], ISTEP_next, Couche2, 2 );
               increment = 1;

            } else if ( AfficheraLayer1 ) {

                AfficheraLayer1 = false;
                AfficheraLayer2 = true;
                ISTEP = Math.min(ISTEP, ISTEP_max);

                resetSource(listUrlCo2[ISTEP], listUrl2[ISTEP], ISTEP, Couche2, 2 );
                resetSource(listUrlCo2[ISTEP_next], listUrl2[ISTEP_next], ISTEP_next, Couche2, 2 );
                increment = -1;
             }
        }
        setTimeout(function() { TimeStep(increment, true); RefreshValeur(); }, 500);
}
// ________________________________________________________________________________
function Refresh() {

    DesactiveAndStopAnimate();
    ISTEP_repeatEndLoop = 0;

    var message=" requesting a refresh for time step: " + ISTEP;
    console.log(message);

    var increment;

        if ( !L_Interca ) {

           ISTEP = Math.min(ISTEP, ISTEP_max);
           ISTEP_next = ISTEP;
           if ( Avance ) {
               ISTEP = ISTEP - 1;
               if ( ISTEP < 0 ) { ISTEP = ISTEP_max  }; 
               increment = 1;
            } else {
               ISTEP = ISTEP + 1;
               if ( ISTEP > ISTEP_max ) { ISTEP = 0 }; 
               increment = -1;
            }        
            updateSource(ISTEP_next, 2)
            updateSource(ISTEP_next, 1)

    //tileLayers1[index].setOpacity(0.);
    //tileLayers2[index].setOpacity(0.);
    //tileLayersCo1[index].setOpacity(0.);
    //tileLayersCo2[index].setOpacity(0.);


        } else {

           if (     AfficheraLayer2 && Avance ) {

               ISTEP = Math.min(ISTEP, ISTEP_max);

               AfficheraLayer2 = false;
               AfficheraLayer1 = true;

               updateSource(ISTEP, 1)
               updateSource(ISTEP_next, 2);
               increment = 1;

           } else if ( AfficheraLayer2           ) {

               ISTEP = Math.min(ISTEP, ISTEP_max);
               ISTEP_next = ISTEP;
               ISTEP = ISTEP + 1;
               if ( ISTEP > ISTEP_max ) { ISTEP = 0 };

               AfficheraLayer2 = false;
               AfficheraLayer1 = true;

               updateSource(ISTEP_next, 1)
               updateSource(ISTEP_next, 2);
               increment = -1;

           } else if ( AfficheraLayer1 && Avance ) {

                ISTEP = Math.min(ISTEP, ISTEP_max);
                ISTEP_next = ISTEP;
                ISTEP = ISTEP - 1;
                if ( ISTEP < 0 ) { ISTEP = ISTEP_max  }; 

                AfficheraLayer1 = false;
                AfficheraLayer2 = true;

                updateSource(ISTEP_next, 2);
                updateSource(ISTEP_next, 1); 
                increment = 1;

            } else if ( AfficheraLayer1 ) {

               ISTEP = Math.min(ISTEP, ISTEP_max);

               AfficheraLayer1 = false;
               AfficheraLayer2 = true;

               updateSource(ISTEP_next, 1)
               updateSource(ISTEP_next, 2);
               increment = -1;
             }
        }
        setTimeout(function() { TimeStep(increment, true); RefreshValeur(); }, 300);
}
// ________________________________________________________________________________
//
 $("#GoToFirstTimeStep").click(function(){ GoToFirstTimeStep(); });
// ________________________________________________________________________________
function StepForward(increment) {

     DesactiveAndStopAnimate()

    ISTEP_repeatEndLoop = 0;
    
    if ( !Avance )  {

        Avance = true;
        if (ISTEP > ISTEP_max ) { ISTEP = ISTEP_max } 
        ISTEP_next = ISTEP + increment;
        if (ISTEP_next > ISTEP_max ) { ISTEP_next = 0 } 

        if (  L_Interca ) {
            if ( AfficheraLayer1 ) {  

                updateSource(ISTEP, 1)
                updateSource(ISTEP_next, 2)

            } else if ( AfficheraLayer2 ) {

                updateSource(ISTEP_next, 2)
                updateSource(ISTEP_next, 1)
            } 

        } else {
            AfficheraLayer1 = true;
            AfficheraLayer2 = true;

            updateSource(ISTEP_next, 2)
            updateSource(ISTEP_next, 1)

        }
        setTimeout( function() { TimeStep(increment, true);RefreshValeur(); }, 350); 
    } else { 
        setTimeout( function() { TimeStep(increment, true);RefreshValeur(); }, 250); 
    }
}
// ________________________________________________________________________________
//
 $("#StepForward").click(function(){ StepForward(1); });
// ________________________________________________________________________________
function StepBackward(increment) {

     DesactiveAndStopAnimate();
       
    ISTEP_repeatEndLoop = 0;

    if ( Avance )  {

        Avance = false;
        if (ISTEP > ISTEP_max ) { ISTEP = ISTEP_max } 
        ISTEP_next = ISTEP + increment;
        if (ISTEP_next < 0 ) { ISTEP_next = ISTEP_max } 

        if (  L_Interca ) {

            if ( AfficheraLayer1 ) {

                updateSource(ISTEP_next, 1)
                updateSource(ISTEP_next, 2)

            } else if ( AfficheraLayer2 ) {

                updateSource(ISTEP_next, 2)
                updateSource(ISTEP_next, 1)
            } 
        } else {
            AfficheraLayer1 = true;
            AfficheraLayer2 = true;
            
            updateSource(ISTEP_next, 2)
            updateSource(ISTEP_next, 1)
        }
        setTimeout(function() { TimeStep(increment, true); RefreshValeur(); }, 350);
    } else {   
        setTimeout(function() { TimeStep(increment, true); RefreshValeur(); }, 250);
    }
}
// ________________________________________________________________________________
//
  $("#StepBackward").click(function(){ StepBackward(-1); });
// ________________________________________________________________________________
// ________________________________________________________________________________
function StepPre() {

    ActiveLoop = false;
    StopAnimate();
    document.getElementById('StopAnimate').style.display = "none";
    document.getElementById('StartAnimate').style.display = "initial";
       
    ISTEP_repeatEndLoop = 0;

    if ( Avance )  {
        StepBackward(-1);
    } else {
        StepForward(1);
    }
}
// ________________________________________________________________________________
//
 $("#StepPre").click(function(){ StepPre(); });
// ________________________________________________________________________________
function Animate() {

    if ( ISTEP_increment != 0 ) {
        LoopRunning = true;
        ActiveLoop = true;
        ISTEP_repeatEndLoop = parseInt( Math.max( 5, Math.min( 10, InitDelay/Delay ) ) );  
        Avance = true;
        TimeStep(ISTEP_increment, false);
    }
}
// ________________________________________________________________________________
//
function DesactiveAndStopAnimate() {

  ActiveLoop = false;
  StopAnimate();
  ResetValeurs();
     document.getElementById('StopAnimate').style.display = "none";
     document.getElementById('StartAnimate').style.display = "initial";
}
// ________________________________________________________________________________
function StopAnimate() {

  LoopRunning = false;
  ISTEP_increment = 0; 
  LoadExtra = false;
}
// ________________________________________________________________________________
//
 $("#StopAnimate").click(function(){ DesactiveAndStopAnimate(); });
// ________________________________________________________________________________
function StartAnimate() {

  if ( !Avance ) {
      StepForward(1);
  }
  UnsetValeurs("0");
  ActiveLoop = true;
  LoopRunning = true;
  ISTEP_increment = 1;
  LoadExtra = false;
}
function ActivateAndStartAnimate() {

     StartAnimate();
     document.getElementById('StartAnimate').style.display = "none";
     document.getElementById('StopAnimate').style.display = "initial";
}
// ________________________________________________________________________________
//
 $("#StartAnimate").click(function(){ ActivateAndStartAnimate(); });
//
// ________________________________________________________________________________
//
function SpeedReset(delay_) {

       StopAnimate();
       clearInterval(RunAnim);
       RunAnim = setInterval(function() {Animate()}, delay_);       
}
// ________________________________________________________________________________
function Slower(delay_) {

   StopAnimate();
   clearInterval(RunAnim);
   var tentativeDelay = delay_*1.26;
   if (tentativeDelay > 20480) tentativeDelay = 20480;

   let message0 = " Requested animation Delay was " + Delay + " ms. It will be set to: " + tentativeDelay + " ms. ";
   console.log(message0);

   if ( CurrentDelay > tentativeDelay ) {
       console.log(" ---------------------------------------------------------------------------" );
       console.log(" ---------------------------------------------------------------------------" );
       let message1 = " However the effective Current Delay is set slower to " + CurrentDelay + " ms. ";
       let message2 = " Your desired pace will be effective if performance is allowing it. ";
       console.log(message1);
       console.log(message2);
       console.log(" ---------------------------------------------------------------------------" );
       console.log(" ---------------------------------------------------------------------------" );
       let message = "<br>" +  message0 + "<br>" + message1 + "<br>" + message2 + "<br> <br>";
       openAfficheInfo(message,10);
   } else {
       CurrentDelay = tentativeDelay;
   }
   Delay = tentativeDelay;

   RunAnim = setInterval(function() {Animate()}, CurrentDelay); 
   
   if (  ActiveLoop  ) {
                StartAnimate();
   }
}
// ________________________________________________________________________________
//
 $("#Slower").click(function(){ Slower(Delay); });
// ________________________________________________________________________________
function Faster(delay_) {

   StopAnimate();
   clearInterval(RunAnim);
   var tentativeDelay = delay_/2.;
   if ( tentativeDelay < 40) tentativeDelay = 40;

   if ( CurrentDelay > Delay ) {
       console.log(" ---------------------------------------------------------------------------" );
       console.log(" ---------------------------------------------------------------------------" );
       let message = " Requested animation pace will remain at " + Delay + " ms due to current performance slowliness. ";
       let message2= " Try a speed up later when the requested pace could be met. Effective Current pace is " + CurrentDelay + " ms. ";
           console.log(message);
       console.log(message2);
       console.log(" ---------------------------------------------------------------------------" );
       console.log(" ---------------------------------------------------------------------------" );
           message = "<br>" +  message + "<br>" + message2 + "<br> <br>";
       openAfficheInfo(message,10);

   } else {
           console.log(" Requested animation pace of " + Delay + " ms will be set to: " + tentativeDelay + " ms if performance allows. ");
            CurrentDelay = tentativeDelay;
           Delay = tentativeDelay;
   }

   RunAnim = setInterval(function() {Animate()}, CurrentDelay); 

   if (  ActiveLoop  ) {
                StartAnimate();
   }
}
// ________________________________________________________________________________
//
 $("#Faster").click(function(){ Faster(Delay); });
// ________________________________________________________________________________
//

//   INITIALISATION DE ANIMATION ----------------------------------------------------------

///old
ActiveLoadLayers = true;
        // Ici mettre le LoadLayers de toute les couches 

console.log(' ici premier appel a LoadLayers');
LoadLayers(ISTEP, 0);
LoadLayers(ISTEP_next, 0);
console.log(' ici après premier appel a LoadLayers');

setTimeout(function() { resetTimeMenus(); },  1000 ) ;

var InitDelay = 640;
var Delay = InitDelay;
var CurrentDelay = InitDelay;

//   FactLongerDelay was 200
var FactLongerDelay = 1.0;

StopAnimate();
let RunAnim= setInterval(function() {Animate()}, CurrentDelay);

//setTimeout(function() { StartAnimate(); }, 3000);
//
//
//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

///  const TEMPS_INACTIVITE = 144 * 5 * 60 * 1000; // 5 minutes
///  let timer;

  function fermerCompletement() {
    // Nettoyage des données locales
    sessionStorage.clear();

    // Tentative de fermeture d'onglet, sinon écran noir
    window.close();
    
    document.body.innerHTML = '<div style="color:#fff;text-align:center;padding-top:20%;"><h1>Interface fermée pour inactivité</h1></div>';
    document.body.style.backgroundColor = '#111';
  }

  function reinitialiserTimer() {
    clearTimeout(timer);
    timer = setTimeout(fermerCompletement, TEMPS_INACTIVITE);
  }

//   le timer d'inactivité est réinititalisé lors des actions suivnates de l'utilisateur

///  ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'].forEach(evt => {
///    window.addEventListener(evt, reinitialiserTimer, { passive: true });
///});

  ///reinitialiserTimer();

//  Ici on ajoute une action de l'utilisateur qui remet le timer à zéro

  ///document.addEventListener("visibilitychange", () => {
    ///if (document.hidden) {
      ///// L'onglet est masqué / minimisé
      ///console.log("L'utilisateur a quitté l'onglet");
    ///} else {
      ///// L'utilisateur revient sur l'onglet -> on réinitialise le timer
      ///reinitialiserTimer();
    ///}
  ///});

//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

//   INITIALISATION du système de mise à jour des date d'origines  ----------------------------
var BackgroundCheckH = setInterval(function() { BackgroundCheckIfHourOIdOk(false)}, 2000) ;
setTimeout(function() { reStartBackgroundCheckH();  }, 20000);
setTimeout(function() {if (Lgnd2Large) { showLgnd(2); }; if (Lgnd1Large) { showLgnd(1); }   }, 2000);

var StorageZoomId = "CurrZoom";
var StorageProjId = "CurrProj";
var StorageCenterIdX = "CurrCenterX";
var StorageCenterIdY = "CurrCenterY";

if ( WindMaps ) { 
     StorageZoomId = "CurrZoom_V";
     StorageProjId = "CurrProj_V";
     StorageCenterIdX = "CurrCenterX_V";
     StorageCenterIdY = "CurrCenterY_V";
} else if ( Nowcast ) {
     StorageZoomId = "CurrZoom_N";
     StorageProjId = "CurrProj_N";
     StorageCenterIdX = "CurrCenterX_N";
     StorageCenterIdY = "CurrCenterY_N";
}

SetVu(  Couche1.projection, ZoomToViewExtent.get( Couche1.zoomId ), true) ;

var CurrZoom = map.getView().getZoom();
var CurrCenter = map.getView().getCenter();
var CurrProj = map.getView().getProjection().getCode();
localStorage.setItem(StorageProjId, CurrProj);


map.on('movestart', function(e) {
      StopAnimate();
    });
map.on('moveend', function(e) {
          StopAnimate();
          var newZoom = map.getView().getZoom();
          if ( CurrZoom != newZoom) {
               console.log('zoom end, new zoom: ' + newZoom);
               CurrZoom = newZoom;
               localStorage.setItem(StorageZoomId, CurrZoom);
               let zoomLayer1=getZLayerCoLayer("1");
               console.log('zoom Layer 1:  ' + zoomLayer1[0] + ' coLayer 1: ' + zoomLayer1[1] );
               CountTiles1=CountTilesInView("1");
               document.getElementById("zoomLvl1").innerHTML = CountTiles1[0];
               document.getElementById("zoomLvlCo1").innerHTML = CountTiles1[1];
               let zoomLayer2=getZLayerCoLayer("2");
               console.log('zoom Layer 2:  ' + zoomLayer2[0] + ' coLayer 2: ' + zoomLayer2[1] );
               CountTiles2=CountTilesInView("2");
               document.getElementById("zoomLvl2").innerHTML = CountTiles2[0];
               document.getElementById("zoomLvlCo2").innerHTML = CountTiles2[1];
           }
           var newProj = map.getView().getProjection().getCode();
           console.log('newProj1 : et CurrProj ' + newProj + "  " + CurrProj );
          if ( CurrProj != newProj ) {
               console.log('Proj2 : ' + newProj );
               CurrProj = newProj;
               localStorage.setItem(StorageProjId, CurrProj);
           }
          var newCenter = map.getView().getCenter();
          if ( CurrCenter != newCenter) {
               console.log('new center: ' + newCenter);
               CurrCenter = newCenter;
               localStorage.setItem(StorageCenterIdX, CurrCenter[0]);
               localStorage.setItem(StorageCenterIdY, CurrCenter[1]);
           }
           if ( ActiveLoop  ) {
               setTimeout(function() { StartAnimate(); }, 500 ) ;
           } 
    });


//if ( Model2localVoid ) {
// ChoixDuo("void", "void", "void",  Couche1.modeleZoom, Couche1.mapIdH, Couche1.mapIdHCo,  "1");
//} 

//map.on('singleclick',  StepForward(1));
//map.on('dblclick', StepForward(1) );

// ________________________________________________________________________________

function CreerUrlImage( tronc, modele, zoomid, mapid, houroid, prog) {


    var string_= houroid.substring(0,10);
    return '../'+ tronc +'/'+ modele +'_'+ zoomid + '/' + string_ +'/TO_'+ mapid +'_'+ houroid +'_'+ prog;  

//} else {
//  return '../'+ tronc +'/'+ modele +'_'+ zoomid + '/TO_'+ mapid +'_'+ houroid +'_'+ prog;  
//}

}

// ________________________________________________________________________________

function CreerUrlImageLeg( tronc, modele, zoomid, mapid, houroid) {

//console.log('../'+ tronc +'/'+ modele +'_'+ zoomid +'/L_'+ mapid +'_'+ houroid + '.png');

    var string_= houroid.substring(0,10);
    return '../'+ tronc +'/'+ modele +'_'+ zoomid + '/' + string_ + '/L_'+ mapid +'_'+ houroid + '.png';  

   //  } else {
   //      return '../'+ tronc +'/'+ modele +'_'+ zoomid + '/L_'+ mapid +'_'+ houroid + '.png';  
   //  }
}

// ________________________________________________________________________________

function CreerUrlImageLatest( tronc, modele, zoomid) {

//console.log('../'+ tronc +'/'+ modele +'_'+ zoomid +'/latest');

return '../'+ tronc +'/'+ modele +'_'+ zoomid +'/latest.txt';  
}

// ________________________________________________________________________________

// ________________________________________________________________________________
function checkIfImageExists() {

   var message = " ";
 
  if ( ActiveImgExist ) {
  if (Img.complete ) {
    message=" Complete: " + UrlImgExist ;
    if ( VerboseImgExist) { console.log(message); }

    if ( ImgExist ) { 
      message=" Image exist " ;
      if ( VerboseImgExist) { console.log(message); } 
    } else {
      message=" Image does not exist " ;
      if ( VerboseImgExist) { console.log(message); } 
    }

    if ( CountImgExist < MaxCountImgExist ) { 

    CountImgExist = CountImgExist + 1;
        
    if ( ICoucheImgExist == 1 ) {
    UrlImgExist = CreerUrlImage( Tronc , Couche1.getModele(), Couche1.getZoomId(), Couche1.getMapId(),
                                     listHourOId1[CountImgExist], listProg1[CountImgExist] );
        } else {
    UrlImgExist = CreerUrlImage( Tronc , Couche2.getModele(), Couche2.getZoomId(), Couche2.getMapId(),
                                     listHourOId2[CountImgExist], listProg2[CountImgExist] );
    }
    message=" Checking for Image: " + UrlImgExist; 
        if ( VerboseImgExist) { console.log(message); }
 
    ImgExist = false; 
    Img.src = UrlImgExist;

    } else {
      clearInterval(CheckIfImageExistsUntilLoaded);
    } 
  }
  }
}
// ________________________________________________________________________________
//
function TriggerCheckIfImageExists( countImgExist, maxCountImgExist, iCoucheImgExist) {

    var message = " ";

    Img.onload = () => {
     ImgExist= true;
     message=" Img onload detected Image exist";
     if ( VerboseImgExist) { console.log(message);  }
        message=" Loaded ok: " + UrlImgExist ;
        if ( VerboseImgExist) { console.log(message); }
     };
    Img.onerror = () => {
     ImgExist = false;
     message=" Img onerror detected Image does not exist";
     if ( VerboseImgExist) { console.log(message);  }
    };

    ActiveImgExist = false;
    CountImgExist = countImgExist;
    MaxCountImgExist = maxCountImgExist;
    ICoucheImgExist = iCoucheImgExist;

        if ( ICoucheImgExist == 1 ) {
        UrlImgExist = CreerUrlImage( Tronc , Couche1.getModele(), Couche1.getZoomId(), Couche1.getMapId(),
                                     listHourOId1[CountImgExist], listProg1[CountImgExist] );
        } else {
        UrlImgExist = CreerUrlImage( Tronc , Couche2.getModele(), Couche2.getZoomId(), Couche2.getMapId(),
                                     listHourOId2[CountImgExist], listProg2[CountImgExist] );
        }
    message=" Checking for Image: " + UrlImgExist; 
    if ( VerboseImgExist) { console.log(message); }

     StopAnimate();
    ActiveLoop = false;
    document.getElementById('StopAnimate').style.display = "none";
         document.getElementById('StartAnimate').style.display = "initial";

    

    ImgExist = false;
        Img.src = UrlImgExist;
    ActiveImgExist = true;
    CheckIfImageExistsUntilLoaded = setInterval(function() { checkIfImageExists()}, 500);
}
//------------------------------------------------------------------
var ImgExist = false;
var UrlImgExist = " ";
var ActiveImgExist = false;
var ICoucheImgExist = 0;
var CountImgExist = 0;
var MaxCountImgExist = 0;
var VerboseImgExist = true;
const Img = new Image();

// ________________________________________________________________________________
function updateLayers(istep2Load, icouche) {

   var message = " ";

    if ( icouche == 0  || icouche == 1 ) {
      updateSource(istep2Load, 1);
     }
    if ( icouche == 0  || icouche == 2 ) {
      updateSource(istep2Load, 2);
    }
}
// ________________________________________________________________________________
// ________________________________________________________________________________
function LoadLayers(istep2Load, icouche) {

   var trouve1 = false;
   var trouve2 = false;
    
    if ( icouche == 0  || icouche == 1 ) {
    trouve1 = resetSource(listUrlCo1[istep2Load], listUrl1[istep2Load], istep2Load, Couche1, 1); 
     }
    if ( icouche == 0  || icouche == 2 ) {
    trouve2 = resetSource(listUrlCo2[istep2Load], listUrl2[istep2Load], istep2Load, Couche2, 2);
    }
}
// ________________________________________________________________________________
//
//

function reStartBackgroundCheckH() {

 clearInterval(BackgroundCheckH)
 BackgroundCheckH = setInterval(function() { BackgroundCheckIfHourOIdOk(false)}, 10000) ;

}
// ________________________________________________________________________________
//

function BackgroundCheckIfHourOIdOk( affiche ) {

    var message = " ";
    var modele = "";
    var metAJour = false;

    indexListHourOIdOk = indexListHourOIdOk + 1;
    if ( indexListHourOIdOk > (ListModeleId.length - 1) ) { indexListHourOIdOk = 0 }
    modele = ListModeleId[ indexListHourOIdOk ];

     let currentLatestH = ModAHourOId.get( modele );

     if ( currentLatestH != GuessHourOId( modele, 0 ) ) {

           readSetLatestHourOId(currentLatestH, modele, affiche, metAJour);
           
//           setTimeout(function() { CheckIfHourOIdOk(currentLatestH, modele, affiche); }, 500 ) ;

      } else {
          message = " According to guess, Houroid of model: " + modele + " is the latest available: " + currentLatestH;
          if ( VerboseHourOIdOk) { console.log(message); }
      }
}
// ________________________________________________________________________________

function readSetLatestHourOId( currentLatestH, modele, affiche, metAJour ) {

    let fichier = CreerUrlImageLatest( Tronc, ModToId.get(modele), ModToZoom.get(modele));
    let latestDate ="";

    if ( modele != "void" ) {

      function fetchFileContent(path, callback) { 
        var httpRequest = new XMLHttpRequest();
        httpRequest.onreadystatechange = function() {
            if (httpRequest.readyState === 4) {
               if (httpRequest.status === 200) {
                 // Ne pas utiliser JSON.parse() ici !
                 var data = httpRequest.responseText; 
                 if (callback) callback(data);
               } else {
                 console.error("Erreur HTTP lors de la récupération du fichier:", httpRequest.status, httpRequest.statusText);
                 // Gérer l'erreur, peut-être appeler le callback avec null ou une erreur
                 if (callback) callback(null, new Error(`HTTP error: ${httpRequest.status}`));
               }
            }
        };
        let numb_=Math.random();
        let spath= path + "?v=" + numb_.toString();
        console.log(" Modele: " + modele + " URL latest: " + spath); 
        httpRequest.open('GET', spath);
        httpRequest.send();
      }

      // this requests the file and executes a callback with the parsed result once
      //    it is available
      fetchFileContent( fichier, function(data, error){ 
          if (error) {
              console.error("Échec de la lecture du fichier :", error);
              return; 
          }
          console.log(" Contenu du fichier reçu pour le modèle " + modele + ": " + data);
          let latestDate = " "; 
          if ( data.length <= 11 ) { 
                latestDate = data.substring(0,10);
          } else if ( data.length == 13 ) {
                latestDate = data.substring(0,12);
          } else { 
                console.log(" fichier latest corrompu avec datestamp: " + data);
          }
          ModAHourOId.set( modele, latestDate );
          CheckIfHourOIdOk(currentLatestH, modele, affiche, metAJour);
      });
    }
}

// ________________________________________________________________________________
        
// ________________________________________________________________________________
//

function CheckIfHourOIdOk(currentLatestH, modele, affiche, metAJour) {

           let prevLatestH = currentLatestH;
           var message = " ";

           let nowcast=isNowcast(modele);
           currentLatestH = ModAHourOId.get( modele );

           if ( prevLatestH != currentLatestH ) {
               
              if ( nowcast || metAJour) {
                 message=" Nouvelle date: " + currentLatestH + " disponible pour: " + modele ;
                 affiche = false;
                 if (( Couche1.modeleZoom == modele ) && (Couche2.modeleZoom == modele ) ) { 
                    refreshHouroid(0); 
                    affiche= true; 
                    message = message + " <br> mise a jour des couches 1 et 2, en cour ...  "; 
                 } else if ( Couche1.modeleZoom == modele ) {
                    refreshHouroid(1); 
                    affiche= true; 
                    message = message + " <br> mise a jour de la couche 1, en cour... "; 
                 } else if ( Couche2.modeleZoom == modele ) { 
                    refreshHouroid(2);
                    affiche= true; 
                    message = message + " <br> mise a jour de la couche 2, en cour ...";
                 }
                 if ( VerboseHourOIdOk) { console.log(message); }
              } else {
                    message=" Nouvelle date: " + currentLatestH + " disponible pour: " + modele ;
                    if ( VerboseHourOIdOk) { console.log(message); } 
              }
              //if ( affiche ) { openAfficheInfo(message,6); }
           } else {
                    message = " After checking Houroid of model: " + modele + " is the latest available: " + currentLatestH;
                    if ( VerboseHourOIdOk) { console.log(message); }
           }
}
// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//   Selector  for afficheInfo

const AfficheInfo = document.getElementById("afficheInfo");
const AfficheInfoTxt = document.getElementById("afficheInfoTxt");

// ________________________________________________________________________________

function openAfficheInfo(message, nbSecondes) {
      
      console.log( " openAfficheInfo: " + message + AfficheInfo.innerHTML );
          AfficheInfoTxt.innerHTML = AfficheInfoTxt.innerHTML + message;
          AfficheInfo.style.display = "block";
    setTimeout(function() { closeAfficheInfo(); },  nbSecondes*1000 ) ;
}

// -----------------------------------------------------------------------------------
//
// $("#openAfficheInfo").click(function(){ openAfficheInfo(); });

function closeAfficheInfo() {

          AfficheInfo.style.display = "none";
      AfficheInfoTxt.innerHTML= " Information: <br>";
}
// -----------------------------------------------------------------------------------
//

 $("#closebtnAfficheInfo").click(function(){ closeAfficheInfo(); });

// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//   Selector  for afficheInit

const AfficheInit = document.getElementById("afficheInit");
const AfficheInitTxt = document.getElementById("afficheInitTxt");

// ________________________________________________________________________________

function openAfficheInit(message, nbSecondes) {
      
      console.log( " openAfficheInit: " + message + AfficheInit.innerHTML );
          AfficheInitTxt.innerHTML = AfficheInitTxt.innerHTML + message;
          AfficheInit.style.display = "block";
    setTimeout(function() { closeAfficheInit(); },  nbSecondes*1000 ) ;
}

// -----------------------------------------------------------------------------------
//

function closeAfficheInit() {

      AfficheInitTxt.innerHTML= " Informations initiales: <br>";
      AfficheInit.style.display = "none";
}
// -----------------------------------------------------------------------------------
//

 $("#closebtnAfficheInit").click(function(){ closeAfficheInit(); });

let VersionCourant = parseInt( parseFloat(Version)*10 );
let VersionHistori = parseInt( parseFloat(INFO_version)*10 );

console.log(" Version x10: ", VersionCourant, " Version antérieur x10:", VersionHistori);

if ( ( VersionCourant !== VersionHistori  ) && ( !WindMaps ) ) {

  var message = " Nouveau: " + Version + " Bienvenue !" + "<br>";
      message = message + "<br>";
      message = message + " Version 3.2 <br>" ;
      message = message + "   avec ajout de diagnostiques sur l'état de la mer DIAGW (Saint-Laurent) <br> ";
      message = message + "   ajout de produit de prévision de vague (régional déterministe),  <br>";
      message = message + "   ajout d'accélérateurs DuoC avec le nouveau mode ....<b>imeteomaps?flots</b> <br> ";
      message = message + "   accès aux produits WCPS (NEMO) 4 fois par jour,  <br>";
      message = message + "   léger agrandissement vers l'Est de la grille SUDQC pour inclure le Golfe, (Saint-Laurent), <br>";
      message = message + "   ajout de cumul de deux périodes de 5 jours de précipitation total (modèles globaux), <br>";
      message = message + "   ajustement de seuils de pallette de couleurs pour les cumules de pluies de 12h et 24h, <br>";
      message = message + "   ajustement aux accélérateurs (DuoA, DuoB, etc) afin de mieux gérer la juxtaposition, <br>";
      message = message + "   réduction significative du nombre de fenêtres popup informatives. <br>";
      message = message + "<br>";
      message = message + "  Documentation de l'interface: <a href='../image_res/documentation_imeteomaps_latest.htm' target='_blank'> documentation</a> <br> ";

      message = message + "<b> Sélectionnez ici la Documentation spécifique de DIAGW (extraits, ou fichier complet): </b><br><br>";
          // Boutons de choix
      message = message + "<button onclick='changerDocument(\"../image_res/../image_res/vague_vent_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>complet</button>";
      message = message + "<button onclick='changerDocument(\"../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>extraits</button>";
         // Cadre iFrame unique (chargé par défaut avec le deuxieme document)
      message = message + "<iframe id='cadreDoc' src='../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH' width='100%' height='550px' style='border: 1px solid #ccc; border-radius: 4px;'></iframe>";

     console.log(" Version: ", Version, " Version antérieur :", INFO_version);
     openAfficheInit(message, 300);
     closeAfficheInfo();
     INFO_version = Version;
     localStorage.setItem("INFO_version", INFO_version);
     console.log(" Version: ", Version, " Version mise à jour :", INFO_version);

} else if ( VersionCourant !== VersionHistori ) {
// WindMaps  est vrai ici

      message = message + " Version 3.2 <br>" ;
      message = message + "   avec ajout de diagnostiques sur l'état de la mer DIAGW (Saint-Laurent) <br> ";
      message = message + "   ajout de produit de prévision de vague (régional déterministe), <br> ";
      message = message + "   ajout d'accélérateurs DuoC avec le nouveau mode ....<b>imeteomaps?flots</b> <br> ";
      message = message + "   accès aux produits WCPS (NEMO) 4 fois par jour, <br> ";
      message = message + "   léger agrandissement vers l'Est de la grille SUDQC pour inclure le Golfe (Saint-Laurent). <br>";
      message = message + "<br>";
      message = message + "  Documentation de l'interface: <a href='../image_res/documentation_imeteomaps_latest.htm' target='_blank'> documentation</a> <br> ";
      message = message + "<b>Documentation détaillée de DIAGW:</b> <a href='../image_res/vague_vent_v3.2b.pdf' target='_blank' style='font-size: 0.9em;'>(Ouvrir plein écran)</a><br>";
      message = message + "<iframe src='../image_res/vague_vent_v3.2b.pdf#view=FitH' width='100%' height='500px' style='border: 1px solid #ccc; margin-top: 5px;'></iframe>";

     console.log(" Version: ", Version, " Version antérieur :", INFO_version);
     openAfficheInit(message, 300);
     INFO_version = Version;
     localStorage.setItem("INFO_version", INFO_version);
     console.log(" Version: ", Version, " Version mise à jour :", INFO_version);
     closeAfficheInfo();
     
} else {
     closeAfficheInfo();
     closeAfficheInit();
     console.log(" Version: ", Version, " Version antérieur :", INFO_version);
}

//------------------------------------------------------------------
//
function messageECMWF(mapIdH) {

   if ( ( Warning_ECMWF_TYPES != "DONE"  ) &&
        ( ( mapIdH.indexOf("WEARN") != -1) || ( mapIdH.indexOf("WEASN") != -1) ||
          ( mapIdH.indexOf("WEAFR") != -1) || ( mapIdH.indexOf("WEAPE") != -1) || ( mapIdH.indexOf("COMPO") != -1) )
                                                                                                                      )   {
                      let message=" <br> Ce message sera affiché une seule fois par session.";
                      message= message + "<br> <br> Les types de précipitation ne sont pas offert directement par le service de données ouvertes de ECMWFA(IFS et AIFS)";
                      message= message + "<br> mais sont diagnostiquées ici en utilisant les données ECMWF disponibles (voir documentation section G) ";
                      message= message + " <br> <br> This message will be displayed once per sesssion.";
                      message= message + "<br> Precipition types are not provided directly by ECMWF OpenData grib service (IFS and AIFS)";
                      message= message + "<br> but are diagnosed using other available ECMWF fields (see documentation section G) ";

                      openAfficheInfo(message, 20);
                      Warning_ECMWF_TYPES = "DONE";
                      localStorage.setItem("Warning_ECMWF_TYPES", Warning_ECMWF_TYPES);
   }
}

//------------------------------------------------------------------
//
var Image1_est_visible = true;
var Image2_est_visible = true;


// ________________________________________________________________________________
//
function affichage_meta_informations(chiffre) {

        var entier = chiffre % 2 ;
        var couleur_actif="yellow";

       if (chiffre < 0 ){

        Image1_est_visible = true;
        Image2_est_visible = true;

        document.getElementById("modelezoom1").style.color = "blue";
        document.getElementById("modelezoom1").style.backgroundColor = couleur_actif;
        document.getElementById("mapidh1").style.color = "blue";
        document.getElementById("mapidh1").style.backgroundColor = couleur_actif;
        document.getElementById("houroid1").style.color = "blue";
        document.getElementById("houroid1").style.backgroundColor = couleur_actif;
        document.getElementById("valeur1").style.color = "blue";
        document.getElementById("valeur1").style.backgroundColor = couleur_actif;
        document.getElementById("opacite1").style.color = "blue";
        document.getElementById("opacite1").style.backgroundColor = couleur_actif;

        document.getElementById("modelezoom2").style.color = "blue";
        document.getElementById("modelezoom2").style.backgroundColor = couleur_actif;
        document.getElementById("mapidh2").style.color = "blue";
        document.getElementById("mapidh2").style.backgroundColor = couleur_actif;
        document.getElementById("houroid2").style.color = "blue";
        document.getElementById("houroid2").style.backgroundColor = couleur_actif;
        document.getElementById("valeur2").style.color = "blue";
        document.getElementById("valeur2").style.backgroundColor = couleur_actif;
        document.getElementById("opacite2").style.color = "blue";
        document.getElementById("opacite2").style.backgroundColor = couleur_actif;

       } else if ( entier == 1 ) {
        Image1_est_visible = true;
        Image2_est_visible = false;
        document.getElementById("modelezoom1").style.color = "blue";
        document.getElementById("modelezoom1").style.backgroundColor = couleur_actif;
        document.getElementById("modelezoom2").style.color = "black";
        document.getElementById("modelezoom2").style.backgroundColor = "white";
        document.getElementById("mapidh1").style.color = "blue";
        document.getElementById("mapidh1").style.backgroundColor = couleur_actif;
        document.getElementById("mapidh2").style.color = "black";
        document.getElementById("mapidh2").style.backgroundColor = "white";
        document.getElementById("houroid1").style.color = "blue";
        document.getElementById("houroid1").style.backgroundColor = couleur_actif;
        document.getElementById("houroid2").style.color = "black";
        document.getElementById("houroid2").style.backgroundColor = "white";
        document.getElementById("valeur1").style.color = "blue";
        document.getElementById("valeur1").style.backgroundColor = couleur_actif;
        document.getElementById("valeur2").style.color = "black";
        document.getElementById("valeur2").style.backgroundColor = "white";
        document.getElementById("opacite1").style.color = "blue";
        document.getElementById("opacite1").style.backgroundColor = couleur_actif;
        document.getElementById("opacite2").style.color = "black";
        document.getElementById("opacite2").style.backgroundColor = "white";
        
       }  else {
        Image1_est_visible = false;
        Image2_est_visible = true;
        document.getElementById("modelezoom1").style.color = "black";
        document.getElementById("modelezoom1").style.backgroundColor = "white";
        document.getElementById("modelezoom2").style.color = "blue";
        document.getElementById("modelezoom2").style.backgroundColor = couleur_actif;
        document.getElementById("mapidh1").style.color = "black";
        document.getElementById("mapidh1").style.backgroundColor = "white";
        document.getElementById("mapidh2").style.color = "blue";
        document.getElementById("mapidh2").style.backgroundColor = couleur_actif;
        document.getElementById("houroid1").style.color = "black";
        document.getElementById("houroid1").style.backgroundColor = "white";
        document.getElementById("houroid2").style.color = "blue";
        document.getElementById("houroid2").style.backgroundColor = couleur_actif;
        document.getElementById("valeur1").style.color = "black";
        document.getElementById("valeur1").style.backgroundColor = "white";
        document.getElementById("valeur2").style.color = "blue";
        document.getElementById("valeur2").style.backgroundColor = couleur_actif;
        document.getElementById("opacite1").style.color = "black";
        document.getElementById("opacite1").style.backgroundColor = "white";
        document.getElementById("opacite2").style.color = "blue";
        document.getElementById("opacite2").style.backgroundColor = couleur_actif;
       }   
}


//
////__________________________________________________________________________________________________________________
//
//
window.changerDocument = function(cheminFichier) {
    var iframe = document.getElementById('cadreDoc');
    if (iframe) {
        iframe.src = cheminFichier;
    }
};

function affiche_aide(aideCode) {

var Aide_text = " Affichage de l'aide ici,   il suffit de cliquer <b> au dessus </b> d'un bouton ou d'un menu sur le symbole <b> ? </b>.<br><br>"
Aide_text = Aide_text + " Pour désactiver ce mode,  il suffit de recliquer sur l'interrupteur d'aide. <br>";

        if ( aideCode == "BurgerNav" ) {
        
          Aide_text = " Activation d'un menu de naviguation sur le côté gauche. <br><br>"; 
          
        } else if ( aideCode == "Label1" ) {
          Aide_text = " Étiquette pour identifier la ligne horizontale de menus pour la sélection de la <b> couche</b> <strong>1</strong>. <br><br>";
          
        } else if ( aideCode == "Label2" ) {
          Aide_text = " Étiquette pour identifier la ligne horizontale de menus pour la sélection de la <b> couche</b> <strong>2</strong>. <br><br>";
        
        } else if ( ( aideCode == "Couche1Model" || aideCode == "Couche2Model" ) && (!WindMaps) ) {
          Aide_text = " Menu Syst prév <br><br>";
          if ( aideCode == "Couche1Model" ) {
            Aide_text = Aide_text + "  Ce menu permet la sélection du système de prévision et du zoom pour la <b> couche</b> <strong>1</strong>. <br><br>";
                Aide_text = Aide_text + " Voici ce qui est offert: <br>";
          } else {
            Aide_text = Aide_text + "  Ce menu permet la sélection du système de prévision et du zoom pour la <b> couche</b> <strong>2</strong>. <br><br>";
                Aide_text = Aide_text + " Voici ce qui est offert: <br>";
            Aide_text = Aide_text + " <b> Void  - </b> Couche 2 désactivées.  <br>";
            Aide_text = Aide_text + " <b> ____ - </b> cette sélection de void effacera la couche 2. <br>";
          }
          Aide_text = Aide_text + " <b> RDPS - </b> système regional du CMC, un seul zoom continental. <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_rdps/readme_rdps_fr' target='_blank'> RDPS référence </a> <br> ";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 10km, offerte 10km; Cartes aux 3h jusqu'a 84h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 6 heures  <br>";
          Aide_text = Aide_text + " <b> HRDPS E - </b> système à haute résolution du CMC: zoom Est canadien. <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 2,5km, offerte 2,5km; Cartes aux 1h jusqu'a 48h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 6 heures  <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_hrdps/readme_hrdps_fr' target='_blank'> HRDPS référence </a> <br>";
          Aide_text = Aide_text + " <b> HRDPS SUDQC - </b> système à haute résolution du CMC: zoom sud du Quebec <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 2,5km, offerte 1km; Cartes aux 1h jusqu'a 48h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 6 heures  <br>";
          Aide_text = Aide_text + " <b> GDPS - </b> systeme global du CMC, un seul zoom sur Amerique du Nord. <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_gdps/readme_gdps_fr' target='_blank'> GDPS: référence </a> <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 15km, offerte 15km; Cartes aux 6h jusqu'a 240h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
          Aide_text = Aide_text + " <b> GFS - </b> systeme global de NCEP un seul zoom sur Amerique du Nord. <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 25km, offerte 20km; Cartes aux 6h jusqu'a 240h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
          Aide_text = Aide_text + " <b> AIFS - </b> systeme global AI de ECMWF un seul zoom sur Amerique du Nord. <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 28km, offerte 20km; Cartes aux 6h jusqu'a 240h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
          Aide_text = Aide_text + " <b> ECMWF - </b> systeme global de ECMWF un seul zoom sur Amerique du Nord. <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 28km, offerte 20km; Cartes aux 6h jusqu'a 240h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
          Aide_text = Aide_text + " <b> ECMWF3 - </b> systeme global de ECMWF un seul zoom sur Amerique du Nord. <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 28km, offerte 20km; Cartes aux <b> 3 </b> h jusqu'a <b> 90 </b>h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
          Aide_text = Aide_text + " <b> NEMO - </b> composante océanique du système de Prévision du cycle de l'eau. <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 1km, offerte 1km; Cartes aux heures jusqu'a 60h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 12 heures  <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_ciops/readme_ciops_fr' target='_blank'> CIOPS référence </a> <br>";
          Aide_text = Aide_text + " <b> RDWPS - </b> système de prévision déterministe de vague, basé sur WaveWatch III.  <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_rdwps/readme_rdwps_fr' target='_blank'> RDWPS référence </a> <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 2,5km, offerte 1km; Cartes aux heures jusqu'a 48h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 6 heures  <br>";
          Aide_text = Aide_text + " <b> DIAGW - </b> Diagnostiques état de la mer de imeteo basés sur RDWPS (Vagues) et NEMO inclu dans WCPS (courants).  <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_rdwps/readme_rdwps_fr' target='_blank'> RDWPS référence </a> <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_wcps/readme_wcps_fr' target='_blank'> WCPS référence </a> <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 2,5km, offerte 1km; Cartes aux heures jusqu'a 48h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 6 heures  <br>";
          Aide_text += "<br>";
          Aide_text = Aide_text + "<b> Sélectionnez ici la Documentation spécifique de DIAGW : </b><br><br>";
          // Boutons de choix
          Aide_text = Aide_text + "<button onclick='changerDocument(\"../image_res/../image_res/vague_vent_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>complet</button>";
          Aide_text = Aide_text + "<button onclick='changerDocument(\"../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>extraits</button>";
          // Cadre iFrame unique (chargé par défaut avec le deuxieme document)
          Aide_text = Aide_text + "<iframe id='cadreDoc' src='../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH' width='100%' height='550px' style='border: 1px solid #ccc; border-radius: 4px;'></iframe>";

      if ( L_SHOP ) {
             Aide_text = Aide_text + " <b> SHOP - </b> système de Simulation Hydrodynamique sur une portion du Saint-Laurent.  <br>";
             Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_ohps/readme_ohps_fr' target='_blank'> SHOP référence </a> <br>";
             Aide_text = Aide_text + " <b> ____ - </b> résolution source 100m, offerte 200m; Cartes aux heures jusqu'a 60h.  <br>";
             Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 12 heures  <br>";
      }
          Aide_text = Aide_text + " <b> RAQDPS - </b> Système Régional de prévision de qualité de l'air du CMC <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 10km, offerte 10km; Cartes aux 3 heures jusqu'a 72h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 12 heures  <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_raqdps/readme_raqdps_fr' target='_blank'> RAQDPS référence </a> <br>";
          Aide_text = Aide_text + " <b>  GOES - </b> Image a partir de donnees GOES-Est continental     <br>";
          Aide_text = Aide_text + " <b> _____ - </b> résolution variable atteignant 1,5km dans le visible;  aux 5 minutes.  <br>";
          Aide_text = Aide_text + " <b> RADAR CO - </b> Extrait COntinental du Composite Radar du CMC    <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution offerte autour de 2km (source 1km);  aux 6 minutes.  <br>";
          Aide_text = Aide_text + " <b> RADART CO - </b> Extrait COntinental du Composite Radar du CMC pour type de pcpn <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution offerte autour de 2km (source 1km); aux 6 minutes.  <br>";
          Aide_text = Aide_text + " <b> FOUDRE CO - </b> Extrait du Composite Radar du CMC    <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution offerte variable près de 1km ;  aux 5 minutes.  <br>";
          Aide_text = Aide_text + " <b> GOES+ - </b> Permet la superposition des produits, GOES,  Foudre et-ou Radar <br>";
          Aide_text = Aide_text + " <b> ____ - </b> décrits ci-haut.  <br>";
      if ( L_GDPSE ) {
            Aide_text = Aide_text + " <b> GDPSE </b> systeme global du CMC, un seul zoom sur EUROPE. <br>";
            Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_gdps/readme_gdps_fr' target='_blank'> GDPS: référence </a> <br>";
            Aide_text = Aide_text + " <b> ____ - </b> résolution source 15km, offerte 15km; Cartes aux 6h jusqu'a 240h.  <br>";
            Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
            Aide_text = Aide_text + " <b> ECMWFE - </b> systeme global de ECMWF un seul zoom sur Europe. <br>";
            Aide_text = Aide_text + " <b> ____ - </b> résolution source 28km, offerte 20km; Cartes aux 6h jusqu'a 240h.  <br>";
            Aide_text = Aide_text + " <b> ____ - </b> Passes: possible aux 12h mais sporadique pour le moment<br>";
            Aide_text = Aide_text + " <b> AIFSE - </b> systeme global AI de ECMWF un seul zoom sur EUROPE. <br>";
            Aide_text = Aide_text + " <b> ____ - </b> résolution source 28km, offerte 20km; Cartes aux 6h jusqu'a 240h.  <br>";
            Aide_text = Aide_text + " <b> ____ - </b> Passes: possibles aux 12 heures mais sporadiques pour le moment   <br>";
          }

        } else if ( ( aideCode == "Couche1Model" || aideCode == "Couche2Model" ) && (WindMaps) ) {
          Aide_text = " Menu Theme <br><br>";

          if ( aideCode == "Couche1Model" ) {
            Aide_text = Aide_text + "  Ce menu permet la sélection du système de prévision de la <b> couche</b> <strong>1</strong>. <br><br>";
                Aide_text = Aide_text + " Voici ce qui est offert: <br>";
          } else {
            Aide_text = Aide_text + "  Ce menu permet la sélection du système de prévision de la <b> couche</b> <strong>2</strong>. <br><br>";
                Aide_text = Aide_text + " Voici ce qui est offert: <br>";
            Aide_text = Aide_text + " <br> <b> Void  - </b> Couche 2 désactivées. ";
            Aide_text = Aide_text + " <br> <b> ____ - </b> La sélection de void effacera la couche 2.<br>";
          }
          Aide_text = Aide_text + " <br> <b> Air: - </b> système de prévision atmosphérique à haute résolution du CMC: zoom sur sud du Québec. ";
          Aide_text = Aide_text + " <br> <b> ____ - </b> Les données sont offertes par le Centre Météorologique Canadien (ECCC): <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_hrdps/readme_hrdps_fr' target='_blank'> HRDPS: référence </a> <br> ";
          Aide_text = Aide_text + " <br> <b> ____ - </b> résolution native: 2,5km; Cartes aux 1h jusqu'a 48h de prévision.  ";
          Aide_text = Aide_text + " <br> <b> ____ - </b> Rafraichissement aux 6 heures  <br>";


          Aide_text = Aide_text + " <br> <b> NEMO: - </b> modèle océanique du système de prévision du cycle de l'eau CMC: zoom sur sud du Québec. ";
          Aide_text = Aide_text + " <br> <b> ____ - </b> Les données sont offertes par le Centre Météorologique Canadien (ECCC). <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_wcps/readme_wcps_fr/' target='_blank'> WCPS: référence</a> <br>";
          Aide_text = Aide_text + " <br> <b> ____ - </b> résolution native: 1km; Cartes aux 1h jusqu'a 60h de prévision.  ";
          Aide_text = Aide_text + " <br> <b> ____ - </b> Rafraichissement aux 12 heures  (temps d'origine 06Z et 18Z) <br>";
             Aide_text = Aide_text + " <b> RDWPS - </b> système de prévision déterministe de vague, basé sur WaveWatch III.  <br>";
             Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_rdwps/readme_rdwps_fr' target='_blank'> RDWPS référence </a> <br>";
             Aide_text = Aide_text + " <b> ____ - </b> résolution source 2,5km, offerte 1km; Cartes aux heures jusqu'a 48h.  <br>";
             Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 6 heures  <br>";
          Aide_text = Aide_text + " <b> DIAGW - </b> Diagnostiques état de la mer de imeteo basés sur RDWPS (Vagues) et NEMO inclu dans WCPS (courants).  <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_rdwps/readme_rdwps_fr' target='_blank'> RDWPS référence </a> <br>";
          Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_wcps/readme_wcps_fr' target='_blank'> WCPS référence </a> <br>";
          Aide_text = Aide_text + " <b> ____ - </b> résolution source 2,5km, offerte 1km; Cartes aux heures jusqu'a 48h.  <br>";
          Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 6 heures  <br>";
          Aide_text += "<br><br>";
          Aide_text = Aide_text + "<b> Sélectionnez ici la Documentation spécifique de DIAGW : </b><br><br>";
          // Boutons de choix
          Aide_text = Aide_text + "<button onclick='changerDocument(\"../image_res/../image_res/vague_vent_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>complet</button>";
          Aide_text = Aide_text + "<button onclick='changerDocument(\"../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>extraits</button>";
          // Cadre iFrame unique (chargé par défaut avec le deuxieme document)
          Aide_text = Aide_text + "<iframe id='cadreDoc' src='../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH' width='100%' height='550px' style='border: 1px solid #ccc; border-radius: 4px;'></iframe>";

      if ( L_SHOP ) {
             Aide_text = Aide_text + " <b> SHOP - </b> système de Simulation Hydrodynamique sur une portion du Saint-Laurent.  <br>";
         Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_ohps/readme_ohps_fr/' target='_blank'> SHOP: référence</a> <br>";
             Aide_text = Aide_text + " <b> ____ - </b> résolution source 100m, offerte 200m; Cartes aux heures jusqu'a 60h.  <br>";
             Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 12 heures  <br>";
      }

        } else if ( aideCode == "Couche1Carte" || aideCode == "Couche2Carte" ) {
           Aide_text = " Menu Cartes météo <br><br>";

          var mapid = Couche1.mapIdH;

          if ( aideCode == "Couche1Carte" ) {
           Aide_text = Aide_text + " Ce menu permet la sélection de la carte pour la <b> couche</b> <strong>1</strong>. ";
           Aide_text = Aide_text + " Le choix de carte peut varier. <b> Certaine </b> sélections de cartes seront décrites plus loin. ";
           Aide_text = Aide_text + " Pour savoir si une carte est documentées ici,";
           Aide_text = Aide_text + " il suffit de sélectionner la carte en question, <b> avant </b> de réactionner ce bouton d aide. <br> <br> ";
           Aide_text = Aide_text + " Notez que la carte de la couche 1 s'affichera: <br> <br> ";
           Aide_text = Aide_text + " ------> par dessus (après) la carte de la couche 2 en mode, couches <b> superposées </b> (voir menu Couches)<br> ";
           Aide_text = Aide_text + " ou <br> ";
           Aide_text = Aide_text + " ------> à la suite de son comparable de la couche 2,  en mode couches en <b> alternances ou intercallées </b> (voir menu Couches) <br>";
           Aide_text = Aide_text + " ou encore,<br> ";
           Aide_text = Aide_text + " ------> sur la carte de gauche (couche 2 sur la carte de droite), en mode <b> juxtaposition </b> de couches (voir menu Couches)<br> <br>";


          } else {
           Aide_text = Aide_text +  " Ce menu permet la sélection de la carte pour la <b> couche </b> <strong>2</strong>. ";
           Aide_text = Aide_text + " Le choix de carte peut varier. <b> Certaine </b> sélections de cartes seront décrites plus loin. ";
           Aide_text = Aide_text + " Pour savoir si une carte est documentées ici,";
           Aide_text = Aide_text + " il suffit de sélectionner la carte en question, <b> avant </b> de réactionner ce bouton d aide. <br> <br> ";
               Aide_text = Aide_text + " Le menu fonctionnera si la couche 2 est active. ";
           Aide_text = Aide_text + " On active la couche 2 avec le menu <b> Syst prév.</b> de la couche 2.  Notez que la carte de la couche 2 s'affichera: <br><br>";
           Aide_text = Aide_text + " ------> en dessous (avant) la carte de la couche 1 en mode, couches <b> superposées </b> (voir menu Couches)<br> ";
           Aide_text = Aide_text + " ou <br> ";
           Aide_text = Aide_text + " ------> avant son comparable de la couche 1, en mode <b> alternances ou intercallées </b> de couches (voir menu Couches)<br> <br>";
           Aide_text = Aide_text + " ou encore,<br> ";
           Aide_text = Aide_text + " ------> sur la carte de droite (couche 1 sur la carte de gauche), en mode <b> juxtaposition </b> de couches (voir menu Couches)<br> <br>";

            mapid = Couche2.mapIdH;
          }
    
          if ( mapid == "HWLA_" )  {

                 Aide_text = Aide_text + " <br>  <b> HWLA : </b> Horizontal Water Level Anomaly (HWLA) with respect to the Intantaneous <b> Mean </b> Lake Water Level (IMLWL) ";
                 Aide_text = Aide_text + " for Lakes Superior, Michigan,  Huron, St-Clair, Erie, Ontario. "; 
         Aide_text = Aide_text + "   HWLA are the Level differences relative to the IMLWL.  They are obtained by subtracting de IMLWL from the current valid time Levels for all lake points.<br> <br>";
         Aide_text = Aide_text + " Intantaneous  <b> Mean </b>  Lake Water Level (IMLWL) are computed for each lake taken individualy, as the average of all lake point levels <b> at a given time </b>. ";
         Aide_text = Aide_text + " The IMLWL depicted values are relative to the International Great Lakes Datum (IGLD, 1985). <br>";
              Aide_text = Aide_text + "   (those in parenthesis are IMLWL differences with the 0h prognosis (analysis time) given in mm for each lakes taken individualy) <br>";

          } else if ( mapid == "WLTC_" )  {

              Aide_text = Aide_text + " <br>  <b> WLTC : </b> Water Level Time Change (WLTC) since the initial water level (0h prognosis)";
              Aide_text = Aide_text + "   for Lakes:  Superior, Michigan,  Huron, St-Clair, Erie, Ontario. ";
         Aide_text = Aide_text + "   WLTC are the Level differences since analysis time.  They are obtained by subtracting de 0h pronostic Levels from the current valid time Levels for all lake points.<br> <br>";
         Aide_text = Aide_text + " Intantaneous  <b> Mean </b>  Lake Water Level (IMLWL) are computed for each lake taken individualy, as the average of all lake point levels <b> at a given time </b>. ";
         Aide_text = Aide_text + " The IMLWL depicted values are relative to the International Great Lakes Datum (IGLD, 1985). <br>";
              Aide_text = Aide_text + "   (those in parenthesis are IMLWL differences with the 0h prognosis (analysis time) given in mm for each lakes taken individualy) <br>";

           } else if ( mapid == "SOSSHEIG_" || mapid == "IICECONC_" || mapid == "VOTEMPER_0.5" || mapid == "CDIR_0.5" || mapid == "CSPEED_0.5" ) {

              Aide_text = Aide_text + " <br> <b> Niveau </b>: Hauteur d'eau relative au <b> zéro des cartes (Charts Datum) </b> " ;
              Aide_text = Aide_text + "    pour le Lac Ontario, ";
          Aide_text = Aide_text + "  et relatif au <b> Niveau moyen de la mer </b> ";
              Aide_text = Aide_text + "    pour le reste du domaine à l'Est de la ville de Québec. <br>";
              Aide_text = Aide_text + " <br> <b> Glace </b>: Couverture de Glace de mer (fraction entre 0 et 1). <br>" ;
              Aide_text = Aide_text + " <br> <b> TMP 50cm </b>: température en degrés Kelvin, 50cm sous la surface de l'eau. <br>" ;
              Aide_text = Aide_text + " <br> <b> Dir_Cou </b>: Direction du courant 50cm sous la surface de l'eau. <br>" ;
              Aide_text = Aide_text + " <br> <b> Vit_Cou </b>: Vitesse du courant 50cm sous la surface de l'eau (noeuds). <br>" ;


           } else if ( mapid == "C02_CO" || mapid == "C13_CO" )  {

                 Aide_text = Aide_text + " <br> <b> VI 02 </b>: produit satellite VIsible (VI canal 2)  <br>" ;
                 Aide_text = Aide_text + " <br> <b> IR 13 </b>: produit satellite Infra-Rouge (IR canal 13) <br>" ;

            } else if ( mapid == "FOUDRE_PTS_CO"  )  {
                 Aide_text = Aide_text + " <br> <b> FOUDRE </b>:  Foudre plus récente à moins récente: rouge, orange, jaune, vert, bleu" ;
                 Aide_text = Aide_text + " par interval 10 minutes pour un total de 60 minutes. <br>" ;

           } else if ( mapid == "RRAI" || mapid == "RRAI_NET" || mapid == "RSNO" || mapid == "RSNO_NET" )  {
                 Aide_text = Aide_text + " <br> <b> R </b>: Taux de précipitation liquide estimé à partir de la réflectivité équivalente RADAR (resol:2km) <br>" ;
                 Aide_text = Aide_text + " <br> <b> S </b>: Taux de précipitation solide estimé à partir de la réflectivité équivalente RADAR  (resol:2km)<br>" ;
                 Aide_text = Aide_text + " <br> <b> R Net </b>: Taux de précipitation liquide estimé à partir de la réflectivité équivalente RADAR  <br>" ;
                 Aide_text = Aide_text + " <br> La catégorie de couleur du taux le plus faible (plus bruité) est retiré pour mieux voir le signal (resol:2km)<br>" ;
                 Aide_text = Aide_text + " <br> <b> S Net</b>: Taux de précipitation solide estimé à partir de la réflectivité équivalente RADAR (resol:2km) <br>" ;
                 Aide_text = Aide_text + " <br> La catégorie de couleur du taux le plus faible (plus bruité) est retiré pour mieux voir le signal <br>" ;

        } else if ( mapid == "RTYP" )  {
                 Aide_text = Aide_text + " <br> <b> TYPE </b>: Taux de précipitation estimé par catégories de types de précipitation (resol:2km)<br>" ;
            } else if ( mapid == "HGT_1000-500_HGT_1000-500"  )  {
                 Aide_text = Aide_text + " <br> <b> Épai500 </b>:  Épaisseur de la couche atmosphérique entre les niveaux de pressions 1000mb et 500mb en dam" ;

            } else if ( mapid == "D-HGT_500" )  {
                 Aide_text = Aide_text + " <br> <b> Del500 </b>:  en couleur, <b> la Différence </b> de la hauteur à 500mb entre le modèle sélectionné au menu syst. prev. et" ;
                 Aide_text = Aide_text + " le modèle global du CMC (GDPS):   GZ500 modèle courant - GZ500 modèle GDPS.  <br><br>" ;
                 Aide_text = Aide_text + " Les tons verts-bleutés (froids) indiquent que le niveau 500mb du modèle est plus bas, plus creux, que celui du GDPS, ";
                 Aide_text = Aide_text + " alors que les tons jaunes-rouges (chauds)  indiquent que le niveau 500mb du modèle est plus haut que celui du GDPS. <br><br>" ;  
           }

        } else if ( aideCode == "CoucheCo1Carte" || aideCode == "CoucheCo2Carte" ) {
           Aide_text = " Menu Co-Cartes <br><br>";

          var mapid = Couche1.mapIdH;

          if ( aideCode == "CoucheCo1Carte" ) {
           Aide_text = Aide_text + " Ce menu permet la sélection d une carte associée a la carte 1,  sélectionnée pour la <b> couche</b> <strong>1</strong>. <br><br>";
           Aide_text = Aide_text + " Le choix de la co carte est plus restrictif puisqu'il s'agit normalement d'une carte comportant des contours,  flèches, symboles. <br>";
           Aide_text = Aide_text + " Cette sélection permet donc la superposition de hauteurs géopotentielles, de la pression, de directions de vents ou de courants, de la foudre, ";
           Aide_text = Aide_text + " par dessus la couche 1, de base, a l'intérieur des produits disponible pour un système de prévision.";
           Aide_text = Aide_text + " Cette carte sera systématiquement superposée a la carte 1 de base, pour les memes temps de validités.";
           Aide_text = Aide_text + " Les sélections de date d'origine et d'opacité s'appliqueront a la co-carte de la meme facon que pour la carte 1.";
           Aide_text = Aide_text + " La sélection au menu Valeur s'apliquera uniquement a la carte 1. <br> <br>";

          } else {
           Aide_text = Aide_text + " Ce menu permet la sélection d une carte associée a la carte 2, sélectionnée pour la <b> couche</b> <strong>2</strong>. <br><br>";
           Aide_text = Aide_text + " Le choix de la co carte est plus restrictif puisqu'il s'agit normalement d'une carte comportant des contours,  flèches, symboles. <br> ";
           Aide_text = Aide_text + " Cette sélection permet donc l'affichage de hauteurs géopotentielles, de la pression, de directions de vents ou de courants, de la foudre,  ";
           Aide_text = Aide_text + " par dessus la couche 2, de base, a l'intérieur des produits disponible pour un système de prévision.";
           Aide_text = Aide_text + " Cette carte sera systématiquement superposée a la carte 2, pour les memes temps de validités.";
           Aide_text = Aide_text + " Les sélections de date d'origine et d'opacité s'appliqueront a la co-carte de la meme facon que pour la carte 2.";
           Aide_text = Aide_text + " La sélection au menu Valeur s'apliquera uniquement a la carte 2. <br><br>";

            mapid = Couche2.mapIdH;
          }
           Aide_text = Aide_text + " Enfin, il n'y a pas d'affichage de légendes pour les co-cartes.  Pour voir ces legendes,";
               Aide_text = Aide_text + " il suffit d'en faire la sélection comme carte de base au menu voisin ...carte météo. ";
           Aide_text = Aide_text + " <br> <br>";


        } else if ( aideCode == "Couche1Dateo"  ||  aideCode == "Couche2Dateo" ) {
           Aide_text = " Menu Date d'origine <br><br>";

           if ( aideCode == "Couche1Dateo" ) {
        Aide_text = Aide_text + " Ce menu permet la sélection de la date d'origine (de départ) de la prévison pour la <b> couche</b> <strong>1</strong>.<br> <br>"; 
               } else  {
            Aide_text = Aide_text + " Ce menu permet la sélection de la date d'origine (de départ) de la prévison pour la <b> couche</b> <strong>2</strong>.<br> <br>";
           }
           if ( !WindMaps ) {
           Aide_text = Aide_text + "  Lors du démarrage de l'interface, les plus récentes dates et heures de disponibilités des produits sont mises à jours. Ce processus prend générales quelques secondess, mais peut prendre jusqu'à 10 ou 20 secondes selon le contexte...";
           Aide_text = Aide_text + " Par la suite, il n'est pas nécessaire de redemarrer l'Interface afin d'obtenir les plus récentes prévisions.  Le tout se fait automatiquement. ";
          Aide_text = Aide_text + " Il suffit de sélectionner le système de prévision, et de vérifier le menu Date d'origine pour voir si il y a du nouveau. <br>";
          Aide_text = Aide_text + " Notez toutefois qu il pourrait être nécessaire de redémarrer l'interface suite à une inactivité de quelques heures. <br>";
        
          Aide_text = Aide_text + " <br> Dans le cas où le système de prévision est déjà sélectionné et actif, il faut  Délectionner et resélectionner pour obtenir le plus récent temps d<origine,  la plus récente prévision. Le bouton  <b> Init. T </b> (voir un peu plus loin) suivi d'un clic sur le bouton date d'origine juste au dessus du présent bouton, permet aussi d'assurer que la date d'origine est à jour. <br> <br>";  
          
              Aide_text = Aide_text + " Ce menu devient <b> inopérant </b> lorsque l'animation est en mode <b> Validité fixée </b> (voir menu Anim. mode, sélection Valid).";
              Aide_text = Aide_text + " En mode <b> Validité fixée </b> la date d'origine changera au grés de l'animation, puisque cette dernière porte ";
              Aide_text = Aide_text + " sur les dates d'origines offertes à ce menu. Il est donc jugé impertinent d'utiliser ce menu pendant cette animation. <br>";
           Aide_text = Aide_text + " Enfin, un clique sur l étiquette <b><i> Date d origine </i></b> située au dessus du menu, fera en sorte que la date sera ajustée de manière automatique. Il faudra toutefois selectionner au menu,  la date la plus recente si celle ci a changee depuis votre derniere selection de ce modele.   Dans le cas des donnees Radar ou Satellitaires,  l<ajustement de la plus recente date d<origine se fait automatiquement. ";
           } else {
               Aide_text = Aide_text + " <br> Les prévisions sont refaites à toutes les 6 heures. <br> <br> ";

           Aide_text = Aide_text + "  Lors du démarrage de l'interface, les plus récentes dates et heures de disponibilités des produits sont mises à jours. Ce processus prend générales quelques secondess, mais peut prendre jusqu'à 10 ou 20 secondes selon le contexte...";
           Aide_text = Aide_text + " Par la suite, il n'est pas nécessaire de redemarrer l'Interface afin d'obtenir les plus récentes prévisions.  Le tout se fait automatiquement. ";
           Aide_text = Aide_text + " Il suffit de sélectionner le menu Thème ou faire une nouvelle sélection au Bouton DuoD, et de vérifier le menu Date d'origine pour voir si il y a du nouveau. <br>";
           Aide_text = Aide_text + " Notez toutefois qu il pourrait être nécessaire de redémarrer l'interface suite à une inactivité de quelques heures. <br>";
               
           Aide_text = Aide_text + " <br> Dans le cas où un thème est déjà sélectionné et actif, il faut  Délectionneri (en sélectionnat un autre)  et resélectionner pour obtenir le plus récent temps d origine,  la plus récente prévision. Le bouton  <b> Init. T </b> (voir un peu plus loin) suivi d'un clic sur le bouton date d'orgine juste au dessus du présent bouton, permet aussi d'assurer que la date d'origine est à jour. <br> <br>";

           }

      } else if ( aideCode == "Couche1Valeurs" || aideCode == "Couche2Valeurs" ) {
           Aide_text = " Menu Valeur <br><br>";
           Aide_text = Aide_text + " Ce menu permet d'activer l'obtention de: <br>";
           Aide_text = Aide_text + "                                      valeurs aux pixelles (selection Popup), ou  <br>" ;
           Aide_text = Aide_text + "                                      séries temporelles de SpotWx (TimSer ou TimSer_e) ou <br>";
           if ( !WindMaps ) { 
           Aide_text = Aide_text + "                                      séries temporelles Météogrammes (ensembles) " ;
           }
       if ( aideCode == "Couche1Valeurs") {
               Aide_text = Aide_text + "  pour la <b> couche</b> <strong>1</strong> .<br><br>";
       } else {
           Aide_text = Aide_text + "  pour la <b> couche</b> <strong>2</strong> .<br><br>";
       }

           Aide_text = Aide_text + " En sélectionnant  <b> Popup </b>... vous obtenez une aide à l'interprétation des couleurs afin d'y associer des valeurs. ";
           Aide_text = Aide_text + " Il suffit ensuite de cliquer sur la carte. Les valeurs pourront être déduites sur l'échelle de la légende, où la couleur ";
           Aide_text = Aide_text + " sélectionnée sur la carte y sera rehaussée. <br>";
           Aide_text = Aide_text + " Les valeurs aux pixelles  ne sont donc disponibles que pour les cartes colorés, comportant des légendes.<br> <br>";
           Aide_text = Aide_text + " Le <b> Popup </b> s'affichera: <br>";
           Aide_text = Aide_text + " ----------------  lorsque l'option est activée pour la couche 1 (ou-et 2) ET la couche 1 (ou 2) est visible <br>";
           Aide_text = Aide_text + " ----------------  lorsque l'option est activées pour <b> les deux couches </b> les boites de popup seront superposées si le mode affichage de couche est superposée (voir menu Couches), alors dans ce cas, vaut mieux avoir le mode intercallé ou juxtaposé pour l'affichage des couches. <br>";
           Aide_text = Aide_text + " La boite du  <b> Popup </b> peut est temporairement effacée en cliquant sur le - situé en haut à gauche de la boite. <br>";
           Aide_text = Aide_text + " Le mode popup peut être désactivé à partir du menu ou en cliquant sur le x en haut à droite de la boite du popup. <br> <br>";

           Aide_text = Aide_text + " La sélection <b> TimSer </b> entrainera l'affichage de séries temporelles de SpotWx dans la même fenêtre (même onglet) que imeteomaps. <br> ";
           Aide_text = Aide_text + " La sélection <b> TimSer_e </b> entrainera l'affichage de séries temporelles de SpotWx dans une fenêtre <b> externe </b> (autre onglet) à imeteomaps. <br> ";
           Aide_text = Aide_text + "       La demande pour fenêtre externe (TimSer_e) se réalise dans un nouvel onglet, sur un téléphone ou une tablette.";
           Aide_text = Aide_text + "       Sur un téléphone en mode portrait, la sélection TimSer affichera le graphique au bas de la page imeteomaps.";
           Aide_text = Aide_text + "       Sur une tablette en mode paysage, la sélection TimSer affichera le graphique cote à cote avec le page imeteomaps.";
           Aide_text = Aide_text + "       Le mode plein écran se désactivera automatique si TimSer_e est demandé...";

           if ( !WindMaps ) {
           Aide_text = Aide_text + "       Les séries temporelles de SpotWx sont disponibles pour les systèmes,  HRDPS, RDPS GDPS et GFS <br>";
           Aide_text = Aide_text + " La sélection <b> MeteoGrm </b> entrainera l'affichYage de Météogrammes (ensembles) dans une fenêtre <b> externe </b> (autre onglet) à imeteomaps. <br> ";
           Aide_text = Aide_text + "       Pour le système IFS ECMWF les météogrammes s`afficheront <b> via l'application OpenData Charts de ECMWF </b>.";
           Aide_text = Aide_text + "       La série temporelle du modèle déterministe ECMWF y est tracée en bleu (il s agit du même modèle que celui qui est ";
           Aide_text = Aide_text + "       affiché sur la carte imeteomaps). Les autres données tracés proviennent des ensembles de ECMWF (qui ne sont pas encore";
           Aide_text = Aide_text + "       dispnibles sur imeteomaps sous forme de cartes). <br>";
           Aide_text = Aide_text + "       Pour le système GDPS ce sont les plutot les météogrammes du système d'ensemble GEPS qui s`afficheront <b> via l'application SpotWx </b>.";
           Aide_text = Aide_text + "       Cet ajout permet de conparer les données des systèmes d'ensembles ECMWF et GEPS.  <br> <br>";
           Aide_text = Aide_text + " La sélection <b> ProfVert </b> entrainera l'affichage de Profile Verticaux de ECMWF dans une fenêtre <b> externe </b> (autre onglet) à imeteomaps. <br> ";
           }
           Aide_text = Aide_text + " Les données affichées correspondent au système de prévision de la couche <b> 1 ou 2 (selon la couche sélectionnée) </b>,";
           Aide_text = Aide_text + " au point géographique sélectionné correspondant au clique sur la carte géographique. ";

           Aide_text = Aide_text + " Notez qu'il peut parfois y avoir de légères incohérences entre les cartes imeteomaps et les série temporelles de spotwx en raison ";
           Aide_text = Aide_text + " des interpolations. Les inhérences peuvent être plus importante en raison de l'impossibilité de la synchronisation des dates d'origines";
           Aide_text = Aide_text + " des produits en tout temps.";
           Aide_text = Aide_text + " Cela est causé par le fait que spotwx ne dispose pas d'archives. Votre requête à SpotWx vous donnera les plus récentes données disponibles";
           Aide_text = Aide_text + " pour ce système de prévision, et cela ne tiendra pas compte de la date d'origine que vous avez sélectionnée dans imeteomaps. <br>";
           Aide_text = Aide_text + " Puisqu'il est inévitable que les mise à jour des systèmes de prévisions ne soient pas synchronisées exactement, cela se produira potentiellement ";
           Aide_text = Aide_text + " plusieurs fois par jours. ";
           if ( !WindMaps ) {
           Aide_text = Aide_text + " Ajoutons que SpotWx offre le GFS aux heures de départs de 06 et 18Z  alors que imeteomaps ne l'offre pas pour";
           Aide_text = Aide_text + " ces date d'origines à ce jour. <br>";
           Aide_text = Aide_text + " Notez que dans le cas des météogrammes de ECMWF, il y a une archive. L'interface Open Charts requiert la date d'origine de votre choix,";
           Aide_text = Aide_text + " et peut accomoder quelques passe en archives.  Ainsi,  dans le cas de ce modèle,  votre choix de date d'origine à l'interface imeteomaps";
           Aide_text = Aide_text + " sera coherent (en principe) avec les series temporelles obtenus. <br>";
           }

      } else if ( aideCode == "Couche1Opacit" ) {
           Aide_text = " Menu Opacit <br><br>";
           Aide_text = Aide_text + " Sélection de l'opacité de la <b> couche</b> <strong>1</strong>.<br> Les sélections vont de 0 (transparent) à 10 (opaque). <br>";
           Aide_text = Aide_text + " La sélection 0 permet de voir uniquement les repères géographiques. <br>";
           
      } else if ( aideCode == "Couche2Opacit" ) {
           Aide_text = " Menu Opacit <br><br>";
           Aide_text = Aide_text + " Sélection de l'opacité de la <b> couche </b> <strong>2</strong>. <br> Les sélections vont de 0 (transparent) à 10 (opaque).<br> ";
           Aide_text = Aide_text + " La sélection 0 permet de voir uniquement les repères géographiques. <br>";
           
      } else if ( aideCode == "AnimMode" ) {         
           Aide_text = " Menu Ani mod <br><br>";
           Aide_text = Aide_text + " ce menu permet la sélection du mode d'animation, dans l'un où l'autre des modes suivants: <br> <br> ";
       Aide_text = Aide_text + " _______<b> Début: </b> Date et heure d'origine fixées. L'animation porte sur les temps de prévisions,  les échéances. <br>";
           Aide_text = Aide_text + "  Il s'agit de l'animation usuelle, qui montre l'évolution des paramètres par couches successives dans le temps de validité. <br><br>";
           Aide_text = Aide_text + " _______<b> Valid: </b> Date et heure de validité fixées. L'animation porte sur les récentes dates et heures d'origines donnant ";
       Aide_text = Aide_text + " des prévisions d'échéances variées <b> ayant en commun la date et heure de validité affichée </b>. <br> ";
           Aide_text = Aide_text + " Il s'agit d'une animation de la séquence historique de prévisions faites pour une date donnée. <br> <br>";
           Aide_text = Aide_text + "  <b> Avant </b>  d'activer le mode -Valid- il faut afficher à l'écran la date et l'heure de validité d'intérêt, parce qu'ils seront ainsi fixées pour le mode -Valid-. Plus tard, pour changer ou pour fixer le temps valide d'intérêt, il faut revenir en mode -Début-, sélectionner la date d'origine, et ajuster le prog pour obtenir la validité désiré.  <br> <br>";
           Aide_text = Aide_text + "  <b> Truc: </b> Avant d'activer le mode -Valid- sélectionne le système, la carte, et la date d'origine des couches 1 et 2 (ensuite).   Plus tard, ajuster le prog au moyen de la flèche avant ou arrière. Il faut tenir compte du nombre de passes historique qui sont conservées...<br> <br>";
           
      } else if ( aideCode == "CoucheAffichage" ) {
           Aide_text = " Menu Couches <br><br>";
           Aide_text = Aide_text + " Il permet la sélection du mode d'affichage des couches 1 et 2, dans l'un ou l'autre des modes suivants: <br> <br> ";
           Aide_text = Aide_text + " _______<b> Interca: pour couches intercallées </b> L'animation affiche <b> successivement </b> les couches 1 et 2 en commencant par la couche 2. <br>";
           Aide_text = Aide_text + " _______<b> Surperp: pour couches superposées </b> L'animation affiche en simultanément les couches 1 et 2 en superposition la couche 1 au dessus. <br> <br>";
           Aide_text = Aide_text + " _______<b> Juxtapo: pour couches juxtaposées </b> L'animation affiche en simultanément les couches 1 et 2 simultanément la couche 1 à gauche et la couche 2 à droite, dans deux cartes géographiques distinctes. <br> <br>";

           Aide_text = Aide_text + "  Notez que la carte de la couche 2 s'affichera:<br> <br> ";
           Aide_text = Aide_text + "  - en dessous (avant) la carte de la couche 1 en mode, couches <b> superposées </b> (voir menu Couches)<br> ";
           Aide_text = Aide_text + " ou <br> ";
           Aide_text = Aide_text + "  - avant son comparable de la couche 1, en mode <b> intercallé </b> de couches (voir menu Couches)<br> <br>";

           Aide_text = Aide_text + "  La carte de la couche 2 devrait normalement être sélectionnée à un Syst. prèv autre que VOID (couche 2 active) en mode superposition, sans quoi <br>";
           Aide_text = Aide_text + "  puisqu'il n'y a alors qu'une seule série d'images, la superposition portera sur des cartes ayant des temps de validités successifs dans la liste de l'animation. ";
           Aide_text = Aide_text + "  On a choisi de laisser l'interface le permettre, même si on n'en voit pas l'utilité... Toutefois, lors de l'effacage de la couche 2, le mode de Couche ";
           Aide_text = Aide_text + "  sera fixé à Intercal automatiquement.   Il faudra sélectionner la Superpo dans le menu Couche pour obtenir la superposition après avoir effacé la couche 2 (sélection void). <br>";

     } else if ( aideCode == "ViewProjection" ) {
           Aide_text = " Menu Proj:<br><br>";
           Aide_text = Aide_text + " Il permet de modifier la sélection de la projection géographique de la visualisation. <br> <br>";
           Aide_text = Aide_text + " Chaque système de prévision a une projection géographique associée, déterminée lors de la création des <b> images </b> à partir des données du service de prévisions. De manière générale, on tentera, à l'avenir, de conserver la projection géographique offerte par le service de prévision tel que décodée dans le fichier GRIB. À ce stade-ci, ce travail n'est pas fait, toutes les images sont encore produites sur une projection EPSG:3857 (Web Mercator). <br> <br> ";

       Aide_text = Aide_text + " Dans cette interface, de façon automatique, la carte météo du système sélectionnée à la <b> couche 1 </b> sera présentée à l'écran dans <b> -sa- projection </b> géographique (i.e. sans interpolation à l'affichage).  Cette projection géographique correspond à celle de <b> l'image météo de la couche 1 </b>.  C'est le mode de départ qui correspond à la sélection <b> Syst.Prev </b>  du menu. Dans ce contexte, la projection de visualisation sera déterminée par la projection du Système de prévision de la couche 1. ";
       Aide_text = Aide_text + " La carte météo du système sélectionné à la couche  <b> 2 </b> sera présentée à l'écran dans <b> -la- projection géographique de la couche 1 </b>. Cela pourrait impliquer des interpolations lors de l'affichage. Cela est inévitable lors de la superposition de systèmes de prévisions différents, ayant des projections distinctes.  On peut intervertir les systèmes des couches 1 et 2,  afin de changer lequel se projette sur l'autre.  <br> <br> "; 
       Aide_text = Aide_text + " La sélection d'une projection particulière faite au menu Proj (autre que Syst.Prev), imposera cette projection géographique de votre choix pour la présentation des deux couches.  On peut revenir au mode de départ en re-sélectionnant Sys.Prev au menu. <br> <br>";
           Aide_text = Aide_text + " Notez que la présentation à l'écran dans une projection différente de celle de l'image à la source entraine une interpolation à l'affichage.  Cela peut avoir un impact sur la rapidité de l'animation. </b>  ";

     } else if ( aideCode == "Interval"  && !WindMaps ) {
           Aide_text = " Menu Interv<br><br>";
           Aide_text = Aide_text + " Il permet la sélection de l'interval de temps pour 2 aspects: <br> <br>";
           Aide_text = Aide_text + " - pour l'accumulation de la précipitation, <br> "; 
       Aide_text = Aide_text + " - <b> ainsi </b> que pour le temps entre chaque prévision dans le cas de l'animation en mode <b> Début fixe </b> (voir menu Anim. mode). <br> <br>";
           Aide_text = Aide_text + " Le choix de valeurs différe d'un système de prévision à l'autre,  et parfois d'un zoom à l'autre. <br> <br> ";
           Aide_text = Aide_text + "  Un algorithme doit parfois ajuster l'interval afin d'obtenir une valeur commune,";
           Aide_text = Aide_text + " dans le cas où deux systèmes différents sont selectionnés sur les couches 1 et 2.  <br> <br> ";
           Aide_text = Aide_text + " Lorsque l'interval est ajusté   automatiquement ,  il prend la valeur la plus petite possible.  En général l'interval valide est établie compte tenu (dans l'ordre) de: les systèmes de prévisions, les dates d'origines (décallage), la carte météo (pour cumul precip). Les parmètres Debut et Fin s'ajusteront à la valeur de l'interval,  si il y a lieu. <br> ";
           Aide_text = Aide_text + " Enfin, un clique sur l étiquette <b><i> Interv. </i></b> située au dessus du menu, fera en sorte que l`intervalle sera ajustée de manière automatique.";
           
    } else if ( aideCode == "Interval"  && WindMaps ) {

           Aide_text = " Menu Interv vent<br><br>";
           Aide_text = Aide_text + " Il permet la sélection de l'interval de temps pour entre chaque prévision l'animation  <br>";

    } else if ( aideCode == "Debut"  && !WindMaps ) {
           Aide_text = " Menu Début.<br><br>";
           Aide_text = Aide_text + " Ce menu est absent lorsque l'animation est en mode <b> Validité fixés </b> (voir menu Anim. mode).<br>"; 
           Aide_text = Aide_text + " Il permet la sélection du <b> premier temps de prévision </b> de l'animation dans le cas de l'animation en mode <b> Début fixé </b>. <br><br> ";
           Aide_text = Aide_text + " Le choix de valeurs différe d'un système de prévision à l'autre,  et parfois d'un zoom à l'autre. <br> <br>";
           Aide_text = Aide_text + "  Un algorithme doit parfois ajuster l'interval afin d'obtenir une valeur commune, ";
           Aide_text = Aide_text + " dans le cas où deux systèmes différents sont selectionnés sur les couches 1 et 2.  <br> <br> ";
           Aide_text = Aide_text + " Lorsque Début est ajusté automatiquement,  il prend la valeur <b> la plus petite possible</b>. En général, le Début valide est établi compte tenu (dans L'ordre) de: les systèmes de prévisions, les dates d'origines (décallage), la carte météo (pour cumul precip) et l'interval de temps. La Fin s'justera à la valeur du Début si il y a lieu. <br> ";
           Aide_text = Aide_text + " Enfin, un clique sur l étiquette <b><i> Début </i></b> situé au dessus du menu, fera en sorte que le valeur de début sera ajustée de manière automatique.";

    } else if ( aideCode == "Debut"  && WindMaps ) {
           Aide_text = " Menu Début. vent<br><br>";
           Aide_text = Aide_text + " Il permet la sélection du <b> premier temps de prévision </b> de l'animation  <br><br> ";
           Aide_text = Aide_text + "  Un algorithme doit parfois ajuster le début afin d'obtenir des temps de validité communs, ";
           Aide_text = Aide_text + " dans le cas où deux dates d'origines différentes sont selectionnées sur les couches 1 et 2.  <br> <br> ";
           Aide_text = Aide_text + " Lorsque Début est ajusté automatiquement,  il prend la valeur <b> la plus petite possible</b>. En général, le Début valide est établi compte tenu (dans L'ordre) de: les systèmes de prévisions, les dates d'origines (décallage), et l'interval de temps. La Fin s'ajustera à la valeur du Début si il y a lieu. <br> ";
           Aide_text = Aide_text + " Enfin, un clique sur l étiquette <b><i> Début </i></b> situé au dessus du menu, fera en sorte que le valeur de début sera ajustée de manière automatique.";

    } else if ( aideCode == "Fin" && !WindMaps ) {
           Aide_text = " Menu Fin.<br><br>";
           Aide_text = Aide_text + " Ce menu est absent lorsque l'animation est en mode <b> Validité fixés </b> (voir menu Anim. mode).<br>"; 
           Aide_text = Aide_text + " Il permet la sélection du <b> dernier temps </b> de prévision (la fin) de l'animation dans le cas de l'animation en mode <b> Début fixe </b>. <br> <br>";
           Aide_text = Aide_text + " Le choix de valeurs différe d'un système de prévision à l'autre,  et parfois d'un zoom à l'autre. <br><br> ";
           Aide_text = Aide_text + "  Un algorithme doit parfois ajuster l'interval afin d'obtenir une valeur commune,  ";
           Aide_text = Aide_text + " dans le cas où deux systèmes différents sont selectionnés sur les couches 1 et 2.  <br> <br> ";
           Aide_text = Aide_text + " Lorsque la Fin est ajustée,  elle prend la valeur <b> la plus grande possible </b>, compte tenu (dans L'ordre) de: les systèmes de prévisions, les dates d'origines (décallage), la carte météo (pour cumul precip) et l'interval de temps,  le Début. <br> ";
           Aide_text = Aide_text + " Enfin, un clique sur l étiquette <b><i> Fin </i></b> situé au dessus du menu, fera en sorte que le valeur de Fin sera ajustée de manière automatique.";


    } else if ( aideCode == "Fin" && WindMaps ) {
           Aide_text = " Menu Fin. vent <br><br>";
           Aide_text = Aide_text + " Il permet la sélection du <b> dernier temps </b> de prévision (la fin) de l'animation <br> <br>";
           Aide_text = Aide_text + "  Un algorithme doit parfois ajuster la fin afin d'obtenir des temps de validités communs,  ";
           Aide_text = Aide_text + " dans le cas où deux dates d'origines différentes sont selectionnées sur les couches 1 et 2.  <br> <br> ";
           Aide_text = Aide_text + " Lorsque la Fin est ajustée,  elle prend la valeur <b> la plus grande possible </b>, compte tenu (dans L'ordre) : des dates d'origines (décallage),  et l'interval de temps,  du Début. <br> ";
           Aide_text = Aide_text + " Enfin, un clique sur l étiquette <b><i> Fin </i></b> situé au dessus du menu, fera en sorte que le valeur de Fin sera ajustée de manière automatique.";
    
     } else if ( aideCode == "ResetTimeMenus"  && !WindMaps) {
           Aide_text = " Bouton Init. Temps <br><br>";
           Aide_text = Aide_text + " Ce Bouton permet, d'une seule touche de mettre à jour les paramètres suivants: <br> <br>"; 
           Aide_text = Aide_text + " La <b> date d'origine </b> sera mise à jour à l'heure (et date) <b> la plus récente </b> pour le(s) système(s) de prévisions sélectionné(s).  <br> ";
           Aide_text = Aide_text + " L' <b> interval </b> de temps (pas de temps d'animation, et période d'accumulation des précipitation) sera ajusté à la valeur la <b> plus courte possible </b>,  selon les choix de systèmes de prévisions, du possible décallage de leurs date d'origine, et de carte météo. <br> ";
           Aide_text = Aide_text + " Le <b> Début </b> de l'animation sera ajusté à <b> la valeur la plus petite possible </b>,  selon les choix de systèmes de prévisions, du possible décallage de leurs dates d'origines et de leurs carte météo, et de l'interval. <br> ";
           Aide_text = Aide_text + " Enfin, la <b> Fin </b> de l'animation sera ajusté à <b> la valeur la plus grande possible </b>,  selon les choix de systèmes de prévisions, du possible décallage de leurs dates d'origines, des cartes météo, et de l'interval, ainsi que du début. <br> ";
           
     } else if ( aideCode == "ResetTimeMenus"  && WindMaps) {
           Aide_text = " Bouton Init. Temps  (vent)<br><br>";
           Aide_text = Aide_text + " Ce Bouton permet, d'une seule touche de mettre à jour les paramètres suivants: <br> <br>"; 
           Aide_text = Aide_text + " La <b> date d'origine </b> sera mise à jour à l'heure (et date) <b> la plus récente </b> pour le(s) secteur(s) sélectionné(s).  <br> ";
           Aide_text = Aide_text + " Le <b> Début </b> de l'animation sera ajusté à <b> la valeur la plus petite possible </b>,  selon le possible décallage de temps entre les dates d'origines des couche 1 et 2  et de l'interval. <br> ";
           Aide_text = Aide_text + " Enfin, la <b> Fin </b> de l'animation sera ajusté à <b> la valeur la plus grande possible </b> <br> ";

    } else if ( aideCode == "DuoA" ) {
           Aide_text = " Bouton DuoA <br><br>";
           Aide_text = Aide_text + " Ce bouton permet, d'une seule touche, d'obtenir un panneau de boutons offrant des associations <b> Cartes Météo. </b>  Il s'agit de raccourcis par rapport à l'utilisation des menus  <b> Syst. Prev. et Cartes Météo </b>. <br> <br>"; 
           Aide_text = Aide_text + " La <b> date d'origine </b> ainsi que les autres paramètres de temps (interval,prog de début et de fin,  etc) ne seront ajustés qu'en cas de nécéssité seulement.  Ainsi, lorsque l'on passe du système Global GDPS à un Système HRDPS, par exemple, la date d'origine pourrait ne pas être la plus récente,   et l'interval de temps pour les accumulations de précipitations/pour les pas de temps de l'animation pourraient ne pas être ceux qui sont désirés. On peut toujours corrigé au moyen des menus,   ou y aller d'un seul coup avec le bouton voisin <b> Init. T. </b>  qui rétablira les valeurs typiques.";

    } else if ( aideCode == "DuoB" ) {
           Aide_text = " Bouton DuoB <br><br>";
           Aide_text = Aide_text + " Ce bouton permet, d'une seule touche, d'obtenir un panneau de boutons des sélections pour <b> comparaisons (ou de juxtaposition) de Systèmes de prévisions </b>.  Il s'agit de raccourcis par rapport àl'utilisation des menus <b> Syst. Prev. et Cartes Météo </b>. Dans la majorité des cas,  l'intercalage des cartes sera sélectionné automatiquement. L'essayer c'est l'adopter !  <br> <br>"; 
           Aide_text = Aide_text + " La <b> date d'origine </b> ainsi que les autres paramètres de temps (interval,prog de début et de fin,  etc) ne seront ajustés qu'en cas de nécéssité seulement.  Ainsi, lorsque l'on passe du système Global GDPS à un Système HRDPS, par exemple, la date d'origine pourrait ne pas être la plus récente,   et l'interval de temps pour les accumulations de précipitations/pour les pas de temps de l'animation pourraient ne pas être ceux qui sont désirés. On peut toujours corrigé au moyen des menus,   ou y aller d'un seul coup avec le bouton voisin <b> Init. T. </b>  qui rétablira les valeurs typiques.";

    } else if ( aideCode == "DuoC" ) {
           Aide_text = " Button DuoC <br><br>";
           Aide_text = Aide_text + " Ce bouton permet, d'une seule touche, d'obtenir un panneau de boutons des sélections de produits";
           Aide_text = Aide_text + "  <b> d états de la mer </b>. Il s'agit de raccourcis par rapport à l'utilisation des menus";
           Aide_text = Aide_text + "  <b> Syst. Prev. et Cartes Météo </b>. <br> <br>"; 
           Aide_text = Aide_text + " Dans la majorité des cas,  l'intercalage des cartes sera sélectionné automatiquement.";
           Aide_text = Aide_text + " La <b> date d'origine </b> ainsi que les autres paramètres de temps (interval,prog de début et de fin,  etc)";
           Aide_text = Aide_text + " ne seront ajustés qu'en cas de nécéssité seulement. Les dates d'origine ajustées automatiquement pourraient";
           Aide_text = Aide_text + " ne pas etre désirées.  Le modèle de vague (RDWPS)  étant disponible environs trois heures plus tôt,";
           Aide_text = Aide_text + " il faut parfois sélectionner la passe précédente afin d'assurer la cohérence avec le plus récent diagnostique (DIAGW).";

    } else if ( aideCode == "DuoD" ) {
           Aide_text = " Bouton DuoD <br><br>";
           Aide_text = Aide_text + " Ce bouton permet, d'une seule touche, d'obtenir un panneau de boutons offrant des pré sélections pour les <b> couches Cartes météo </b>"; 

    } else if ( aideCode == "DuoN" ) {
           Aide_text = " Bouton DuoN <br><br>";
           Aide_text = Aide_text + " Ce bouton permet, d'une seule touche, d'obtenir un panneau de boutons offrant des pré sélections pour les <b> couches Satellites et Radar</b>.  Il s'agit de raccourcis par rapport à l'utilisation des menus <b> Secteur (zoom) et Cartes Météo </b>."; 

    } else if ( aideCode == "Archives") {
        Aide_text = " Bouton Archives <br><br>";
         Aide_text = Aide_text + " Ce bouton permet de revenir en arrière afin de comparer les performance récentes des systèmes de prévisions.  Ce n'est qu'u essai pour le moment. En mode  <b> Archives </b>,  le nombre de <b> Carte Météo </b> sera limité,  mais l'historique de temps de départs, offert au menu <b> Dates d'origine </b>, est beaucoup plus généreux.";

    } else if ( aideCode == "Loc") {
        Aide_text = " Bouton Loc <br><br>";
         Aide_text = Aide_text + " Ce bouton permet d activer des <b> marqueurs (Marker) de localisation </b> sur les cartes météo.  Il y a 2 marqueurs:  un noirxi et blanc et un deuxième qui est noir et rouge. Ces marqueurs peuvent être positionnés selon votre préférence: soit avec la souris (grab & move),  ou à l aide des zones d entrées de données pour les longitudes et latitudes. Ces zones d entrées de données sont situés juste en dessous du bouton Loc. Les localisations que vous choisissez au cours d'une session sur un ordinateur/tablette/téléphone sont conservées sur l'appareil,  et elles vous seront offertes lors d'une session ultérieur sur cet appareil en particulier, si vous activez à nouveau les marqueurs.";


    } else if ( aideCode == "AllerDebut" ) {
           Aide_text = " Aller directement <b> au début </b> de l'animation. <br> <br>";
    } else if ( aideCode == "AllerFin" ) {
           Aide_text = " Aller directement <b> à la fin </b> de l'animation. <br> <br>";
    } else if ( aideCode == "Arreter" ) {
           Aide_text = " <b> Arrêt ou démarrage </b> de l'animation. <br> <br>";
    } else if ( aideCode == "Demarrer" ) {
           Aide_text = " <b> Arrêt ou démarrage </b> de l'animation. <br> <br>";
    } else if ( aideCode == "Avance" ) {
           Aide_text = " <b> Avancer d'un pas  </b> dans l'animation. <br> <br>";
    } else if ( aideCode == "Recule" ) {
          Aide_text = " <b> Reculer d'un pas  </b> dans l'animation. <br> <br>";
    } else if ( aideCode == "Ralentir" ) {
           Aide_text = " <b> Ralentir </b> l'animation. <br> <br>";
           Aide_text = Aide_text + " - Avec un clique la cadence diminue d'un facteur 1.26 environs <br>";
           Aide_text = Aide_text + " - Avec 3 cliques, la cadence diminue d'un facteur 2. <br>";
    } else if ( aideCode == "Accelerer" ) {
           Aide_text = " <b> Accélérer </b> l'animation. <br> <br>";
           Aide_text = Aide_text + " - À chaque clique, la cadence se augmente d'un facteur 2.   <br>";  
    } else if ( aideCode == "Last" ) {
           Aide_text = " <b> Revenir à l'image précédente dans la séquence d'animation </b> <br> <br>";
           
    }

 if ( !WindMaps ) { 
  Aide_text = Aide_text + " <br> Pour changer le sujet de l aide ,  il suffit de cliquer <b> au dessus </b> d'un bouton ou d'un menu sur le symbole <b> ? </b>.<br>";
  Aide_text = Aide_text + " Pour désactiver ce mode,  il suffit de cliquer à nouveau sur l'interrupteur d'aide. <br>";
  Aide_text = Aide_text + " <br> Plus de détails sont disponibles dans la <a href='../image_res/documentation_imeteomaps_latest.htm' target='_blank'> documentation</a> ";
 } 
document.getElementById("afficher_aide").innerHTML=" <b> Aide: </b> " + Aide_text;

}

////
//-----------------------------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
//
 $("#helpLabel1").click(function(){ affiche_aide("Label1"); });
 $("#helpLabel2").click(function(){ affiche_aide("Label2"); });
 $("#helpCouche1Model").click(function(){ affiche_aide("Couche1Model"); });
 $("#helpCouche2Model").click(function(){ affiche_aide("Couche2Model"); });
 $("#helpCouche1Carte").click(function(){ affiche_aide("Couche1Carte"); });
 $("#helpCouche2Carte").click(function(){ affiche_aide("Couche2Carte"); });
 $("#helpCoucheCo1Carte").click(function(){ affiche_aide("CoucheCo1Carte"); });
 $("#helpCoucheCo2Carte").click(function(){ affiche_aide("CoucheCo2Carte"); });
 $("#helpCouche1Dateo").click(function(){ affiche_aide("Couche1Dateo"); });
 $("#helpCouche2Dateo").click(function(){ affiche_aide("Couche2Dateo"); });
 $("#helpCouche1Valeurs").click(function(){ affiche_aide("Couche1Valeurs"); });
 $("#helpCouche2Valeurs").click(function(){ affiche_aide("Couche2Valeurs"); });
 $("#helpCouche1Opacit").click(function(){ affiche_aide("Couche1Opacit"); });
 $("#helpCouche2Opacit").click(function(){ affiche_aide("Couche2Opacit"); });
 $("#helpAnimMode").click(function(){ affiche_aide("AnimMode"); });
 $("#helpCoucheAffichage").click(function(){ affiche_aide("CoucheAffichage"); });
 $("#helpViewProjection").click(function(){ affiche_aide("ViewProjection"); });
 $("#helpInterval").click(function(){ affiche_aide("Interval"); });
 $("#helpDebut").click(function(){ affiche_aide("Debut"); });
 $("#helpFin").click(function(){ affiche_aide("Fin"); });
 $("#helpResetTimeMenus").click(function(){ affiche_aide("ResetTimeMenus"); });
 $("#helpDuoA").click(function(){ affiche_aide("DuoA"); });
 $("#helpDuoB").click(function(){ affiche_aide("DuoB"); });
 $("#helpDuoC").click(function(){ affiche_aide("DuoC"); });
 $("#helpDuoD").click(function(){ affiche_aide("DuoD"); });
 $("#helpDuoN").click(function(){ affiche_aide("DuoN"); });
// $("#helpArchives").click(function(){ affiche_aide("Archives"); });
 $("#helpLoc").click(function(){ affiche_aide("Loc"); });


var Helpswitch = document.getElementById("helpswitch");
var Helpswitchlabel = document.getElementById("helpswitchlabel");
Helpswitchlabel.style.backgroundColor = "#fffff";

var HelpClass = document.getElementsByClassName("help");
var HelpClass0 = document.getElementsByClassName("help0");
var HelpClass2 = document.getElementsByClassName("help2");
var HelpClass3 = document.getElementsByClassName("help3");

        for (var i = 0; i < HelpClass.length; i++) {
           HelpClass[i].style.backgroundColor = "#ffffff";
           HelpClass[i].style.display = "none";
         }
        for (var i = 0; i < HelpClass0.length; i++) {
           HelpClass0[i].style.backgroundColor = "#ffffff";
           HelpClass0[i].style.display = "none";
         }
        for (var i = 0; i < HelpClass2.length; i++) {
           HelpClass2[i].style.backgroundColor = "#ffffff";
           HelpClass2[i].style.display = "none";
         }
        for (var i = 0; i < HelpClass3.length; i++) {
           HelpClass3[i].style.backgroundColor = "#ffffff";
           HelpClass3[i].style.display = "none";
         }
////
//____________________________________________________________________________________________________
//
//

function switch_help() {
  if (Helpswitch.checked == true){
    Helpswitchlabel.style.backgroundColor = "#fefbd8";  
    for (var i = 0; i < HelpClass.length; i++) {
           HelpClass[i].style.backgroundColor = "#f1f1f1";
           HelpClass[i].style.display = "block";
           affiche_aide("start");
    }
    for (var i = 0; i < HelpClass0.length; i++) {
           HelpClass0[i].style.backgroundColor = "#f1f1f1";
           HelpClass0[i].style.display = "block";
           affiche_aide("start");
    }
    if ( !WindMaps ) {

        for (var i = 0; i < HelpClass2.length; i++) {
           HelpClass2[i].style.backgroundColor = "#f1f1f1";
           HelpClass2[i].style.display = "block";
           affiche_aide("start");
        }
        for (var i = 0; i < HelpClass3.length; i++) {
           HelpClass3[i].style.backgroundColor = "#f1f1f1";
           HelpClass3[i].style.display = "block";
           affiche_aide("start");
        }
    } else {

          for (var i = 0; i < HelpClass3.length; i++) {
           HelpClass3[i].style.backgroundColor = "#f1f1f1";
           HelpClass3[i].style.display = "block";
           affiche_aide("start");
          }
    }
    
  } else {
    Helpswitchlabel.style.backgroundColor = "#f1f1f1";
        for (var i = 0; i < HelpClass.length; i++) {
           HelpClass[i].style.backgroundColor = "#f1f1f1";
           HelpClass[i].style.display = "none";
         }
        for (var i = 0; i < HelpClass0.length; i++) {
           HelpClass0[i].style.backgroundColor = "#f1f1f1";
           HelpClass0[i].style.display = "none";
         }
    if ( !WindMaps ) {

         for (var i = 0; i < HelpClass2.length; i++) {
           HelpClass2[i].style.backgroundColor = "#f1f1f1";
           HelpClass2[i].style.display = "none";
         }
         for (var i = 0; i < HelpClass3.length; i++) {
           HelpClass3[i].style.backgroundColor = "#f1f1f1";
           HelpClass3[i].style.display = "none";
         }

    } else {
         for (var i = 0; i < HelpClass3.length; i++) {
           HelpClass3[i].style.backgroundColor = "#f1f1f1";
           HelpClass3[i].style.display = "none";
         }

    }
  }
}

// -----------------------------------------------------------------------------------
//
 $("#helpswitch").click(function(){ switch_help(); });

////var ArchivesSwitch = document.getElementById("archivesSwitch");
////var ArchivesSwitchLabel = document.getElementById("archivesSwitchlabel");
////ArchivesSwitchLabel.style.backgroundColor = "#fffff";
//____________________________________________________________________________________________________
//

////function switch_archives() {
////  var message=" ";
  ////var couche_change_pas = true;
  ////if (ArchivesSwitch.checked == true){
    ////ArchivesSwitchLabel.style.backgroundColor = "#ff3300";  
    ////ArchivesVerif = true;
    ////Tronc = 'maps_archives';
      ////message=" l archives est activees:  le tronc sera: " +  Tronc;
      ////console.log(message);
         ////ModAInterv.set("RDPS", 360);
         ////ModAInterv.set("GDPS", 720);
         ////ModAInterv.set("GDPSE", 720);
         ////ModAInterv.set("GFS", 720);
         ////ModAInterv.set("AIFS", 720);
         ////ModAInterv.set("AIFSE", 720);
         ////ModAInterv.set("ECMWF", 720);
         ////ModAInterv.set("ECMWFE", 720);
         ////ModAInterv.set("ECMWF3", 360);
         ////ModADebut.set("RDPS", 360);
         ////ModADebut.set("GDPS", 720);
         ////ModADebut.set("GDPSE", 720);
         ////ModADebut.set("GFS", 720);
         ////ModADebut.set("AIFS", 720);
         ////ModADebut.set("AIFSE", 720);
         ////ModADebut.set("ECMWF", 720);
         ////ModADebut.set("ECMWFE", 720);
         ////ModADebut.set("ECMWF3", 360);
         ////ModADebut.set("GOESR NE", 60);
         ////ModADebut.set("GOESR CO", 60);
         ////ModADebut.set("GOESR_PLUS", 60);
         ////ModADebut.set("FOUDRE CO", 60);
         ////ModADebut.set("RADAR NE", 60);
         ////ModADebut.set("RADAR CO", 60);
         ////IntercaSelect.options.selectedIndex = 0;
         ////updateIntercaFromMenu("refresh");
         ////couche_change_pas = setMenuMapIdH(1,   MapIdH1Select );
         ////couche_change_pas = setMenuMapIdH(2,   MapIdH2Select );
     ////resetTimeMenus();

  ////} else {
    ////ArchivesSwitchLabel.style.backgroundColor = "#f1f1f1";
    ////ArchivesVerif = false;
    ////Tronc = 'maps';
      ////message=" l archive est desactivees:  le tronc sera: " +  Tronc;
      ////console.log(message);
         ////ModAInterv.set("RDPS", 180);
         ////ModAInterv.set("GDPS", 360);
         ////ModAInterv.set("GDPSE", 360);
         ////ModAInterv.set("GFS", 360);
         ////ModAInterv.set("AIFS", 360);
         ////ModAInterv.set("AIFSE", 360);
         ////ModAInterv.set("ECMWF", 360);
         ////ModAInterv.set("ECMWFE", 360);
         ////ModAInterv.set("ECMWF3", 180);
         ////ModADebut.set("RDPS", 180);
         ////ModADebut.set("GDPS", 360);
         ////ModADebut.set("GDPSE", 360);
         ////ModADebut.set("GFS", 360);
         ////ModADebut.set("AIFS", 360);
         ////ModADebut.set("AIFSE", 360);
         ////ModADebut.set("ECMWF", 360);
         ////ModADebut.set("ECMWFE", 360);
         ////ModADebut.set("ECMWF3", 180);
         ////ModADebut.set("GOESR NE", 60);
         ////ModADebut.set("GOESR CO", 60);
         ////ModADebut.set("GOESR_PLUS", 60);
         ////ModADebut.set("FOUDRE CO", 60);
         ////ModADebut.set("RADAR NE", 60);
         ////ModADebut.set("RADAR CO", 60);
         ////couche_change_pas = setMenuMapIdH(1,   MapIdH1Select );
         ////couche_change_pas = setMenuMapIdH(2,   MapIdH2Select );
     ////resetTimeMenus();
  ////}
////}

// -----------------------------------------------------------------------------------
//
////if ( WindMaps ) {

////   document.getElementById("archivesSwitchlabel").style.display = "none";
////   document.getElementById("archivesSwitch").style.display = "none";
////} else {
//// $("#archivesSwitch").click(function(){  switch_archives();  });
//}

//   Loc Loc   for marker controls from switch...

var LocActif = false;
var LocSwitch = document.getElementById("locSwitch");
var LocSwitchLabel = document.getElementById("locSwitchlabel");
LocSwitchLabel.style.backgroundColor = "#fffff";
//____________________________________________________________________________________________________
//

function switch_loc() {
  var message=" ";
  if (LocSwitch.checked == true){
    LocSwitchLabel.style.backgroundColor = "#ffCC00";  
    LocActif = true;
      message=" la switch loc est  activees ";
      console.log(message);
      document.getElementById("longitudeALabel").style.display = "block";
      document.getElementById("longitudeBLabel").style.display = "block";
      document.getElementById("latitudeALabel").style.display = "block";
      document.getElementById("latitudeBLabel").style.display = "block";
      document.getElementById("longitudeA").style.display = "block";
      document.getElementById("longitudeB").style.display = "block";
      document.getElementById("latitudeA").style.display = "block";
      document.getElementById("latitudeB").style.display = "block";
      MiseAJourFeaturesFromInputs();
  } else {
    LocSwitchLabel.style.backgroundColor = "#ffffff";
    LocActif = false;
      message=" la switch loc  est desactivees";
      console.log(message);
      document.getElementById("longitudeALabel").style.display = "none";
      document.getElementById("longitudeBLabel").style.display = "none";
      document.getElementById("latitudeALabel").style.display = "none";
      document.getElementById("latitudeBLabel").style.display = "none";
      document.getElementById("longitudeA").style.display = "none";
      document.getElementById("longitudeB").style.display = "none";
      document.getElementById("latitudeA").style.display = "none";
      document.getElementById("latitudeB").style.display = "none";
      MiseEnPauseFeatures();
  }
}

// -----------------------------------------------------------------------------------
//
 switch_loc();
 $("#locSwitch").click(function(){  switch_loc();  });

// ________________________________________________________________________________
        
/* Set the width of the side navigation to 300px and the left margin of the page content to 300px */
function openSideNav() {
  document.getElementById("mySidenav").style.width = "300px";
  document.getElementById("total-wrapper").style.marginLeft = "300px";
    window.dispatchEvent(new Event('resize'));
}

// -----------------------------------------------------------------------------------
//
 $("#openSideNav").click(function(){ openSideNav(); });

/* Set the width of the side navigation to 0 and the left margin of the page content to 0 */
function closeSideNav() {
  document.getElementById("mySidenav").style.width = "0";
  document.getElementById("total-wrapper").style.marginLeft = "0";
    window.dispatchEvent(new Event('resize'));
}
// -----------------------------------------------------------------------------------
//
 $("#closeSideNav").click(function(){ closeSideNav(); });

// ________________________________________________________________________________
        
//
function closeChoixDuo(lettre) {
    if ( lettre == "A" )  {
          document.getElementById("choixDuoA").style.display = "none";
    } else if ( lettre == "B" ) {
          document.getElementById("choixDuoB").style.display = "none";
    } else if ( lettre == "C" ) {
          document.getElementById("choixDuoC").style.display = "none";
    } else if ( lettre == "D" ) {
          document.getElementById("choixDuoD").style.display = "none";
    } else if ( lettre == "N" ) {
          document.getElementById("choixDuoN").style.display = "none";
    } else {
      document.getElementById("choixDuoA").style.display = "none";
      document.getElementById("choixDuoB").style.display = "none";
      document.getElementById("choixDuoC").style.display = "none";
      document.getElementById("choixDuoD").style.display = "none";
      document.getElementById("choixDuoN").style.display = "none";
    }
    if ( ActiveLoop  ) {   StartAnimate(); }
}
// -----------------------------------------------------------------------------------
//
 $("#closeChoixDuoA").click(function(){ closeChoixDuo("A"); });
 $("#closeChoixDuoB").click(function(){ closeChoixDuo("B"); });
 $("#closeChoixDuoC").click(function(){ closeChoixDuo("C"); });
 $("#closeChoixDuoD").click(function(){ closeChoixDuo("D"); });
 $("#closeChoixDuoN").click(function(){ closeChoixDuo("N"); });

// ________________________________________________________________________________
//
function ChoixDuo(model2, mapId2, mapIdCo2, model1, mapId1, mapIdCo1, superpo) {

    ChoixDuoEnCour = true;
    //DesactiveAndStopAnimate();

    var indice =0;
    var indice_trouve1 =0;
    var indice_trouve2 =0;
    var trouve1 = false;
    var trouve2 = false;
    var indice_trouveCo1 =0;
    var indice_trouveCo2 =0;
    var trouveCo1 = false;
    var trouveCo2 = false;

    for ( let indice = 0; indice < ModeleZoom1Select.options.length; indice++ ) {

            if ( model1  == ModeleZoom1Select.options[indice].value ) {
                indice_trouve1= indice;
                trouve1=true;
            }
    }
    for ( let indice = 0; indice < ModeleZoom2Select.options.length; indice++ ) {

            if ( model2  == ModeleZoom2Select.options[indice].value ) {
                indice_trouve2= indice;
                trouve2=true;
            }
    }

    var oldMapIdH = Couche1.mapIdH;
       
    if ( WindMaps ) {
        if ( ( oldMapIdH.indexOf("WDIR") != -1 ) && ( oldMapIdH.indexOf("WIN") == -1 ) ) {

                      OpaciteSelect1.options.selectedIndex = OpaciteSelect1.options.length - 1;
                      Opacitee1 = parseInt( OpaciteSelect1.options[OpaciteSelect1.options.selectedIndex].value )/10. ;
        }

        if ( ( mapId1.indexOf("WDIR") != -1) && ( mapId1.indexOf("WIN") == -1 ) && ( Couche2.modeleZoom != "void" ) ) {

                      OpaciteSelect1.options.selectedIndex = OpaciteSelect1.options.length - 1;
                      Opacitee1 = parseInt( OpaciteSelect1.options[OpaciteSelect1.options.selectedIndex].value )/10. ;
        }
    }

    if ( trouve1 && trouve2 ) {

        Couche1.mapIdH = mapId1;
        Couche1.mapIdCo = mapIdCo1;
        ModeleZoom1Select.options.selectedIndex = indice_trouve1;
        Couche2.mapIdH = mapId2;
        Couche2.mapIdCo = mapIdCo2;
        ModeleZoom2Select.options.selectedIndex = indice_trouve2;
        updateModeleZoomFromMenu(0);

        let nowcast1=isNowcast( Couche1.getModeleZoom() );
        if ( nowcast1 ) {
            updateDebut(-60);
        }
        console.log(" Modele Zoom trouvees: ", model1, model2);

        trouve1=false;
        indice_trouve1 =0;
        for ( let indice = 0; indice < MapIdH1Select.options.length; indice++ ) {
                   if ( mapId1  == MapIdH1Select.options[indice].value ) {
                                                indice_trouve1 = indice;
                                                trouve1=true;
              }
        }
        trouveCo1=false;
        indice_trouveCo1 =0;
        if ( mapIdCo1  == "void" ) { 
            trouveCo1=true;
        } else {
           for ( let indice = 0; indice < MapIdCo1Select.options.length; indice++ ) {
                 if ( mapIdCo1  == MapIdCo1Select.options[indice].value ) {
                                                indice_trouveCo1 = indice;
                                                trouveCo1=true;
              }
           }
        }
        trouve2=false;
        indice_trouve2 =0;
        if ( mapId2  == "void" ) { 
            trouve2=true;
        } else {
        for ( let indice = 0; indice < MapIdH2Select.options.length; indice++ ) {
                   if ( mapId2  == MapIdH2Select.options[indice].value ) {
                        indice_trouve2 = indice;
                        trouve2=true;
            }
         }
        }
        trouveCo2=false;
        indice_trouveCo2 =0;
        if ( mapIdCo2  == "void" ) { 
            trouveCo2=true;
        } else {
        for ( indice = 0; indice < MapIdCo2Select.options.length; indice++ ) {
               if ( mapIdCo2  == MapIdCo2Select.options[indice].value ) {
                        indice_trouveCo2 = indice;
                        trouveCo2=true;
            }
         }
        }
        if ( trouve1 && trouveCo1 && trouve2 && trouveCo2 ) {
 
           // superpo vaut 0  ou 1
           //  le cas 0 est sans superposition,  et donc intercallé (menu 0)  OU justaposé (menu 2)

            if ( superpo == 1 ) {
               if ( IntercaSelect.options.selectedIndex != 1 ) {
                                IntercaSelect.options.selectedIndex = superpo;
                                updateIntercaFromMenu("refresh");
               }
            } else {
               if ( IntercaSelect.options.selectedIndex == 1 ) {
                                IntercaSelect.options.selectedIndex = 2; 
                                updateIntercaFromMenu("refresh");
               }
            }
            console.log(" MapId trouvees: ", mapId1, mapIdCo1, mapId2, mapIdCo2 );
            closeChoixDuo("ALL");

        if ( ActiveLoop  ) {   StartAnimate(); }
        
        } else {
            alert("ChoixDuo pas trouve mapid couche 1: " + mapId1 + " ou couche 2: " + mapId2 );
        }
    } else {
       alert("ChoixDuo pas trouve model couche 1: " + model1 + " ou couche 2: " + model2 );
    }
    let modele1 = Couche1.getModeleZoom();
    let modele2 = Couche2.getModeleZoom();

    let nowcast1=isNowcast(modele1);
    let nowcast2=isNowcast(modele2);
    
    if ( WindMaps ) {
       localStorage.setItem("Model1_V", Couche1.modeleZoom);
       localStorage.setItem("Model2_V", Couche1.modeleZoom);
       localStorage.setItem("MapIdH1_V", Couche1.mapIdH);
       localStorage.setItem("MapIdH2_V", Couche2.mapIdH);
       localStorage.setItem("MapIdCo1_V", Couche1.mapIdCo);
       localStorage.setItem("MapIdCo2_V", Couche2.mapIdCo);
    }  else if (( Nowcast && (nowcast1 || nowcast2) ) || ( ModelMode && nowcast1 && nowcast2) ) {
       localStorage.setItem("Model1_N", Couche1.modeleZoom);
       localStorage.setItem("Model2_N", Couche2.modeleZoom);
       localStorage.setItem("MapIdH1_N", Couche1.mapIdH);
       localStorage.setItem("MapIdH2_N", Couche2.mapIdH);
       localStorage.setItem("MapIdCo1_N", Couche1.mapIdCo);
       localStorage.setItem("MapIdCo2_N", Couche2.mapIdCo);
    }  else {
       localStorage.setItem("Model1", Couche1.modeleZoom);
       localStorage.setItem("Model2", Couche2.modeleZoom);
       localStorage.setItem("MapIdH1", Couche1.mapIdH);
       localStorage.setItem("MapIdH2", Couche2.mapIdH);
       localStorage.setItem("MapIdCo1", Couche1.mapIdCo);
       localStorage.setItem("MapIdCo2", Couche2.mapIdCo);
    }
    ChoixDuoEnCour = false;
}

// -----------------------------------------------------------------------------------
//
// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//


if ( WindMaps ) {

   document.getElementById("ChoixDuoA").style.display = "none";
   document.getElementById("ChoixDuoB").style.display = "none";
   document.getElementById("ChoixDuoN").style.display = "none";
} else {

   document.getElementById("ChoixDuoC").style.display = "none";
}

// DuoD  pour vents sur sud du quebec

 $("#HRDPSve10mvd10m").click(function(){ ChoixDuo("void", "void", "void", "HRDPS S0",   "WIN-_10", "WDIR_10", 1); });
 $("#HRDPSvp10mvd10m").click(function(){ ChoixDuo("void", "void", "void", "HRDPS S0",   "WIND_10", "WDIR_10", 1); });
 $("#HRDPSvd10m").click(function(){ ChoixDuo("void", "void", "void", "HRDPS S0",   "WDIR_10", "void", 1); });
 $("#HRDPSvr10m").click(function(){ ChoixDuo("void", "void", "void", "HRDPS S0",   "GUST_10", "void", 1); });
 $("#HRDPSve10m").click(function(){ ChoixDuo("void", "void", "void", "HRDPS S0",   "WIN-_10", "void", 1); });
 $("#HRDPSvp10m").click(function(){ ChoixDuo("void", "void", "void", "HRDPS S0",   "WIND_10", "void", 1); });

 $("#WCPSCSPEED").click(function(){ ChoixDuo("void", "void", "void", "WCPS", "CSPEED_0.5", "CDIR_0.5", 1); });
 $("#WCPSCDIR").click(function(){ ChoixDuo("void", "void", "void", "WCPS", "CDIR_0.5", "void", 1); });
 $("#WCPSCSPEEDCDIR").click(function(){ ChoixDuo("void", "void", "void", "WCPS", "CSPEED_0.5", "CDIR_0.5", 1); });

 $("#WCPSCSPEEDCDIRHRDPSve10mvd10m").click(function(){ ChoixDuo( "WCPS", "CSPEED_0.5", "CDIR_0.5", "HRDPS S0",   "WIN-_10", "WDIR_10", 0); });
 $("#WCPSCDIRHRDPSvd10m").click(function(){ ChoixDuo( "WCPS", "CDIR_0.5", "void", "HRDPS S0",  "WDIR_10", "void", 0); });

 $("#WCPSWLvl").click(function(){ ChoixDuo("void", "void", "void", "WCPS", "SOSSHEIG_", "void", 1); }); 
 $("#WCPSTTp5m").click(function(){ ChoixDuo("void", "void", "void", "WCPS", "VOTEMPER_0.5", "void", 1); }); 
 $("#WCPSIcc").click(function(){ ChoixDuo("void", "void", "void", "WCPS", "IICECONC_", "void", 1); }); 
 $("#WCPSWCPSTTp5mIcc").click(function(){ ChoixDuo("WCPS", "VOTEMPER_0.5", "void", "WCPS", "IICECONC_", "void", 1); }); 

//  DuoA combinaison de cartes pour un modèle    ET DuoB comparaison de modèles:
 
 $("#RDPSRDPScompoTCDC").click(function(){ ChoixDuo("RDPS",   "TCDC_", "HGT_500", "RDPS", "COMPO__h", "PRMSL_", 1); });
 $("#HRDEHRDEcompoTCDC").click(function(){ ChoixDuo("HRDPS E","TCDC_", "HGT_500", "HRDPS E", "COMPO__h", "PRMSL_", 1); });
 $("#GDPSGDPScompoTCDC").click(function(){ ChoixDuo("GDPS",   "TCDC_", "HGT_500", "GDPS",    "COMPO__h", "PRMSL_", 1); });
 $("#GFSGFScompoTCDC").click(function(){   ChoixDuo("GFS",   "TCDC_", "HGT_500", "GFS",    "COMPO__h", "PRMSL_", 1); });
 $("#ECMWFECMWFcompoTCDC").click(function(){ChoixDuo("ECMWF", "COMPO__h", "HGT_500", "ECMWF", "COMPO__h", "PRMSL_", 1); });
 $("#AIFSAIFScompoTCDC").click(function(){  ChoixDuo("AIFS",  "TCDC_", "HGT_500", "AIFS",    "COMPO__h", "PRMSL_", 1); });

 $("#HRDPSERDPScompo").click(function(){ ChoixDuo("HRDPS E", "COMPO__h", "PRMSL_", "RDPS", "COMPO__h", "PRMSL_", 0); });
 $("#GDPSRDPScompo").click(function(){ ChoixDuo("GDPS", "COMPO__h", "PRMSL_", "RDPS", "COMPO__h", "PRMSL_", 0); });
 $("#GFSGDPScompo").click(function(){ ChoixDuo("GFS", "COMPO__h", "PRMSL_", "GDPS", "COMPO__h", "PRMSL_", 0); });
 $("#ECMWFGDPScompo").click(function(){ ChoixDuo("ECMWF", "COMPO__h", "PRMSL_", "GDPS", "COMPO__h", "PRMSL_", 0); });
 $("#AIFSGDPScompo").click(function(){ ChoixDuo("AIFS", "COMPO__h", "PRMSL_", "GDPS", "COMPO__h", "PRMSL_", 0); });

 $("#RDPSRDPScompoSNOW").click(function(){ ChoixDuo("RDPS",   "WEASN__h", "PRMSL_", "RDPS",    "COMPO__h", "PRMSL_", 0); });
 $("#HRDEHRDEcompoSNOW").click(function(){ ChoixDuo("HRDPS E","WEASN__h", "PRMSL_", "HRDPS E", "COMPO__h", "PRMSL_", 0); });
 $("#GDPSGDPScompoSNOW").click(function(){ ChoixDuo("GDPS",   "WEASN__h", "PRMSL_", "GDPS",    "COMPO__h", "PRMSL_", 0); });
 $("#GFSGFScompoSNOW").click(function(){   ChoixDuo("GFS",    "WEASN__h", "PRMSL_", "GFS",     "COMPO__h", "PRMSL_", 0); });
 $("#ECMWFECMWFcompoSNOW").click(function(){ChoixDuo("ECMWF", "WEASN__h", "PRMSL_", "ECMWF",   "COMPO__h", "PRMSL_", 0); });
 $("#AIFSAIFScompoSNOW").click(function(){  ChoixDuo("AIFS",  "WEASN__h", "PRMSL_", "AIFS",    "COMPO__h", "PRMSL_", 0); });
 
 $("#HRDPSERDPSSNOW").click(function(){ ChoixDuo("HRDPS E", "WEASN__h", "PRMSL_", "void", "RDPS", "WEASN__h", "PRMSL_", 0); });
 $("#GDPSRDPSSNOW").click(function(){ ChoixDuo("GRDPS", "WEASN__h", "PRMSL_", "RDPS", "WEASN__h", "PRMSL_", 0); });
 $("#GFSGDPSSNOW").click(function(){ ChoixDuo("GFS", "WEASN__h", "PRMSL_", "GDPS", "WEASN__h", "PRMSL_", 0); });
 $("#ECMWFGDPSSNOW").click(function(){ ChoixDuo("ECMWF", "WEASN__h", "PRMSL_", "GDPS", "WEASN__h", "PRMSL_", 0); });
 $("#AIFSGDPSSNOW").click(function(){ ChoixDuo("AIFS", "WEASN__h", "PRMSL_", "GDPS", "WEASN__h", "PRMSL_", 0); });

 $("#RDPSRDPScompoFRZR").click(function(){ ChoixDuo("RDPS",   "WEAFR__h", "PRMSL_", "RDPS",    "COMPO__h", "PRMSL_", 0); });
 $("#HRDEHRDEcompoFRZR").click(function(){ ChoixDuo("HRDPS E","WEAFR__h", "PRMSL_", "HRDPS E", "COMPO__h", "PRMSL_", 0); });
 $("#GDPSGDPScompoFRZR").click(function(){ ChoixDuo("GDPS",   "WEAFR__h", "PRMSL_", "GDPS",    "COMPO__h", "PRMSL_", 0); });
 $("#GFSGFScompoFRZR").click(function(){   ChoixDuo("GFS",    "WEAFR__h",  "PRMSL_","GFS",     "COMPO__h", "PRMSL_", 0); });
 $("#ECMWFECMWFcompoFRZR").click(function(){ChoixDuo("ECMWF", "WEAFR__h", "PRMSL_", "ECMWF",   "COMPO__h", "PRMSL_", 0); });
 $("#AIFSAIFScompoFRZR").click(function(){  ChoixDuo("AIFS",  "WEAFR__h", "PRMSL_", "AIFS",    "COMPO__h", "PRMSL_", 0); });

 $("#HRDPSERDPSFRZR").click(function(){ ChoixDuo("HRDPS E", "WEAFR__h", "PRMSL_", "RDPS", "WEAFR__h", "PRMSL_", 0); });
 $("#GDPSRDPSFRZR").click(function(){   ChoixDuo("GDPS",    "WEAFR__h", "PRMSL_", "RDPS", "WEAFR__h", "PRMSL_", 0); });
 $("#GFSGDPSFRZR").click(function(){    ChoixDuo("GFS",     "WEAFR__h", "PRMSL_", "GDPS", "WEAFR__h", "PRMSL_", 0); });
 $("#ECMWFGDPSFRZR").click(function(){  ChoixDuo("ECMWF",   "WEAFR__h", "PRMSL_", "GDPS", "WEAFR__h", "PRMSL_", 0); });
 $("#AIFSGDPSFRZR").click(function(){   ChoixDuo("AIFS",    "WEAFR__h", "PRMSL_", "GDPS", "WEAFR__h", "PRMSL_", 0); });

 $("#RDPSRDPScompoIPIP").click(function(){ ChoixDuo("RDPS",   "WEAPE__h", "PRMSL_", "RDPS",    "COMPO__h", "PRMSL_", 0); });
 $("#HRDEHRDEcompoIPIP").click(function(){ ChoixDuo("HRDPS E","WEAPE__h", "PRMSL_", "HRDPS E", "COMPO__h", "PRMSL_", 0); });
 $("#GDPSGDPScompoIPIP").click(function(){ ChoixDuo("GDPS",   "WEAPE__h", "PRMSL_", "GDPS",    "COMPO__h", "PRMSL_", 0); });
 $("#GFSGFScompoIPIP").click(function(){   ChoixDuo("GFS",    "WEAPE__h", "PRMSL_", "GFS",     "COMPO__h", "PRMSL_", 0); });
 $("#ECMWFECMWFcompoIPIP").click(function(){ChoixDuo("ECMWF", "WEAPE__h", "PRMSL_", "ECMWF",   "COMPO__h", "PRMSL_", 0); });
 $("#AIFSAIFScompoIPIP").click(function(){   ChoixDuo("AIFS", "WEAPE__h", "PRMSL_", "AIFS",    "COMPO__h", "PRMSL_", 0); });

 $("#HRDPSERDPSIPIP").click(function(){ ChoixDuo("HRDPS E", "WEAPE__h", "PRMSL_", "RDPS", "WEAPE__h", "PRMSL_", 0); });
 $("#GDPSRDPSIPIP").click(function(){   ChoixDuo("GDPS",    "WEAPE__h", "PRMSL_", "RDPS", "WEAPE__h", "PRMSL_", 0); });
 $("#GFSGDPSIPIP").click(function(){    ChoixDuo("GFS",     "WEAPE__h", "PRMSL_", "GDPS", "WEAPE__h", "PRMSL_", 0); });
 $("#ECMWFGDPSIPIP").click(function(){  ChoixDuo("ECMWF",   "WEAPE__h", "PRMSL_", "GDPS", "WEAPE__h", "PRMSL_", 0); });
 $("#AIFSGDPSIPIP").click(function(){   ChoixDuo("AIFS",    "WEAPE__h", "PRMSL_", "GDPS", "WEAPE__h", "PRMSL_", 0); });

 $("#RDPSRDPScompoRAIN").click(function(){ ChoixDuo("RDPS",   "WEARN__h", "PRMSL_", "RDPS",    "COMPO__h", "PRMSL_", 0); });
 $("#HRDEHRDEcompoRAIN").click(function(){ ChoixDuo("HRDPS E","WEARN__h", "PRMSL_", "HRDPS E", "COMPO__h", "PRMSL_", 0); });
 $("#GDPSGDPScompoRAIN").click(function(){ ChoixDuo("GDPS",   "WEARN__h", "PRMSL_", "GDPS",    "COMPO__h", "PRMSL_", 0); });
 $("#GFSGFScompoRAIN").click(function(){   ChoixDuo("GFS",    "WEARN__h", "PRMSL_", "GFS",     "COMPO__h", "PRMSL_", 0); });
 $("#ECMWFECMWFcompoRAIN").click(function(){ChoixDuo("ECMWF", "WEARN__h", "PRMSL_", "ECMWF",   "COMPO__h", "PRMSL_", 0); });
 $("#AIFSAIFScompoRAIN").click(function(){   ChoixDuo("AIFS", "WEARN__h", "PRMSL_", "AIFS",    "COMPO__h", "PRMSL_", 0); });

 $("#HRDPSERDPSRAIN").click(function(){ ChoixDuo("HRDPS E", "WEARN__h", "PRMSL_", "RDPS", "WEARN__h", "PRMSL_", 0); });
 $("#GDPSRDPSRAIN").click(function(){   ChoixDuo("GDPS",    "WEARN__h", "PRMSL_", "RDPS", "WEARN__h", "PRMSL_", 0); });
 $("#GFSGDPSRAIN").click(function(){    ChoixDuo("GFS",     "WEARN__h", "PRMSL_", "GDPS", "WEARN__h", "PRMSL_", 0); });
 $("#ECMWFGDPSRAIN").click(function(){  ChoixDuo("ECMWF",   "WEARN__h", "PRMSL_", "GDPS", "WEARN__h", "PRMSL_", 0); });
 $("#AIFSGDPSRAIN").click(function(){   ChoixDuo("AIFS",    "WEARN__h", "PRMSL_", "GDPS", "WEARN__h", "PRMSL_", 0); });

 $("#RDPSRDPSEpaPNPN").click(function(){  ChoixDuo("void","void","void","RDPS", "HGT_1000-500_HGT_1000-500", "PRMSL_", 1); });
 $("#GDPSGDPSEpaPNPN").click(function(){  ChoixDuo("void","void","void","GDPS", "HGT_1000-500_HGT_1000-500", "PRMSL_", 1); });
 $("#GFSGFSEpaPNPN").click(function(){    ChoixDuo("void","void","void","GFS",  "HGT_1000-500_HGT_1000-500", "PRMSL_", 1); });
 $("#ECMWFECMWFEpaPNPN").click(function(){ChoixDuo("void","void","void","ECMWF","HGT_1000-500_HGT_1000-500", "PRMSL_", 1); });
 $("#AIFSAIFSEpaPNPN").click(function(){  ChoixDuo("void","void","void","AIFS", "HGT_1000-500_HGT_1000-500", "PRMSL_", 1); });

 $("#GDPSRDPSEpaPN").click(function(){ ChoixDuo("GDPS","HGT_1000-500_HGT_1000-500", "void","RDPS","HGT_1000-500_HGT_1000-500", "void", 0); });
 $("#GFSGDPSEpaPN").click(function(){ ChoixDuo("GFS",  "HGT_1000-500_HGT_1000-500", "void", "GDPS", "HGT_1000-500_HGT_1000-500", "void", 0); });
 $("#ECMWFGDPSEpaPN").click(function(){ChoixDuo("ECMWF","HGT_1000-500_HGT_1000-500", "void","GDPS", "HGT_1000-500_HGT_1000-500", "void", 0); });
 $("#AIFSGDPSEpaPN").click(function(){ ChoixDuo("AIFS", "HGT_1000-500_HGT_1000-500", "void","GDPS", "HGT_1000-500_HGT_1000-500", "void", 0); });
 
 $("#GFSGDPSdelta500").click(function(){   ChoixDuo("GFS",   "D-HGT_500", "HGT_500", "GDPS", "HGT_500", "void", 1); });
 $("#ECMWFGDPSdelta500").click(function(){ ChoixDuo("ECMWF", "D-HGT_500", "HGT_500", "GDPS", "HGT_500", "void", 1); });
 $("#AIFSGDPSdelta500").click(function(){  ChoixDuo("AIFS",  "D-HGT_500", "HGT_500", "GDPS", "HGT_500", "void", 1); });

 $("#RDPSRDPSLIFXPNGZ500").click(function(){ ChoixDuo("RDPS", "MU-VT-LI_500", "PRMSL_",  "RDPS",    "HGT_500", "void", 1); });
 $("#GDPSGDPSLIFXPNGZ500").click(function(){ ChoixDuo("GDPS", "MU-VT-LI_500", "PRMSL_", "GDPS",    "HGT_500", "void", 1); });
 $("#GDPSRDPSLIFX").click(function(){        ChoixDuo("GDPS", "MU-VT-LI_500", "PRMSL_", "RDPS",    "MU-VT-LI_500", "PRMSL_", 0); });

 $("#RDPSRDPSDPTsfcPNGZ500").click(function(){ ChoixDuo("RDPS", "DPT_sfc", "PRMSL_","RDPS",    "HGT_500", "void", 1); });
 $("#HRDEHRDEDPTsfcPNGZ500").click(function(){ ChoixDuo("HRDPS E", "DPT_sfc", "PRMSL_","HRDPS E", "HGT_500", "void", 1); });
 $("#GDPSGDPSDPTsfcPNGZ500").click(function(){ ChoixDuo("GDPS", "DPT_sfc", "PRMSL_","GDPS",    "HGT_500", "void", 1); });
 $("#ECMWFECMWFDPTsfcPNGZ500").click(function(){ChoixDuo("ECMWF", "DPT_sfc", "PRMSL_","ECMWF",  "HGT_500", "void", 1); });
 $("#AIFSAIFSDPTsfcPNGZ500").click(function(){  ChoixDuo("AIFS", "DPT_sfc", "PRMSL_","AIFS",   "HGT_500", "void", 1); });

 $("#HRDPSERDPSDPTsfc").click(function(){ ChoixDuo("HRDPS E","DPT_sfc", "PRMSL_", "RDPS", "DPT_sfc", "PRMSL_", 0); });
 $("#GDPSRDPSDPTsfc").click(function(){   ChoixDuo("GDPS",   "DPT_sfc", "PRMSL_", "RDPS", "DPT_sfc", "PRMSL_", 0); });
 $("#ECMWFGDPSDPTsfc").click(function(){  ChoixDuo("ECMWF",  "DPT_sfc", "PRMSL_", "GDPS", "DPT_sfc", "PRMSL_", 0); });
 $("#AIFSGDPSDPTsfc").click(function(){   ChoixDuo("AIFS",   "DPT_sfc", "PRMSL_", "GDPS", "DPT_sfc", "PRMSL_", 0); });

 $("#RDPSRDPSTT12mPNGZ500").click(function(){ ChoixDuo("RDPS", "TMP_sfc", "PRMSL_","RDPS",   "HGT_500", "void", 1); });
 $("#HRDEHRDETT12mPNGZ500").click(function(){ ChoixDuo("HRDPS E", "TMP_sfc", "PRMSL_","HRDPS E","HGT_500", "void", 1); });
 $("#GDPSGDPSTT12mPNGZ500").click(function(){ ChoixDuo("GDPS", "TMP_sfc", "PRMSL_","GDPS",   "HGT_500", "void", 1); });
 $("#GFSGFSTT12mPNGZ500").click(function(){   ChoixDuo("GFS", "TMP_sfc", "PRMSL_","GFS",    "HGT_500", "void", 1); });
 $("#ECMWFECMWFTT12mPNGZ500").click(function(){ChoixDuo("ECMWF", "TMP_sfc", "PRMSL_","ECMWF", "HGT_500", "void", 1); });
 $("#AIFSAIFSTT12mPNGZ500").click(function(){ ChoixDuo("AIFS", "TMP_sfc", "PRMSL_","AIFS",   "HGT_500", "void", 1); });

 // $("#HRDPSWHRDPSETT12m").click(function(){ ChoixDuo("HRDPS W", "TMP_sfc", "HRDPS E", "TMP_sfc", 1); });
 $("#HRDPSERDPSTT12m").click(function(){ ChoixDuo("HRDPS E","TMP_sfc","PRMSL_", "RDPS", "TMP_sfc", "PRMSL_",  0); });
 $("#GDPSRDPSTT12m").click(function(){   ChoixDuo("GDPS",   "TMP_sfc","PRMSL_",  "RDPS", "TMP_sfc", "PRMSL_", 0); });
 $("#GFSGDPSTT12m").click(function(){    ChoixDuo("GFS",    "TMP_sfc","PRMSL_",  "GDPS", "TMP_sfc", "PRMSL_", 0); });
 $("#ECMWFGDPSTT12m").click(function(){  ChoixDuo("ECMWF",  "TMP_sfc","PRMSL_",  "GDPS", "TMP_sfc", "PRMSL_", 0); });
 $("#AIFSGDPSTT12m").click(function(){   ChoixDuo("AIFS",   "TMP_sfc","PRMSL_",  "GDPS", "TMP_sfc", "PRMSL_", 0); });
 
 $("#RDPSRDPSTT850PNGZ500").click(function(){ ChoixDuo("RDPS", "TMP_850", "PRMSL_","RDPS",   "HGT_500", "void", 1); });
 $("#HRDEHRDETT850PNGZ500").click(function(){ ChoixDuo("HRDPS E", "TMP_850", "PRMSL_","HRDPS E","HGT_500", "void", 1); });
 $("#GDPSGDPSTT850PNGZ500").click(function(){ ChoixDuo("GDPS", "TMP_850", "PRMSL_","GDPS",   "HGT_500", "void", 1); });
 $("#GFSGFSTT850PNGZ500").click(function(){   ChoixDuo("GFS", "TMP_850", "PRMSL_","GFS",    "HGT_500", "void", 1); });
 $("#ECMWFECMWFTT850PNGZ500").click(function(){ChoixDuo("ECMWF","TMP_850", "PRMSL_","ECMWF",  "HGT_500", "void", 1); });
 $("#AIFSAIFSTT850PNGZ500").click(function(){  ChoixDuo("AIFS","TMP_850", "PRMSL_","AIFS",   "HGT_500", "void", 1); });

 $("#HRDPSERDPSTT850").click(function(){ ChoixDuo("HRDPS E","TMP_850", "PRMSL_", "RDPS", "TMP_850", "PRMSL_", 0); });
 $("#GDPSRDPSTT850").click(function(){   ChoixDuo("GDPS",   "TMP_850", "PRMSL_", "RDPS", "TMP_850", "PRMSL_", 0); });
 $("#GFSGDPSTT850").click(function(){    ChoixDuo("GFS",    "TMP_850", "PRMSL_", "GDPS", "TMP_850", "PRMSL_", 0); });
 $("#ECMWFGDPSTT850").click(function(){  ChoixDuo("ECMWF",  "TMP_850", "PRMSL_", "GDPS", "TMP_850", "PRMSL_", 0); });
 $("#AIFSGDPSTT850").click(function(){   ChoixDuo("AIFS",   "TMP_850", "PRMSL_", "GDPS", "TMP_850", "PRMSL_", 0); });
 
 $("#RDPSRDPSve10mvd10m").click(function(){ ChoixDuo("void", "void", "void","RDPS",   "WIN-_10",  "WDIR_10", 1); });
 $("#HRDEHRDEve10mvd10m").click(function(){ ChoixDuo("void", "void", "void","HRDPS E","WIN-_10",  "WDIR_10", 1); });
 $("#GDPSGDPSve10mvd10m").click(function(){ ChoixDuo("void", "void", "void","GDPS",   "WIN-_10",  "WDIR_10", 1); });

 $("#HRDPSERDPSve10m").click(function(){ ChoixDuo("HRDPS E", "WIN-_10", "WDIR_10", "RDPS", "WIN-_10","WDIR_10", 0); });
 $("#GDPSRDPSve10m").click(function(){   ChoixDuo("GDPS",    "WIN-_10", "WDIR_10", "RDPS", "WIN-_10","WDIR_10", 0); });
 
 $("#HRDPSERDPSvd10m").click(function(){ ChoixDuo("HRDPS E", "WDIR_10", "void", "RDPS", "WDIR_10",  "void", 0); });
 $("#GDPSRDPSvd10m").click(function(){   ChoixDuo("GDPS",    "WDIR_10", "void", "RDPS", "WDIR_10",  "void",0); });

 $("#RDPSRDPSvv850gz850").click(function(){ ChoixDuo("RDPS", "WIND_850", "WDIR_850", "RDPS", "HGT_850", "void", 1); });
 $("#GDPSGDPSvv850gz850").click(function(){ ChoixDuo("GDPS", "WIND_850", "WDIR_850", "GDPS", "HGT_850", "void", 1); });

 $("#HRDPSERDPSve850").click(function(){ ChoixDuo("HRDPS E", "WIND_850", "WDIR_850", "RDPS", "WIND_850", "WDIR_850", 0); });
 $("#GDPSRDPSve850").click(function(){   ChoixDuo("GDPS",    "WIND_850", "WDIR_850", "RDPS", "WIND_850", "WDIR_850", 0); });
 
 $("#RDPSRDPSvv250gz250").click(function(){ ChoixDuo("RDPS", "WIND_250", "WDIR_250", "RDPS", "HGT_250", "void", 1); });
 $("#GDPSGDPSvv250gz250").click(function(){ ChoixDuo("GDPS", "WIND_250", "WDIR_250", "GDPS", "HGT_250", "void", 1); });

 $("#RDPSRDPSvv850windgz850").click(function(){ ChoixDuo("RDPS", "WIND_850", "WDIR_850", "RDPS", "WIND_850", "HGT_850", 0); });
 $("#GDPSGDPSvv850windgz850").click(function(){ ChoixDuo("GDPS", "WIND_850", "WDIR_850", "GDPS", "WIND_850", "HGT_850", 0); });

 $("#RDPSRDPSvv250windgz250").click(function(){ ChoixDuo("RDPS", "WIND_250", "WDIR_250", "RDPS", "WIND_250", "HGT_250", 0); });
 $("#GDPSGDPSvv250windgz250").click(function(){ ChoixDuo("GDPS", "WIND_250", "WDIR_250", "GDPS", "WIND_250", "HGT_250", 0); });

 $("#RDPSRDPSvr10mGP500").click(function(){ ChoixDuo("RDPS", "GUST_10", "PRMSL_", "RDPS",   "HGT_500", "void", 1); });
 $("#HRDEHRDEvr10mGP500").click(function(){ ChoixDuo("HRDPS E", "GUST_10", "PRMSL_", "HRDPS E","HGT_500", "void", 1); });
 $("#GDPSGDPSvr10mGP500").click(function(){ ChoixDuo("GDPS", "GUST_10", "PRMSL_", "GDPS",   "HGT_500", "void", 1); });

 $("#HRDPSERDPSvr10m").click(function(){ ChoixDuo("HRDPS E", "GUST_10", "void",  "RDPS", "GUST_10", "void",  0); });
 $("#GDPSRDPSvr10m").click(function(){   ChoixDuo("GDPS",    "GUST_10", "void",  "RDPS", "GUST_10", "void",  0); });

// DuoC   pour état de la mer             

              //Ici Variable combinées   
 $("#DIAGWDIAGWIaGIaDirIaH").click(function(){       ChoixDuo("DIAGW", "IaH_Sfc", "void", "DIAGW", "IaG_Sfc",    "IaDir_Sfc", 0); }); 
 $("#DIAGWDIAGWIaGIaDirIaLc").click(function(){      ChoixDuo("DIAGW", "IaLc_Sfc", "void", "DIAGW", "IaG_Sfc",    "IaDir_Sfc", 0); }); 
 $("#DIAGWDIAGWIaGIaDirAMPLCDIR").click(function(){   ChoixDuo("DIAGW", "AMPL_Sfc", "CDIR_0.5", "DIAGW", "IaG_Sfc", "IaDir_Sfc", 0); }); 
 $("#DIAGWDIAGWIaGIaDirIamask").click(function(){    ChoixDuo("DIAGW", "Ia_mask_Sfc", "void", "DIAGW", "IaG_Sfc",    "IaDir_Sfc", 0); }); 
 $("#DIAGWDIAGWIa2GIa2DirIa2mask").click(function(){ ChoixDuo("DIAGW", "Ia2_mask_Sfc", "void", "DIAGW", "Ia2G_Sfc",    "Ia2Dir_Sfc", 0); }); 
 $("#DIAGWDIAGWIa2GIa2DirIaGIaDir").click(function(){ ChoixDuo("DIAGW", "Ia2G_Sfc", "Ia2Dir_Sfc", "DIAGW", "IaG_Sfc",    "IaDir_Sfc", 0); }); 

        //------------------------------------------------------------Par groupes --------------------------------------
             // ici agitation et hauteur
$("#DIAGWDIAGWIaVWavHVWavDir").click(function(){    ChoixDuo("DIAGW", "WVHGT_Sfc",    "WVDIR_Sfc",    "DIAGW", "Ia_V_Sfc",  "void", 0); });
$("#DIAGWDIAGWIa1HWavHH1WavDir").click(function(){ ChoixDuo("DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", "DIAGW", "Ia_1H_Sfc", "void", 0); });
$("#DIAGWDIAGWIa2HWavHH2WavDir").click(function(){ ChoixDuo("DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", "DIAGW", "Ia_2H_Sfc", "void", 0); });

              //Ici agitation et cambrure 
$("#DIAGWDIAGWIaVCmbrV").click(function(){   ChoixDuo("DIAGW", "CmbrV_Sfc",  "WVDIR_Sfc", "DIAGW", "Ia_V_Sfc",  "WVDIR_Sfc", 0); });
$("#DIAGWDIAGWIa1HCmbr1H").click(function(){ ChoixDuo("DIAGW", "Cmbr1H_Sfc", "H1DIR_Sfc", "DIAGW", "Ia_1H_Sfc", "H1DIR_Sfc", 0); });
$("#DIAGWDIAGWIa2HCmbr2H").click(function(){ ChoixDuo("DIAGW", "Cmbr2H_Sfc", "H2DIR_Sfc", "DIAGW", "Ia_2H_Sfc", "H2DIR_Sfc", 0); });

              //Ici courant et cambrure 
$("#DIAGWDIAGWCSPEEDCmbrV").click(function(){  ChoixDuo("DIAGW", "CmbrV_Sfc",  "WVDIR_Sfc", "DIAGW", "CSPEED_0.5", "CDIR_0.5", 0); });
$("#DIAGWDIAGWCSPEEDCmbr1H").click(function(){ ChoixDuo("DIAGW", "Cmbr1H_Sfc", "H1DIR_Sfc", "DIAGW", "CSPEED_0.5", "CDIR_0.5", 0); });
$("#DIAGWDIAGWCSPEEDCmbr2H").click(function(){ ChoixDuo("DIAGW", "Cmbr2H_Sfc", "H2DIR_Sfc", "DIAGW", "CSPEED_0.5", "CDIR_0.5", 0); });

              //Ici hauteur et cambrure 
$("#DIAGWDIAGWWWavHWWavDirCambV").click(function(){    ChoixDuo("DIAGW", "CmbrV_Sfc", "WVDIR_Sfc", "DIAGW", "WVHGT_Sfc",    "WVDIR_Sfc",    0); });
$("#DIAGWDIAGWH1WavHH1WavDirCamb1H").click(function(){ ChoixDuo("DIAGW", "Cmbr1H_Sfc", "H1DIR_Sfc", "DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", 0); });
$("#DIAGWDIAGWH2WavHH2WavDirCamb2H").click(function(){ ChoixDuo("DIAGW", "Cmbr2H_Sfc", "H2DIR_Sfc", "DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", 0); });

              //Ici hauteur et amplification+ dircou 
$("#DIAGWDIAGWWavHWWavDirAMPLV").click(function(){    ChoixDuo("DIAGW", "AMPLV_Sfc", "CDIR_0.5", "DIAGW", "WVHGT_Sfc",    "WVDIR_Sfc",    0); });
$("#DIAGWDIAGWWavHH1WavDirAMPL1H").click(function(){ ChoixDuo("DIAGW", "AMPL1H_Sfc", "CDIR_0.5", "DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", 0); });
$("#DIAGWDIAGWWavHH2WavDirAMPL2H").click(function(){ ChoixDuo("DIAGW", "AMPL2H_Sfc", "CDIR_0.5", "DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", 0); });

              //Ici hauteur+dir  d origine et hauteur recalculés+dircou 
$("#DIAGWRDWPSWavHWWavDirWVHGT").click(function(){    ChoixDuo("DIAGW", "WVHGT_Sfc", "WVDIR_Sfc", "RDWPS", "WVHGT_Sfc",    "WVDIR_Sfc",    0); });
$("#DIAGWRDWPSWavHH1WavDirSWHFSWEL").click(function(){ ChoixDuo("DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", "RDWPS", "SWHFSWEL_Sfc", "MWDFSWEL_Sfc", 0); });
$("#DIAGWRDWPSWavHH2WavDirSWHSSWEL").click(function(){ ChoixDuo("DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", "RDWPS", "SWHSSWEL_Sfc", "MWDSSWEL_Sfc", 0); });

             // ici agitation et croisement 
$("#DIAGWDIAGWIaVXV").click(function(){   ChoixDuo("DIAGW", "Ic_V_Sfc",  "WVDIR_Sfc", "DIAGW", "Ia_V_Sfc",  "void", 0); });
$("#DIAGWDIAGWIa1HX1H").click(function(){ ChoixDuo("DIAGW", "Ic_1H_Sfc", "H1DIR_Sfc", "DIAGW", "Ia_1H_Sfc", "void", 0); });
$("#DIAGWDIAGWIa2HX2H").click(function(){ ChoixDuo("DIAGW", "Ic_2H_Sfc", "H2DIR_Sfc", "DIAGW", "Ia_2H_Sfc", "void", 0); });

             // ici comparaison de groupe :  Periodes  et directions
//$("#RWDPSRDWPSPerWWWavDirPerH1H1WavDir").click(function(){    ChoixDuo("RDWPS", "PWPFSWEL_Sfc", "MWDFSWEL_Sfc", "RDWPS", "PPERWW_Sfc",   "WVDIR_Sfc", 0); });
//$("#RWDPSRDWPSPerH1H1WavDirPerH2H2WavDir").click(function(){  ChoixDuo("RDWPS", "PWPSSWEL_Sfc", "MWDSSWEL_Sfc", "RDWPS", "PWPFSWEL_Sfc", "MWDFSWEL_Sfc", 0); });
//$("#RWDPSRDWPSPerH2H2WavDirPerWWWavDir").click(function(){    ChoixDuo("RDWPS", "PPERWW_Sfc",   "WVDIR_Sfc",    "RDWPS", "PWPSSWEL_Sfc", "MWDSSWEL_Sfc", 0); });

             // ici comparaison de groupe :  Agitation  et directions
$("#DIAGWDIAGWIa_VVWavDirIa_1HH1WavDir").click(function(){  ChoixDuo("DIAGW", "Ia_1H_Sfc", "H1DIR_Sfc", "DIAGW", "Ia_V_Sfc",    "WVDIR_Sfc", 0); });
$("#DIAGWDIAGWIa_1HH1VWavDirIa_2HH2WavDir").click(function(){ ChoixDuo("DIAGW", "Ia_2H_Sfc", "H2DIR_Sfc", "DIAGW", "Ia_1H_Sfc", "H1DIR_Sfc", 0); });
$("#DIAGWDIAGWIa_2HH2WavDirIa_VVWavDir").click(function(){  ChoixDuo("DIAGW", "Ia_V_Sfc",    "WVDIR_Sfc", "DIAGW", "Ia_2H_Sfc", "H2DIR_Sfc", 0); });

             // ici comparaison de groupe :  Hauteurs  et directions
$("#DIAGWDIAGWWavHVVWavDirH1WavDir").click(function(){  ChoixDuo("DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", "DIAGW", "WVHGT_Sfc",    "WVDIR_Sfc", 0); });
$("#DIAGWDIAGWWavHH1WavDirH2WavDir").click(function(){ ChoixDuo("DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", "DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", 0); });
$("#DIAGWDIAGWWavHH2WavDirVWavDir").click(function(){  ChoixDuo("DIAGW", "WVHGT_Sfc",    "WVDIR_Sfc", "DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", 0); });

             // ici comparaison de groupe :  directions
$("#DIAGWDIAGWVWavDirH1WavDir").click(function(){  ChoixDuo("DIAGW", "H1DIR_Sfc", "H1DIR_Sfc", "DIAGW", "WVDIR_Sfc", "WVDIR_Sfc", 1); });
$("#DIAGWDIAGWH1WavDirH2WavDir").click(function(){ ChoixDuo("DIAGW", "H2DIR_Sfc", "H2DIR_Sfc", "DIAGW", "H1DIR_Sfc", "H1DIR_Sfc", 1); });
$("#DIAGWDIAGWH2WavDirVWavDir").click(function(){  ChoixDuo("DIAGW", "WVDIR_Sfc", "WVDIR_Sfc", "DIAGW", "H2DIR_Sfc", "H2DIR_Sfc", 1); });

//-----------------------------------------------------------------------------------------------

// DuoN : active COntinental
$("#voidRADARvoidRco").click(function(){ ChoixDuo("void",      "void",        "void", "RADAR CO",   "RRAI",    "void", 1); });
$("#GOESRADARIRcoRco").click(function(){ ChoixDuo("void",      "void",        "void", "GOESR_PLUS","C13_CO",  "RRAI", 1); });
$("#GOESRADARVIcoRco").click(function(){ ChoixDuo("void",      "void",        "void", "GOESR_PLUS","C02_CO",  "RRAI", 1); });
$("#RADARRADARRcoRcoN").click(function(){ ChoixDuo("RADAR CO", "RRAI",        "void", "RADAR CO",   "RRAI_NET","void", 0); });
$("#GOESRADARFOcoRco").click(function(){ ChoixDuo("FOUDRE CO", "FOUDRE_PTS_CO", "void", "RADAR CO", "RRAI",    "void", 0); });

$("#voidRADARvoidSco").click(function(){ ChoixDuo("void",        "void",   "void", "RADAR CO", "RSNO", "void", 1); });
$("#GOESRADARIRcoSco").click(function(){ ChoixDuo("void",      "void",        "void", "GOESR_PLUS","C13_CO",  "RSNO", 1); });
$("#GOESRADARVIcoSco").click(function(){ ChoixDuo("void",      "void",        "void", "GOESR_PLUS","C02_CO",  "RSNO", 1); });
$("#RADARRADARScoScoN").click(function(){ ChoixDuo("RADAR CO", "RSNO",        "void", "RADAR CO",   "RSNO_NET","void", 0); });
$("#GOESRADARFOcoSco").click(function(){ ChoixDuo("FOUDRE CO", "FOUDRE_PTS_CO", "void", "RADAR CO", "RSNO",    "void", 0); });

$("#GOESRADARIR_FOcoIR_Rco").click(function(){ ChoixDuo("GOESR_PLUS", "C13_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C13_CO", "RRAI", 0); });
$("#GOESRADARVI_FOcoVI_Rco").click(function(){ ChoixDuo("GOESR_PLUS", "C02_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C02_CO", "RRAI", 0); });
$("#GOESRADARIR_FOcoVI_Rco").click(function(){ ChoixDuo("GOESR_PLUS", "C13_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C02_CO", "RRAI", 0); });
$("#GOESRADARVI_FOcoIR_Rco").click(function(){ ChoixDuo("GOESR_PLUS", "C02_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C13_CO", "RRAI", 0); });
$("#RADARRADARVI_RcoIR_Rco").click(function(){ ChoixDuo("GOESR_PLUS", "C02_CO", "RRAI",          "GOESR_PLUS", "C13_CO", "RRAI" , 0); });

$("#GOESRADARIR_FOcoIR_Sco").click(function(){ ChoixDuo("GOESR_PLUS", "C13_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C13_CO", "RSNO", 0); });
$("#GOESRADARVI_FOcoVI_Sco").click(function(){ ChoixDuo("GOESR_PLUS", "C02_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C02_CO", "RSNO", 0); });
$("#GOESRADARIR_FOcoVI_Sco").click(function(){ ChoixDuo("GOESR_PLUS", "C13_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C02_CO", "RSNO", 0); });
$("#GOESRADARVI_FOcoIR_Sco").click(function(){ ChoixDuo("GOESR_PLUS", "C02_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C13_CO", "RSNO", 0); });
$("#RADARRADARVI_ScoIR_Sco").click(function(){ ChoixDuo("GOESR_PLUS", "C02_CO", "RSNO",          "GOESR_PLUS", "C13_CO", "RSNO" , 0); });

$("#voidGOESRvoidIRco").click(function(){ ChoixDuo("void",   "void", "void",  "GOESR CO",    "C13_CO", "void",  1); });
$("#voidGOESRvoidVIco").click(function(){ ChoixDuo("void",   "void", "void",  "GOESR CO",    "C02_CO", "void",  1); });
$("#GOESGOESIRcoVIco").click(function(){ ChoixDuo("GOESR CO", "C02_CO", "void","GOESR CO", "C13_CO", "void",  0); });
$("#GOESGOESIR_FOcoIR_Sco").click(function(){ ChoixDuo("GOESR_PLUS", "C02_CO","FOUDRE_PTS_CO","GOESR_PLUS","C13_CO","FOUDRE_PTS_CO", 0); });

// DuoN   not active
//$("#GOESRDPSIRcoNu").click(function(){ ChoixDuo("GOESR CO",   "C13_CO", "RDPS",    "HGT_500_TCDC_", 0); });
//$("#GOESRDPSIRcocompo").click(function(){ ChoixDuo("GOESR CO",   "C13_CO", "RDPS",    "COMPO__h", 1); });
//$("#GOESRDPSIRcoGZ500PN").click(function(){ ChoixDuo("GOESR CO",   "C13_CO", "RDPS",    "HGT_500_PRMSL_", 1); });

//$("#GOESRDPSVIcoNu").click(function(){ ChoixDuo("GOESR CO",   "C02_CO", "RDPS",    "HGT_500_TCDC_", 0); });
//$("#GOESRDPSVIcocompo").click(function(){ ChoixDuo("GOESR CO",   "C02_CO", "RDPS",    "COMPO__h", 1); });
//$("#GOESRDPSVIcoGZ500PN").click(function(){ ChoixDuo("GOESR CO",   "C02_CO", "RDPS",    "HGT_500_PRMSL_", 1); });

//$("#RADARRDPSRcocompo").click(function(){ ChoixDuo("RADAR CO",  "2KM_RRAI", "RDPS",    "COMPO__h", 0); });
//$("#RADARRDPSRcoGZ500PN").click(function(){ ChoixDuo("RADAR CO",  "2KM_RRAI", "RDPS",    "HGT_500_PRMSL_", 1); });
//$("#RADARRDPSRcoGZ500Vort").click(function(){ ChoixDuo("RADAR CO",  "2KM_RRAI", "RDPS",    "ABSV_500_HGT_500_ABSV_500", 1); });

//$("#RADARRADARScoRco").click(function(){ ChoixDuo("RADAR CO",   "2KM_RSNO", "RADAR CO",    "2KM_RRAI", 0); });
//$("#RADARRDPSScocompo").click(function(){ ChoixDuo("RADAR CO",  "2KM_RSNO", "RDPS",    "COMPO__h", 0); });
//$("#RADARRDPSScoGZ500PN").click(function(){ ChoixDuo("RADAR CO",  "2KM_RSNO", "RDPS",    "HGT_500_PRMSL_", 1); });
//$("#RADARRDPSScoGZ500Vort").click(function(){ ChoixDuo("RADAR CO",  "2KM_RSNO", "RDPS",    "ABSV_500_HGT_500_ABSV_500", 1); });

//$("#RDPSRADARNuSco").click(function(){ ChoixDuo("RDPS",   "HGT_500_TCDC_", "RADAR CO",    "2KM_RSNO", 0); });
//$("#RDPSRADARNuRco").click(function(){ ChoixDuo("RDPS",  "HGT_500_TCDC_", "RADAR CO",    "2KM_RRAI", 0); });
//$("#RDPSGOESRNuIRco").click(function(){ ChoixDuo("RDPS", "HGT_500_TCDC_", "GOESR CO",    "C13_CO", 0); });
//$("#RDPSGOESRNuVIco").click(function(){ ChoixDuo("RDPS", "HGT_500_TCDC_", "GOESR CO",    "C02_CO", 0); });

//$("#RDPSRADARcompoSco").click(function(){ ChoixDuo("RDPS",   "COMPO__h", "RADAR CO",    "2KM_RSNO", 0); });
//$("#RDPSRADARcompoRco").click(function(){ ChoixDuo("RDPS",  "COMPO__h", "RADAR CO",    "2KM_RRAI", 0); });
//$("#RDPSGOESRcompoIRco").click(function(){ ChoixDuo("RDPS", "COMPO__h", "GOESR CO",    "C13_CO", 0); });
//$("#RDPSGOESRcompoVIco").click(function(){ ChoixDuo("RDPS", "COMPO__h", "GOESR CO",    "C02_CO", 0); });

